
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jk232", function(module, exports) {
'use strict';

module.exports = (parcelRequire("abGvd"));

});
parcelRegister("abGvd", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $76abe68dd2b5f1d5$export$ffb0004e005737fa; }, function (v) { return $76abe68dd2b5f1d5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $76abe68dd2b5f1d5$export$34b9dba7ce09269b; }, function (v) { return $76abe68dd2b5f1d5$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $76abe68dd2b5f1d5$export$25062201e9e25d76; }, function (v) { return $76abe68dd2b5f1d5$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $76abe68dd2b5f1d5$export$ffb0004e005737fa;
var $76abe68dd2b5f1d5$export$34b9dba7ce09269b;
var $76abe68dd2b5f1d5$export$25062201e9e25d76;
'use strict';

var $4RFnf = parcelRequire("4RFnf");
var $76abe68dd2b5f1d5$var$k = Symbol.for("react.element"), $76abe68dd2b5f1d5$var$l = Symbol.for("react.fragment"), $76abe68dd2b5f1d5$var$m = Object.prototype.hasOwnProperty, $76abe68dd2b5f1d5$var$n = $4RFnf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $76abe68dd2b5f1d5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $76abe68dd2b5f1d5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$76abe68dd2b5f1d5$var$m.call(a, b) && !$76abe68dd2b5f1d5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $76abe68dd2b5f1d5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $76abe68dd2b5f1d5$var$n.current
    };
}
$76abe68dd2b5f1d5$export$ffb0004e005737fa = $76abe68dd2b5f1d5$var$l;
$76abe68dd2b5f1d5$export$34b9dba7ce09269b = $76abe68dd2b5f1d5$var$q;
$76abe68dd2b5f1d5$export$25062201e9e25d76 = $76abe68dd2b5f1d5$var$q;

});
parcelRegister("4RFnf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kAGzt"));

});
parcelRegister("kAGzt", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $efd8312e16f87340$export$dca3b0875bd9a954; }, function (v) { return $efd8312e16f87340$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $efd8312e16f87340$export$16fa2f45be04daa8; }, function (v) { return $efd8312e16f87340$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $efd8312e16f87340$export$ffb0004e005737fa; }, function (v) { return $efd8312e16f87340$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $efd8312e16f87340$export$e2c29f18771995cb; }, function (v) { return $efd8312e16f87340$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $efd8312e16f87340$export$221d75b3f55bb0bd; }, function (v) { return $efd8312e16f87340$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $efd8312e16f87340$export$5f8d39834fd61797; }, function (v) { return $efd8312e16f87340$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $efd8312e16f87340$export$74bf444e3cd11ea5; }, function (v) { return $efd8312e16f87340$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $efd8312e16f87340$export$ae55be85d98224ed; }, function (v) { return $efd8312e16f87340$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $efd8312e16f87340$export$3ba232387fd5d6dd; }, function (v) { return $efd8312e16f87340$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $efd8312e16f87340$export$e530037191fcd5d7; }, function (v) { return $efd8312e16f87340$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $efd8312e16f87340$export$fd42f52fd3ae1109; }, function (v) { return $efd8312e16f87340$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $efd8312e16f87340$export$c8a8987d4410bf2d; }, function (v) { return $efd8312e16f87340$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $efd8312e16f87340$export$d38cd72104c1f0e9; }, function (v) { return $efd8312e16f87340$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $efd8312e16f87340$export$7d1e3a5e95ceca43; }, function (v) { return $efd8312e16f87340$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $efd8312e16f87340$export$257a8862b851cb5b; }, function (v) { return $efd8312e16f87340$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $efd8312e16f87340$export$a8257692ac88316c; }, function (v) { return $efd8312e16f87340$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $efd8312e16f87340$export$488013bae63b21da; }, function (v) { return $efd8312e16f87340$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $efd8312e16f87340$export$7c73462e0d25e514; }, function (v) { return $efd8312e16f87340$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $efd8312e16f87340$export$7568632d0d33d16d; }, function (v) { return $efd8312e16f87340$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $efd8312e16f87340$export$88948ce120ea2619; }, function (v) { return $efd8312e16f87340$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $efd8312e16f87340$export$35808ee640e87ca7; }, function (v) { return $efd8312e16f87340$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $efd8312e16f87340$export$fae74005e78b1a27; }, function (v) { return $efd8312e16f87340$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $efd8312e16f87340$export$dc8fbce3eb94dc1e; }, function (v) { return $efd8312e16f87340$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $efd8312e16f87340$export$6a7bc4e911dc01cf; }, function (v) { return $efd8312e16f87340$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $efd8312e16f87340$export$6d9c69b0de29b591; }, function (v) { return $efd8312e16f87340$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $efd8312e16f87340$export$f680877a34711e37; }, function (v) { return $efd8312e16f87340$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $efd8312e16f87340$export$d5a552a76deda3c2; }, function (v) { return $efd8312e16f87340$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $efd8312e16f87340$export$aaabe4eda9ed9969; }, function (v) { return $efd8312e16f87340$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $efd8312e16f87340$export$e5c5a5f917a5871c; }, function (v) { return $efd8312e16f87340$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $efd8312e16f87340$export$1538c33de8887b59; }, function (v) { return $efd8312e16f87340$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $efd8312e16f87340$export$13e3392192263954; }, function (v) { return $efd8312e16f87340$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $efd8312e16f87340$export$b8f5890fc79d6aca; }, function (v) { return $efd8312e16f87340$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $efd8312e16f87340$export$60241385465d0a34; }, function (v) { return $efd8312e16f87340$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $efd8312e16f87340$export$306c0aa65ff9ec16; }, function (v) { return $efd8312e16f87340$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $efd8312e16f87340$export$7b286972b8d8ccbf; }, function (v) { return $efd8312e16f87340$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $efd8312e16f87340$export$83d89fbfd8236492; }, function (v) { return $efd8312e16f87340$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $efd8312e16f87340$export$dca3b0875bd9a954;
var $efd8312e16f87340$export$16fa2f45be04daa8;
var $efd8312e16f87340$export$ffb0004e005737fa;
var $efd8312e16f87340$export$e2c29f18771995cb;
var $efd8312e16f87340$export$221d75b3f55bb0bd;
var $efd8312e16f87340$export$5f8d39834fd61797;
var $efd8312e16f87340$export$74bf444e3cd11ea5;
var $efd8312e16f87340$export$ae55be85d98224ed;
var $efd8312e16f87340$export$3ba232387fd5d6dd;
var $efd8312e16f87340$export$e530037191fcd5d7;
var $efd8312e16f87340$export$fd42f52fd3ae1109;
var $efd8312e16f87340$export$c8a8987d4410bf2d;
var $efd8312e16f87340$export$d38cd72104c1f0e9;
var $efd8312e16f87340$export$7d1e3a5e95ceca43;
var $efd8312e16f87340$export$257a8862b851cb5b;
var $efd8312e16f87340$export$a8257692ac88316c;
var $efd8312e16f87340$export$488013bae63b21da;
var $efd8312e16f87340$export$7c73462e0d25e514;
var $efd8312e16f87340$export$7568632d0d33d16d;
var $efd8312e16f87340$export$88948ce120ea2619;
var $efd8312e16f87340$export$35808ee640e87ca7;
var $efd8312e16f87340$export$fae74005e78b1a27;
var $efd8312e16f87340$export$dc8fbce3eb94dc1e;
var $efd8312e16f87340$export$6a7bc4e911dc01cf;
var $efd8312e16f87340$export$6d9c69b0de29b591;
var $efd8312e16f87340$export$f680877a34711e37;
var $efd8312e16f87340$export$d5a552a76deda3c2;
var $efd8312e16f87340$export$aaabe4eda9ed9969;
var $efd8312e16f87340$export$e5c5a5f917a5871c;
var $efd8312e16f87340$export$1538c33de8887b59;
var $efd8312e16f87340$export$13e3392192263954;
var $efd8312e16f87340$export$b8f5890fc79d6aca;
var $efd8312e16f87340$export$60241385465d0a34;
var $efd8312e16f87340$export$306c0aa65ff9ec16;
var $efd8312e16f87340$export$7b286972b8d8ccbf;
var $efd8312e16f87340$export$83d89fbfd8236492;
'use strict';
var $efd8312e16f87340$var$l = Symbol.for("react.element"), $efd8312e16f87340$var$n = Symbol.for("react.portal"), $efd8312e16f87340$var$p = Symbol.for("react.fragment"), $efd8312e16f87340$var$q = Symbol.for("react.strict_mode"), $efd8312e16f87340$var$r = Symbol.for("react.profiler"), $efd8312e16f87340$var$t = Symbol.for("react.provider"), $efd8312e16f87340$var$u = Symbol.for("react.context"), $efd8312e16f87340$var$v = Symbol.for("react.forward_ref"), $efd8312e16f87340$var$w = Symbol.for("react.suspense"), $efd8312e16f87340$var$x = Symbol.for("react.memo"), $efd8312e16f87340$var$y = Symbol.for("react.lazy"), $efd8312e16f87340$var$z = Symbol.iterator;
function $efd8312e16f87340$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $efd8312e16f87340$var$z && a[$efd8312e16f87340$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $efd8312e16f87340$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $efd8312e16f87340$var$C = Object.assign, $efd8312e16f87340$var$D = {};
function $efd8312e16f87340$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $efd8312e16f87340$var$D;
    this.updater = e || $efd8312e16f87340$var$B;
}
$efd8312e16f87340$var$E.prototype.isReactComponent = {};
$efd8312e16f87340$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$efd8312e16f87340$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $efd8312e16f87340$var$F() {}
$efd8312e16f87340$var$F.prototype = $efd8312e16f87340$var$E.prototype;
function $efd8312e16f87340$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $efd8312e16f87340$var$D;
    this.updater = e || $efd8312e16f87340$var$B;
}
var $efd8312e16f87340$var$H = $efd8312e16f87340$var$G.prototype = new $efd8312e16f87340$var$F;
$efd8312e16f87340$var$H.constructor = $efd8312e16f87340$var$G;
$efd8312e16f87340$var$C($efd8312e16f87340$var$H, $efd8312e16f87340$var$E.prototype);
$efd8312e16f87340$var$H.isPureReactComponent = !0;
var $efd8312e16f87340$var$I = Array.isArray, $efd8312e16f87340$var$J = Object.prototype.hasOwnProperty, $efd8312e16f87340$var$K = {
    current: null
}, $efd8312e16f87340$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $efd8312e16f87340$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$efd8312e16f87340$var$J.call(b, d) && !$efd8312e16f87340$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $efd8312e16f87340$var$K.current
    };
}
function $efd8312e16f87340$var$N(a, b) {
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $efd8312e16f87340$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $efd8312e16f87340$var$l;
}
function $efd8312e16f87340$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $efd8312e16f87340$var$P = /\/+/g;
function $efd8312e16f87340$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $efd8312e16f87340$var$escape("" + a.key) : b.toString(36);
}
function $efd8312e16f87340$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $efd8312e16f87340$var$l:
                case $efd8312e16f87340$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $efd8312e16f87340$var$Q(h, 0) : d, $efd8312e16f87340$var$I(c) ? (e = "", null != a && (e = a.replace($efd8312e16f87340$var$P, "$&/") + "/"), $efd8312e16f87340$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($efd8312e16f87340$var$O(c) && (c = $efd8312e16f87340$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($efd8312e16f87340$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($efd8312e16f87340$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $efd8312e16f87340$var$Q(k, g);
        h += $efd8312e16f87340$var$R(k, b, e, f, c);
    }
    else if (f = $efd8312e16f87340$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $efd8312e16f87340$var$Q(k, g++), h += $efd8312e16f87340$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $efd8312e16f87340$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $efd8312e16f87340$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $efd8312e16f87340$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $efd8312e16f87340$var$U = {
    current: null
}, $efd8312e16f87340$var$V = {
    transition: null
}, $efd8312e16f87340$var$W = {
    ReactCurrentDispatcher: $efd8312e16f87340$var$U,
    ReactCurrentBatchConfig: $efd8312e16f87340$var$V,
    ReactCurrentOwner: $efd8312e16f87340$var$K
};
function $efd8312e16f87340$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$efd8312e16f87340$export$dca3b0875bd9a954 = {
    map: $efd8312e16f87340$var$S,
    forEach: function(a, b, e) {
        $efd8312e16f87340$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $efd8312e16f87340$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $efd8312e16f87340$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$efd8312e16f87340$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$efd8312e16f87340$export$16fa2f45be04daa8 = $efd8312e16f87340$var$E;
$efd8312e16f87340$export$ffb0004e005737fa = $efd8312e16f87340$var$p;
$efd8312e16f87340$export$e2c29f18771995cb = $efd8312e16f87340$var$r;
$efd8312e16f87340$export$221d75b3f55bb0bd = $efd8312e16f87340$var$G;
$efd8312e16f87340$export$5f8d39834fd61797 = $efd8312e16f87340$var$q;
$efd8312e16f87340$export$74bf444e3cd11ea5 = $efd8312e16f87340$var$w;
$efd8312e16f87340$export$ae55be85d98224ed = $efd8312e16f87340$var$W;
$efd8312e16f87340$export$3ba232387fd5d6dd = $efd8312e16f87340$var$X;
$efd8312e16f87340$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $efd8312e16f87340$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $efd8312e16f87340$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$efd8312e16f87340$var$J.call(b, f) && !$efd8312e16f87340$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $efd8312e16f87340$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$efd8312e16f87340$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $efd8312e16f87340$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $efd8312e16f87340$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$efd8312e16f87340$export$c8a8987d4410bf2d = $efd8312e16f87340$var$M;
$efd8312e16f87340$export$d38cd72104c1f0e9 = function(a) {
    var b = $efd8312e16f87340$var$M.bind(null, a);
    b.type = a;
    return b;
};
$efd8312e16f87340$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$efd8312e16f87340$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $efd8312e16f87340$var$v,
        render: a
    };
};
$efd8312e16f87340$export$a8257692ac88316c = $efd8312e16f87340$var$O;
$efd8312e16f87340$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $efd8312e16f87340$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $efd8312e16f87340$var$T
    };
};
$efd8312e16f87340$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $efd8312e16f87340$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$efd8312e16f87340$export$7568632d0d33d16d = function(a) {
    var b = $efd8312e16f87340$var$V.transition;
    $efd8312e16f87340$var$V.transition = {};
    try {
        a();
    } finally{
        $efd8312e16f87340$var$V.transition = b;
    }
};
$efd8312e16f87340$export$88948ce120ea2619 = $efd8312e16f87340$var$X;
$efd8312e16f87340$export$35808ee640e87ca7 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useCallback(a, b);
};
$efd8312e16f87340$export$fae74005e78b1a27 = function(a) {
    return $efd8312e16f87340$var$U.current.useContext(a);
};
$efd8312e16f87340$export$dc8fbce3eb94dc1e = function() {};
$efd8312e16f87340$export$6a7bc4e911dc01cf = function(a) {
    return $efd8312e16f87340$var$U.current.useDeferredValue(a);
};
$efd8312e16f87340$export$6d9c69b0de29b591 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useEffect(a, b);
};
$efd8312e16f87340$export$f680877a34711e37 = function() {
    return $efd8312e16f87340$var$U.current.useId();
};
$efd8312e16f87340$export$d5a552a76deda3c2 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useImperativeHandle(a, b, e);
};
$efd8312e16f87340$export$aaabe4eda9ed9969 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useInsertionEffect(a, b);
};
$efd8312e16f87340$export$e5c5a5f917a5871c = function(a, b) {
    return $efd8312e16f87340$var$U.current.useLayoutEffect(a, b);
};
$efd8312e16f87340$export$1538c33de8887b59 = function(a, b) {
    return $efd8312e16f87340$var$U.current.useMemo(a, b);
};
$efd8312e16f87340$export$13e3392192263954 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useReducer(a, b, e);
};
$efd8312e16f87340$export$b8f5890fc79d6aca = function(a) {
    return $efd8312e16f87340$var$U.current.useRef(a);
};
$efd8312e16f87340$export$60241385465d0a34 = function(a) {
    return $efd8312e16f87340$var$U.current.useState(a);
};
$efd8312e16f87340$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $efd8312e16f87340$var$U.current.useSyncExternalStore(a, b, e);
};
$efd8312e16f87340$export$7b286972b8d8ccbf = function() {
    return $efd8312e16f87340$var$U.current.useTransition();
};
$efd8312e16f87340$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("bwgJJ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $862faa6cda49c095$export$ae55be85d98224ed; }, function (v) { return $862faa6cda49c095$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $862faa6cda49c095$export$d39a5bbd09211389; }, function (v) { return $862faa6cda49c095$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $862faa6cda49c095$export$882461b6382ed46c; }, function (v) { return $862faa6cda49c095$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $862faa6cda49c095$export$466bfc07425424d5; }, function (v) { return $862faa6cda49c095$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $862faa6cda49c095$export$cd75ccfd720a3cd4; }, function (v) { return $862faa6cda49c095$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $862faa6cda49c095$export$fa8d919ba61d84db; }, function (v) { return $862faa6cda49c095$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $862faa6cda49c095$export$757ceba2d55c277e; }, function (v) { return $862faa6cda49c095$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $862faa6cda49c095$export$b3890eb0ae9dca99; }, function (v) { return $862faa6cda49c095$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $862faa6cda49c095$export$502457920280e6be; }, function (v) { return $862faa6cda49c095$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $862faa6cda49c095$export$c78a37762a8d58e1; }, function (v) { return $862faa6cda49c095$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $862faa6cda49c095$export$dc54d992c10e8a18; }, function (v) { return $862faa6cda49c095$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $862faa6cda49c095$export$83d89fbfd8236492; }, function (v) { return $862faa6cda49c095$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $862faa6cda49c095$export$ae55be85d98224ed;
var $862faa6cda49c095$export$d39a5bbd09211389;
var $862faa6cda49c095$export$882461b6382ed46c;
var $862faa6cda49c095$export$466bfc07425424d5;
var $862faa6cda49c095$export$cd75ccfd720a3cd4;
var $862faa6cda49c095$export$fa8d919ba61d84db;
var $862faa6cda49c095$export$757ceba2d55c277e;
var $862faa6cda49c095$export$b3890eb0ae9dca99;
var $862faa6cda49c095$export$502457920280e6be;
var $862faa6cda49c095$export$c78a37762a8d58e1;
var $862faa6cda49c095$export$dc54d992c10e8a18;
var $862faa6cda49c095$export$83d89fbfd8236492;
'use strict';

var $4RFnf = parcelRequire("4RFnf");

var $8TTSu = parcelRequire("8TTSu");
function $862faa6cda49c095$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $862faa6cda49c095$var$da = new Set, $862faa6cda49c095$var$ea = {};
function $862faa6cda49c095$var$fa(a, b) {
    $862faa6cda49c095$var$ha(a, b);
    $862faa6cda49c095$var$ha(a + "Capture", b);
}
function $862faa6cda49c095$var$ha(a, b) {
    $862faa6cda49c095$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$862faa6cda49c095$var$da.add(b[a]);
}
var $862faa6cda49c095$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $862faa6cda49c095$var$ja = Object.prototype.hasOwnProperty, $862faa6cda49c095$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $862faa6cda49c095$var$la = {}, $862faa6cda49c095$var$ma = {};
function $862faa6cda49c095$var$oa(a) {
    if ($862faa6cda49c095$var$ja.call($862faa6cda49c095$var$ma, a)) return !0;
    if ($862faa6cda49c095$var$ja.call($862faa6cda49c095$var$la, a)) return !1;
    if ($862faa6cda49c095$var$ka.test(a)) return $862faa6cda49c095$var$ma[a] = !0;
    $862faa6cda49c095$var$la[a] = !0;
    return !1;
}
function $862faa6cda49c095$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $862faa6cda49c095$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $862faa6cda49c095$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $862faa6cda49c095$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $862faa6cda49c095$var$ra = /[\-:]([a-z])/g;
function $862faa6cda49c095$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($862faa6cda49c095$var$ra, $862faa6cda49c095$var$sa);
    $862faa6cda49c095$var$z[b] = new $862faa6cda49c095$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$862faa6cda49c095$var$z.xlinkHref = new $862faa6cda49c095$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $862faa6cda49c095$var$z[a] = new $862faa6cda49c095$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $862faa6cda49c095$var$ta(a, b, c, d) {
    var e = $862faa6cda49c095$var$z.hasOwnProperty(b) ? $862faa6cda49c095$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $862faa6cda49c095$var$qa(b, c, e, d) && (c = null), d || null === e ? $862faa6cda49c095$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $862faa6cda49c095$var$ua = $4RFnf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $862faa6cda49c095$var$va = Symbol.for("react.element"), $862faa6cda49c095$var$wa = Symbol.for("react.portal"), $862faa6cda49c095$var$ya = Symbol.for("react.fragment"), $862faa6cda49c095$var$za = Symbol.for("react.strict_mode"), $862faa6cda49c095$var$Aa = Symbol.for("react.profiler"), $862faa6cda49c095$var$Ba = Symbol.for("react.provider"), $862faa6cda49c095$var$Ca = Symbol.for("react.context"), $862faa6cda49c095$var$Da = Symbol.for("react.forward_ref"), $862faa6cda49c095$var$Ea = Symbol.for("react.suspense"), $862faa6cda49c095$var$Fa = Symbol.for("react.suspense_list"), $862faa6cda49c095$var$Ga = Symbol.for("react.memo"), $862faa6cda49c095$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $862faa6cda49c095$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $862faa6cda49c095$var$Ja = Symbol.iterator;
function $862faa6cda49c095$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $862faa6cda49c095$var$Ja && a[$862faa6cda49c095$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $862faa6cda49c095$var$A = Object.assign, $862faa6cda49c095$var$La;
function $862faa6cda49c095$var$Ma(a) {
    if (void 0 === $862faa6cda49c095$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $862faa6cda49c095$var$La = b && b[1] || "";
    }
    return "\n" + $862faa6cda49c095$var$La + a;
}
var $862faa6cda49c095$var$Na = !1;
function $862faa6cda49c095$var$Oa(a, b) {
    if (!a || $862faa6cda49c095$var$Na) return "";
    $862faa6cda49c095$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $862faa6cda49c095$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $862faa6cda49c095$var$Ma(a) : "";
}
function $862faa6cda49c095$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $862faa6cda49c095$var$Ma(a.type);
        case 16:
            return $862faa6cda49c095$var$Ma("Lazy");
        case 13:
            return $862faa6cda49c095$var$Ma("Suspense");
        case 19:
            return $862faa6cda49c095$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $862faa6cda49c095$var$Oa(a.type, !1), a;
        case 11:
            return a = $862faa6cda49c095$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $862faa6cda49c095$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $862faa6cda49c095$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $862faa6cda49c095$var$ya:
            return "Fragment";
        case $862faa6cda49c095$var$wa:
            return "Portal";
        case $862faa6cda49c095$var$Aa:
            return "Profiler";
        case $862faa6cda49c095$var$za:
            return "StrictMode";
        case $862faa6cda49c095$var$Ea:
            return "Suspense";
        case $862faa6cda49c095$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $862faa6cda49c095$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $862faa6cda49c095$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $862faa6cda49c095$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $862faa6cda49c095$var$Ga:
            return b = a.displayName || null, null !== b ? b : $862faa6cda49c095$var$Qa(a.type) || "Memo";
        case $862faa6cda49c095$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $862faa6cda49c095$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $862faa6cda49c095$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $862faa6cda49c095$var$Qa(b);
        case 8:
            return b === $862faa6cda49c095$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $862faa6cda49c095$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $862faa6cda49c095$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $862faa6cda49c095$var$Ua(a) {
    var b = $862faa6cda49c095$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $862faa6cda49c095$var$Va(a) {
    a._valueTracker || (a._valueTracker = $862faa6cda49c095$var$Ua(a));
}
function $862faa6cda49c095$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $862faa6cda49c095$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $862faa6cda49c095$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $862faa6cda49c095$var$Ya(a, b) {
    var c = b.checked;
    return $862faa6cda49c095$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $862faa6cda49c095$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $862faa6cda49c095$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $862faa6cda49c095$var$ab(a, b) {
    b = b.checked;
    null != b && $862faa6cda49c095$var$ta(a, "checked", b, !1);
}
function $862faa6cda49c095$var$bb(a, b) {
    $862faa6cda49c095$var$ab(a, b);
    var c = $862faa6cda49c095$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $862faa6cda49c095$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $862faa6cda49c095$var$cb(a, b.type, $862faa6cda49c095$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $862faa6cda49c095$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $862faa6cda49c095$var$cb(a, b, c) {
    if ("number" !== b || $862faa6cda49c095$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $862faa6cda49c095$var$eb = Array.isArray;
function $862faa6cda49c095$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $862faa6cda49c095$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $862faa6cda49c095$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($862faa6cda49c095$var$p(91));
    return $862faa6cda49c095$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $862faa6cda49c095$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($862faa6cda49c095$var$p(92));
            if ($862faa6cda49c095$var$eb(c)) {
                if (1 < c.length) throw Error($862faa6cda49c095$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $862faa6cda49c095$var$Sa(c)
    };
}
function $862faa6cda49c095$var$ib(a, b) {
    var c = $862faa6cda49c095$var$Sa(b.value), d = $862faa6cda49c095$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $862faa6cda49c095$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $862faa6cda49c095$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $862faa6cda49c095$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $862faa6cda49c095$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $862faa6cda49c095$var$mb, $862faa6cda49c095$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $862faa6cda49c095$var$mb = $862faa6cda49c095$var$mb || document.createElement("div");
        $862faa6cda49c095$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $862faa6cda49c095$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $862faa6cda49c095$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $862faa6cda49c095$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $862faa6cda49c095$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($862faa6cda49c095$var$pb).forEach(function(a) {
    $862faa6cda49c095$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $862faa6cda49c095$var$pb[b] = $862faa6cda49c095$var$pb[a];
    });
});
function $862faa6cda49c095$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $862faa6cda49c095$var$pb.hasOwnProperty(a) && $862faa6cda49c095$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $862faa6cda49c095$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $862faa6cda49c095$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $862faa6cda49c095$var$tb = $862faa6cda49c095$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $862faa6cda49c095$var$ub(a, b) {
    if (b) {
        if ($862faa6cda49c095$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($862faa6cda49c095$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($862faa6cda49c095$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($862faa6cda49c095$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($862faa6cda49c095$var$p(62));
    }
}
function $862faa6cda49c095$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $862faa6cda49c095$var$wb = null;
function $862faa6cda49c095$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $862faa6cda49c095$var$yb = null, $862faa6cda49c095$var$zb = null, $862faa6cda49c095$var$Ab = null;
function $862faa6cda49c095$var$Bb(a) {
    if (a = $862faa6cda49c095$var$Cb(a)) {
        if ("function" !== typeof $862faa6cda49c095$var$yb) throw Error($862faa6cda49c095$var$p(280));
        var b = a.stateNode;
        b && (b = $862faa6cda49c095$var$Db(b), $862faa6cda49c095$var$yb(a.stateNode, a.type, b));
    }
}
function $862faa6cda49c095$var$Eb(a) {
    $862faa6cda49c095$var$zb ? $862faa6cda49c095$var$Ab ? $862faa6cda49c095$var$Ab.push(a) : $862faa6cda49c095$var$Ab = [
        a
    ] : $862faa6cda49c095$var$zb = a;
}
function $862faa6cda49c095$var$Fb() {
    if ($862faa6cda49c095$var$zb) {
        var a = $862faa6cda49c095$var$zb, b = $862faa6cda49c095$var$Ab;
        $862faa6cda49c095$var$Ab = $862faa6cda49c095$var$zb = null;
        $862faa6cda49c095$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$862faa6cda49c095$var$Bb(b[a]);
    }
}
function $862faa6cda49c095$var$Gb(a, b) {
    return a(b);
}
function $862faa6cda49c095$var$Hb() {}
var $862faa6cda49c095$var$Ib = !1;
function $862faa6cda49c095$var$Jb(a, b, c) {
    if ($862faa6cda49c095$var$Ib) return a(b, c);
    $862faa6cda49c095$var$Ib = !0;
    try {
        return $862faa6cda49c095$var$Gb(a, b, c);
    } finally{
        if ($862faa6cda49c095$var$Ib = !1, null !== $862faa6cda49c095$var$zb || null !== $862faa6cda49c095$var$Ab) $862faa6cda49c095$var$Hb(), $862faa6cda49c095$var$Fb();
    }
}
function $862faa6cda49c095$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $862faa6cda49c095$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($862faa6cda49c095$var$p(231, b, typeof c));
    return c;
}
var $862faa6cda49c095$var$Lb = !1;
if ($862faa6cda49c095$var$ia) try {
    var $862faa6cda49c095$var$Mb = {};
    Object.defineProperty($862faa6cda49c095$var$Mb, "passive", {
        get: function() {
            $862faa6cda49c095$var$Lb = !0;
        }
    });
    window.addEventListener("test", $862faa6cda49c095$var$Mb, $862faa6cda49c095$var$Mb);
    window.removeEventListener("test", $862faa6cda49c095$var$Mb, $862faa6cda49c095$var$Mb);
} catch (a) {
    $862faa6cda49c095$var$Lb = !1;
}
function $862faa6cda49c095$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $862faa6cda49c095$var$Ob = !1, $862faa6cda49c095$var$Pb = null, $862faa6cda49c095$var$Qb = !1, $862faa6cda49c095$var$Rb = null, $862faa6cda49c095$var$Sb = {
    onError: function(a) {
        $862faa6cda49c095$var$Ob = !0;
        $862faa6cda49c095$var$Pb = a;
    }
};
function $862faa6cda49c095$var$Tb(a, b, c, d, e, f, g, h, k) {
    $862faa6cda49c095$var$Ob = !1;
    $862faa6cda49c095$var$Pb = null;
    $862faa6cda49c095$var$Nb.apply($862faa6cda49c095$var$Sb, arguments);
}
function $862faa6cda49c095$var$Ub(a, b, c, d, e, f, g, h, k) {
    $862faa6cda49c095$var$Tb.apply(this, arguments);
    if ($862faa6cda49c095$var$Ob) {
        if ($862faa6cda49c095$var$Ob) {
            var l = $862faa6cda49c095$var$Pb;
            $862faa6cda49c095$var$Ob = !1;
            $862faa6cda49c095$var$Pb = null;
        } else throw Error($862faa6cda49c095$var$p(198));
        $862faa6cda49c095$var$Qb || ($862faa6cda49c095$var$Qb = !0, $862faa6cda49c095$var$Rb = l);
    }
}
function $862faa6cda49c095$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $862faa6cda49c095$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $862faa6cda49c095$var$Xb(a) {
    if ($862faa6cda49c095$var$Vb(a) !== a) throw Error($862faa6cda49c095$var$p(188));
}
function $862faa6cda49c095$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $862faa6cda49c095$var$Vb(a);
        if (null === b) throw Error($862faa6cda49c095$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $862faa6cda49c095$var$Xb(e), a;
                if (f === d) return $862faa6cda49c095$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($862faa6cda49c095$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($862faa6cda49c095$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($862faa6cda49c095$var$p(190));
    }
    if (3 !== c.tag) throw Error($862faa6cda49c095$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $862faa6cda49c095$var$Zb(a) {
    a = $862faa6cda49c095$var$Yb(a);
    return null !== a ? $862faa6cda49c095$var$$b(a) : null;
}
function $862faa6cda49c095$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $862faa6cda49c095$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $862faa6cda49c095$var$ac = $8TTSu.unstable_scheduleCallback, $862faa6cda49c095$var$bc = $8TTSu.unstable_cancelCallback, $862faa6cda49c095$var$cc = $8TTSu.unstable_shouldYield, $862faa6cda49c095$var$dc = $8TTSu.unstable_requestPaint, $862faa6cda49c095$var$B = $8TTSu.unstable_now, $862faa6cda49c095$var$ec = $8TTSu.unstable_getCurrentPriorityLevel, $862faa6cda49c095$var$fc = $8TTSu.unstable_ImmediatePriority, $862faa6cda49c095$var$gc = $8TTSu.unstable_UserBlockingPriority, $862faa6cda49c095$var$hc = $8TTSu.unstable_NormalPriority, $862faa6cda49c095$var$ic = $8TTSu.unstable_LowPriority, $862faa6cda49c095$var$jc = $8TTSu.unstable_IdlePriority, $862faa6cda49c095$var$kc = null, $862faa6cda49c095$var$lc = null;
function $862faa6cda49c095$var$mc(a) {
    if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onCommitFiberRoot) try {
        $862faa6cda49c095$var$lc.onCommitFiberRoot($862faa6cda49c095$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $862faa6cda49c095$var$oc = Math.clz32 ? Math.clz32 : $862faa6cda49c095$var$nc, $862faa6cda49c095$var$pc = Math.log, $862faa6cda49c095$var$qc = Math.LN2;
function $862faa6cda49c095$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($862faa6cda49c095$var$pc(a) / $862faa6cda49c095$var$qc | 0) | 0;
}
var $862faa6cda49c095$var$rc = 64, $862faa6cda49c095$var$sc = 4194304;
function $862faa6cda49c095$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $862faa6cda49c095$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $862faa6cda49c095$var$tc(h) : (f &= g, 0 !== f && (d = $862faa6cda49c095$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $862faa6cda49c095$var$tc(g) : 0 !== f && (d = $862faa6cda49c095$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $862faa6cda49c095$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $862faa6cda49c095$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $862faa6cda49c095$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $862faa6cda49c095$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $862faa6cda49c095$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $862faa6cda49c095$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $862faa6cda49c095$var$yc() {
    var a = $862faa6cda49c095$var$rc;
    $862faa6cda49c095$var$rc <<= 1;
    0 === ($862faa6cda49c095$var$rc & 4194240) && ($862faa6cda49c095$var$rc = 64);
    return a;
}
function $862faa6cda49c095$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $862faa6cda49c095$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $862faa6cda49c095$var$oc(b);
    a[b] = c;
}
function $862faa6cda49c095$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $862faa6cda49c095$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $862faa6cda49c095$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $862faa6cda49c095$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $862faa6cda49c095$var$C = 0;
function $862faa6cda49c095$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $862faa6cda49c095$var$Ec, $862faa6cda49c095$var$Fc, $862faa6cda49c095$var$Gc, $862faa6cda49c095$var$Hc, $862faa6cda49c095$var$Ic, $862faa6cda49c095$var$Jc = !1, $862faa6cda49c095$var$Kc = [], $862faa6cda49c095$var$Lc = null, $862faa6cda49c095$var$Mc = null, $862faa6cda49c095$var$Nc = null, $862faa6cda49c095$var$Oc = new Map, $862faa6cda49c095$var$Pc = new Map, $862faa6cda49c095$var$Qc = [], $862faa6cda49c095$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $862faa6cda49c095$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $862faa6cda49c095$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $862faa6cda49c095$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $862faa6cda49c095$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $862faa6cda49c095$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $862faa6cda49c095$var$Pc.delete(b.pointerId);
    }
}
function $862faa6cda49c095$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $862faa6cda49c095$var$Cb(b), null !== b && $862faa6cda49c095$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $862faa6cda49c095$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $862faa6cda49c095$var$Lc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $862faa6cda49c095$var$Mc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $862faa6cda49c095$var$Nc = $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $862faa6cda49c095$var$Oc.set(f, $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $862faa6cda49c095$var$Pc.set(f, $862faa6cda49c095$var$Tc($862faa6cda49c095$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $862faa6cda49c095$var$Vc(a) {
    var b = $862faa6cda49c095$var$Wc(a.target);
    if (null !== b) {
        var c = $862faa6cda49c095$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $862faa6cda49c095$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $862faa6cda49c095$var$Ic(a.priority, function() {
                        $862faa6cda49c095$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $862faa6cda49c095$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $862faa6cda49c095$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $862faa6cda49c095$var$wb = d;
            c.target.dispatchEvent(d);
            $862faa6cda49c095$var$wb = null;
        } else return b = $862faa6cda49c095$var$Cb(c), null !== b && $862faa6cda49c095$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $862faa6cda49c095$var$Zc(a, b, c) {
    $862faa6cda49c095$var$Xc(a) && c.delete(b);
}
function $862faa6cda49c095$var$$c() {
    $862faa6cda49c095$var$Jc = !1;
    null !== $862faa6cda49c095$var$Lc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Lc) && ($862faa6cda49c095$var$Lc = null);
    null !== $862faa6cda49c095$var$Mc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Mc) && ($862faa6cda49c095$var$Mc = null);
    null !== $862faa6cda49c095$var$Nc && $862faa6cda49c095$var$Xc($862faa6cda49c095$var$Nc) && ($862faa6cda49c095$var$Nc = null);
    $862faa6cda49c095$var$Oc.forEach($862faa6cda49c095$var$Zc);
    $862faa6cda49c095$var$Pc.forEach($862faa6cda49c095$var$Zc);
}
function $862faa6cda49c095$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $862faa6cda49c095$var$Jc || ($862faa6cda49c095$var$Jc = !0, $8TTSu.unstable_scheduleCallback($8TTSu.unstable_NormalPriority, $862faa6cda49c095$var$$c)));
}
function $862faa6cda49c095$var$bd(a) {
    function b(b) {
        return $862faa6cda49c095$var$ad(b, a);
    }
    if (0 < $862faa6cda49c095$var$Kc.length) {
        $862faa6cda49c095$var$ad($862faa6cda49c095$var$Kc[0], a);
        for(var c = 1; c < $862faa6cda49c095$var$Kc.length; c++){
            var d = $862faa6cda49c095$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $862faa6cda49c095$var$Lc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Lc, a);
    null !== $862faa6cda49c095$var$Mc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Mc, a);
    null !== $862faa6cda49c095$var$Nc && $862faa6cda49c095$var$ad($862faa6cda49c095$var$Nc, a);
    $862faa6cda49c095$var$Oc.forEach(b);
    $862faa6cda49c095$var$Pc.forEach(b);
    for(c = 0; c < $862faa6cda49c095$var$Qc.length; c++)d = $862faa6cda49c095$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $862faa6cda49c095$var$Qc.length && (c = $862faa6cda49c095$var$Qc[0], null === c.blockedOn);)$862faa6cda49c095$var$Vc(c), null === c.blockedOn && $862faa6cda49c095$var$Qc.shift();
}
var $862faa6cda49c095$var$cd = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$dd = !0;
function $862faa6cda49c095$var$ed(a, b, c, d) {
    var e = $862faa6cda49c095$var$C, f = $862faa6cda49c095$var$cd.transition;
    $862faa6cda49c095$var$cd.transition = null;
    try {
        $862faa6cda49c095$var$C = 1, $862faa6cda49c095$var$fd(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$C = e, $862faa6cda49c095$var$cd.transition = f;
    }
}
function $862faa6cda49c095$var$gd(a, b, c, d) {
    var e = $862faa6cda49c095$var$C, f = $862faa6cda49c095$var$cd.transition;
    $862faa6cda49c095$var$cd.transition = null;
    try {
        $862faa6cda49c095$var$C = 4, $862faa6cda49c095$var$fd(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$C = e, $862faa6cda49c095$var$cd.transition = f;
    }
}
function $862faa6cda49c095$var$fd(a, b, c, d) {
    if ($862faa6cda49c095$var$dd) {
        var e = $862faa6cda49c095$var$Yc(a, b, c, d);
        if (null === e) $862faa6cda49c095$var$hd(a, b, d, $862faa6cda49c095$var$id, c), $862faa6cda49c095$var$Sc(a, d);
        else if ($862faa6cda49c095$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($862faa6cda49c095$var$Sc(a, d), b & 4 && -1 < $862faa6cda49c095$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $862faa6cda49c095$var$Cb(e);
                null !== f && $862faa6cda49c095$var$Ec(f);
                f = $862faa6cda49c095$var$Yc(a, b, c, d);
                null === f && $862faa6cda49c095$var$hd(a, b, d, $862faa6cda49c095$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $862faa6cda49c095$var$hd(a, b, d, null, c);
    }
}
var $862faa6cda49c095$var$id = null;
function $862faa6cda49c095$var$Yc(a, b, c, d) {
    $862faa6cda49c095$var$id = null;
    a = $862faa6cda49c095$var$xb(d);
    a = $862faa6cda49c095$var$Wc(a);
    if (null !== a) {
        if (b = $862faa6cda49c095$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $862faa6cda49c095$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $862faa6cda49c095$var$id = a;
    return null;
}
function $862faa6cda49c095$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($862faa6cda49c095$var$ec()){
                case $862faa6cda49c095$var$fc:
                    return 1;
                case $862faa6cda49c095$var$gc:
                    return 4;
                case $862faa6cda49c095$var$hc:
                case $862faa6cda49c095$var$ic:
                    return 16;
                case $862faa6cda49c095$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $862faa6cda49c095$var$kd = null, $862faa6cda49c095$var$ld = null, $862faa6cda49c095$var$md = null;
function $862faa6cda49c095$var$nd() {
    if ($862faa6cda49c095$var$md) return $862faa6cda49c095$var$md;
    var a, b = $862faa6cda49c095$var$ld, c = b.length, d, e = "value" in $862faa6cda49c095$var$kd ? $862faa6cda49c095$var$kd.value : $862faa6cda49c095$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $862faa6cda49c095$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $862faa6cda49c095$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $862faa6cda49c095$var$pd() {
    return !0;
}
function $862faa6cda49c095$var$qd() {
    return !1;
}
function $862faa6cda49c095$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $862faa6cda49c095$var$pd : $862faa6cda49c095$var$qd;
        this.isPropagationStopped = $862faa6cda49c095$var$qd;
        return this;
    }
    $862faa6cda49c095$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $862faa6cda49c095$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $862faa6cda49c095$var$pd);
        },
        persist: function() {},
        isPersistent: $862faa6cda49c095$var$pd
    });
    return b;
}
var $862faa6cda49c095$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $862faa6cda49c095$var$td = $862faa6cda49c095$var$rd($862faa6cda49c095$var$sd), $862faa6cda49c095$var$ud = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    view: 0,
    detail: 0
}), $862faa6cda49c095$var$vd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$ud), $862faa6cda49c095$var$wd, $862faa6cda49c095$var$xd, $862faa6cda49c095$var$yd, $862faa6cda49c095$var$Ad = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $862faa6cda49c095$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $862faa6cda49c095$var$yd && ($862faa6cda49c095$var$yd && "mousemove" === a.type ? ($862faa6cda49c095$var$wd = a.screenX - $862faa6cda49c095$var$yd.screenX, $862faa6cda49c095$var$xd = a.screenY - $862faa6cda49c095$var$yd.screenY) : $862faa6cda49c095$var$xd = $862faa6cda49c095$var$wd = 0, $862faa6cda49c095$var$yd = a);
        return $862faa6cda49c095$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $862faa6cda49c095$var$xd;
    }
}), $862faa6cda49c095$var$Bd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ad), $862faa6cda49c095$var$Cd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    dataTransfer: 0
}), $862faa6cda49c095$var$Dd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Cd), $862faa6cda49c095$var$Ed = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    relatedTarget: 0
}), $862faa6cda49c095$var$Fd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ed), $862faa6cda49c095$var$Gd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $862faa6cda49c095$var$Hd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Gd), $862faa6cda49c095$var$Id = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $862faa6cda49c095$var$Jd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Id), $862faa6cda49c095$var$Kd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    data: 0
}), $862faa6cda49c095$var$Ld = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Kd), $862faa6cda49c095$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $862faa6cda49c095$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $862faa6cda49c095$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $862faa6cda49c095$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $862faa6cda49c095$var$Od[a]) ? !!b[a] : !1;
}
function $862faa6cda49c095$var$zd() {
    return $862faa6cda49c095$var$Pd;
}
var $862faa6cda49c095$var$Qd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $862faa6cda49c095$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $862faa6cda49c095$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $862faa6cda49c095$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $862faa6cda49c095$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $862faa6cda49c095$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $862faa6cda49c095$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $862faa6cda49c095$var$Rd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Qd), $862faa6cda49c095$var$Sd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $862faa6cda49c095$var$Td = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Sd), $862faa6cda49c095$var$Ud = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $862faa6cda49c095$var$zd
}), $862faa6cda49c095$var$Vd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Ud), $862faa6cda49c095$var$Wd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $862faa6cda49c095$var$Xd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Wd), $862faa6cda49c095$var$Yd = $862faa6cda49c095$var$A({}, $862faa6cda49c095$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $862faa6cda49c095$var$Zd = $862faa6cda49c095$var$rd($862faa6cda49c095$var$Yd), $862faa6cda49c095$var$$d = [
    9,
    13,
    27,
    32
], $862faa6cda49c095$var$ae = $862faa6cda49c095$var$ia && "CompositionEvent" in window, $862faa6cda49c095$var$be = null;
$862faa6cda49c095$var$ia && "documentMode" in document && ($862faa6cda49c095$var$be = document.documentMode);
var $862faa6cda49c095$var$ce = $862faa6cda49c095$var$ia && "TextEvent" in window && !$862faa6cda49c095$var$be, $862faa6cda49c095$var$de = $862faa6cda49c095$var$ia && (!$862faa6cda49c095$var$ae || $862faa6cda49c095$var$be && 8 < $862faa6cda49c095$var$be && 11 >= $862faa6cda49c095$var$be), $862faa6cda49c095$var$ee = String.fromCharCode(32), $862faa6cda49c095$var$fe = !1;
function $862faa6cda49c095$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $862faa6cda49c095$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $862faa6cda49c095$var$ie = !1;
function $862faa6cda49c095$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $862faa6cda49c095$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $862faa6cda49c095$var$fe = !0;
            return $862faa6cda49c095$var$ee;
        case "textInput":
            return a = b.data, a === $862faa6cda49c095$var$ee && $862faa6cda49c095$var$fe ? null : a;
        default:
            return null;
    }
}
function $862faa6cda49c095$var$ke(a, b) {
    if ($862faa6cda49c095$var$ie) return "compositionend" === a || !$862faa6cda49c095$var$ae && $862faa6cda49c095$var$ge(a, b) ? (a = $862faa6cda49c095$var$nd(), $862faa6cda49c095$var$md = $862faa6cda49c095$var$ld = $862faa6cda49c095$var$kd = null, $862faa6cda49c095$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $862faa6cda49c095$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $862faa6cda49c095$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $862faa6cda49c095$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$862faa6cda49c095$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $862faa6cda49c095$var$ne(a, b, c, d) {
    $862faa6cda49c095$var$Eb(d);
    b = $862faa6cda49c095$var$oe(b, "onChange");
    0 < b.length && (c = new $862faa6cda49c095$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $862faa6cda49c095$var$pe = null, $862faa6cda49c095$var$qe = null;
function $862faa6cda49c095$var$re(a) {
    $862faa6cda49c095$var$se(a, 0);
}
function $862faa6cda49c095$var$te(a) {
    var b = $862faa6cda49c095$var$ue(a);
    if ($862faa6cda49c095$var$Wa(b)) return a;
}
function $862faa6cda49c095$var$ve(a, b) {
    if ("change" === a) return b;
}
var $862faa6cda49c095$var$we = !1;
if ($862faa6cda49c095$var$ia) {
    var $862faa6cda49c095$var$xe;
    if ($862faa6cda49c095$var$ia) {
        var $862faa6cda49c095$var$ye = "oninput" in document;
        if (!$862faa6cda49c095$var$ye) {
            var $862faa6cda49c095$var$ze = document.createElement("div");
            $862faa6cda49c095$var$ze.setAttribute("oninput", "return;");
            $862faa6cda49c095$var$ye = "function" === typeof $862faa6cda49c095$var$ze.oninput;
        }
        $862faa6cda49c095$var$xe = $862faa6cda49c095$var$ye;
    } else $862faa6cda49c095$var$xe = !1;
    $862faa6cda49c095$var$we = $862faa6cda49c095$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $862faa6cda49c095$var$Ae() {
    $862faa6cda49c095$var$pe && ($862faa6cda49c095$var$pe.detachEvent("onpropertychange", $862faa6cda49c095$var$Be), $862faa6cda49c095$var$qe = $862faa6cda49c095$var$pe = null);
}
function $862faa6cda49c095$var$Be(a) {
    if ("value" === a.propertyName && $862faa6cda49c095$var$te($862faa6cda49c095$var$qe)) {
        var b = [];
        $862faa6cda49c095$var$ne(b, $862faa6cda49c095$var$qe, a, $862faa6cda49c095$var$xb(a));
        $862faa6cda49c095$var$Jb($862faa6cda49c095$var$re, b);
    }
}
function $862faa6cda49c095$var$Ce(a, b, c) {
    "focusin" === a ? ($862faa6cda49c095$var$Ae(), $862faa6cda49c095$var$pe = b, $862faa6cda49c095$var$qe = c, $862faa6cda49c095$var$pe.attachEvent("onpropertychange", $862faa6cda49c095$var$Be)) : "focusout" === a && $862faa6cda49c095$var$Ae();
}
function $862faa6cda49c095$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $862faa6cda49c095$var$te($862faa6cda49c095$var$qe);
}
function $862faa6cda49c095$var$Ee(a, b) {
    if ("click" === a) return $862faa6cda49c095$var$te(b);
}
function $862faa6cda49c095$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $862faa6cda49c095$var$te(b);
}
function $862faa6cda49c095$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $862faa6cda49c095$var$He = "function" === typeof Object.is ? Object.is : $862faa6cda49c095$var$Ge;
function $862faa6cda49c095$var$Ie(a, b) {
    if ($862faa6cda49c095$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$862faa6cda49c095$var$ja.call(b, e) || !$862faa6cda49c095$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $862faa6cda49c095$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $862faa6cda49c095$var$Ke(a, b) {
    var c = $862faa6cda49c095$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $862faa6cda49c095$var$Je(c);
    }
}
function $862faa6cda49c095$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $862faa6cda49c095$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $862faa6cda49c095$var$Me() {
    for(var a = window, b = $862faa6cda49c095$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $862faa6cda49c095$var$Xa(a.document);
    }
    return b;
}
function $862faa6cda49c095$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $862faa6cda49c095$var$Oe(a) {
    var b = $862faa6cda49c095$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $862faa6cda49c095$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $862faa6cda49c095$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $862faa6cda49c095$var$Ke(c, f);
                var g = $862faa6cda49c095$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $862faa6cda49c095$var$Pe = $862faa6cda49c095$var$ia && "documentMode" in document && 11 >= document.documentMode, $862faa6cda49c095$var$Qe = null, $862faa6cda49c095$var$Re = null, $862faa6cda49c095$var$Se = null, $862faa6cda49c095$var$Te = !1;
function $862faa6cda49c095$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $862faa6cda49c095$var$Te || null == $862faa6cda49c095$var$Qe || $862faa6cda49c095$var$Qe !== $862faa6cda49c095$var$Xa(d) || (d = $862faa6cda49c095$var$Qe, "selectionStart" in d && $862faa6cda49c095$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $862faa6cda49c095$var$Se && $862faa6cda49c095$var$Ie($862faa6cda49c095$var$Se, d) || ($862faa6cda49c095$var$Se = d, d = $862faa6cda49c095$var$oe($862faa6cda49c095$var$Re, "onSelect"), 0 < d.length && (b = new $862faa6cda49c095$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $862faa6cda49c095$var$Qe)));
}
function $862faa6cda49c095$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $862faa6cda49c095$var$We = {
    animationend: $862faa6cda49c095$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $862faa6cda49c095$var$Ve("Animation", "AnimationIteration"),
    animationstart: $862faa6cda49c095$var$Ve("Animation", "AnimationStart"),
    transitionend: $862faa6cda49c095$var$Ve("Transition", "TransitionEnd")
}, $862faa6cda49c095$var$Xe = {}, $862faa6cda49c095$var$Ye = {};
$862faa6cda49c095$var$ia && ($862faa6cda49c095$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $862faa6cda49c095$var$We.animationend.animation, delete $862faa6cda49c095$var$We.animationiteration.animation, delete $862faa6cda49c095$var$We.animationstart.animation), "TransitionEvent" in window || delete $862faa6cda49c095$var$We.transitionend.transition);
function $862faa6cda49c095$var$Ze(a) {
    if ($862faa6cda49c095$var$Xe[a]) return $862faa6cda49c095$var$Xe[a];
    if (!$862faa6cda49c095$var$We[a]) return a;
    var b = $862faa6cda49c095$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $862faa6cda49c095$var$Ye) return $862faa6cda49c095$var$Xe[a] = b[c];
    return a;
}
var $862faa6cda49c095$var$$e = $862faa6cda49c095$var$Ze("animationend"), $862faa6cda49c095$var$af = $862faa6cda49c095$var$Ze("animationiteration"), $862faa6cda49c095$var$bf = $862faa6cda49c095$var$Ze("animationstart"), $862faa6cda49c095$var$cf = $862faa6cda49c095$var$Ze("transitionend"), $862faa6cda49c095$var$df = new Map, $862faa6cda49c095$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $862faa6cda49c095$var$ff(a, b) {
    $862faa6cda49c095$var$df.set(a, b);
    $862faa6cda49c095$var$fa(b, [
        a
    ]);
}
for(var $862faa6cda49c095$var$gf = 0; $862faa6cda49c095$var$gf < $862faa6cda49c095$var$ef.length; $862faa6cda49c095$var$gf++){
    var $862faa6cda49c095$var$hf = $862faa6cda49c095$var$ef[$862faa6cda49c095$var$gf], $862faa6cda49c095$var$jf = $862faa6cda49c095$var$hf.toLowerCase(), $862faa6cda49c095$var$kf = $862faa6cda49c095$var$hf[0].toUpperCase() + $862faa6cda49c095$var$hf.slice(1);
    $862faa6cda49c095$var$ff($862faa6cda49c095$var$jf, "on" + $862faa6cda49c095$var$kf);
}
$862faa6cda49c095$var$ff($862faa6cda49c095$var$$e, "onAnimationEnd");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$af, "onAnimationIteration");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$bf, "onAnimationStart");
$862faa6cda49c095$var$ff("dblclick", "onDoubleClick");
$862faa6cda49c095$var$ff("focusin", "onFocus");
$862faa6cda49c095$var$ff("focusout", "onBlur");
$862faa6cda49c095$var$ff($862faa6cda49c095$var$cf, "onTransitionEnd");
$862faa6cda49c095$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$862faa6cda49c095$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$862faa6cda49c095$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$862faa6cda49c095$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$862faa6cda49c095$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$862faa6cda49c095$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$862faa6cda49c095$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$862faa6cda49c095$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$862faa6cda49c095$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$862faa6cda49c095$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $862faa6cda49c095$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $862faa6cda49c095$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($862faa6cda49c095$var$lf));
function $862faa6cda49c095$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $862faa6cda49c095$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $862faa6cda49c095$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $862faa6cda49c095$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $862faa6cda49c095$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($862faa6cda49c095$var$Qb) throw a = $862faa6cda49c095$var$Rb, $862faa6cda49c095$var$Qb = !1, $862faa6cda49c095$var$Rb = null, a;
}
function $862faa6cda49c095$var$D(a, b) {
    var c = b[$862faa6cda49c095$var$of];
    void 0 === c && (c = b[$862faa6cda49c095$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($862faa6cda49c095$var$pf(b, a, 2, !1), c.add(d));
}
function $862faa6cda49c095$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $862faa6cda49c095$var$pf(c, a, d, b);
}
var $862faa6cda49c095$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $862faa6cda49c095$var$sf(a) {
    if (!a[$862faa6cda49c095$var$rf]) {
        a[$862faa6cda49c095$var$rf] = !0;
        $862faa6cda49c095$var$da.forEach(function(b) {
            "selectionchange" !== b && ($862faa6cda49c095$var$mf.has(b) || $862faa6cda49c095$var$qf(b, !1, a), $862faa6cda49c095$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$862faa6cda49c095$var$rf] || (b[$862faa6cda49c095$var$rf] = !0, $862faa6cda49c095$var$qf("selectionchange", !1, b));
    }
}
function $862faa6cda49c095$var$pf(a, b, c, d) {
    switch($862faa6cda49c095$var$jd(b)){
        case 1:
            var e = $862faa6cda49c095$var$ed;
            break;
        case 4:
            e = $862faa6cda49c095$var$gd;
            break;
        default:
            e = $862faa6cda49c095$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$862faa6cda49c095$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $862faa6cda49c095$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $862faa6cda49c095$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $862faa6cda49c095$var$Jb(function() {
        var d = f, e = $862faa6cda49c095$var$xb(c), g = [];
        a: {
            var h = $862faa6cda49c095$var$df.get(a);
            if (void 0 !== h) {
                var k = $862faa6cda49c095$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $862faa6cda49c095$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $862faa6cda49c095$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $862faa6cda49c095$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $862faa6cda49c095$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $862faa6cda49c095$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $862faa6cda49c095$var$Vd;
                        break;
                    case $862faa6cda49c095$var$$e:
                    case $862faa6cda49c095$var$af:
                    case $862faa6cda49c095$var$bf:
                        k = $862faa6cda49c095$var$Hd;
                        break;
                    case $862faa6cda49c095$var$cf:
                        k = $862faa6cda49c095$var$Xd;
                        break;
                    case "scroll":
                        k = $862faa6cda49c095$var$vd;
                        break;
                    case "wheel":
                        k = $862faa6cda49c095$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $862faa6cda49c095$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $862faa6cda49c095$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $862faa6cda49c095$var$Kb(w, x), null != F && t.push($862faa6cda49c095$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $862faa6cda49c095$var$wb && (n = c.relatedTarget || c.fromElement) && ($862faa6cda49c095$var$Wc(n) || n[$862faa6cda49c095$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $862faa6cda49c095$var$Wc(n) : null, null !== n && (J = $862faa6cda49c095$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $862faa6cda49c095$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $862faa6cda49c095$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $862faa6cda49c095$var$ue(k);
                        u = null == n ? h : $862faa6cda49c095$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $862faa6cda49c095$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $862faa6cda49c095$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $862faa6cda49c095$var$vf(F))u++;
                            for(; 0 < w - u;)t = $862faa6cda49c095$var$vf(t), w--;
                            for(; 0 < u - w;)x = $862faa6cda49c095$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $862faa6cda49c095$var$vf(t);
                                x = $862faa6cda49c095$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $862faa6cda49c095$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $862faa6cda49c095$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $862faa6cda49c095$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $862faa6cda49c095$var$ve;
                else if ($862faa6cda49c095$var$me(h)) {
                    if ($862faa6cda49c095$var$we) na = $862faa6cda49c095$var$Fe;
                    else {
                        na = $862faa6cda49c095$var$De;
                        var xa = $862faa6cda49c095$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $862faa6cda49c095$var$Ee);
                if (na && (na = na(a, d))) {
                    $862faa6cda49c095$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $862faa6cda49c095$var$cb(h, "number", h.value);
            }
            xa = d ? $862faa6cda49c095$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($862faa6cda49c095$var$me(xa) || "true" === xa.contentEditable) $862faa6cda49c095$var$Qe = xa, $862faa6cda49c095$var$Re = d, $862faa6cda49c095$var$Se = null;
                    break;
                case "focusout":
                    $862faa6cda49c095$var$Se = $862faa6cda49c095$var$Re = $862faa6cda49c095$var$Qe = null;
                    break;
                case "mousedown":
                    $862faa6cda49c095$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $862faa6cda49c095$var$Te = !1;
                    $862faa6cda49c095$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($862faa6cda49c095$var$Pe) break;
                case "keydown":
                case "keyup":
                    $862faa6cda49c095$var$Ue(g, c, e);
            }
            var $a;
            if ($862faa6cda49c095$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $862faa6cda49c095$var$ie ? $862faa6cda49c095$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($862faa6cda49c095$var$de && "ko" !== c.locale && ($862faa6cda49c095$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $862faa6cda49c095$var$ie && ($a = $862faa6cda49c095$var$nd()) : ($862faa6cda49c095$var$kd = e, $862faa6cda49c095$var$ld = "value" in $862faa6cda49c095$var$kd ? $862faa6cda49c095$var$kd.value : $862faa6cda49c095$var$kd.textContent, $862faa6cda49c095$var$ie = !0)), xa = $862faa6cda49c095$var$oe(d, ba), 0 < xa.length && (ba = new $862faa6cda49c095$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $862faa6cda49c095$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $862faa6cda49c095$var$ce ? $862faa6cda49c095$var$je(a, c) : $862faa6cda49c095$var$ke(a, c)) d = $862faa6cda49c095$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $862faa6cda49c095$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $862faa6cda49c095$var$se(g, b);
    });
}
function $862faa6cda49c095$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $862faa6cda49c095$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $862faa6cda49c095$var$Kb(a, c), null != f && d.unshift($862faa6cda49c095$var$tf(a, f, e)), f = $862faa6cda49c095$var$Kb(a, b), null != f && d.push($862faa6cda49c095$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $862faa6cda49c095$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $862faa6cda49c095$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $862faa6cda49c095$var$Kb(c, f), null != k && g.unshift($862faa6cda49c095$var$tf(c, k, h))) : e || (k = $862faa6cda49c095$var$Kb(c, f), null != k && g.push($862faa6cda49c095$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $862faa6cda49c095$var$xf = /\r\n?/g, $862faa6cda49c095$var$yf = /\u0000|\uFFFD/g;
function $862faa6cda49c095$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($862faa6cda49c095$var$xf, "\n").replace($862faa6cda49c095$var$yf, "");
}
function $862faa6cda49c095$var$Af(a, b, c) {
    b = $862faa6cda49c095$var$zf(b);
    if ($862faa6cda49c095$var$zf(a) !== b && c) throw Error($862faa6cda49c095$var$p(425));
}
function $862faa6cda49c095$var$Bf() {}
var $862faa6cda49c095$var$Cf = null, $862faa6cda49c095$var$Df = null;
function $862faa6cda49c095$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $862faa6cda49c095$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $862faa6cda49c095$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $862faa6cda49c095$var$Hf = "function" === typeof Promise ? Promise : void 0, $862faa6cda49c095$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $862faa6cda49c095$var$Hf ? function(a) {
    return $862faa6cda49c095$var$Hf.resolve(null).then(a).catch($862faa6cda49c095$var$If);
} : $862faa6cda49c095$var$Ff;
function $862faa6cda49c095$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $862faa6cda49c095$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $862faa6cda49c095$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $862faa6cda49c095$var$bd(b);
}
function $862faa6cda49c095$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $862faa6cda49c095$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $862faa6cda49c095$var$Nf = Math.random().toString(36).slice(2), $862faa6cda49c095$var$Of = "__reactFiber$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Pf = "__reactProps$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$uf = "__reactContainer$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$of = "__reactEvents$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Qf = "__reactListeners$" + $862faa6cda49c095$var$Nf, $862faa6cda49c095$var$Rf = "__reactHandles$" + $862faa6cda49c095$var$Nf;
function $862faa6cda49c095$var$Wc(a) {
    var b = a[$862faa6cda49c095$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$862faa6cda49c095$var$uf] || c[$862faa6cda49c095$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $862faa6cda49c095$var$Mf(a); null !== a;){
                if (c = a[$862faa6cda49c095$var$Of]) return c;
                a = $862faa6cda49c095$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $862faa6cda49c095$var$Cb(a) {
    a = a[$862faa6cda49c095$var$Of] || a[$862faa6cda49c095$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $862faa6cda49c095$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($862faa6cda49c095$var$p(33));
}
function $862faa6cda49c095$var$Db(a) {
    return a[$862faa6cda49c095$var$Pf] || null;
}
var $862faa6cda49c095$var$Sf = [], $862faa6cda49c095$var$Tf = -1;
function $862faa6cda49c095$var$Uf(a) {
    return {
        current: a
    };
}
function $862faa6cda49c095$var$E(a) {
    0 > $862faa6cda49c095$var$Tf || (a.current = $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf], $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf] = null, $862faa6cda49c095$var$Tf--);
}
function $862faa6cda49c095$var$G(a, b) {
    $862faa6cda49c095$var$Tf++;
    $862faa6cda49c095$var$Sf[$862faa6cda49c095$var$Tf] = a.current;
    a.current = b;
}
var $862faa6cda49c095$var$Vf = {}, $862faa6cda49c095$var$H = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$Vf), $862faa6cda49c095$var$Wf = $862faa6cda49c095$var$Uf(!1), $862faa6cda49c095$var$Xf = $862faa6cda49c095$var$Vf;
function $862faa6cda49c095$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $862faa6cda49c095$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $862faa6cda49c095$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $862faa6cda49c095$var$$f() {
    $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
}
function $862faa6cda49c095$var$ag(a, b, c) {
    if ($862faa6cda49c095$var$H.current !== $862faa6cda49c095$var$Vf) throw Error($862faa6cda49c095$var$p(168));
    $862faa6cda49c095$var$G($862faa6cda49c095$var$H, b);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, c);
}
function $862faa6cda49c095$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($862faa6cda49c095$var$p(108, $862faa6cda49c095$var$Ra(a) || "Unknown", e));
    return $862faa6cda49c095$var$A({}, c, d);
}
function $862faa6cda49c095$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $862faa6cda49c095$var$Vf;
    $862faa6cda49c095$var$Xf = $862faa6cda49c095$var$H.current;
    $862faa6cda49c095$var$G($862faa6cda49c095$var$H, a);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, $862faa6cda49c095$var$Wf.current);
    return !0;
}
function $862faa6cda49c095$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($862faa6cda49c095$var$p(169));
    c ? (a = $862faa6cda49c095$var$bg(a, b, $862faa6cda49c095$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf), $862faa6cda49c095$var$E($862faa6cda49c095$var$H), $862faa6cda49c095$var$G($862faa6cda49c095$var$H, a)) : $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$Wf, c);
}
var $862faa6cda49c095$var$eg = null, $862faa6cda49c095$var$fg = !1, $862faa6cda49c095$var$gg = !1;
function $862faa6cda49c095$var$hg(a) {
    null === $862faa6cda49c095$var$eg ? $862faa6cda49c095$var$eg = [
        a
    ] : $862faa6cda49c095$var$eg.push(a);
}
function $862faa6cda49c095$var$ig(a) {
    $862faa6cda49c095$var$fg = !0;
    $862faa6cda49c095$var$hg(a);
}
function $862faa6cda49c095$var$jg() {
    if (!$862faa6cda49c095$var$gg && null !== $862faa6cda49c095$var$eg) {
        $862faa6cda49c095$var$gg = !0;
        var a = 0, b = $862faa6cda49c095$var$C;
        try {
            var c = $862faa6cda49c095$var$eg;
            for($862faa6cda49c095$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $862faa6cda49c095$var$eg = null;
            $862faa6cda49c095$var$fg = !1;
        } catch (e) {
            throw null !== $862faa6cda49c095$var$eg && ($862faa6cda49c095$var$eg = $862faa6cda49c095$var$eg.slice(a + 1)), $862faa6cda49c095$var$ac($862faa6cda49c095$var$fc, $862faa6cda49c095$var$jg), e;
        } finally{
            $862faa6cda49c095$var$C = b, $862faa6cda49c095$var$gg = !1;
        }
    }
    return null;
}
var $862faa6cda49c095$var$kg = [], $862faa6cda49c095$var$lg = 0, $862faa6cda49c095$var$mg = null, $862faa6cda49c095$var$ng = 0, $862faa6cda49c095$var$og = [], $862faa6cda49c095$var$pg = 0, $862faa6cda49c095$var$qg = null, $862faa6cda49c095$var$rg = 1, $862faa6cda49c095$var$sg = "";
function $862faa6cda49c095$var$tg(a, b) {
    $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg++] = $862faa6cda49c095$var$ng;
    $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg++] = $862faa6cda49c095$var$mg;
    $862faa6cda49c095$var$mg = a;
    $862faa6cda49c095$var$ng = b;
}
function $862faa6cda49c095$var$ug(a, b, c) {
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$rg;
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$sg;
    $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$qg;
    $862faa6cda49c095$var$qg = a;
    var d = $862faa6cda49c095$var$rg;
    a = $862faa6cda49c095$var$sg;
    var e = 32 - $862faa6cda49c095$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $862faa6cda49c095$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $862faa6cda49c095$var$rg = 1 << 32 - $862faa6cda49c095$var$oc(b) + e | c << e | d;
        $862faa6cda49c095$var$sg = f + a;
    } else $862faa6cda49c095$var$rg = 1 << f | c << e | d, $862faa6cda49c095$var$sg = a;
}
function $862faa6cda49c095$var$vg(a) {
    null !== a.return && ($862faa6cda49c095$var$tg(a, 1), $862faa6cda49c095$var$ug(a, 1, 0));
}
function $862faa6cda49c095$var$wg(a) {
    for(; a === $862faa6cda49c095$var$mg;)$862faa6cda49c095$var$mg = $862faa6cda49c095$var$kg[--$862faa6cda49c095$var$lg], $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg] = null, $862faa6cda49c095$var$ng = $862faa6cda49c095$var$kg[--$862faa6cda49c095$var$lg], $862faa6cda49c095$var$kg[$862faa6cda49c095$var$lg] = null;
    for(; a === $862faa6cda49c095$var$qg;)$862faa6cda49c095$var$qg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null, $862faa6cda49c095$var$sg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null, $862faa6cda49c095$var$rg = $862faa6cda49c095$var$og[--$862faa6cda49c095$var$pg], $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg] = null;
}
var $862faa6cda49c095$var$xg = null, $862faa6cda49c095$var$yg = null, $862faa6cda49c095$var$I = !1, $862faa6cda49c095$var$zg = null;
function $862faa6cda49c095$var$Ag(a, b) {
    var c = $862faa6cda49c095$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $862faa6cda49c095$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $862faa6cda49c095$var$qg ? {
                id: $862faa6cda49c095$var$rg,
                overflow: $862faa6cda49c095$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $862faa6cda49c095$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $862faa6cda49c095$var$xg = a, $862faa6cda49c095$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $862faa6cda49c095$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $862faa6cda49c095$var$Eg(a) {
    if ($862faa6cda49c095$var$I) {
        var b = $862faa6cda49c095$var$yg;
        if (b) {
            var c = b;
            if (!$862faa6cda49c095$var$Cg(a, b)) {
                if ($862faa6cda49c095$var$Dg(a)) throw Error($862faa6cda49c095$var$p(418));
                b = $862faa6cda49c095$var$Lf(c.nextSibling);
                var d = $862faa6cda49c095$var$xg;
                b && $862faa6cda49c095$var$Cg(a, b) ? $862faa6cda49c095$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $862faa6cda49c095$var$I = !1, $862faa6cda49c095$var$xg = a);
            }
        } else {
            if ($862faa6cda49c095$var$Dg(a)) throw Error($862faa6cda49c095$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $862faa6cda49c095$var$I = !1;
            $862faa6cda49c095$var$xg = a;
        }
    }
}
function $862faa6cda49c095$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $862faa6cda49c095$var$xg = a;
}
function $862faa6cda49c095$var$Gg(a) {
    if (a !== $862faa6cda49c095$var$xg) return !1;
    if (!$862faa6cda49c095$var$I) return $862faa6cda49c095$var$Fg(a), $862faa6cda49c095$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$862faa6cda49c095$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $862faa6cda49c095$var$yg)) {
        if ($862faa6cda49c095$var$Dg(a)) throw $862faa6cda49c095$var$Hg(), Error($862faa6cda49c095$var$p(418));
        for(; b;)$862faa6cda49c095$var$Ag(a, b), b = $862faa6cda49c095$var$Lf(b.nextSibling);
    }
    $862faa6cda49c095$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($862faa6cda49c095$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $862faa6cda49c095$var$yg = null;
        }
    } else $862faa6cda49c095$var$yg = $862faa6cda49c095$var$xg ? $862faa6cda49c095$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $862faa6cda49c095$var$Hg() {
    for(var a = $862faa6cda49c095$var$yg; a;)a = $862faa6cda49c095$var$Lf(a.nextSibling);
}
function $862faa6cda49c095$var$Ig() {
    $862faa6cda49c095$var$yg = $862faa6cda49c095$var$xg = null;
    $862faa6cda49c095$var$I = !1;
}
function $862faa6cda49c095$var$Jg(a) {
    null === $862faa6cda49c095$var$zg ? $862faa6cda49c095$var$zg = [
        a
    ] : $862faa6cda49c095$var$zg.push(a);
}
var $862faa6cda49c095$var$Kg = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig;
function $862faa6cda49c095$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($862faa6cda49c095$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($862faa6cda49c095$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($862faa6cda49c095$var$p(284));
        if (!c._owner) throw Error($862faa6cda49c095$var$p(290, a));
    }
    return a;
}
function $862faa6cda49c095$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($862faa6cda49c095$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $862faa6cda49c095$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $862faa6cda49c095$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $862faa6cda49c095$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $862faa6cda49c095$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $862faa6cda49c095$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $862faa6cda49c095$var$Ha && $862faa6cda49c095$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $862faa6cda49c095$var$Lg(a, b, c), d.return = a, d;
        d = $862faa6cda49c095$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $862faa6cda49c095$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $862faa6cda49c095$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $862faa6cda49c095$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $862faa6cda49c095$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $862faa6cda49c095$var$va:
                    return c = $862faa6cda49c095$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $862faa6cda49c095$var$Lg(a, null, b), c.return = a, c;
                case $862faa6cda49c095$var$wa:
                    return b = $862faa6cda49c095$var$Sg(b, a.mode, c), b.return = a, b;
                case $862faa6cda49c095$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($862faa6cda49c095$var$eb(b) || $862faa6cda49c095$var$Ka(b)) return b = $862faa6cda49c095$var$Tg(b, a.mode, c, null), b.return = a, b;
            $862faa6cda49c095$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $862faa6cda49c095$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $862faa6cda49c095$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $862faa6cda49c095$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($862faa6cda49c095$var$eb(c) || $862faa6cda49c095$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $862faa6cda49c095$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $862faa6cda49c095$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $862faa6cda49c095$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $862faa6cda49c095$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($862faa6cda49c095$var$eb(d) || $862faa6cda49c095$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $862faa6cda49c095$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $862faa6cda49c095$var$Ka(h);
        if ("function" !== typeof l) throw Error($862faa6cda49c095$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($862faa6cda49c095$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $862faa6cda49c095$var$I && $862faa6cda49c095$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $862faa6cda49c095$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $862faa6cda49c095$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $862faa6cda49c095$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $862faa6cda49c095$var$Ha && $862faa6cda49c095$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $862faa6cda49c095$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $862faa6cda49c095$var$ya ? (d = $862faa6cda49c095$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $862faa6cda49c095$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $862faa6cda49c095$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $862faa6cda49c095$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $862faa6cda49c095$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $862faa6cda49c095$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($862faa6cda49c095$var$eb(f)) return n(a, d, f, h);
            if ($862faa6cda49c095$var$Ka(f)) return t(a, d, f, h);
            $862faa6cda49c095$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $862faa6cda49c095$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $862faa6cda49c095$var$Ug = $862faa6cda49c095$var$Og(!0), $862faa6cda49c095$var$Vg = $862faa6cda49c095$var$Og(!1), $862faa6cda49c095$var$Wg = $862faa6cda49c095$var$Uf(null), $862faa6cda49c095$var$Xg = null, $862faa6cda49c095$var$Yg = null, $862faa6cda49c095$var$Zg = null;
function $862faa6cda49c095$var$$g() {
    $862faa6cda49c095$var$Zg = $862faa6cda49c095$var$Yg = $862faa6cda49c095$var$Xg = null;
}
function $862faa6cda49c095$var$ah(a) {
    var b = $862faa6cda49c095$var$Wg.current;
    $862faa6cda49c095$var$E($862faa6cda49c095$var$Wg);
    a._currentValue = b;
}
function $862faa6cda49c095$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $862faa6cda49c095$var$ch(a, b) {
    $862faa6cda49c095$var$Xg = a;
    $862faa6cda49c095$var$Zg = $862faa6cda49c095$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($862faa6cda49c095$var$dh = !0), a.firstContext = null);
}
function $862faa6cda49c095$var$eh(a) {
    var b = a._currentValue;
    if ($862faa6cda49c095$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $862faa6cda49c095$var$Yg) {
            if (null === $862faa6cda49c095$var$Xg) throw Error($862faa6cda49c095$var$p(308));
            $862faa6cda49c095$var$Yg = a;
            $862faa6cda49c095$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $862faa6cda49c095$var$Yg = $862faa6cda49c095$var$Yg.next = a;
    }
    return b;
}
var $862faa6cda49c095$var$fh = null;
function $862faa6cda49c095$var$gh(a) {
    null === $862faa6cda49c095$var$fh ? $862faa6cda49c095$var$fh = [
        a
    ] : $862faa6cda49c095$var$fh.push(a);
}
function $862faa6cda49c095$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $862faa6cda49c095$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $862faa6cda49c095$var$ih(a, d);
}
function $862faa6cda49c095$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $862faa6cda49c095$var$jh = !1;
function $862faa6cda49c095$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $862faa6cda49c095$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $862faa6cda49c095$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $862faa6cda49c095$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($862faa6cda49c095$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $862faa6cda49c095$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $862faa6cda49c095$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $862faa6cda49c095$var$ih(a, c);
}
function $862faa6cda49c095$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $862faa6cda49c095$var$Cc(a, c);
    }
}
function $862faa6cda49c095$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $862faa6cda49c095$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $862faa6cda49c095$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $862faa6cda49c095$var$A({}, q, r);
                            break a;
                        case 2:
                            $862faa6cda49c095$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $862faa6cda49c095$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $862faa6cda49c095$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($862faa6cda49c095$var$p(191, e));
            e.call(d);
        }
    }
}
var $862faa6cda49c095$var$th = {}, $862faa6cda49c095$var$uh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th), $862faa6cda49c095$var$vh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th), $862faa6cda49c095$var$wh = $862faa6cda49c095$var$Uf($862faa6cda49c095$var$th);
function $862faa6cda49c095$var$xh(a) {
    if (a === $862faa6cda49c095$var$th) throw Error($862faa6cda49c095$var$p(174));
    return a;
}
function $862faa6cda49c095$var$yh(a, b) {
    $862faa6cda49c095$var$G($862faa6cda49c095$var$wh, b);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$vh, a);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, $862faa6cda49c095$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $862faa6cda49c095$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $862faa6cda49c095$var$lb(b, a);
    }
    $862faa6cda49c095$var$E($862faa6cda49c095$var$uh);
    $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, b);
}
function $862faa6cda49c095$var$zh() {
    $862faa6cda49c095$var$E($862faa6cda49c095$var$uh);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$vh);
    $862faa6cda49c095$var$E($862faa6cda49c095$var$wh);
}
function $862faa6cda49c095$var$Ah(a) {
    $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
    var b = $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
    var c = $862faa6cda49c095$var$lb(b, a.type);
    b !== c && ($862faa6cda49c095$var$G($862faa6cda49c095$var$vh, a), $862faa6cda49c095$var$G($862faa6cda49c095$var$uh, c));
}
function $862faa6cda49c095$var$Bh(a) {
    $862faa6cda49c095$var$vh.current === a && ($862faa6cda49c095$var$E($862faa6cda49c095$var$uh), $862faa6cda49c095$var$E($862faa6cda49c095$var$vh));
}
var $862faa6cda49c095$var$L = $862faa6cda49c095$var$Uf(0);
function $862faa6cda49c095$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $862faa6cda49c095$var$Dh = [];
function $862faa6cda49c095$var$Eh() {
    for(var a = 0; a < $862faa6cda49c095$var$Dh.length; a++)$862faa6cda49c095$var$Dh[a]._workInProgressVersionPrimary = null;
    $862faa6cda49c095$var$Dh.length = 0;
}
var $862faa6cda49c095$var$Fh = $862faa6cda49c095$var$ua.ReactCurrentDispatcher, $862faa6cda49c095$var$Gh = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$Hh = 0, $862faa6cda49c095$var$M = null, $862faa6cda49c095$var$N = null, $862faa6cda49c095$var$O = null, $862faa6cda49c095$var$Ih = !1, $862faa6cda49c095$var$Jh = !1, $862faa6cda49c095$var$Kh = 0, $862faa6cda49c095$var$Lh = 0;
function $862faa6cda49c095$var$P() {
    throw Error($862faa6cda49c095$var$p(321));
}
function $862faa6cda49c095$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$862faa6cda49c095$var$He(a[c], b[c])) return !1;
    return !0;
}
function $862faa6cda49c095$var$Nh(a, b, c, d, e, f) {
    $862faa6cda49c095$var$Hh = f;
    $862faa6cda49c095$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $862faa6cda49c095$var$Fh.current = null === a || null === a.memoizedState ? $862faa6cda49c095$var$Oh : $862faa6cda49c095$var$Ph;
    a = c(d, e);
    if ($862faa6cda49c095$var$Jh) {
        f = 0;
        do {
            $862faa6cda49c095$var$Jh = !1;
            $862faa6cda49c095$var$Kh = 0;
            if (25 <= f) throw Error($862faa6cda49c095$var$p(301));
            f += 1;
            $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = null;
            b.updateQueue = null;
            $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Qh;
            a = c(d, e);
        }while ($862faa6cda49c095$var$Jh);
    }
    $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Rh;
    b = null !== $862faa6cda49c095$var$N && null !== $862faa6cda49c095$var$N.next;
    $862faa6cda49c095$var$Hh = 0;
    $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = $862faa6cda49c095$var$M = null;
    $862faa6cda49c095$var$Ih = !1;
    if (b) throw Error($862faa6cda49c095$var$p(300));
    return a;
}
function $862faa6cda49c095$var$Sh() {
    var a = 0 !== $862faa6cda49c095$var$Kh;
    $862faa6cda49c095$var$Kh = 0;
    return a;
}
function $862faa6cda49c095$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState = $862faa6cda49c095$var$O = a : $862faa6cda49c095$var$O = $862faa6cda49c095$var$O.next = a;
    return $862faa6cda49c095$var$O;
}
function $862faa6cda49c095$var$Uh() {
    if (null === $862faa6cda49c095$var$N) {
        var a = $862faa6cda49c095$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $862faa6cda49c095$var$N.next;
    var b = null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState : $862faa6cda49c095$var$O.next;
    if (null !== b) $862faa6cda49c095$var$O = b, $862faa6cda49c095$var$N = a;
    else {
        if (null === a) throw Error($862faa6cda49c095$var$p(310));
        $862faa6cda49c095$var$N = a;
        a = {
            memoizedState: $862faa6cda49c095$var$N.memoizedState,
            baseState: $862faa6cda49c095$var$N.baseState,
            baseQueue: $862faa6cda49c095$var$N.baseQueue,
            queue: $862faa6cda49c095$var$N.queue,
            next: null
        };
        null === $862faa6cda49c095$var$O ? $862faa6cda49c095$var$M.memoizedState = $862faa6cda49c095$var$O = a : $862faa6cda49c095$var$O = $862faa6cda49c095$var$O.next = a;
    }
    return $862faa6cda49c095$var$O;
}
function $862faa6cda49c095$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $862faa6cda49c095$var$Wh(a) {
    var b = $862faa6cda49c095$var$Uh(), c = b.queue;
    if (null === c) throw Error($862faa6cda49c095$var$p(311));
    c.lastRenderedReducer = a;
    var d = $862faa6cda49c095$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($862faa6cda49c095$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $862faa6cda49c095$var$M.lanes |= m;
                $862faa6cda49c095$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $862faa6cda49c095$var$He(d, b.memoizedState) || ($862faa6cda49c095$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $862faa6cda49c095$var$M.lanes |= f, $862faa6cda49c095$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $862faa6cda49c095$var$Xh(a) {
    var b = $862faa6cda49c095$var$Uh(), c = b.queue;
    if (null === c) throw Error($862faa6cda49c095$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $862faa6cda49c095$var$He(f, b.memoizedState) || ($862faa6cda49c095$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $862faa6cda49c095$var$Yh() {}
function $862faa6cda49c095$var$Zh(a, b) {
    var c = $862faa6cda49c095$var$M, d = $862faa6cda49c095$var$Uh(), e = b(), f = !$862faa6cda49c095$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $862faa6cda49c095$var$dh = !0);
    d = d.queue;
    $862faa6cda49c095$var$$h($862faa6cda49c095$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $862faa6cda49c095$var$O && $862faa6cda49c095$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $862faa6cda49c095$var$bi(9, $862faa6cda49c095$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $862faa6cda49c095$var$Q) throw Error($862faa6cda49c095$var$p(349));
        0 !== ($862faa6cda49c095$var$Hh & 30) || $862faa6cda49c095$var$di(c, b, e);
    }
    return e;
}
function $862faa6cda49c095$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $862faa6cda49c095$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $862faa6cda49c095$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $862faa6cda49c095$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $862faa6cda49c095$var$ei(b) && $862faa6cda49c095$var$fi(a);
}
function $862faa6cda49c095$var$ai(a, b, c) {
    return c(function() {
        $862faa6cda49c095$var$ei(b) && $862faa6cda49c095$var$fi(a);
    });
}
function $862faa6cda49c095$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$862faa6cda49c095$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $862faa6cda49c095$var$fi(a) {
    var b = $862faa6cda49c095$var$ih(a, 1);
    null !== b && $862faa6cda49c095$var$gi(b, a, 1, -1);
}
function $862faa6cda49c095$var$hi(a) {
    var b = $862faa6cda49c095$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $862faa6cda49c095$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $862faa6cda49c095$var$ii.bind(null, $862faa6cda49c095$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $862faa6cda49c095$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $862faa6cda49c095$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $862faa6cda49c095$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $862faa6cda49c095$var$ji() {
    return $862faa6cda49c095$var$Uh().memoizedState;
}
function $862faa6cda49c095$var$ki(a, b, c, d) {
    var e = $862faa6cda49c095$var$Th();
    $862faa6cda49c095$var$M.flags |= a;
    e.memoizedState = $862faa6cda49c095$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $862faa6cda49c095$var$li(a, b, c, d) {
    var e = $862faa6cda49c095$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $862faa6cda49c095$var$N) {
        var g = $862faa6cda49c095$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $862faa6cda49c095$var$Mh(d, g.deps)) {
            e.memoizedState = $862faa6cda49c095$var$bi(b, c, f, d);
            return;
        }
    }
    $862faa6cda49c095$var$M.flags |= a;
    e.memoizedState = $862faa6cda49c095$var$bi(1 | b, c, f, d);
}
function $862faa6cda49c095$var$mi(a, b) {
    return $862faa6cda49c095$var$ki(8390656, 8, a, b);
}
function $862faa6cda49c095$var$$h(a, b) {
    return $862faa6cda49c095$var$li(2048, 8, a, b);
}
function $862faa6cda49c095$var$ni(a, b) {
    return $862faa6cda49c095$var$li(4, 2, a, b);
}
function $862faa6cda49c095$var$oi(a, b) {
    return $862faa6cda49c095$var$li(4, 4, a, b);
}
function $862faa6cda49c095$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $862faa6cda49c095$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $862faa6cda49c095$var$li(4, 4, $862faa6cda49c095$var$pi.bind(null, b, a), c);
}
function $862faa6cda49c095$var$ri() {}
function $862faa6cda49c095$var$si(a, b) {
    var c = $862faa6cda49c095$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $862faa6cda49c095$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $862faa6cda49c095$var$ti(a, b) {
    var c = $862faa6cda49c095$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $862faa6cda49c095$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $862faa6cda49c095$var$ui(a, b, c) {
    if (0 === ($862faa6cda49c095$var$Hh & 21)) return a.baseState && (a.baseState = !1, $862faa6cda49c095$var$dh = !0), a.memoizedState = c;
    $862faa6cda49c095$var$He(c, b) || (c = $862faa6cda49c095$var$yc(), $862faa6cda49c095$var$M.lanes |= c, $862faa6cda49c095$var$rh |= c, a.baseState = !0);
    return b;
}
function $862faa6cda49c095$var$vi(a, b) {
    var c = $862faa6cda49c095$var$C;
    $862faa6cda49c095$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $862faa6cda49c095$var$Gh.transition;
    $862faa6cda49c095$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $862faa6cda49c095$var$C = c, $862faa6cda49c095$var$Gh.transition = d;
    }
}
function $862faa6cda49c095$var$wi() {
    return $862faa6cda49c095$var$Uh().memoizedState;
}
function $862faa6cda49c095$var$xi(a, b, c) {
    var d = $862faa6cda49c095$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($862faa6cda49c095$var$zi(a)) $862faa6cda49c095$var$Ai(b, c);
    else if (c = $862faa6cda49c095$var$hh(a, b, c, d), null !== c) {
        var e = $862faa6cda49c095$var$R();
        $862faa6cda49c095$var$gi(c, a, d, e);
        $862faa6cda49c095$var$Bi(c, b, d);
    }
}
function $862faa6cda49c095$var$ii(a, b, c) {
    var d = $862faa6cda49c095$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($862faa6cda49c095$var$zi(a)) $862faa6cda49c095$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($862faa6cda49c095$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $862faa6cda49c095$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $862faa6cda49c095$var$hh(a, b, e, d);
        null !== c && (e = $862faa6cda49c095$var$R(), $862faa6cda49c095$var$gi(c, a, d, e), $862faa6cda49c095$var$Bi(c, b, d));
    }
}
function $862faa6cda49c095$var$zi(a) {
    var b = a.alternate;
    return a === $862faa6cda49c095$var$M || null !== b && b === $862faa6cda49c095$var$M;
}
function $862faa6cda49c095$var$Ai(a, b) {
    $862faa6cda49c095$var$Jh = $862faa6cda49c095$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $862faa6cda49c095$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $862faa6cda49c095$var$Cc(a, c);
    }
}
var $862faa6cda49c095$var$Rh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$P,
    useContext: $862faa6cda49c095$var$P,
    useEffect: $862faa6cda49c095$var$P,
    useImperativeHandle: $862faa6cda49c095$var$P,
    useInsertionEffect: $862faa6cda49c095$var$P,
    useLayoutEffect: $862faa6cda49c095$var$P,
    useMemo: $862faa6cda49c095$var$P,
    useReducer: $862faa6cda49c095$var$P,
    useRef: $862faa6cda49c095$var$P,
    useState: $862faa6cda49c095$var$P,
    useDebugValue: $862faa6cda49c095$var$P,
    useDeferredValue: $862faa6cda49c095$var$P,
    useTransition: $862faa6cda49c095$var$P,
    useMutableSource: $862faa6cda49c095$var$P,
    useSyncExternalStore: $862faa6cda49c095$var$P,
    useId: $862faa6cda49c095$var$P,
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Oh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: function(a, b) {
        $862faa6cda49c095$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $862faa6cda49c095$var$ki(4194308, 4, $862faa6cda49c095$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $862faa6cda49c095$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $862faa6cda49c095$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $862faa6cda49c095$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $862faa6cda49c095$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $862faa6cda49c095$var$xi.bind(null, $862faa6cda49c095$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $862faa6cda49c095$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $862faa6cda49c095$var$hi,
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        return $862faa6cda49c095$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$hi(!1), b = a[0];
        a = $862faa6cda49c095$var$vi.bind(null, a[1]);
        $862faa6cda49c095$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $862faa6cda49c095$var$M, e = $862faa6cda49c095$var$Th();
        if ($862faa6cda49c095$var$I) {
            if (void 0 === c) throw Error($862faa6cda49c095$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $862faa6cda49c095$var$Q) throw Error($862faa6cda49c095$var$p(349));
            0 !== ($862faa6cda49c095$var$Hh & 30) || $862faa6cda49c095$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $862faa6cda49c095$var$mi($862faa6cda49c095$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $862faa6cda49c095$var$bi(9, $862faa6cda49c095$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $862faa6cda49c095$var$Th(), b = $862faa6cda49c095$var$Q.identifierPrefix;
        if ($862faa6cda49c095$var$I) {
            var c = $862faa6cda49c095$var$sg;
            var d = $862faa6cda49c095$var$rg;
            c = (d & ~(1 << 32 - $862faa6cda49c095$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $862faa6cda49c095$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $862faa6cda49c095$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Ph = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$si,
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$$h,
    useImperativeHandle: $862faa6cda49c095$var$qi,
    useInsertionEffect: $862faa6cda49c095$var$ni,
    useLayoutEffect: $862faa6cda49c095$var$oi,
    useMemo: $862faa6cda49c095$var$ti,
    useReducer: $862faa6cda49c095$var$Wh,
    useRef: $862faa6cda49c095$var$ji,
    useState: function() {
        return $862faa6cda49c095$var$Wh($862faa6cda49c095$var$Vh);
    },
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        var b = $862faa6cda49c095$var$Uh();
        return $862faa6cda49c095$var$ui(b, $862faa6cda49c095$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$Wh($862faa6cda49c095$var$Vh)[0], b = $862faa6cda49c095$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $862faa6cda49c095$var$Yh,
    useSyncExternalStore: $862faa6cda49c095$var$Zh,
    useId: $862faa6cda49c095$var$wi,
    unstable_isNewReconciler: !1
}, $862faa6cda49c095$var$Qh = {
    readContext: $862faa6cda49c095$var$eh,
    useCallback: $862faa6cda49c095$var$si,
    useContext: $862faa6cda49c095$var$eh,
    useEffect: $862faa6cda49c095$var$$h,
    useImperativeHandle: $862faa6cda49c095$var$qi,
    useInsertionEffect: $862faa6cda49c095$var$ni,
    useLayoutEffect: $862faa6cda49c095$var$oi,
    useMemo: $862faa6cda49c095$var$ti,
    useReducer: $862faa6cda49c095$var$Xh,
    useRef: $862faa6cda49c095$var$ji,
    useState: function() {
        return $862faa6cda49c095$var$Xh($862faa6cda49c095$var$Vh);
    },
    useDebugValue: $862faa6cda49c095$var$ri,
    useDeferredValue: function(a) {
        var b = $862faa6cda49c095$var$Uh();
        return null === $862faa6cda49c095$var$N ? b.memoizedState = a : $862faa6cda49c095$var$ui(b, $862faa6cda49c095$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $862faa6cda49c095$var$Xh($862faa6cda49c095$var$Vh)[0], b = $862faa6cda49c095$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $862faa6cda49c095$var$Yh,
    useSyncExternalStore: $862faa6cda49c095$var$Zh,
    useId: $862faa6cda49c095$var$wi,
    unstable_isNewReconciler: !1
};
function $862faa6cda49c095$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $862faa6cda49c095$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $862faa6cda49c095$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $862faa6cda49c095$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $862faa6cda49c095$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $862faa6cda49c095$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $862faa6cda49c095$var$R(), e = $862faa6cda49c095$var$yi(a), f = $862faa6cda49c095$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $862faa6cda49c095$var$nh(a, f, e);
        null !== b && ($862faa6cda49c095$var$gi(b, a, e, d), $862faa6cda49c095$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $862faa6cda49c095$var$R(), e = $862faa6cda49c095$var$yi(a), f = $862faa6cda49c095$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $862faa6cda49c095$var$nh(a, f, e);
        null !== b && ($862faa6cda49c095$var$gi(b, a, e, d), $862faa6cda49c095$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $862faa6cda49c095$var$R(), d = $862faa6cda49c095$var$yi(a), e = $862faa6cda49c095$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $862faa6cda49c095$var$nh(a, e, d);
        null !== b && ($862faa6cda49c095$var$gi(b, a, d, c), $862faa6cda49c095$var$oh(b, a, d));
    }
};
function $862faa6cda49c095$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$862faa6cda49c095$var$Ie(c, d) || !$862faa6cda49c095$var$Ie(e, f) : !0;
}
function $862faa6cda49c095$var$Gi(a, b, c) {
    var d = !1, e = $862faa6cda49c095$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $862faa6cda49c095$var$eh(f) : (e = $862faa6cda49c095$var$Zf(b) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $862faa6cda49c095$var$Yf(a, e) : $862faa6cda49c095$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $862faa6cda49c095$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $862faa6cda49c095$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $862faa6cda49c095$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $862faa6cda49c095$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $862faa6cda49c095$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $862faa6cda49c095$var$eh(f) : (f = $862faa6cda49c095$var$Zf(b) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, e.context = $862faa6cda49c095$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($862faa6cda49c095$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $862faa6cda49c095$var$Ei.enqueueReplaceState(e, e.state, null), $862faa6cda49c095$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $862faa6cda49c095$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $862faa6cda49c095$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $862faa6cda49c095$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $862faa6cda49c095$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $862faa6cda49c095$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $862faa6cda49c095$var$Ni(a, b, c) {
    c = $862faa6cda49c095$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $862faa6cda49c095$var$Oi || ($862faa6cda49c095$var$Oi = !0, $862faa6cda49c095$var$Pi = d);
        $862faa6cda49c095$var$Li(a, b);
    };
    return c;
}
function $862faa6cda49c095$var$Qi(a, b, c) {
    c = $862faa6cda49c095$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $862faa6cda49c095$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $862faa6cda49c095$var$Li(a, b);
        "function" !== typeof d && (null === $862faa6cda49c095$var$Ri ? $862faa6cda49c095$var$Ri = new Set([
            this
        ]) : $862faa6cda49c095$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $862faa6cda49c095$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $862faa6cda49c095$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $862faa6cda49c095$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $862faa6cda49c095$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $862faa6cda49c095$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $862faa6cda49c095$var$mh(-1, 1), b.tag = 2, $862faa6cda49c095$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $862faa6cda49c095$var$Wi = $862faa6cda49c095$var$ua.ReactCurrentOwner, $862faa6cda49c095$var$dh = !1;
function $862faa6cda49c095$var$Xi(a, b, c, d) {
    b.child = null === a ? $862faa6cda49c095$var$Vg(b, null, c, d) : $862faa6cda49c095$var$Ug(b, a.child, c, d);
}
function $862faa6cda49c095$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $862faa6cda49c095$var$ch(b, e);
    d = $862faa6cda49c095$var$Nh(a, b, c, d, f, e);
    c = $862faa6cda49c095$var$Sh();
    if (null !== a && !$862faa6cda49c095$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $862faa6cda49c095$var$Zi(a, b, e);
    $862faa6cda49c095$var$I && c && $862faa6cda49c095$var$vg(b);
    b.flags |= 1;
    $862faa6cda49c095$var$Xi(a, b, d, e);
    return b.child;
}
function $862faa6cda49c095$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$862faa6cda49c095$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $862faa6cda49c095$var$bj(a, b, f, d, e);
        a = $862faa6cda49c095$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $862faa6cda49c095$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $862faa6cda49c095$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $862faa6cda49c095$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $862faa6cda49c095$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($862faa6cda49c095$var$Ie(f, d) && a.ref === b.ref) {
            if ($862faa6cda49c095$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($862faa6cda49c095$var$dh = !0);
            else return b.lanes = a.lanes, $862faa6cda49c095$var$Zi(a, b, e);
        }
    }
    return $862faa6cda49c095$var$cj(a, b, c, d, e);
}
function $862faa6cda49c095$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj);
            $862faa6cda49c095$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $862faa6cda49c095$var$G($862faa6cda49c095$var$ej, $862faa6cda49c095$var$fj), $862faa6cda49c095$var$fj |= d;
    $862faa6cda49c095$var$Xi(a, b, e, c);
    return b.child;
}
function $862faa6cda49c095$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $862faa6cda49c095$var$cj(a, b, c, d, e) {
    var f = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current;
    f = $862faa6cda49c095$var$Yf(b, f);
    $862faa6cda49c095$var$ch(b, e);
    c = $862faa6cda49c095$var$Nh(a, b, c, d, f, e);
    d = $862faa6cda49c095$var$Sh();
    if (null !== a && !$862faa6cda49c095$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $862faa6cda49c095$var$Zi(a, b, e);
    $862faa6cda49c095$var$I && d && $862faa6cda49c095$var$vg(b);
    b.flags |= 1;
    $862faa6cda49c095$var$Xi(a, b, c, e);
    return b.child;
}
function $862faa6cda49c095$var$hj(a, b, c, d, e) {
    if ($862faa6cda49c095$var$Zf(c)) {
        var f = !0;
        $862faa6cda49c095$var$cg(b);
    } else f = !1;
    $862faa6cda49c095$var$ch(b, e);
    if (null === b.stateNode) $862faa6cda49c095$var$ij(a, b), $862faa6cda49c095$var$Gi(b, c, d), $862faa6cda49c095$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $862faa6cda49c095$var$eh(l) : (l = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, l = $862faa6cda49c095$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $862faa6cda49c095$var$Hi(b, g, d, l);
        $862faa6cda49c095$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $862faa6cda49c095$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $862faa6cda49c095$var$Wf.current || $862faa6cda49c095$var$jh ? ("function" === typeof m && ($862faa6cda49c095$var$Di(b, c, m, d), k = b.memoizedState), (h = $862faa6cda49c095$var$jh || $862faa6cda49c095$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $862faa6cda49c095$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $862faa6cda49c095$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $862faa6cda49c095$var$eh(k) : (k = $862faa6cda49c095$var$Zf(c) ? $862faa6cda49c095$var$Xf : $862faa6cda49c095$var$H.current, k = $862faa6cda49c095$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $862faa6cda49c095$var$Hi(b, g, d, k);
        $862faa6cda49c095$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $862faa6cda49c095$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $862faa6cda49c095$var$Wf.current || $862faa6cda49c095$var$jh ? ("function" === typeof y && ($862faa6cda49c095$var$Di(b, c, y, d), n = b.memoizedState), (l = $862faa6cda49c095$var$jh || $862faa6cda49c095$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $862faa6cda49c095$var$jj(a, b, c, d, f, e);
}
function $862faa6cda49c095$var$jj(a, b, c, d, e, f) {
    $862faa6cda49c095$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $862faa6cda49c095$var$dg(b, c, !1), $862faa6cda49c095$var$Zi(a, b, f);
    d = b.stateNode;
    $862faa6cda49c095$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $862faa6cda49c095$var$Ug(b, a.child, null, f), b.child = $862faa6cda49c095$var$Ug(b, null, h, f)) : $862faa6cda49c095$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $862faa6cda49c095$var$dg(b, c, !0);
    return b.child;
}
function $862faa6cda49c095$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $862faa6cda49c095$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $862faa6cda49c095$var$ag(a, b.context, !1);
    $862faa6cda49c095$var$yh(a, b.containerInfo);
}
function $862faa6cda49c095$var$lj(a, b, c, d, e) {
    $862faa6cda49c095$var$Ig();
    $862faa6cda49c095$var$Jg(e);
    b.flags |= 256;
    $862faa6cda49c095$var$Xi(a, b, c, d);
    return b.child;
}
var $862faa6cda49c095$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $862faa6cda49c095$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $862faa6cda49c095$var$oj(a, b, c) {
    var d = b.pendingProps, e = $862faa6cda49c095$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $862faa6cda49c095$var$G($862faa6cda49c095$var$L, e & 1);
    if (null === a) {
        $862faa6cda49c095$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $862faa6cda49c095$var$pj(g, d, 0, null), a = $862faa6cda49c095$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $862faa6cda49c095$var$nj(c), b.memoizedState = $862faa6cda49c095$var$mj, a) : $862faa6cda49c095$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $862faa6cda49c095$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $862faa6cda49c095$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $862faa6cda49c095$var$Pg(h, f) : (f = $862faa6cda49c095$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $862faa6cda49c095$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $862faa6cda49c095$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $862faa6cda49c095$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $862faa6cda49c095$var$qj(a, b) {
    b = $862faa6cda49c095$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $862faa6cda49c095$var$sj(a, b, c, d) {
    null !== d && $862faa6cda49c095$var$Jg(d);
    $862faa6cda49c095$var$Ug(b, a.child, null, c);
    a = $862faa6cda49c095$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $862faa6cda49c095$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $862faa6cda49c095$var$Ki(Error($862faa6cda49c095$var$p(422))), $862faa6cda49c095$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $862faa6cda49c095$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $862faa6cda49c095$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $862faa6cda49c095$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $862faa6cda49c095$var$nj(g);
        b.memoizedState = $862faa6cda49c095$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $862faa6cda49c095$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($862faa6cda49c095$var$p(419));
        d = $862faa6cda49c095$var$Ki(f, d, void 0);
        return $862faa6cda49c095$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($862faa6cda49c095$var$dh || h) {
        d = $862faa6cda49c095$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $862faa6cda49c095$var$ih(a, e), $862faa6cda49c095$var$gi(d, a, e, -1));
        }
        $862faa6cda49c095$var$tj();
        d = $862faa6cda49c095$var$Ki(Error($862faa6cda49c095$var$p(421)));
        return $862faa6cda49c095$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $862faa6cda49c095$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(e.nextSibling);
    $862faa6cda49c095$var$xg = b;
    $862faa6cda49c095$var$I = !0;
    $862faa6cda49c095$var$zg = null;
    null !== a && ($862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$rg, $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$sg, $862faa6cda49c095$var$og[$862faa6cda49c095$var$pg++] = $862faa6cda49c095$var$qg, $862faa6cda49c095$var$rg = a.id, $862faa6cda49c095$var$sg = a.overflow, $862faa6cda49c095$var$qg = b);
    b = $862faa6cda49c095$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $862faa6cda49c095$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $862faa6cda49c095$var$bh(a.return, b, c);
}
function $862faa6cda49c095$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $862faa6cda49c095$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $862faa6cda49c095$var$Xi(a, b, d.children, c);
    d = $862faa6cda49c095$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $862faa6cda49c095$var$vj(a, c, b);
            else if (19 === a.tag) $862faa6cda49c095$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $862faa6cda49c095$var$G($862faa6cda49c095$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $862faa6cda49c095$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $862faa6cda49c095$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $862faa6cda49c095$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $862faa6cda49c095$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $862faa6cda49c095$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $862faa6cda49c095$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $862faa6cda49c095$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $862faa6cda49c095$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($862faa6cda49c095$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $862faa6cda49c095$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $862faa6cda49c095$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $862faa6cda49c095$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $862faa6cda49c095$var$kj(b);
            $862faa6cda49c095$var$Ig();
            break;
        case 5:
            $862faa6cda49c095$var$Ah(b);
            break;
        case 1:
            $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$cg(b);
            break;
        case 4:
            $862faa6cda49c095$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $862faa6cda49c095$var$G($862faa6cda49c095$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $862faa6cda49c095$var$oj(a, b, c);
                $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1);
                a = $862faa6cda49c095$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $862faa6cda49c095$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $862faa6cda49c095$var$dj(a, b, c);
    }
    return $862faa6cda49c095$var$Zi(a, b, c);
}
var $862faa6cda49c095$var$zj, $862faa6cda49c095$var$Aj, $862faa6cda49c095$var$Bj, $862faa6cda49c095$var$Cj;
$862faa6cda49c095$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$862faa6cda49c095$var$Aj = function() {};
$862faa6cda49c095$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $862faa6cda49c095$var$Ya(a, e);
                d = $862faa6cda49c095$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $862faa6cda49c095$var$A({}, e, {
                    value: void 0
                });
                d = $862faa6cda49c095$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $862faa6cda49c095$var$gb(a, e);
                d = $862faa6cda49c095$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $862faa6cda49c095$var$Bf);
        }
        $862faa6cda49c095$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($862faa6cda49c095$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($862faa6cda49c095$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $862faa6cda49c095$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$862faa6cda49c095$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $862faa6cda49c095$var$Dj(a, b) {
    if (!$862faa6cda49c095$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $862faa6cda49c095$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $862faa6cda49c095$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $862faa6cda49c095$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $862faa6cda49c095$var$S(b), null;
        case 1:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), $862faa6cda49c095$var$S(b), null;
        case 3:
            d = b.stateNode;
            $862faa6cda49c095$var$zh();
            $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
            $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
            $862faa6cda49c095$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $862faa6cda49c095$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $862faa6cda49c095$var$zg && ($862faa6cda49c095$var$Fj($862faa6cda49c095$var$zg), $862faa6cda49c095$var$zg = null));
            $862faa6cda49c095$var$Aj(a, b);
            $862faa6cda49c095$var$S(b);
            return null;
        case 5:
            $862faa6cda49c095$var$Bh(b);
            var e = $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $862faa6cda49c095$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($862faa6cda49c095$var$p(166));
                    $862faa6cda49c095$var$S(b);
                    return null;
                }
                a = $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
                if ($862faa6cda49c095$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$862faa6cda49c095$var$Of] = b;
                    d[$862faa6cda49c095$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $862faa6cda49c095$var$D("cancel", d);
                            $862faa6cda49c095$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $862faa6cda49c095$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $862faa6cda49c095$var$lf.length; e++)$862faa6cda49c095$var$D($862faa6cda49c095$var$lf[e], d);
                            break;
                        case "source":
                            $862faa6cda49c095$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $862faa6cda49c095$var$D("error", d);
                            $862faa6cda49c095$var$D("load", d);
                            break;
                        case "details":
                            $862faa6cda49c095$var$D("toggle", d);
                            break;
                        case "input":
                            $862faa6cda49c095$var$Za(d, f);
                            $862faa6cda49c095$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $862faa6cda49c095$var$D("invalid", d);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$hb(d, f), $862faa6cda49c095$var$D("invalid", d);
                    }
                    $862faa6cda49c095$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $862faa6cda49c095$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $862faa6cda49c095$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $862faa6cda49c095$var$Va(d);
                            $862faa6cda49c095$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$Va(d);
                            $862faa6cda49c095$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $862faa6cda49c095$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $862faa6cda49c095$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$862faa6cda49c095$var$Of] = b;
                    a[$862faa6cda49c095$var$Pf] = d;
                    $862faa6cda49c095$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $862faa6cda49c095$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $862faa6cda49c095$var$D("cancel", a);
                                $862faa6cda49c095$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $862faa6cda49c095$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $862faa6cda49c095$var$lf.length; e++)$862faa6cda49c095$var$D($862faa6cda49c095$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $862faa6cda49c095$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $862faa6cda49c095$var$D("error", a);
                                $862faa6cda49c095$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $862faa6cda49c095$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $862faa6cda49c095$var$Za(a, d);
                                e = $862faa6cda49c095$var$Ya(a, d);
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $862faa6cda49c095$var$A({}, d, {
                                    value: void 0
                                });
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            case "textarea":
                                $862faa6cda49c095$var$hb(a, d);
                                e = $862faa6cda49c095$var$gb(a, d);
                                $862faa6cda49c095$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $862faa6cda49c095$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $862faa6cda49c095$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $862faa6cda49c095$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $862faa6cda49c095$var$ob(a, k) : "number" === typeof k && $862faa6cda49c095$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($862faa6cda49c095$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $862faa6cda49c095$var$D("scroll", a) : null != k && $862faa6cda49c095$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $862faa6cda49c095$var$Va(a);
                                $862faa6cda49c095$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $862faa6cda49c095$var$Va(a);
                                $862faa6cda49c095$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $862faa6cda49c095$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $862faa6cda49c095$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $862faa6cda49c095$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $862faa6cda49c095$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $862faa6cda49c095$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $862faa6cda49c095$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($862faa6cda49c095$var$p(166));
                c = $862faa6cda49c095$var$xh($862faa6cda49c095$var$wh.current);
                $862faa6cda49c095$var$xh($862faa6cda49c095$var$uh.current);
                if ($862faa6cda49c095$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$862faa6cda49c095$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $862faa6cda49c095$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $862faa6cda49c095$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $862faa6cda49c095$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$862faa6cda49c095$var$Of] = b, b.stateNode = d;
            }
            $862faa6cda49c095$var$S(b);
            return null;
        case 13:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($862faa6cda49c095$var$I && null !== $862faa6cda49c095$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $862faa6cda49c095$var$Hg(), $862faa6cda49c095$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $862faa6cda49c095$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($862faa6cda49c095$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($862faa6cda49c095$var$p(317));
                        f[$862faa6cda49c095$var$Of] = b;
                    } else $862faa6cda49c095$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $862faa6cda49c095$var$S(b);
                    f = !1;
                } else null !== $862faa6cda49c095$var$zg && ($862faa6cda49c095$var$Fj($862faa6cda49c095$var$zg), $862faa6cda49c095$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($862faa6cda49c095$var$L.current & 1) ? 0 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 3) : $862faa6cda49c095$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $862faa6cda49c095$var$S(b);
            return null;
        case 4:
            return $862faa6cda49c095$var$zh(), $862faa6cda49c095$var$Aj(a, b), null === a && $862faa6cda49c095$var$sf(b.stateNode.containerInfo), $862faa6cda49c095$var$S(b), null;
        case 10:
            return $862faa6cda49c095$var$ah(b.type._context), $862faa6cda49c095$var$S(b), null;
        case 17:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), $862faa6cda49c095$var$S(b), null;
        case 19:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            f = b.memoizedState;
            if (null === f) return $862faa6cda49c095$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $862faa6cda49c095$var$Dj(f, !1);
                else {
                    if (0 !== $862faa6cda49c095$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $862faa6cda49c095$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $862faa6cda49c095$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $862faa6cda49c095$var$G($862faa6cda49c095$var$L, $862faa6cda49c095$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $862faa6cda49c095$var$B() > $862faa6cda49c095$var$Gj && (b.flags |= 128, d = !0, $862faa6cda49c095$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $862faa6cda49c095$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $862faa6cda49c095$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$862faa6cda49c095$var$I) return $862faa6cda49c095$var$S(b), null;
                    } else 2 * $862faa6cda49c095$var$B() - f.renderingStartTime > $862faa6cda49c095$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $862faa6cda49c095$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $862faa6cda49c095$var$B(), b.sibling = null, c = $862faa6cda49c095$var$L.current, $862faa6cda49c095$var$G($862faa6cda49c095$var$L, d ? c & 1 | 2 : c & 1), b;
            $862faa6cda49c095$var$S(b);
            return null;
        case 22:
        case 23:
            return $862faa6cda49c095$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($862faa6cda49c095$var$fj & 1073741824) && ($862faa6cda49c095$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $862faa6cda49c095$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($862faa6cda49c095$var$p(156, b.tag));
}
function $862faa6cda49c095$var$Ij(a, b) {
    $862faa6cda49c095$var$wg(b);
    switch(b.tag){
        case 1:
            return $862faa6cda49c095$var$Zf(b.type) && $862faa6cda49c095$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $862faa6cda49c095$var$zh(), $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf), $862faa6cda49c095$var$E($862faa6cda49c095$var$H), $862faa6cda49c095$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $862faa6cda49c095$var$Bh(b), null;
        case 13:
            $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($862faa6cda49c095$var$p(340));
                $862faa6cda49c095$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $862faa6cda49c095$var$E($862faa6cda49c095$var$L), null;
        case 4:
            return $862faa6cda49c095$var$zh(), null;
        case 10:
            return $862faa6cda49c095$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $862faa6cda49c095$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $862faa6cda49c095$var$Jj = !1, $862faa6cda49c095$var$U = !1, $862faa6cda49c095$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $862faa6cda49c095$var$V = null;
function $862faa6cda49c095$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $862faa6cda49c095$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $862faa6cda49c095$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $862faa6cda49c095$var$W(a, b, d);
    }
}
var $862faa6cda49c095$var$Nj = !1;
function $862faa6cda49c095$var$Oj(a, b) {
    $862faa6cda49c095$var$Cf = $862faa6cda49c095$var$dd;
    a = $862faa6cda49c095$var$Me();
    if ($862faa6cda49c095$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $862faa6cda49c095$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $862faa6cda49c095$var$dd = !1;
    for($862faa6cda49c095$var$V = b; null !== $862faa6cda49c095$var$V;)if (b = $862faa6cda49c095$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $862faa6cda49c095$var$V = a;
    else for(; null !== $862faa6cda49c095$var$V;){
        b = $862faa6cda49c095$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $862faa6cda49c095$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(163));
            }
        } catch (F) {
            $862faa6cda49c095$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $862faa6cda49c095$var$V = a;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
    n = $862faa6cda49c095$var$Nj;
    $862faa6cda49c095$var$Nj = !1;
    return n;
}
function $862faa6cda49c095$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $862faa6cda49c095$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $862faa6cda49c095$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $862faa6cda49c095$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $862faa6cda49c095$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $862faa6cda49c095$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$862faa6cda49c095$var$Of], delete b[$862faa6cda49c095$var$Pf], delete b[$862faa6cda49c095$var$of], delete b[$862faa6cda49c095$var$Qf], delete b[$862faa6cda49c095$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $862faa6cda49c095$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $862faa6cda49c095$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $862faa6cda49c095$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $862faa6cda49c095$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $862faa6cda49c095$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($862faa6cda49c095$var$Vj(a, b, c), a = a.sibling; null !== a;)$862faa6cda49c095$var$Vj(a, b, c), a = a.sibling;
}
function $862faa6cda49c095$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($862faa6cda49c095$var$Wj(a, b, c), a = a.sibling; null !== a;)$862faa6cda49c095$var$Wj(a, b, c), a = a.sibling;
}
var $862faa6cda49c095$var$X = null, $862faa6cda49c095$var$Xj = !1;
function $862faa6cda49c095$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$862faa6cda49c095$var$Zj(a, b, c), c = c.sibling;
}
function $862faa6cda49c095$var$Zj(a, b, c) {
    if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onCommitFiberUnmount) try {
        $862faa6cda49c095$var$lc.onCommitFiberUnmount($862faa6cda49c095$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $862faa6cda49c095$var$U || $862faa6cda49c095$var$Lj(c, b);
        case 6:
            var d = $862faa6cda49c095$var$X, e = $862faa6cda49c095$var$Xj;
            $862faa6cda49c095$var$X = null;
            $862faa6cda49c095$var$Yj(a, b, c);
            $862faa6cda49c095$var$X = d;
            $862faa6cda49c095$var$Xj = e;
            null !== $862faa6cda49c095$var$X && ($862faa6cda49c095$var$Xj ? (a = $862faa6cda49c095$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $862faa6cda49c095$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $862faa6cda49c095$var$X && ($862faa6cda49c095$var$Xj ? (a = $862faa6cda49c095$var$X, c = c.stateNode, 8 === a.nodeType ? $862faa6cda49c095$var$Kf(a.parentNode, c) : 1 === a.nodeType && $862faa6cda49c095$var$Kf(a, c), $862faa6cda49c095$var$bd(a)) : $862faa6cda49c095$var$Kf($862faa6cda49c095$var$X, c.stateNode));
            break;
        case 4:
            d = $862faa6cda49c095$var$X;
            e = $862faa6cda49c095$var$Xj;
            $862faa6cda49c095$var$X = c.stateNode.containerInfo;
            $862faa6cda49c095$var$Xj = !0;
            $862faa6cda49c095$var$Yj(a, b, c);
            $862faa6cda49c095$var$X = d;
            $862faa6cda49c095$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$862faa6cda49c095$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $862faa6cda49c095$var$Mj(c, b, g) : 0 !== (f & 4) && $862faa6cda49c095$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 1:
            if (!$862faa6cda49c095$var$U && ($862faa6cda49c095$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $862faa6cda49c095$var$W(c, b, h);
            }
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 21:
            $862faa6cda49c095$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($862faa6cda49c095$var$U = (d = $862faa6cda49c095$var$U) || null !== c.memoizedState, $862faa6cda49c095$var$Yj(a, b, c), $862faa6cda49c095$var$U = d) : $862faa6cda49c095$var$Yj(a, b, c);
            break;
        default:
            $862faa6cda49c095$var$Yj(a, b, c);
    }
}
function $862faa6cda49c095$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $862faa6cda49c095$var$Kj);
        b.forEach(function(b) {
            var d = $862faa6cda49c095$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $862faa6cda49c095$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $862faa6cda49c095$var$X = h.stateNode;
                        $862faa6cda49c095$var$Xj = !1;
                        break a;
                    case 3:
                        $862faa6cda49c095$var$X = h.stateNode.containerInfo;
                        $862faa6cda49c095$var$Xj = !0;
                        break a;
                    case 4:
                        $862faa6cda49c095$var$X = h.stateNode.containerInfo;
                        $862faa6cda49c095$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $862faa6cda49c095$var$X) throw Error($862faa6cda49c095$var$p(160));
            $862faa6cda49c095$var$Zj(f, g, e);
            $862faa6cda49c095$var$X = null;
            $862faa6cda49c095$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $862faa6cda49c095$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$862faa6cda49c095$var$dk(b, a), b = b.sibling;
}
function $862faa6cda49c095$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4) {
                try {
                    $862faa6cda49c095$var$Pj(3, a, a.return), $862faa6cda49c095$var$Qj(3, a);
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
                try {
                    $862faa6cda49c095$var$Pj(5, a, a.return);
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 512 && null !== c && $862faa6cda49c095$var$Lj(c, c.return);
            break;
        case 5:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 512 && null !== c && $862faa6cda49c095$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $862faa6cda49c095$var$ob(e, "");
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $862faa6cda49c095$var$ab(e, f);
                    $862faa6cda49c095$var$vb(h, g);
                    var l = $862faa6cda49c095$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $862faa6cda49c095$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $862faa6cda49c095$var$nb(e, q) : "children" === m ? $862faa6cda49c095$var$ob(e, q) : $862faa6cda49c095$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $862faa6cda49c095$var$bb(e, f);
                            break;
                        case "textarea":
                            $862faa6cda49c095$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $862faa6cda49c095$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $862faa6cda49c095$var$fb(e, !!f.multiple, f.defaultValue, !0) : $862faa6cda49c095$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$862faa6cda49c095$var$Pf] = f;
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($862faa6cda49c095$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $862faa6cda49c095$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $862faa6cda49c095$var$bd(b.containerInfo);
            } catch (t) {
                $862faa6cda49c095$var$W(a, a.return, t);
            }
            break;
        case 4:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            break;
        case 13:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($862faa6cda49c095$var$fk = $862faa6cda49c095$var$B()));
            d & 4 && $862faa6cda49c095$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($862faa6cda49c095$var$U = (l = $862faa6cda49c095$var$U) || m, $862faa6cda49c095$var$ck(b, a), $862faa6cda49c095$var$U = l) : $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($862faa6cda49c095$var$V = a, m = a.child; null !== m;){
                    for(q = $862faa6cda49c095$var$V = m; null !== $862faa6cda49c095$var$V;){
                        r = $862faa6cda49c095$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $862faa6cda49c095$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $862faa6cda49c095$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $862faa6cda49c095$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $862faa6cda49c095$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $862faa6cda49c095$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $862faa6cda49c095$var$V = y) : $862faa6cda49c095$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $862faa6cda49c095$var$rb("display", g));
                            } catch (t) {
                                $862faa6cda49c095$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $862faa6cda49c095$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $862faa6cda49c095$var$ck(b, a);
            $862faa6cda49c095$var$ek(a);
            d & 4 && $862faa6cda49c095$var$ak(a);
            break;
        case 21:
            break;
        default:
            $862faa6cda49c095$var$ck(b, a), $862faa6cda49c095$var$ek(a);
    }
}
function $862faa6cda49c095$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($862faa6cda49c095$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($862faa6cda49c095$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($862faa6cda49c095$var$ob(e, ""), d.flags &= -33);
                    var f = $862faa6cda49c095$var$Uj(a);
                    $862faa6cda49c095$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $862faa6cda49c095$var$Uj(a);
                    $862faa6cda49c095$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(161));
            }
        } catch (k) {
            $862faa6cda49c095$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $862faa6cda49c095$var$hk(a, b, c) {
    $862faa6cda49c095$var$V = a;
    $862faa6cda49c095$var$ik(a, b, c);
}
function $862faa6cda49c095$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $862faa6cda49c095$var$V;){
        var e = $862faa6cda49c095$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $862faa6cda49c095$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $862faa6cda49c095$var$U;
                h = $862faa6cda49c095$var$Jj;
                var l = $862faa6cda49c095$var$U;
                $862faa6cda49c095$var$Jj = g;
                if (($862faa6cda49c095$var$U = k) && !l) for($862faa6cda49c095$var$V = e; null !== $862faa6cda49c095$var$V;)g = $862faa6cda49c095$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $862faa6cda49c095$var$jk(e) : null !== k ? (k.return = g, $862faa6cda49c095$var$V = k) : $862faa6cda49c095$var$jk(e);
                for(; null !== f;)$862faa6cda49c095$var$V = f, $862faa6cda49c095$var$ik(f, b, c), f = f.sibling;
                $862faa6cda49c095$var$V = e;
                $862faa6cda49c095$var$Jj = h;
                $862faa6cda49c095$var$U = l;
            }
            $862faa6cda49c095$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $862faa6cda49c095$var$V = f) : $862faa6cda49c095$var$kk(a, b, c);
    }
}
function $862faa6cda49c095$var$kk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $862faa6cda49c095$var$U || $862faa6cda49c095$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$862faa6cda49c095$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $862faa6cda49c095$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $862faa6cda49c095$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $862faa6cda49c095$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $862faa6cda49c095$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($862faa6cda49c095$var$p(163));
                }
                $862faa6cda49c095$var$U || b.flags & 512 && $862faa6cda49c095$var$Rj(b);
            } catch (r) {
                $862faa6cda49c095$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $862faa6cda49c095$var$V = c;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
function $862faa6cda49c095$var$gk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $862faa6cda49c095$var$V = c;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
function $862faa6cda49c095$var$jk(a) {
    for(; null !== $862faa6cda49c095$var$V;){
        var b = $862faa6cda49c095$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $862faa6cda49c095$var$Qj(4, b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $862faa6cda49c095$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $862faa6cda49c095$var$Rj(b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $862faa6cda49c095$var$Rj(b);
                    } catch (k) {
                        $862faa6cda49c095$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $862faa6cda49c095$var$W(b, b.return, k);
        }
        if (b === a) {
            $862faa6cda49c095$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $862faa6cda49c095$var$V = h;
            break;
        }
        $862faa6cda49c095$var$V = b.return;
    }
}
var $862faa6cda49c095$var$lk = Math.ceil, $862faa6cda49c095$var$mk = $862faa6cda49c095$var$ua.ReactCurrentDispatcher, $862faa6cda49c095$var$nk = $862faa6cda49c095$var$ua.ReactCurrentOwner, $862faa6cda49c095$var$ok = $862faa6cda49c095$var$ua.ReactCurrentBatchConfig, $862faa6cda49c095$var$K = 0, $862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Y = null, $862faa6cda49c095$var$Z = 0, $862faa6cda49c095$var$fj = 0, $862faa6cda49c095$var$ej = $862faa6cda49c095$var$Uf(0), $862faa6cda49c095$var$T = 0, $862faa6cda49c095$var$pk = null, $862faa6cda49c095$var$rh = 0, $862faa6cda49c095$var$qk = 0, $862faa6cda49c095$var$rk = 0, $862faa6cda49c095$var$sk = null, $862faa6cda49c095$var$tk = null, $862faa6cda49c095$var$fk = 0, $862faa6cda49c095$var$Gj = Infinity, $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Oi = !1, $862faa6cda49c095$var$Pi = null, $862faa6cda49c095$var$Ri = null, $862faa6cda49c095$var$vk = !1, $862faa6cda49c095$var$wk = null, $862faa6cda49c095$var$xk = 0, $862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = null, $862faa6cda49c095$var$Ak = -1, $862faa6cda49c095$var$Bk = 0;
function $862faa6cda49c095$var$R() {
    return 0 !== ($862faa6cda49c095$var$K & 6) ? $862faa6cda49c095$var$B() : -1 !== $862faa6cda49c095$var$Ak ? $862faa6cda49c095$var$Ak : $862faa6cda49c095$var$Ak = $862faa6cda49c095$var$B();
}
function $862faa6cda49c095$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($862faa6cda49c095$var$K & 2) && 0 !== $862faa6cda49c095$var$Z) return $862faa6cda49c095$var$Z & -$862faa6cda49c095$var$Z;
    if (null !== $862faa6cda49c095$var$Kg.transition) return 0 === $862faa6cda49c095$var$Bk && ($862faa6cda49c095$var$Bk = $862faa6cda49c095$var$yc()), $862faa6cda49c095$var$Bk;
    a = $862faa6cda49c095$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $862faa6cda49c095$var$jd(a.type);
    return a;
}
function $862faa6cda49c095$var$gi(a, b, c, d) {
    if (50 < $862faa6cda49c095$var$yk) throw $862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = null, Error($862faa6cda49c095$var$p(185));
    $862faa6cda49c095$var$Ac(a, c, d);
    if (0 === ($862faa6cda49c095$var$K & 2) || a !== $862faa6cda49c095$var$Q) a === $862faa6cda49c095$var$Q && (0 === ($862faa6cda49c095$var$K & 2) && ($862faa6cda49c095$var$qk |= c), 4 === $862faa6cda49c095$var$T && $862faa6cda49c095$var$Ck(a, $862faa6cda49c095$var$Z)), $862faa6cda49c095$var$Dk(a, d), 1 === c && 0 === $862faa6cda49c095$var$K && 0 === (b.mode & 1) && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$fg && $862faa6cda49c095$var$jg());
}
function $862faa6cda49c095$var$Dk(a, b) {
    var c = a.callbackNode;
    $862faa6cda49c095$var$wc(a, b);
    var d = $862faa6cda49c095$var$uc(a, a === $862faa6cda49c095$var$Q ? $862faa6cda49c095$var$Z : 0);
    if (0 === d) null !== c && $862faa6cda49c095$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $862faa6cda49c095$var$bc(c);
        if (1 === b) 0 === a.tag ? $862faa6cda49c095$var$ig($862faa6cda49c095$var$Ek.bind(null, a)) : $862faa6cda49c095$var$hg($862faa6cda49c095$var$Ek.bind(null, a)), $862faa6cda49c095$var$Jf(function() {
            0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$jg();
        }), c = null;
        else {
            switch($862faa6cda49c095$var$Dc(d)){
                case 1:
                    c = $862faa6cda49c095$var$fc;
                    break;
                case 4:
                    c = $862faa6cda49c095$var$gc;
                    break;
                case 16:
                    c = $862faa6cda49c095$var$hc;
                    break;
                case 536870912:
                    c = $862faa6cda49c095$var$jc;
                    break;
                default:
                    c = $862faa6cda49c095$var$hc;
            }
            c = $862faa6cda49c095$var$Fk(c, $862faa6cda49c095$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $862faa6cda49c095$var$Gk(a, b) {
    $862faa6cda49c095$var$Ak = -1;
    $862faa6cda49c095$var$Bk = 0;
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    var c = a.callbackNode;
    if ($862faa6cda49c095$var$Hk() && a.callbackNode !== c) return null;
    var d = $862faa6cda49c095$var$uc(a, a === $862faa6cda49c095$var$Q ? $862faa6cda49c095$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $862faa6cda49c095$var$Ik(a, d);
    else {
        b = d;
        var e = $862faa6cda49c095$var$K;
        $862faa6cda49c095$var$K |= 2;
        var f = $862faa6cda49c095$var$Jk();
        if ($862faa6cda49c095$var$Q !== a || $862faa6cda49c095$var$Z !== b) $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$Kk(a, b);
        for(;;)try {
            $862faa6cda49c095$var$Lk();
            break;
        } catch (h) {
            $862faa6cda49c095$var$Mk(a, h);
        }
        $862faa6cda49c095$var$$g();
        $862faa6cda49c095$var$mk.current = f;
        $862faa6cda49c095$var$K = e;
        null !== $862faa6cda49c095$var$Y ? b = 0 : ($862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Z = 0, b = $862faa6cda49c095$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $862faa6cda49c095$var$xc(a), 0 !== e && (d = e, b = $862faa6cda49c095$var$Nk(a, e)));
        if (1 === b) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, d), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
        if (6 === b) $862faa6cda49c095$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$862faa6cda49c095$var$Ok(e) && (b = $862faa6cda49c095$var$Ik(a, d), 2 === b && (f = $862faa6cda49c095$var$xc(a), 0 !== f && (d = f, b = $862faa6cda49c095$var$Nk(a, f))), 1 === b)) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, d), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($862faa6cda49c095$var$p(345));
                case 2:
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 3:
                    $862faa6cda49c095$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $862faa6cda49c095$var$fk + 500 - $862faa6cda49c095$var$B(), 10 < b)) {
                        if (0 !== $862faa6cda49c095$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $862faa6cda49c095$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $862faa6cda49c095$var$Ff($862faa6cda49c095$var$Pk.bind(null, a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk), b);
                        break;
                    }
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 4:
                    $862faa6cda49c095$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $862faa6cda49c095$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $862faa6cda49c095$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $862faa6cda49c095$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $862faa6cda49c095$var$Ff($862faa6cda49c095$var$Pk.bind(null, a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk), d);
                        break;
                    }
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                case 5:
                    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
                    break;
                default:
                    throw Error($862faa6cda49c095$var$p(329));
            }
        }
    }
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    return a.callbackNode === c ? $862faa6cda49c095$var$Gk.bind(null, a) : null;
}
function $862faa6cda49c095$var$Nk(a, b) {
    var c = $862faa6cda49c095$var$sk;
    a.current.memoizedState.isDehydrated && ($862faa6cda49c095$var$Kk(a, b).flags |= 256);
    a = $862faa6cda49c095$var$Ik(a, b);
    2 !== a && (b = $862faa6cda49c095$var$tk, $862faa6cda49c095$var$tk = c, null !== b && $862faa6cda49c095$var$Fj(b));
    return a;
}
function $862faa6cda49c095$var$Fj(a) {
    null === $862faa6cda49c095$var$tk ? $862faa6cda49c095$var$tk = a : $862faa6cda49c095$var$tk.push.apply($862faa6cda49c095$var$tk, a);
}
function $862faa6cda49c095$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$862faa6cda49c095$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $862faa6cda49c095$var$Ck(a, b) {
    b &= ~$862faa6cda49c095$var$rk;
    b &= ~$862faa6cda49c095$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $862faa6cda49c095$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $862faa6cda49c095$var$Ek(a) {
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    $862faa6cda49c095$var$Hk();
    var b = $862faa6cda49c095$var$uc(a, 0);
    if (0 === (b & 1)) return $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), null;
    var c = $862faa6cda49c095$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $862faa6cda49c095$var$xc(a);
        0 !== d && (b = d, c = $862faa6cda49c095$var$Nk(a, d));
    }
    if (1 === c) throw c = $862faa6cda49c095$var$pk, $862faa6cda49c095$var$Kk(a, 0), $862faa6cda49c095$var$Ck(a, b), $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B()), c;
    if (6 === c) throw Error($862faa6cda49c095$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $862faa6cda49c095$var$Pk(a, $862faa6cda49c095$var$tk, $862faa6cda49c095$var$uk);
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    return null;
}
function $862faa6cda49c095$var$Qk(a, b) {
    var c = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 1;
    try {
        return a(b);
    } finally{
        $862faa6cda49c095$var$K = c, 0 === $862faa6cda49c095$var$K && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$fg && $862faa6cda49c095$var$jg());
    }
}
function $862faa6cda49c095$var$Rk(a) {
    null !== $862faa6cda49c095$var$wk && 0 === $862faa6cda49c095$var$wk.tag && 0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$Hk();
    var b = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 1;
    var c = $862faa6cda49c095$var$ok.transition, d = $862faa6cda49c095$var$C;
    try {
        if ($862faa6cda49c095$var$ok.transition = null, $862faa6cda49c095$var$C = 1, a) return a();
    } finally{
        $862faa6cda49c095$var$C = d, $862faa6cda49c095$var$ok.transition = c, $862faa6cda49c095$var$K = b, 0 === ($862faa6cda49c095$var$K & 6) && $862faa6cda49c095$var$jg();
    }
}
function $862faa6cda49c095$var$Hj() {
    $862faa6cda49c095$var$fj = $862faa6cda49c095$var$ej.current;
    $862faa6cda49c095$var$E($862faa6cda49c095$var$ej);
}
function $862faa6cda49c095$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $862faa6cda49c095$var$Gf(c));
    if (null !== $862faa6cda49c095$var$Y) for(c = $862faa6cda49c095$var$Y.return; null !== c;){
        var d = c;
        $862faa6cda49c095$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $862faa6cda49c095$var$$f();
                break;
            case 3:
                $862faa6cda49c095$var$zh();
                $862faa6cda49c095$var$E($862faa6cda49c095$var$Wf);
                $862faa6cda49c095$var$E($862faa6cda49c095$var$H);
                $862faa6cda49c095$var$Eh();
                break;
            case 5:
                $862faa6cda49c095$var$Bh(d);
                break;
            case 4:
                $862faa6cda49c095$var$zh();
                break;
            case 13:
                $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
                break;
            case 19:
                $862faa6cda49c095$var$E($862faa6cda49c095$var$L);
                break;
            case 10:
                $862faa6cda49c095$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $862faa6cda49c095$var$Hj();
        }
        c = c.return;
    }
    $862faa6cda49c095$var$Q = a;
    $862faa6cda49c095$var$Y = a = $862faa6cda49c095$var$Pg(a.current, null);
    $862faa6cda49c095$var$Z = $862faa6cda49c095$var$fj = b;
    $862faa6cda49c095$var$T = 0;
    $862faa6cda49c095$var$pk = null;
    $862faa6cda49c095$var$rk = $862faa6cda49c095$var$qk = $862faa6cda49c095$var$rh = 0;
    $862faa6cda49c095$var$tk = $862faa6cda49c095$var$sk = null;
    if (null !== $862faa6cda49c095$var$fh) {
        for(b = 0; b < $862faa6cda49c095$var$fh.length; b++)if (c = $862faa6cda49c095$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $862faa6cda49c095$var$fh = null;
    }
    return a;
}
function $862faa6cda49c095$var$Mk(a, b) {
    do {
        var c = $862faa6cda49c095$var$Y;
        try {
            $862faa6cda49c095$var$$g();
            $862faa6cda49c095$var$Fh.current = $862faa6cda49c095$var$Rh;
            if ($862faa6cda49c095$var$Ih) {
                for(var d = $862faa6cda49c095$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $862faa6cda49c095$var$Ih = !1;
            }
            $862faa6cda49c095$var$Hh = 0;
            $862faa6cda49c095$var$O = $862faa6cda49c095$var$N = $862faa6cda49c095$var$M = null;
            $862faa6cda49c095$var$Jh = !1;
            $862faa6cda49c095$var$Kh = 0;
            $862faa6cda49c095$var$nk.current = null;
            if (null === c || null === c.return) {
                $862faa6cda49c095$var$T = 1;
                $862faa6cda49c095$var$pk = b;
                $862faa6cda49c095$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $862faa6cda49c095$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $862faa6cda49c095$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $862faa6cda49c095$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $862faa6cda49c095$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $862faa6cda49c095$var$Si(f, l, b);
                            $862faa6cda49c095$var$tj();
                            break a;
                        }
                        k = Error($862faa6cda49c095$var$p(426));
                    }
                } else if ($862faa6cda49c095$var$I && h.mode & 1) {
                    var J = $862faa6cda49c095$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $862faa6cda49c095$var$Vi(J, g, h, f, b);
                        $862faa6cda49c095$var$Jg($862faa6cda49c095$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $862faa6cda49c095$var$Ji(k, h);
                4 !== $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 2);
                null === $862faa6cda49c095$var$sk ? $862faa6cda49c095$var$sk = [
                    f
                ] : $862faa6cda49c095$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $862faa6cda49c095$var$Ni(f, k, b);
                            $862faa6cda49c095$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $862faa6cda49c095$var$Ri || !$862faa6cda49c095$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $862faa6cda49c095$var$Qi(f, h, b);
                                $862faa6cda49c095$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $862faa6cda49c095$var$Sk(c);
        } catch (na) {
            b = na;
            $862faa6cda49c095$var$Y === c && null !== c && ($862faa6cda49c095$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $862faa6cda49c095$var$Jk() {
    var a = $862faa6cda49c095$var$mk.current;
    $862faa6cda49c095$var$mk.current = $862faa6cda49c095$var$Rh;
    return null === a ? $862faa6cda49c095$var$Rh : a;
}
function $862faa6cda49c095$var$tj() {
    if (0 === $862faa6cda49c095$var$T || 3 === $862faa6cda49c095$var$T || 2 === $862faa6cda49c095$var$T) $862faa6cda49c095$var$T = 4;
    null === $862faa6cda49c095$var$Q || 0 === ($862faa6cda49c095$var$rh & 268435455) && 0 === ($862faa6cda49c095$var$qk & 268435455) || $862faa6cda49c095$var$Ck($862faa6cda49c095$var$Q, $862faa6cda49c095$var$Z);
}
function $862faa6cda49c095$var$Ik(a, b) {
    var c = $862faa6cda49c095$var$K;
    $862faa6cda49c095$var$K |= 2;
    var d = $862faa6cda49c095$var$Jk();
    if ($862faa6cda49c095$var$Q !== a || $862faa6cda49c095$var$Z !== b) $862faa6cda49c095$var$uk = null, $862faa6cda49c095$var$Kk(a, b);
    for(;;)try {
        $862faa6cda49c095$var$Tk();
        break;
    } catch (e) {
        $862faa6cda49c095$var$Mk(a, e);
    }
    $862faa6cda49c095$var$$g();
    $862faa6cda49c095$var$K = c;
    $862faa6cda49c095$var$mk.current = d;
    if (null !== $862faa6cda49c095$var$Y) throw Error($862faa6cda49c095$var$p(261));
    $862faa6cda49c095$var$Q = null;
    $862faa6cda49c095$var$Z = 0;
    return $862faa6cda49c095$var$T;
}
function $862faa6cda49c095$var$Tk() {
    for(; null !== $862faa6cda49c095$var$Y;)$862faa6cda49c095$var$Uk($862faa6cda49c095$var$Y);
}
function $862faa6cda49c095$var$Lk() {
    for(; null !== $862faa6cda49c095$var$Y && !$862faa6cda49c095$var$cc();)$862faa6cda49c095$var$Uk($862faa6cda49c095$var$Y);
}
function $862faa6cda49c095$var$Uk(a) {
    var b = $862faa6cda49c095$var$Vk(a.alternate, a, $862faa6cda49c095$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $862faa6cda49c095$var$Sk(a) : $862faa6cda49c095$var$Y = b;
    $862faa6cda49c095$var$nk.current = null;
}
function $862faa6cda49c095$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $862faa6cda49c095$var$Ej(c, b, $862faa6cda49c095$var$fj), null !== c) {
                $862faa6cda49c095$var$Y = c;
                return;
            }
        } else {
            c = $862faa6cda49c095$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $862faa6cda49c095$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $862faa6cda49c095$var$T = 6;
                $862faa6cda49c095$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $862faa6cda49c095$var$Y = b;
            return;
        }
        $862faa6cda49c095$var$Y = b = a;
    }while (null !== b);
    0 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$T = 5);
}
function $862faa6cda49c095$var$Pk(a, b, c) {
    var d = $862faa6cda49c095$var$C, e = $862faa6cda49c095$var$ok.transition;
    try {
        $862faa6cda49c095$var$ok.transition = null, $862faa6cda49c095$var$C = 1, $862faa6cda49c095$var$Wk(a, b, c, d);
    } finally{
        $862faa6cda49c095$var$ok.transition = e, $862faa6cda49c095$var$C = d;
    }
    return null;
}
function $862faa6cda49c095$var$Wk(a, b, c, d) {
    do $862faa6cda49c095$var$Hk();
    while (null !== $862faa6cda49c095$var$wk);
    if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($862faa6cda49c095$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $862faa6cda49c095$var$Bc(a, f);
    a === $862faa6cda49c095$var$Q && ($862faa6cda49c095$var$Y = $862faa6cda49c095$var$Q = null, $862faa6cda49c095$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $862faa6cda49c095$var$vk || ($862faa6cda49c095$var$vk = !0, $862faa6cda49c095$var$Fk($862faa6cda49c095$var$hc, function() {
        $862faa6cda49c095$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $862faa6cda49c095$var$ok.transition;
        $862faa6cda49c095$var$ok.transition = null;
        var g = $862faa6cda49c095$var$C;
        $862faa6cda49c095$var$C = 1;
        var h = $862faa6cda49c095$var$K;
        $862faa6cda49c095$var$K |= 4;
        $862faa6cda49c095$var$nk.current = null;
        $862faa6cda49c095$var$Oj(a, c);
        $862faa6cda49c095$var$dk(c, a);
        $862faa6cda49c095$var$Oe($862faa6cda49c095$var$Df);
        $862faa6cda49c095$var$dd = !!$862faa6cda49c095$var$Cf;
        $862faa6cda49c095$var$Df = $862faa6cda49c095$var$Cf = null;
        a.current = c;
        $862faa6cda49c095$var$hk(c, a, e);
        $862faa6cda49c095$var$dc();
        $862faa6cda49c095$var$K = h;
        $862faa6cda49c095$var$C = g;
        $862faa6cda49c095$var$ok.transition = f;
    } else a.current = c;
    $862faa6cda49c095$var$vk && ($862faa6cda49c095$var$vk = !1, $862faa6cda49c095$var$wk = a, $862faa6cda49c095$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($862faa6cda49c095$var$Ri = null);
    $862faa6cda49c095$var$mc(c.stateNode, d);
    $862faa6cda49c095$var$Dk(a, $862faa6cda49c095$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($862faa6cda49c095$var$Oi) throw $862faa6cda49c095$var$Oi = !1, a = $862faa6cda49c095$var$Pi, $862faa6cda49c095$var$Pi = null, a;
    0 !== ($862faa6cda49c095$var$xk & 1) && 0 !== a.tag && $862faa6cda49c095$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $862faa6cda49c095$var$zk ? $862faa6cda49c095$var$yk++ : ($862faa6cda49c095$var$yk = 0, $862faa6cda49c095$var$zk = a) : $862faa6cda49c095$var$yk = 0;
    $862faa6cda49c095$var$jg();
    return null;
}
function $862faa6cda49c095$var$Hk() {
    if (null !== $862faa6cda49c095$var$wk) {
        var a = $862faa6cda49c095$var$Dc($862faa6cda49c095$var$xk), b = $862faa6cda49c095$var$ok.transition, c = $862faa6cda49c095$var$C;
        try {
            $862faa6cda49c095$var$ok.transition = null;
            $862faa6cda49c095$var$C = 16 > a ? 16 : a;
            if (null === $862faa6cda49c095$var$wk) var d = !1;
            else {
                a = $862faa6cda49c095$var$wk;
                $862faa6cda49c095$var$wk = null;
                $862faa6cda49c095$var$xk = 0;
                if (0 !== ($862faa6cda49c095$var$K & 6)) throw Error($862faa6cda49c095$var$p(331));
                var e = $862faa6cda49c095$var$K;
                $862faa6cda49c095$var$K |= 4;
                for($862faa6cda49c095$var$V = a.current; null !== $862faa6cda49c095$var$V;){
                    var f = $862faa6cda49c095$var$V, g = f.child;
                    if (0 !== ($862faa6cda49c095$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($862faa6cda49c095$var$V = l; null !== $862faa6cda49c095$var$V;){
                                    var m = $862faa6cda49c095$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $862faa6cda49c095$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $862faa6cda49c095$var$V = q;
                                    else for(; null !== $862faa6cda49c095$var$V;){
                                        m = $862faa6cda49c095$var$V;
                                        var r = m.sibling, y = m.return;
                                        $862faa6cda49c095$var$Sj(m);
                                        if (m === l) {
                                            $862faa6cda49c095$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $862faa6cda49c095$var$V = r;
                                            break;
                                        }
                                        $862faa6cda49c095$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $862faa6cda49c095$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $862faa6cda49c095$var$V = g;
                    else b: for(; null !== $862faa6cda49c095$var$V;){
                        f = $862faa6cda49c095$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $862faa6cda49c095$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $862faa6cda49c095$var$V = x;
                            break b;
                        }
                        $862faa6cda49c095$var$V = f.return;
                    }
                }
                var w = a.current;
                for($862faa6cda49c095$var$V = w; null !== $862faa6cda49c095$var$V;){
                    g = $862faa6cda49c095$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $862faa6cda49c095$var$V = u;
                    else b: for(g = w; null !== $862faa6cda49c095$var$V;){
                        h = $862faa6cda49c095$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $862faa6cda49c095$var$Qj(9, h);
                            }
                        } catch (na) {
                            $862faa6cda49c095$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $862faa6cda49c095$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $862faa6cda49c095$var$V = F;
                            break b;
                        }
                        $862faa6cda49c095$var$V = h.return;
                    }
                }
                $862faa6cda49c095$var$K = e;
                $862faa6cda49c095$var$jg();
                if ($862faa6cda49c095$var$lc && "function" === typeof $862faa6cda49c095$var$lc.onPostCommitFiberRoot) try {
                    $862faa6cda49c095$var$lc.onPostCommitFiberRoot($862faa6cda49c095$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $862faa6cda49c095$var$C = c, $862faa6cda49c095$var$ok.transition = b;
        }
    }
    return !1;
}
function $862faa6cda49c095$var$Xk(a, b, c) {
    b = $862faa6cda49c095$var$Ji(c, b);
    b = $862faa6cda49c095$var$Ni(a, b, 1);
    a = $862faa6cda49c095$var$nh(a, b, 1);
    b = $862faa6cda49c095$var$R();
    null !== a && ($862faa6cda49c095$var$Ac(a, 1, b), $862faa6cda49c095$var$Dk(a, b));
}
function $862faa6cda49c095$var$W(a, b, c) {
    if (3 === a.tag) $862faa6cda49c095$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $862faa6cda49c095$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $862faa6cda49c095$var$Ri || !$862faa6cda49c095$var$Ri.has(d))) {
                a = $862faa6cda49c095$var$Ji(c, a);
                a = $862faa6cda49c095$var$Qi(b, a, 1);
                b = $862faa6cda49c095$var$nh(b, a, 1);
                a = $862faa6cda49c095$var$R();
                null !== b && ($862faa6cda49c095$var$Ac(b, 1, a), $862faa6cda49c095$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $862faa6cda49c095$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $862faa6cda49c095$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $862faa6cda49c095$var$Q === a && ($862faa6cda49c095$var$Z & c) === c && (4 === $862faa6cda49c095$var$T || 3 === $862faa6cda49c095$var$T && ($862faa6cda49c095$var$Z & 130023424) === $862faa6cda49c095$var$Z && 500 > $862faa6cda49c095$var$B() - $862faa6cda49c095$var$fk ? $862faa6cda49c095$var$Kk(a, 0) : $862faa6cda49c095$var$rk |= c);
    $862faa6cda49c095$var$Dk(a, b);
}
function $862faa6cda49c095$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $862faa6cda49c095$var$sc, $862faa6cda49c095$var$sc <<= 1, 0 === ($862faa6cda49c095$var$sc & 130023424) && ($862faa6cda49c095$var$sc = 4194304)));
    var c = $862faa6cda49c095$var$R();
    a = $862faa6cda49c095$var$ih(a, b);
    null !== a && ($862faa6cda49c095$var$Ac(a, b, c), $862faa6cda49c095$var$Dk(a, c));
}
function $862faa6cda49c095$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $862faa6cda49c095$var$Yk(a, c);
}
function $862faa6cda49c095$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($862faa6cda49c095$var$p(314));
    }
    null !== d && d.delete(b);
    $862faa6cda49c095$var$Yk(a, c);
}
var $862faa6cda49c095$var$Vk;
$862faa6cda49c095$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $862faa6cda49c095$var$Wf.current) $862faa6cda49c095$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $862faa6cda49c095$var$dh = !1, $862faa6cda49c095$var$yj(a, b, c);
            $862faa6cda49c095$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $862faa6cda49c095$var$dh = !1, $862faa6cda49c095$var$I && 0 !== (b.flags & 1048576) && $862faa6cda49c095$var$ug(b, $862faa6cda49c095$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $862faa6cda49c095$var$ij(a, b);
            a = b.pendingProps;
            var e = $862faa6cda49c095$var$Yf(b, $862faa6cda49c095$var$H.current);
            $862faa6cda49c095$var$ch(b, c);
            e = $862faa6cda49c095$var$Nh(null, b, d, a, e, c);
            var f = $862faa6cda49c095$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $862faa6cda49c095$var$Zf(d) ? (f = !0, $862faa6cda49c095$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $862faa6cda49c095$var$kh(b), e.updater = $862faa6cda49c095$var$Ei, b.stateNode = e, e._reactInternals = b, $862faa6cda49c095$var$Ii(b, d, a, c), b = $862faa6cda49c095$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $862faa6cda49c095$var$I && f && $862faa6cda49c095$var$vg(b), $862faa6cda49c095$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $862faa6cda49c095$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $862faa6cda49c095$var$Zk(d);
                a = $862faa6cda49c095$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $862faa6cda49c095$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $862faa6cda49c095$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $862faa6cda49c095$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $862faa6cda49c095$var$$i(null, b, d, $862faa6cda49c095$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($862faa6cda49c095$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $862faa6cda49c095$var$kj(b);
                if (null === a) throw Error($862faa6cda49c095$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $862faa6cda49c095$var$lh(a, b);
                $862faa6cda49c095$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $862faa6cda49c095$var$Ji(Error($862faa6cda49c095$var$p(423)), b);
                        b = $862faa6cda49c095$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $862faa6cda49c095$var$Ji(Error($862faa6cda49c095$var$p(424)), b);
                        b = $862faa6cda49c095$var$lj(a, b, d, c, e);
                        break a;
                    } else for($862faa6cda49c095$var$yg = $862faa6cda49c095$var$Lf(b.stateNode.containerInfo.firstChild), $862faa6cda49c095$var$xg = b, $862faa6cda49c095$var$I = !0, $862faa6cda49c095$var$zg = null, c = $862faa6cda49c095$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $862faa6cda49c095$var$Ig();
                    if (d === e) {
                        b = $862faa6cda49c095$var$Zi(a, b, c);
                        break a;
                    }
                    $862faa6cda49c095$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $862faa6cda49c095$var$Ah(b), null === a && $862faa6cda49c095$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $862faa6cda49c095$var$Ef(d, e) ? g = null : null !== f && $862faa6cda49c095$var$Ef(d, f) && (b.flags |= 32), $862faa6cda49c095$var$gj(a, b), $862faa6cda49c095$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $862faa6cda49c095$var$Eg(b), null;
        case 13:
            return $862faa6cda49c095$var$oj(a, b, c);
        case 4:
            return $862faa6cda49c095$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $862faa6cda49c095$var$Ug(b, null, d, c) : $862faa6cda49c095$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$Yi(a, b, d, e, c);
        case 7:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $862faa6cda49c095$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $862faa6cda49c095$var$G($862faa6cda49c095$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($862faa6cda49c095$var$He(f.value, g)) {
                        if (f.children === e.children && !$862faa6cda49c095$var$Wf.current) {
                            b = $862faa6cda49c095$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $862faa6cda49c095$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $862faa6cda49c095$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($862faa6cda49c095$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $862faa6cda49c095$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $862faa6cda49c095$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $862faa6cda49c095$var$ch(b, c), e = $862faa6cda49c095$var$eh(e), d = d(e), b.flags |= 1, $862faa6cda49c095$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $862faa6cda49c095$var$Ci(d, b.pendingProps), e = $862faa6cda49c095$var$Ci(d.type, e), $862faa6cda49c095$var$$i(a, b, d, e, c);
        case 15:
            return $862faa6cda49c095$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $862faa6cda49c095$var$Ci(d, e), $862faa6cda49c095$var$ij(a, b), b.tag = 1, $862faa6cda49c095$var$Zf(d) ? (a = !0, $862faa6cda49c095$var$cg(b)) : a = !1, $862faa6cda49c095$var$ch(b, c), $862faa6cda49c095$var$Gi(b, d, e), $862faa6cda49c095$var$Ii(b, d, e, c), $862faa6cda49c095$var$jj(null, b, d, !0, a, c);
        case 19:
            return $862faa6cda49c095$var$xj(a, b, c);
        case 22:
            return $862faa6cda49c095$var$dj(a, b, c);
    }
    throw Error($862faa6cda49c095$var$p(156, b.tag));
};
function $862faa6cda49c095$var$Fk(a, b) {
    return $862faa6cda49c095$var$ac(a, b);
}
function $862faa6cda49c095$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $862faa6cda49c095$var$Bg(a, b, c, d) {
    return new $862faa6cda49c095$var$$k(a, b, c, d);
}
function $862faa6cda49c095$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $862faa6cda49c095$var$Zk(a) {
    if ("function" === typeof a) return $862faa6cda49c095$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $862faa6cda49c095$var$Da) return 11;
        if (a === $862faa6cda49c095$var$Ga) return 14;
    }
    return 2;
}
function $862faa6cda49c095$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $862faa6cda49c095$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $862faa6cda49c095$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $862faa6cda49c095$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $862faa6cda49c095$var$ya:
            return $862faa6cda49c095$var$Tg(c.children, e, f, b);
        case $862faa6cda49c095$var$za:
            g = 8;
            e |= 8;
            break;
        case $862faa6cda49c095$var$Aa:
            return a = $862faa6cda49c095$var$Bg(12, c, b, e | 2), a.elementType = $862faa6cda49c095$var$Aa, a.lanes = f, a;
        case $862faa6cda49c095$var$Ea:
            return a = $862faa6cda49c095$var$Bg(13, c, b, e), a.elementType = $862faa6cda49c095$var$Ea, a.lanes = f, a;
        case $862faa6cda49c095$var$Fa:
            return a = $862faa6cda49c095$var$Bg(19, c, b, e), a.elementType = $862faa6cda49c095$var$Fa, a.lanes = f, a;
        case $862faa6cda49c095$var$Ia:
            return $862faa6cda49c095$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $862faa6cda49c095$var$Ba:
                    g = 10;
                    break a;
                case $862faa6cda49c095$var$Ca:
                    g = 9;
                    break a;
                case $862faa6cda49c095$var$Da:
                    g = 11;
                    break a;
                case $862faa6cda49c095$var$Ga:
                    g = 14;
                    break a;
                case $862faa6cda49c095$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($862faa6cda49c095$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $862faa6cda49c095$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $862faa6cda49c095$var$Tg(a, b, c, d) {
    a = $862faa6cda49c095$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $862faa6cda49c095$var$pj(a, b, c, d) {
    a = $862faa6cda49c095$var$Bg(22, a, d, b);
    a.elementType = $862faa6cda49c095$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $862faa6cda49c095$var$Qg(a, b, c) {
    a = $862faa6cda49c095$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $862faa6cda49c095$var$Sg(a, b, c) {
    b = $862faa6cda49c095$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $862faa6cda49c095$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $862faa6cda49c095$var$zc(0);
    this.expirationTimes = $862faa6cda49c095$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $862faa6cda49c095$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $862faa6cda49c095$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $862faa6cda49c095$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $862faa6cda49c095$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $862faa6cda49c095$var$kh(f);
    return a;
}
function $862faa6cda49c095$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $862faa6cda49c095$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $862faa6cda49c095$var$dl(a) {
    if (!a) return $862faa6cda49c095$var$Vf;
    a = a._reactInternals;
    a: {
        if ($862faa6cda49c095$var$Vb(a) !== a || 1 !== a.tag) throw Error($862faa6cda49c095$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($862faa6cda49c095$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($862faa6cda49c095$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($862faa6cda49c095$var$Zf(c)) return $862faa6cda49c095$var$bg(a, c, b);
    }
    return b;
}
function $862faa6cda49c095$var$el(a, b, c, d, e, f, g, h, k) {
    a = $862faa6cda49c095$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $862faa6cda49c095$var$dl(null);
    c = a.current;
    d = $862faa6cda49c095$var$R();
    e = $862faa6cda49c095$var$yi(c);
    f = $862faa6cda49c095$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $862faa6cda49c095$var$nh(c, f, e);
    a.current.lanes = e;
    $862faa6cda49c095$var$Ac(a, e, d);
    $862faa6cda49c095$var$Dk(a, d);
    return a;
}
function $862faa6cda49c095$var$fl(a, b, c, d) {
    var e = b.current, f = $862faa6cda49c095$var$R(), g = $862faa6cda49c095$var$yi(e);
    c = $862faa6cda49c095$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $862faa6cda49c095$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $862faa6cda49c095$var$nh(e, b, g);
    null !== a && ($862faa6cda49c095$var$gi(a, e, g, f), $862faa6cda49c095$var$oh(a, e, g));
    return g;
}
function $862faa6cda49c095$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $862faa6cda49c095$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $862faa6cda49c095$var$il(a, b) {
    $862faa6cda49c095$var$hl(a, b);
    (a = a.alternate) && $862faa6cda49c095$var$hl(a, b);
}
function $862faa6cda49c095$var$jl() {
    return null;
}
var $862faa6cda49c095$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $862faa6cda49c095$var$ll(a) {
    this._internalRoot = a;
}
$862faa6cda49c095$var$ml.prototype.render = $862faa6cda49c095$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($862faa6cda49c095$var$p(409));
    $862faa6cda49c095$var$fl(a, b, null, null);
};
$862faa6cda49c095$var$ml.prototype.unmount = $862faa6cda49c095$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $862faa6cda49c095$var$Rk(function() {
            $862faa6cda49c095$var$fl(null, a, null, null);
        });
        b[$862faa6cda49c095$var$uf] = null;
    }
};
function $862faa6cda49c095$var$ml(a) {
    this._internalRoot = a;
}
$862faa6cda49c095$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $862faa6cda49c095$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $862faa6cda49c095$var$Qc.length && 0 !== b && b < $862faa6cda49c095$var$Qc[c].priority; c++);
        $862faa6cda49c095$var$Qc.splice(c, 0, a);
        0 === c && $862faa6cda49c095$var$Vc(a);
    }
};
function $862faa6cda49c095$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $862faa6cda49c095$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $862faa6cda49c095$var$pl() {}
function $862faa6cda49c095$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $862faa6cda49c095$var$gl(g);
                f.call(a);
            };
        }
        var g = $862faa6cda49c095$var$el(b, d, a, 0, null, !1, !1, "", $862faa6cda49c095$var$pl);
        a._reactRootContainer = g;
        a[$862faa6cda49c095$var$uf] = g.current;
        $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
        $862faa6cda49c095$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $862faa6cda49c095$var$gl(k);
            h.call(a);
        };
    }
    var k = $862faa6cda49c095$var$bl(a, 0, !1, null, null, !1, !1, "", $862faa6cda49c095$var$pl);
    a._reactRootContainer = k;
    a[$862faa6cda49c095$var$uf] = k.current;
    $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
    $862faa6cda49c095$var$Rk(function() {
        $862faa6cda49c095$var$fl(b, k, c, d);
    });
    return k;
}
function $862faa6cda49c095$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $862faa6cda49c095$var$gl(g);
                h.call(a);
            };
        }
        $862faa6cda49c095$var$fl(b, g, a, e);
    } else g = $862faa6cda49c095$var$ql(c, b, a, e, d);
    return $862faa6cda49c095$var$gl(g);
}
$862faa6cda49c095$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $862faa6cda49c095$var$tc(b.pendingLanes);
                0 !== c && ($862faa6cda49c095$var$Cc(b, c | 1), $862faa6cda49c095$var$Dk(b, $862faa6cda49c095$var$B()), 0 === ($862faa6cda49c095$var$K & 6) && ($862faa6cda49c095$var$Gj = $862faa6cda49c095$var$B() + 500, $862faa6cda49c095$var$jg()));
            }
            break;
        case 13:
            $862faa6cda49c095$var$Rk(function() {
                var b = $862faa6cda49c095$var$ih(a, 1);
                if (null !== b) {
                    var c = $862faa6cda49c095$var$R();
                    $862faa6cda49c095$var$gi(b, a, 1, c);
                }
            }), $862faa6cda49c095$var$il(a, 1);
    }
};
$862faa6cda49c095$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $862faa6cda49c095$var$ih(a, 134217728);
        if (null !== b) {
            var c = $862faa6cda49c095$var$R();
            $862faa6cda49c095$var$gi(b, a, 134217728, c);
        }
        $862faa6cda49c095$var$il(a, 134217728);
    }
};
$862faa6cda49c095$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $862faa6cda49c095$var$yi(a), c = $862faa6cda49c095$var$ih(a, b);
        if (null !== c) {
            var d = $862faa6cda49c095$var$R();
            $862faa6cda49c095$var$gi(c, a, b, d);
        }
        $862faa6cda49c095$var$il(a, b);
    }
};
$862faa6cda49c095$var$Hc = function() {
    return $862faa6cda49c095$var$C;
};
$862faa6cda49c095$var$Ic = function(a, b) {
    var c = $862faa6cda49c095$var$C;
    try {
        return $862faa6cda49c095$var$C = a, b();
    } finally{
        $862faa6cda49c095$var$C = c;
    }
};
$862faa6cda49c095$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $862faa6cda49c095$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $862faa6cda49c095$var$Db(d);
                        if (!e) throw Error($862faa6cda49c095$var$p(90));
                        $862faa6cda49c095$var$Wa(d);
                        $862faa6cda49c095$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $862faa6cda49c095$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $862faa6cda49c095$var$fb(a, !!c.multiple, b, !1);
    }
};
$862faa6cda49c095$var$Gb = $862faa6cda49c095$var$Qk;
$862faa6cda49c095$var$Hb = $862faa6cda49c095$var$Rk;
var $862faa6cda49c095$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $862faa6cda49c095$var$Cb,
        $862faa6cda49c095$var$ue,
        $862faa6cda49c095$var$Db,
        $862faa6cda49c095$var$Eb,
        $862faa6cda49c095$var$Fb,
        $862faa6cda49c095$var$Qk
    ]
}, $862faa6cda49c095$var$tl = {
    findFiberByHostInstance: $862faa6cda49c095$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $862faa6cda49c095$var$ul = {
    bundleType: $862faa6cda49c095$var$tl.bundleType,
    version: $862faa6cda49c095$var$tl.version,
    rendererPackageName: $862faa6cda49c095$var$tl.rendererPackageName,
    rendererConfig: $862faa6cda49c095$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $862faa6cda49c095$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $862faa6cda49c095$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $862faa6cda49c095$var$tl.findFiberByHostInstance || $862faa6cda49c095$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $862faa6cda49c095$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$862faa6cda49c095$var$vl.isDisabled && $862faa6cda49c095$var$vl.supportsFiber) try {
        $862faa6cda49c095$var$kc = $862faa6cda49c095$var$vl.inject($862faa6cda49c095$var$ul), $862faa6cda49c095$var$lc = $862faa6cda49c095$var$vl;
    } catch (a) {}
}
$862faa6cda49c095$export$ae55be85d98224ed = $862faa6cda49c095$var$sl;
$862faa6cda49c095$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$862faa6cda49c095$var$nl(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$cl(a, b, null, c);
};
$862faa6cda49c095$export$882461b6382ed46c = function(a, b) {
    if (!$862faa6cda49c095$var$nl(a)) throw Error($862faa6cda49c095$var$p(299));
    var c = !1, d = "", e = $862faa6cda49c095$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $862faa6cda49c095$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$862faa6cda49c095$var$uf] = b.current;
    $862faa6cda49c095$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $862faa6cda49c095$var$ll(b);
};
$862faa6cda49c095$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($862faa6cda49c095$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($862faa6cda49c095$var$p(268, a));
    }
    a = $862faa6cda49c095$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$862faa6cda49c095$export$cd75ccfd720a3cd4 = function(a) {
    return $862faa6cda49c095$var$Rk(a);
};
$862faa6cda49c095$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$862faa6cda49c095$var$ol(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$rl(null, a, b, !0, c);
};
$862faa6cda49c095$export$757ceba2d55c277e = function(a, b, c) {
    if (!$862faa6cda49c095$var$nl(a)) throw Error($862faa6cda49c095$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $862faa6cda49c095$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $862faa6cda49c095$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$862faa6cda49c095$var$uf] = b.current;
    $862faa6cda49c095$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $862faa6cda49c095$var$ml(b);
};
$862faa6cda49c095$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$862faa6cda49c095$var$ol(b)) throw Error($862faa6cda49c095$var$p(200));
    return $862faa6cda49c095$var$rl(null, a, b, !1, c);
};
$862faa6cda49c095$export$502457920280e6be = function(a) {
    if (!$862faa6cda49c095$var$ol(a)) throw Error($862faa6cda49c095$var$p(40));
    return a._reactRootContainer ? ($862faa6cda49c095$var$Rk(function() {
        $862faa6cda49c095$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$862faa6cda49c095$var$uf] = null;
        });
    }), !0) : !1;
};
$862faa6cda49c095$export$c78a37762a8d58e1 = $862faa6cda49c095$var$Qk;
$862faa6cda49c095$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$862faa6cda49c095$var$ol(c)) throw Error($862faa6cda49c095$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($862faa6cda49c095$var$p(38));
    return $862faa6cda49c095$var$rl(a, b, c, !1, d);
};
$862faa6cda49c095$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8TTSu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fYG2A"));

});
parcelRegister("fYG2A", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ba1d120a78855737$export$c4744153514ff05d; }, function (v) { return $ba1d120a78855737$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ba1d120a78855737$export$3e506c1ccc9cc1a7; }, function (v) { return $ba1d120a78855737$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ba1d120a78855737$export$e26fe2ed2fa76875; }, function (v) { return $ba1d120a78855737$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ba1d120a78855737$export$502329bbf4b505b1; }, function (v) { return $ba1d120a78855737$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ba1d120a78855737$export$6e3807111c4874c4; }, function (v) { return $ba1d120a78855737$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ba1d120a78855737$export$c27134553091fb3a; }, function (v) { return $ba1d120a78855737$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ba1d120a78855737$export$33ee1acdc04fd2a2; }, function (v) { return $ba1d120a78855737$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ba1d120a78855737$export$b00a404bbd5edef2; }, function (v) { return $ba1d120a78855737$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ba1d120a78855737$export$8352ce38b91d0c62; }, function (v) { return $ba1d120a78855737$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ba1d120a78855737$export$d66a1c1c77bd778b; }, function (v) { return $ba1d120a78855737$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ba1d120a78855737$export$d3dfb8e4810cb555; }, function (v) { return $ba1d120a78855737$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ba1d120a78855737$export$839f9183b0465a69; }, function (v) { return $ba1d120a78855737$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ba1d120a78855737$export$72fdf0e06517287b; }, function (v) { return $ba1d120a78855737$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ba1d120a78855737$export$4b844e58a3e414b4; }, function (v) { return $ba1d120a78855737$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ba1d120a78855737$export$816d2913ae6b83b1; }, function (v) { return $ba1d120a78855737$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ba1d120a78855737$export$61bcfe829111a1d0; }, function (v) { return $ba1d120a78855737$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ba1d120a78855737$export$7ee8c9beb337bc3f; }, function (v) { return $ba1d120a78855737$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ba1d120a78855737$export$b5836b71941fa3ed; }, function (v) { return $ba1d120a78855737$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ba1d120a78855737$export$cf845f2c119da08a; }, function (v) { return $ba1d120a78855737$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba1d120a78855737$export$c4744153514ff05d;
var $ba1d120a78855737$export$3e506c1ccc9cc1a7;
var $ba1d120a78855737$export$e26fe2ed2fa76875;
var $ba1d120a78855737$export$502329bbf4b505b1;
var $ba1d120a78855737$export$6e3807111c4874c4;
var $ba1d120a78855737$export$c27134553091fb3a;
var $ba1d120a78855737$export$33ee1acdc04fd2a2;
var $ba1d120a78855737$export$b00a404bbd5edef2;
var $ba1d120a78855737$export$8352ce38b91d0c62;
var $ba1d120a78855737$export$d66a1c1c77bd778b;
var $ba1d120a78855737$export$d3dfb8e4810cb555;
var $ba1d120a78855737$export$839f9183b0465a69;
var $ba1d120a78855737$export$72fdf0e06517287b;
var $ba1d120a78855737$export$4b844e58a3e414b4;
var $ba1d120a78855737$export$816d2913ae6b83b1;
var $ba1d120a78855737$export$61bcfe829111a1d0;
var $ba1d120a78855737$export$7ee8c9beb337bc3f;
var $ba1d120a78855737$export$b5836b71941fa3ed;
var $ba1d120a78855737$export$cf845f2c119da08a;
'use strict';
function $ba1d120a78855737$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ba1d120a78855737$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ba1d120a78855737$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ba1d120a78855737$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ba1d120a78855737$var$g(C, c)) n < e && 0 > $ba1d120a78855737$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ba1d120a78855737$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ba1d120a78855737$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ba1d120a78855737$var$l = performance;
    $ba1d120a78855737$export$c4744153514ff05d = function() {
        return $ba1d120a78855737$var$l.now();
    };
} else {
    var $ba1d120a78855737$var$p = Date, $ba1d120a78855737$var$q = $ba1d120a78855737$var$p.now();
    $ba1d120a78855737$export$c4744153514ff05d = function() {
        return $ba1d120a78855737$var$p.now() - $ba1d120a78855737$var$q;
    };
}
var $ba1d120a78855737$var$r = [], $ba1d120a78855737$var$t = [], $ba1d120a78855737$var$u = 1, $ba1d120a78855737$var$v = null, $ba1d120a78855737$var$y = 3, $ba1d120a78855737$var$z = !1, $ba1d120a78855737$var$A = !1, $ba1d120a78855737$var$B = !1, $ba1d120a78855737$var$D = "function" === typeof setTimeout ? setTimeout : null, $ba1d120a78855737$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ba1d120a78855737$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ba1d120a78855737$var$G(a) {
    for(var b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t); null !== b;){
        if (null === b.callback) $ba1d120a78855737$var$k($ba1d120a78855737$var$t);
        else if (b.startTime <= a) $ba1d120a78855737$var$k($ba1d120a78855737$var$t), b.sortIndex = b.expirationTime, $ba1d120a78855737$var$f($ba1d120a78855737$var$r, b);
        else break;
        b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
    }
}
function $ba1d120a78855737$var$H(a) {
    $ba1d120a78855737$var$B = !1;
    $ba1d120a78855737$var$G(a);
    if (!$ba1d120a78855737$var$A) {
        if (null !== $ba1d120a78855737$var$h($ba1d120a78855737$var$r)) $ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J);
        else {
            var b = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
            null !== b && $ba1d120a78855737$var$K($ba1d120a78855737$var$H, b.startTime - a);
        }
    }
}
function $ba1d120a78855737$var$J(a, b) {
    $ba1d120a78855737$var$A = !1;
    $ba1d120a78855737$var$B && ($ba1d120a78855737$var$B = !1, $ba1d120a78855737$var$E($ba1d120a78855737$var$L), $ba1d120a78855737$var$L = -1);
    $ba1d120a78855737$var$z = !0;
    var c = $ba1d120a78855737$var$y;
    try {
        $ba1d120a78855737$var$G(b);
        for($ba1d120a78855737$var$v = $ba1d120a78855737$var$h($ba1d120a78855737$var$r); null !== $ba1d120a78855737$var$v && (!($ba1d120a78855737$var$v.expirationTime > b) || a && !$ba1d120a78855737$var$M());){
            var d = $ba1d120a78855737$var$v.callback;
            if ("function" === typeof d) {
                $ba1d120a78855737$var$v.callback = null;
                $ba1d120a78855737$var$y = $ba1d120a78855737$var$v.priorityLevel;
                var e = d($ba1d120a78855737$var$v.expirationTime <= b);
                b = $ba1d120a78855737$export$c4744153514ff05d();
                "function" === typeof e ? $ba1d120a78855737$var$v.callback = e : $ba1d120a78855737$var$v === $ba1d120a78855737$var$h($ba1d120a78855737$var$r) && $ba1d120a78855737$var$k($ba1d120a78855737$var$r);
                $ba1d120a78855737$var$G(b);
            } else $ba1d120a78855737$var$k($ba1d120a78855737$var$r);
            $ba1d120a78855737$var$v = $ba1d120a78855737$var$h($ba1d120a78855737$var$r);
        }
        if (null !== $ba1d120a78855737$var$v) var w = !0;
        else {
            var m = $ba1d120a78855737$var$h($ba1d120a78855737$var$t);
            null !== m && $ba1d120a78855737$var$K($ba1d120a78855737$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ba1d120a78855737$var$v = null, $ba1d120a78855737$var$y = c, $ba1d120a78855737$var$z = !1;
    }
}
var $ba1d120a78855737$var$N = !1, $ba1d120a78855737$var$O = null, $ba1d120a78855737$var$L = -1, $ba1d120a78855737$var$P = 5, $ba1d120a78855737$var$Q = -1;
function $ba1d120a78855737$var$M() {
    return $ba1d120a78855737$export$c4744153514ff05d() - $ba1d120a78855737$var$Q < $ba1d120a78855737$var$P ? !1 : !0;
}
function $ba1d120a78855737$var$R() {
    if (null !== $ba1d120a78855737$var$O) {
        var a = $ba1d120a78855737$export$c4744153514ff05d();
        $ba1d120a78855737$var$Q = a;
        var b = !0;
        try {
            b = $ba1d120a78855737$var$O(!0, a);
        } finally{
            b ? $ba1d120a78855737$var$S() : ($ba1d120a78855737$var$N = !1, $ba1d120a78855737$var$O = null);
        }
    } else $ba1d120a78855737$var$N = !1;
}
var $ba1d120a78855737$var$S;
if ("function" === typeof $ba1d120a78855737$var$F) $ba1d120a78855737$var$S = function() {
    $ba1d120a78855737$var$F($ba1d120a78855737$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ba1d120a78855737$var$T = new MessageChannel, $ba1d120a78855737$var$U = $ba1d120a78855737$var$T.port2;
    $ba1d120a78855737$var$T.port1.onmessage = $ba1d120a78855737$var$R;
    $ba1d120a78855737$var$S = function() {
        $ba1d120a78855737$var$U.postMessage(null);
    };
} else $ba1d120a78855737$var$S = function() {
    $ba1d120a78855737$var$D($ba1d120a78855737$var$R, 0);
};
function $ba1d120a78855737$var$I(a) {
    $ba1d120a78855737$var$O = a;
    $ba1d120a78855737$var$N || ($ba1d120a78855737$var$N = !0, $ba1d120a78855737$var$S());
}
function $ba1d120a78855737$var$K(a, b) {
    $ba1d120a78855737$var$L = $ba1d120a78855737$var$D(function() {
        a($ba1d120a78855737$export$c4744153514ff05d());
    }, b);
}
$ba1d120a78855737$export$3e506c1ccc9cc1a7 = 5;
$ba1d120a78855737$export$e26fe2ed2fa76875 = 1;
$ba1d120a78855737$export$502329bbf4b505b1 = 4;
$ba1d120a78855737$export$6e3807111c4874c4 = 3;
$ba1d120a78855737$export$c27134553091fb3a = null;
$ba1d120a78855737$export$33ee1acdc04fd2a2 = 2;
$ba1d120a78855737$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ba1d120a78855737$export$8352ce38b91d0c62 = function() {
    $ba1d120a78855737$var$A || $ba1d120a78855737$var$z || ($ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J));
};
$ba1d120a78855737$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ba1d120a78855737$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ba1d120a78855737$export$d3dfb8e4810cb555 = function() {
    return $ba1d120a78855737$var$y;
};
$ba1d120a78855737$export$839f9183b0465a69 = function() {
    return $ba1d120a78855737$var$h($ba1d120a78855737$var$r);
};
$ba1d120a78855737$export$72fdf0e06517287b = function(a) {
    switch($ba1d120a78855737$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ba1d120a78855737$var$y;
    }
    var c = $ba1d120a78855737$var$y;
    $ba1d120a78855737$var$y = b;
    try {
        return a();
    } finally{
        $ba1d120a78855737$var$y = c;
    }
};
$ba1d120a78855737$export$4b844e58a3e414b4 = function() {};
$ba1d120a78855737$export$816d2913ae6b83b1 = function() {};
$ba1d120a78855737$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ba1d120a78855737$var$y;
    $ba1d120a78855737$var$y = a;
    try {
        return b();
    } finally{
        $ba1d120a78855737$var$y = c;
    }
};
$ba1d120a78855737$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ba1d120a78855737$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ba1d120a78855737$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ba1d120a78855737$var$f($ba1d120a78855737$var$t, a), null === $ba1d120a78855737$var$h($ba1d120a78855737$var$r) && a === $ba1d120a78855737$var$h($ba1d120a78855737$var$t) && ($ba1d120a78855737$var$B ? ($ba1d120a78855737$var$E($ba1d120a78855737$var$L), $ba1d120a78855737$var$L = -1) : $ba1d120a78855737$var$B = !0, $ba1d120a78855737$var$K($ba1d120a78855737$var$H, c - d))) : (a.sortIndex = e, $ba1d120a78855737$var$f($ba1d120a78855737$var$r, a), $ba1d120a78855737$var$A || $ba1d120a78855737$var$z || ($ba1d120a78855737$var$A = !0, $ba1d120a78855737$var$I($ba1d120a78855737$var$J)));
    return a;
};
$ba1d120a78855737$export$b5836b71941fa3ed = $ba1d120a78855737$var$M;
$ba1d120a78855737$export$cf845f2c119da08a = function(a) {
    var b = $ba1d120a78855737$var$y;
    return function() {
        var c = $ba1d120a78855737$var$y;
        $ba1d120a78855737$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ba1d120a78855737$var$y = c;
        }
    };
};

});



parcelRegister("j11Is", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $dd7f711204de761b$export$bf730a2d8bf68b42; }, function (v) { return $dd7f711204de761b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd7f711204de761b$export$bf730a2d8bf68b42;
"use strict";

var $4RFnf = parcelRequire("4RFnf");
function $dd7f711204de761b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd7f711204de761b$var$objectIs = "function" === typeof Object.is ? Object.is : $dd7f711204de761b$var$is, $dd7f711204de761b$var$useSyncExternalStore = $4RFnf.useSyncExternalStore, $dd7f711204de761b$var$useRef = $4RFnf.useRef, $dd7f711204de761b$var$useEffect = $4RFnf.useEffect, $dd7f711204de761b$var$useMemo = $4RFnf.useMemo, $dd7f711204de761b$var$useDebugValue = $4RFnf.useDebugValue;
$dd7f711204de761b$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd7f711204de761b$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd7f711204de761b$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd7f711204de761b$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd7f711204de761b$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd7f711204de761b$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd7f711204de761b$var$useDebugValue(value);
    return value;
};

});

parcelRegister("7WqRZ", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $28bbcb162884bfbd$export$e25e478948902b8b; });

var $5g0Lz = parcelRequire("5g0Lz");

var $6tuCf = parcelRequire("6tuCf");

var $dK2It = parcelRequire("dK2It");
const $28bbcb162884bfbd$export$e25e478948902b8b = /*@__PURE__*/ (0, $6tuCf.createMotionProxy)((0, $dK2It.featureBundle), (0, $5g0Lz.createDomVisualElement));

});
parcelRegister("5g0Lz", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $3f34675d01ef4842$export$56ba0183203348f5; });

var $4RFnf = parcelRequire("4RFnf");

var $9Dwik = parcelRequire("9Dwik");

var $2sH6y = parcelRequire("2sH6y");

var $b85su = parcelRequire("b85su");
const $3f34675d01ef4842$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $b85su.isSVGComponent)(Component) ? new (0, $2sH6y.SVGVisualElement)(options) : new (0, $9Dwik.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $4RFnf.Fragment)
    });
};

});
parcelRegister("9Dwik", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $9737f2a37c9863dd$export$23fea75b03ac16b3; });

var $7a1mp = parcelRequire("7a1mp");
var $7V3so = parcelRequire("7V3so");
var $3Vm0J = parcelRequire("3Vm0J");

var $hQqmZ = parcelRequire("hQqmZ");

var $dqCvj = parcelRequire("dqCvj");

var $3v57z = parcelRequire("3v57z");

var $fmykX = parcelRequire("fmykX");

var $fS3sq = parcelRequire("fS3sq");
function $9737f2a37c9863dd$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $9737f2a37c9863dd$export$23fea75b03ac16b3 extends (0, $dqCvj.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $fmykX.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, $3Vm0J.transformProps).has(key)) return this.projection?.isProjecting ? (0, $7a1mp.defaultTransformValue)(key) : (0, $7a1mp.readTransformValue)(instance, key);
        else {
            const computedStyle = $9737f2a37c9863dd$export$3735103072e4a80(instance);
            const value = ((0, $7V3so.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $hQqmZ.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $3v57z.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $fS3sq.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

});
parcelRegister("7a1mp", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", function () { return $a26a394a4c476a7e$export$1f10c01143b9f089; });
$parcel$export(module.exports, "parseValueFromTransform", function () { return $a26a394a4c476a7e$export$f9111f9e16b73a26; });
$parcel$export(module.exports, "readTransformValue", function () { return $a26a394a4c476a7e$export$bcd97e0e03ba17f6; });
const $a26a394a4c476a7e$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $a26a394a4c476a7e$var$rotate = (v)=>{
    const angle = $a26a394a4c476a7e$var$radToDeg(Math.atan2(v[1], v[0]));
    return $a26a394a4c476a7e$var$rebaseAngle(angle);
};
const $a26a394a4c476a7e$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $a26a394a4c476a7e$var$rotate,
    rotateZ: $a26a394a4c476a7e$var$rotate,
    skewX: (v)=>$a26a394a4c476a7e$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$a26a394a4c476a7e$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $a26a394a4c476a7e$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $a26a394a4c476a7e$var$rotateZ = $a26a394a4c476a7e$var$rotate;
const $a26a394a4c476a7e$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $a26a394a4c476a7e$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $a26a394a4c476a7e$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $a26a394a4c476a7e$var$scaleX,
    scaleY: $a26a394a4c476a7e$var$scaleY,
    scale: (v)=>($a26a394a4c476a7e$var$scaleX(v) + $a26a394a4c476a7e$var$scaleY(v)) / 2,
    rotateX: (v)=>$a26a394a4c476a7e$var$rebaseAngle($a26a394a4c476a7e$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$a26a394a4c476a7e$var$rebaseAngle($a26a394a4c476a7e$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $a26a394a4c476a7e$var$rotateZ,
    rotate: $a26a394a4c476a7e$var$rotateZ,
    skewX: (v)=>$a26a394a4c476a7e$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$a26a394a4c476a7e$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $a26a394a4c476a7e$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $a26a394a4c476a7e$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $a26a394a4c476a7e$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $a26a394a4c476a7e$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $a26a394a4c476a7e$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $a26a394a4c476a7e$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($a26a394a4c476a7e$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $a26a394a4c476a7e$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $a26a394a4c476a7e$export$f9111f9e16b73a26(transform, name);
};
function $a26a394a4c476a7e$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});

parcelRegister("7V3so", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $e6f5c9c386863d04$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $e6f5c9c386863d04$export$31f9caa2600b5723; });
const $e6f5c9c386863d04$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $e6f5c9c386863d04$export$9de1236619d9e756 = /*@__PURE__*/ $e6f5c9c386863d04$var$checkStringStartsWith("--");
const $e6f5c9c386863d04$var$startsAsVariableToken = /*@__PURE__*/ $e6f5c9c386863d04$var$checkStringStartsWith("var(--");
const $e6f5c9c386863d04$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $e6f5c9c386863d04$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $e6f5c9c386863d04$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $e6f5c9c386863d04$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});

parcelRegister("3Vm0J", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $0de92f1313a396d2$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $0de92f1313a396d2$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $0de92f1313a396d2$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $0de92f1313a396d2$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($0de92f1313a396d2$export$280dc01950909d86))();

});

parcelRegister("hQqmZ", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $fd45c157b82e0231$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $fd45c157b82e0231$export$6a597be7a7940a96; });

var $eIYTw = parcelRequire("eIYTw");

var $9J9kF = parcelRequire("9J9kF");
function $fd45c157b82e0231$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $eIYTw.convertBoundingBoxToBox)((0, $eIYTw.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $fd45c157b82e0231$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $fd45c157b82e0231$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $9J9kF.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $9J9kF.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("eIYTw", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $52c3c04007ac61d0$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $52c3c04007ac61d0$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $52c3c04007ac61d0$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $52c3c04007ac61d0$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $52c3c04007ac61d0$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $52c3c04007ac61d0$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("9J9kF", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $6cd9900eb68fa7b5$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $6cd9900eb68fa7b5$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $6cd9900eb68fa7b5$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $6cd9900eb68fa7b5$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $6cd9900eb68fa7b5$export$a807a5ce5ebb3895; });

var $bTGI6 = parcelRequire("bTGI6");

var $1Xmdc = parcelRequire("1Xmdc");
/**
 * Scales a point based on a factor and an originPoint
 */ function $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $6cd9900eb68fa7b5$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $6cd9900eb68fa7b5$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $6cd9900eb68fa7b5$export$d80074982803af5c(box, { x: x, y: y }) {
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $6cd9900eb68fa7b5$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $6cd9900eb68fa7b5$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $6cd9900eb68fa7b5$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $1Xmdc.hasTransform)(node.latestValues)) $6cd9900eb68fa7b5$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MAX && treeScale.x > $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MAX && treeScale.y > $6cd9900eb68fa7b5$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $6cd9900eb68fa7b5$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $bTGI6.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $6cd9900eb68fa7b5$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $6cd9900eb68fa7b5$export$58b16271041fbfb(box, transform) {
    $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $6cd9900eb68fa7b5$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("bTGI6", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $993626fa39952433$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $993626fa39952433$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("1Xmdc", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $cd7697370eec385d$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $cd7697370eec385d$export$a545127cf1fbb600; });
$parcel$export(module.exports, "has2DTranslate", function () { return $cd7697370eec385d$export$bf80f5f8f4dc327f; });
function $cd7697370eec385d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $cd7697370eec385d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$cd7697370eec385d$var$isIdentityScale(scale) || !$cd7697370eec385d$var$isIdentityScale(scaleX) || !$cd7697370eec385d$var$isIdentityScale(scaleY);
}
function $cd7697370eec385d$export$a545127cf1fbb600(values) {
    return $cd7697370eec385d$export$bdf30dca883ea463(values) || $cd7697370eec385d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $cd7697370eec385d$export$bf80f5f8f4dc327f(values) {
    return $cd7697370eec385d$var$is2DTranslate(values.x) || $cd7697370eec385d$var$is2DTranslate(values.y);
}
function $cd7697370eec385d$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("dqCvj", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $ac6f4802411cfd4a$export$e49735c2a366bdc7; });

var $8234g = parcelRequire("8234g");
var $8XwwR = parcelRequire("8XwwR");

var $5yq0L = parcelRequire("5yq0L");
class $ac6f4802411cfd4a$export$e49735c2a366bdc7 extends (0, $5yq0L.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $8234g.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $8XwwR.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("8234g", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $12986ed5b42a9286$export$4983792d11b61017; });

var $3d5As = parcelRequire("3d5As");

var $axu4m = parcelRequire("axu4m");

var $gWOc4 = parcelRequire("gWOc4");

var $7V3so = parcelRequire("7V3so");

var $jVEGV = parcelRequire("jVEGV");

var $hAvoj = parcelRequire("hAvoj");

var $3UfKJ = parcelRequire("3UfKJ");

var $huj13 = parcelRequire("huj13");
class $12986ed5b42a9286$export$4983792d11b61017 extends (0, $jVEGV.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7V3so.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $gWOc4.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $3d5As.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $axu4m.findDimensionValueType)(origin);
        const targetType = (0, $axu4m.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $huj13.isNumOrPxType)(originType) && (0, $huj13.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $huj13.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $hAvoj.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $3UfKJ.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $huj13.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $huj13.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("3d5As", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $b8629f92973a9927$export$c66c0d5db2a205d; });

var $3Vm0J = parcelRequire("3Vm0J");
const $b8629f92973a9927$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $3Vm0J.transformPropOrder)
]);

});

parcelRegister("axu4m", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $bb8bf66fc11c7d99$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $bb8bf66fc11c7d99$export$eefdd52e3ccae428; });

var $bFOYH = parcelRequire("bFOYH");

var $groAF = parcelRequire("groAF");

var $7mQ5b = parcelRequire("7mQ5b");

var $2WUJq = parcelRequire("2WUJq");
/**
 * A list of value types commonly used for dimensions
 */ const $bb8bf66fc11c7d99$export$d176691c1998a1f5 = [
    (0, $groAF.number),
    (0, $7mQ5b.px),
    (0, $7mQ5b.percent),
    (0, $7mQ5b.degrees),
    (0, $7mQ5b.vw),
    (0, $7mQ5b.vh),
    (0, $bFOYH.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $bb8bf66fc11c7d99$export$eefdd52e3ccae428 = (v)=>$bb8bf66fc11c7d99$export$d176691c1998a1f5.find((0, $2WUJq.testValueType)(v));

});
parcelRegister("bFOYH", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $b0680deec3711d07$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $b0680deec3711d07$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});

parcelRegister("groAF", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $218e91984ecee6e5$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $218e91984ecee6e5$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $218e91984ecee6e5$export$dcdf75081b88279d; });

var $9M1og = parcelRequire("9M1og");
const $218e91984ecee6e5$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $218e91984ecee6e5$export$58f0f39f63f3cf42 = {
    ...$218e91984ecee6e5$export$98e628dec113755e,
    transform: (v)=>(0, $9M1og.clamp)(0, 1, v)
};
const $218e91984ecee6e5$export$dcdf75081b88279d = {
    ...$218e91984ecee6e5$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("9M1og", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $73f113e44868bb75$export$7d15b64cf5a3a4c4; });
const $73f113e44868bb75$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("7mQ5b", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $a96bb35f6c60c830$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $a96bb35f6c60c830$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $a96bb35f6c60c830$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $a96bb35f6c60c830$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $a96bb35f6c60c830$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $a96bb35f6c60c830$export$44e2e1705876d7ed; });
/*#__NO_SIDE_EFFECTS__*/ const $a96bb35f6c60c830$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $a96bb35f6c60c830$export$41fc368e1a942b97 = /*@__PURE__*/ $a96bb35f6c60c830$var$createUnitType("deg");
const $a96bb35f6c60c830$export$626336c2cd4b14de = /*@__PURE__*/ $a96bb35f6c60c830$var$createUnitType("%");
const $a96bb35f6c60c830$export$91c0eda1d06bf008 = /*@__PURE__*/ $a96bb35f6c60c830$var$createUnitType("px");
const $a96bb35f6c60c830$export$f91e8c45a95a32f2 = /*@__PURE__*/ $a96bb35f6c60c830$var$createUnitType("vh");
const $a96bb35f6c60c830$export$aed3d7b7d206c196 = /*@__PURE__*/ $a96bb35f6c60c830$var$createUnitType("vw");
const $a96bb35f6c60c830$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$a96bb35f6c60c830$export$626336c2cd4b14de,
        parse: (v)=>$a96bb35f6c60c830$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$a96bb35f6c60c830$export$626336c2cd4b14de.transform(v * 100)
    }))();

});

parcelRegister("2WUJq", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $2e434efb99de470b$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $2e434efb99de470b$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});


parcelRegister("gWOc4", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $d645921af7eec51c$export$289398774300c991; });

var $5ygSW = parcelRequire("5ygSW");
var $cRw1i = parcelRequire("cRw1i");

var $7V3so = parcelRequire("7V3so");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $d645921af7eec51c$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $d645921af7eec51c$export$b9f0c1f373aee2b0(current) {
    const match = $d645921af7eec51c$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $d645921af7eec51c$var$maxDepth = 4;
function $d645921af7eec51c$export$289398774300c991(current, element, depth = 1) {
    (0, $5ygSW.invariant)(depth <= $d645921af7eec51c$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $d645921af7eec51c$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $cRw1i.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7V3so.isCSSVariableToken)(fallback) ? $d645921af7eec51c$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("5ygSW", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $1af39a50481ed229$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $1af39a50481ed229$export$f5708dca728d7177; });

let $1af39a50481ed229$export$491112666e282270 = ()=>{};
let $1af39a50481ed229$export$f5708dca728d7177 = ()=>{};
var $1af39a50481ed229$var$check, $1af39a50481ed229$var$message, $1af39a50481ed229$var$errorCode, $1af39a50481ed229$var$check1, $1af39a50481ed229$var$message1, $1af39a50481ed229$var$errorCode1;

});

parcelRegister("cRw1i", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $50e7f91c79ff6bd5$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $50e7f91c79ff6bd5$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});


parcelRegister("jVEGV", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $8999ac09c494d3d4$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $8999ac09c494d3d4$export$74d34ca3182f1750; });

var $cDtZ3 = parcelRequire("cDtZ3");

var $huj13 = parcelRequire("huj13");

var $15WwJ = parcelRequire("15WwJ");
const $8999ac09c494d3d4$var$toResolve = new Set();
let $8999ac09c494d3d4$var$isScheduled = false;
let $8999ac09c494d3d4$var$anyNeedsMeasurement = false;
let $8999ac09c494d3d4$var$isForced = false;
function $8999ac09c494d3d4$var$measureAllKeyframes() {
    if ($8999ac09c494d3d4$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($8999ac09c494d3d4$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $huj13.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8999ac09c494d3d4$var$anyNeedsMeasurement = false;
    $8999ac09c494d3d4$var$isScheduled = false;
    $8999ac09c494d3d4$var$toResolve.forEach((resolver)=>resolver.complete($8999ac09c494d3d4$var$isForced));
    $8999ac09c494d3d4$var$toResolve.clear();
}
function $8999ac09c494d3d4$var$readAllKeyframes() {
    $8999ac09c494d3d4$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8999ac09c494d3d4$var$anyNeedsMeasurement = true;
    });
}
function $8999ac09c494d3d4$export$78b96d2a12593b05() {
    $8999ac09c494d3d4$var$isForced = true;
    $8999ac09c494d3d4$var$readAllKeyframes();
    $8999ac09c494d3d4$var$measureAllKeyframes();
    $8999ac09c494d3d4$var$isForced = false;
}
class $8999ac09c494d3d4$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $8999ac09c494d3d4$var$toResolve.add(this);
            if (!$8999ac09c494d3d4$var$isScheduled) {
                $8999ac09c494d3d4$var$isScheduled = true;
                (0, $15WwJ.frame).read($8999ac09c494d3d4$var$readAllKeyframes);
                (0, $15WwJ.frame).resolveKeyframes($8999ac09c494d3d4$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $cDtZ3.fillWildcards)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $8999ac09c494d3d4$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $8999ac09c494d3d4$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}

});
parcelRegister("cDtZ3", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", function () { return $7b12ae55e0cc081f$export$5a98a90409277f5a; });
function $7b12ae55e0cc081f$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}

});

parcelRegister("huj13", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $1a0e74a29f47c4ce$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $1a0e74a29f47c4ce$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $1a0e74a29f47c4ce$export$781d46a8aa670d52; });

var $7a1mp = parcelRequire("7a1mp");

var $3Vm0J = parcelRequire("3Vm0J");

var $groAF = parcelRequire("groAF");

var $7mQ5b = parcelRequire("7mQ5b");
const $1a0e74a29f47c4ce$export$8e5250d1aa9bf370 = (v)=>v === (0, $groAF.number) || v === (0, $7mQ5b.px);
const $1a0e74a29f47c4ce$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $1a0e74a29f47c4ce$var$nonTranslationalTransformKeys = (0, $3Vm0J.transformPropOrder).filter((key)=>!$1a0e74a29f47c4ce$var$transformKeys.has(key));
function $1a0e74a29f47c4ce$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $1a0e74a29f47c4ce$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $1a0e74a29f47c4ce$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $7a1mp.parseValueFromTransform)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $7a1mp.parseValueFromTransform)(transform, "y")
};
// Alias translate longform names
$1a0e74a29f47c4ce$export$781d46a8aa670d52.translateX = $1a0e74a29f47c4ce$export$781d46a8aa670d52.x;
$1a0e74a29f47c4ce$export$781d46a8aa670d52.translateY = $1a0e74a29f47c4ce$export$781d46a8aa670d52.y;

});

parcelRegister("15WwJ", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $4beea059f2846b9a$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $4beea059f2846b9a$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $4beea059f2846b9a$export$fff89137e9e818ce; });
$parcel$export(module.exports, "frameSteps", function () { return $4beea059f2846b9a$export$1811c3a7e3af92f0; });

var $hI3Mj = parcelRequire("hI3Mj");

var $5rb9Z = parcelRequire("5rb9Z");
const { schedule: $4beea059f2846b9a$export$2cef06c20297c17d, cancel: $4beea059f2846b9a$export$ec99c0ef4978dccb, state: $4beea059f2846b9a$export$fff89137e9e818ce, steps: $4beea059f2846b9a$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $5rb9Z.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $hI3Mj.noop), true);

});
parcelRegister("hI3Mj", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $f3277e58d5ad8cca$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ const $f3277e58d5ad8cca$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("5rb9Z", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $c2b0b11dfc7932fe$export$510b0596a933801a; });

var $knqqV = parcelRequire("knqqV");

var $eEUCX = parcelRequire("eEUCX");

var $9pDh4 = parcelRequire("9pDh4");
const $c2b0b11dfc7932fe$var$maxElapsed = 40;
function $c2b0b11dfc7932fe$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $eEUCX.stepsOrder).reduce((acc, key)=>{
        acc[key] = (0, $9pDh4.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $knqqV.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $knqqV.MotionGlobalConfig).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $c2b0b11dfc7932fe$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $eEUCX.stepsOrder).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $eEUCX.stepsOrder).length; i++)steps[(0, $eEUCX.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("knqqV", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $0903b5d0e2a234ba$export$dd826089e3c5e502; });
const $0903b5d0e2a234ba$export$dd826089e3c5e502 = {};

});

parcelRegister("eEUCX", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", function () { return $a9a7ba7b5be70f73$export$71ecace0a033b35a; });
const $a9a7ba7b5be70f73$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("9pDh4", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $0bb63bf4376a186b$export$b995e5e85f5c8289; });

var $cgohm = parcelRequire("cgohm");
function $0bb63bf4376a186b$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $cgohm.statsBuffer).value) (0, $cgohm.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});
parcelRegister("cgohm", function(module, exports) {

$parcel$export(module.exports, "statsBuffer", function () { return $87ba51feeed3fde4$export$84ce9a476f53d110; });
const $87ba51feeed3fde4$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};

});





parcelRegister("hAvoj", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $f0831dc7a20b5acf$export$e56af863d5645d5f; });

var $9Vqjg = parcelRequire("9Vqjg");
function $f0831dc7a20b5acf$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $9Vqjg.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("9Vqjg", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $6f0df97b55122a27$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $6f0df97b55122a27$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("3UfKJ", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $6dac3a24ec955a0b$export$8cc4958f8e540f37; });

var $bxC6Y = parcelRequire("bxC6Y");

var $dP8BU = parcelRequire("dP8BU");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $6dac3a24ec955a0b$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $6dac3a24ec955a0b$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$6dac3a24ec955a0b$var$invalidTemplates.has(keyframe) && (0, $bxC6Y.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $dP8BU.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("bxC6Y", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $b494319156a64347$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $b494319156a64347$export$83a0e34f1302825b; });

var $gfwoY = parcelRequire("gfwoY");

var $2IDBt = parcelRequire("2IDBt");

var $9Kg8w = parcelRequire("9Kg8w");

var $1QW1Q = parcelRequire("1QW1Q");
function $b494319156a64347$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $9Kg8w.floatRegex))?.length || 0) + (v.match((0, $2IDBt.colorRegex))?.length || 0) > 0;
}
const $b494319156a64347$var$NUMBER_TOKEN = "number";
const $b494319156a64347$var$COLOR_TOKEN = "color";
const $b494319156a64347$var$VAR_TOKEN = "var";
const $b494319156a64347$var$VAR_FUNCTION_TOKEN = "var(";
const $b494319156a64347$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $b494319156a64347$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $b494319156a64347$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($b494319156a64347$var$complexRegex, (parsedValue)=>{
        if ((0, $gfwoY.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($b494319156a64347$var$COLOR_TOKEN);
            values.push((0, $gfwoY.color).parse(parsedValue));
        } else if (parsedValue.startsWith($b494319156a64347$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($b494319156a64347$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($b494319156a64347$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $b494319156a64347$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($b494319156a64347$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $b494319156a64347$var$parseComplexValue(v) {
    return $b494319156a64347$export$b61fc7c44bf646d5(v).values;
}
function $b494319156a64347$var$createTransformer(source) {
    const { split: split, types: types } = $b494319156a64347$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $b494319156a64347$var$NUMBER_TOKEN) output += (0, $1QW1Q.sanitize)(v[i]);
                else if (type === $b494319156a64347$var$COLOR_TOKEN) output += (0, $gfwoY.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $b494319156a64347$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $gfwoY.color).test(v) ? (0, $gfwoY.color).getAnimatableNone(v) : v;
function $b494319156a64347$var$getAnimatableNone(v) {
    const parsed = $b494319156a64347$var$parseComplexValue(v);
    const transformer = $b494319156a64347$var$createTransformer(v);
    return transformer(parsed.map($b494319156a64347$var$convertNumbersToZero));
}
const $b494319156a64347$export$83a0e34f1302825b = {
    test: $b494319156a64347$var$test,
    parse: $b494319156a64347$var$parseComplexValue,
    createTransformer: $b494319156a64347$var$createTransformer,
    getAnimatableNone: $b494319156a64347$var$getAnimatableNone
};

});
parcelRegister("gfwoY", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $766d129665134d3b$export$35e9368ef982300f; });

var $f255w = parcelRequire("f255w");

var $cKWhy = parcelRequire("cKWhy");

var $cDMAl = parcelRequire("cDMAl");
const $766d129665134d3b$export$35e9368ef982300f = {
    test: (v)=>(0, $cDMAl.rgba).test(v) || (0, $f255w.hex).test(v) || (0, $cKWhy.hsla).test(v),
    parse: (v)=>{
        if ((0, $cDMAl.rgba).test(v)) return (0, $cDMAl.rgba).parse(v);
        else if ((0, $cKWhy.hsla).test(v)) return (0, $cKWhy.hsla).parse(v);
        else return (0, $f255w.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $cDMAl.rgba).transform(v) : (0, $cKWhy.hsla).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $766d129665134d3b$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $766d129665134d3b$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("f255w", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $5b773c14ac7dc011$export$834dfc94dde4b3d8; });

var $cDMAl = parcelRequire("cDMAl");

var $7j9lY = parcelRequire("7j9lY");
function $5b773c14ac7dc011$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $5b773c14ac7dc011$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $7j9lY.isColorString)("#"),
    parse: $5b773c14ac7dc011$var$parseHex,
    transform: (0, $cDMAl.rgba).transform
};

});
parcelRegister("cDMAl", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $387ab7621765195c$export$4e46ac54fc82cf3b; });

var $9M1og = parcelRequire("9M1og");

var $groAF = parcelRequire("groAF");

var $1QW1Q = parcelRequire("1QW1Q");

var $7j9lY = parcelRequire("7j9lY");
const $387ab7621765195c$var$clampRgbUnit = (v)=>(0, $9M1og.clamp)(0, 255, v);
const $387ab7621765195c$export$7a99c86b5b1f4c9e = {
    ...(0, $groAF.number),
    transform: (v)=>Math.round($387ab7621765195c$var$clampRgbUnit(v))
};
const $387ab7621765195c$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $7j9lY.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $7j9lY.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $387ab7621765195c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $387ab7621765195c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $387ab7621765195c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $1QW1Q.sanitize)((0, $groAF.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("1QW1Q", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $a88d5c687e528f03$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $a88d5c687e528f03$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("7j9lY", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $443c2e76ba3c4ca8$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $443c2e76ba3c4ca8$export$73d6f35be992df24; });

var $9Kg8w = parcelRequire("9Kg8w");

var $ffIZi = parcelRequire("ffIZi");

var $jZUo5 = parcelRequire("jZUo5");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $443c2e76ba3c4ca8$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $jZUo5.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $ffIZi.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $443c2e76ba3c4ca8$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $9Kg8w.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("9Kg8w", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $2f0fdf453a0f7749$export$2444ca58c08448e4; });
const $2f0fdf453a0f7749$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("ffIZi", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $62e1b98751daed4b$export$b931b78cbb3caf86; });
function $62e1b98751daed4b$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("jZUo5", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $f3a84f72d7e36ca2$export$ed808ff6ecd39e8d; });
const $f3a84f72d7e36ca2$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("cKWhy", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $6aeb1dcef2ff6208$export$810b04175080204c; });

var $groAF = parcelRequire("groAF");

var $7mQ5b = parcelRequire("7mQ5b");

var $1QW1Q = parcelRequire("1QW1Q");

var $7j9lY = parcelRequire("7j9lY");
const $6aeb1dcef2ff6208$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $7j9lY.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $7j9lY.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $7mQ5b.percent).transform((0, $1QW1Q.sanitize)(saturation)) + ", " + (0, $7mQ5b.percent).transform((0, $1QW1Q.sanitize)(lightness)) + ", " + (0, $1QW1Q.sanitize)((0, $groAF.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("2IDBt", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $bb758740f19e9c54$export$740b69c5fad25dba; });
const $bb758740f19e9c54$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("dP8BU", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $0caf471284efd1ad$export$cea0cedcb94873b5; });

var $bxC6Y = parcelRequire("bxC6Y");

var $eqV9d = parcelRequire("eqV9d");

var $5KEIp = parcelRequire("5KEIp");
function $0caf471284efd1ad$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5KEIp.getDefaultValueType)(key);
    if (defaultValueType !== (0, $eqV9d.filter)) defaultValueType = (0, $bxC6Y.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("eqV9d", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $dbac3302d3e82920$export$3dea766d36a8935f; });

var $bxC6Y = parcelRequire("bxC6Y");

var $9Kg8w = parcelRequire("9Kg8w");
/**
 * Properties that should default to 1 or 100%
 */ const $dbac3302d3e82920$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $dbac3302d3e82920$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9Kg8w.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $dbac3302d3e82920$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $dbac3302d3e82920$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $dbac3302d3e82920$export$3dea766d36a8935f = {
    ...(0, $bxC6Y.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($dbac3302d3e82920$var$functionRegex);
        return functions ? functions.map($dbac3302d3e82920$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("5KEIp", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $04a759491d9c7f23$export$67d1babe0338d23b; });

var $gfwoY = parcelRequire("gfwoY");

var $eqV9d = parcelRequire("eqV9d");

var $dM90h = parcelRequire("dM90h");
/**
 * A map of default value types for common values
 */ const $04a759491d9c7f23$export$98cd7c72c5a731fb = {
    ...(0, $dM90h.numberValueTypes),
    color: // Color props
    $gfwoY.color,
    backgroundColor: (0, $gfwoY.color),
    outlineColor: (0, $gfwoY.color),
    fill: (0, $gfwoY.color),
    stroke: (0, $gfwoY.color),
    // Border props
    borderColor: (0, $gfwoY.color),
    borderTopColor: (0, $gfwoY.color),
    borderRightColor: (0, $gfwoY.color),
    borderBottomColor: (0, $gfwoY.color),
    borderLeftColor: (0, $gfwoY.color),
    filter: $eqV9d.filter,
    WebkitFilter: (0, $eqV9d.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $04a759491d9c7f23$export$67d1babe0338d23b = (key)=>$04a759491d9c7f23$export$98cd7c72c5a731fb[key];

});
parcelRegister("dM90h", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $5b777eb6eec9d3c6$export$eec14432cd1cb67b; });

var $31rOD = parcelRequire("31rOD");

var $groAF = parcelRequire("groAF");

var $7mQ5b = parcelRequire("7mQ5b");

var $6yPAW = parcelRequire("6yPAW");
const $5b777eb6eec9d3c6$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $7mQ5b.px),
    borderTopWidth: (0, $7mQ5b.px),
    borderRightWidth: (0, $7mQ5b.px),
    borderBottomWidth: (0, $7mQ5b.px),
    borderLeftWidth: (0, $7mQ5b.px),
    borderRadius: (0, $7mQ5b.px),
    radius: (0, $7mQ5b.px),
    borderTopLeftRadius: (0, $7mQ5b.px),
    borderTopRightRadius: (0, $7mQ5b.px),
    borderBottomRightRadius: (0, $7mQ5b.px),
    borderBottomLeftRadius: (0, $7mQ5b.px),
    // Positioning props
    width: (0, $7mQ5b.px),
    maxWidth: (0, $7mQ5b.px),
    height: (0, $7mQ5b.px),
    maxHeight: (0, $7mQ5b.px),
    top: (0, $7mQ5b.px),
    right: (0, $7mQ5b.px),
    bottom: (0, $7mQ5b.px),
    left: (0, $7mQ5b.px),
    // Spacing props
    padding: (0, $7mQ5b.px),
    paddingTop: (0, $7mQ5b.px),
    paddingRight: (0, $7mQ5b.px),
    paddingBottom: (0, $7mQ5b.px),
    paddingLeft: (0, $7mQ5b.px),
    margin: (0, $7mQ5b.px),
    marginTop: (0, $7mQ5b.px),
    marginRight: (0, $7mQ5b.px),
    marginBottom: (0, $7mQ5b.px),
    marginLeft: (0, $7mQ5b.px),
    // Misc
    backgroundPositionX: (0, $7mQ5b.px),
    backgroundPositionY: (0, $7mQ5b.px),
    ...(0, $6yPAW.transformValueTypes),
    zIndex: (0, $31rOD.int),
    // SVG
    fillOpacity: (0, $groAF.alpha),
    strokeOpacity: (0, $groAF.alpha),
    numOctaves: (0, $31rOD.int)
};

});
parcelRegister("31rOD", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $963f404b2ebd65dc$export$7d260a2a5f8bc19e; });

var $groAF = parcelRequire("groAF");
const $963f404b2ebd65dc$export$7d260a2a5f8bc19e = {
    ...(0, $groAF.number),
    transform: Math.round
};

});

parcelRegister("6yPAW", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $60d5a14b75267270$export$f2e4285fee37e26; });

var $groAF = parcelRequire("groAF");

var $7mQ5b = parcelRequire("7mQ5b");
const $60d5a14b75267270$export$f2e4285fee37e26 = {
    rotate: (0, $7mQ5b.degrees),
    rotateX: (0, $7mQ5b.degrees),
    rotateY: (0, $7mQ5b.degrees),
    rotateZ: (0, $7mQ5b.degrees),
    scale: $groAF.scale,
    scaleX: (0, $groAF.scale),
    scaleY: (0, $groAF.scale),
    scaleZ: (0, $groAF.scale),
    skew: (0, $7mQ5b.degrees),
    skewX: (0, $7mQ5b.degrees),
    skewY: (0, $7mQ5b.degrees),
    distance: (0, $7mQ5b.px),
    translateX: (0, $7mQ5b.px),
    translateY: (0, $7mQ5b.px),
    translateZ: (0, $7mQ5b.px),
    x: (0, $7mQ5b.px),
    y: (0, $7mQ5b.px),
    z: (0, $7mQ5b.px),
    perspective: (0, $7mQ5b.px),
    transformPerspective: (0, $7mQ5b.px),
    opacity: (0, $groAF.alpha),
    originX: (0, $7mQ5b.progressPercentage),
    originY: (0, $7mQ5b.progressPercentage),
    originZ: (0, $7mQ5b.px)
};

});






parcelRegister("8XwwR", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $261ce907cb331887$export$605d60a2578142d3; });
const $261ce907cb331887$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});

parcelRegister("5yq0L", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $adc4c987989bb6aa$export$fa8b653c0f3714e5; });

var $15WwJ = parcelRequire("15WwJ");
var $bxC6Y = parcelRequire("bxC6Y");
var $bSiV3 = parcelRequire("bSiV3");
var $dP8BU = parcelRequire("dP8BU");
var $8XwwR = parcelRequire("8XwwR");
var $jVEGV = parcelRequire("jVEGV");
var $ehNhG = parcelRequire("ehNhG");
var $a8Cmn = parcelRequire("a8Cmn");
var $3cj4G = parcelRequire("3cj4G");
var $3Vm0J = parcelRequire("3Vm0J");

var $cRw1i = parcelRequire("cRw1i");
var $9Vqjg = parcelRequire("9Vqjg");
var $8zNyL = parcelRequire("8zNyL");

var $ffgug = parcelRequire("ffgug");

var $k1gBv = parcelRequire("k1gBv");

var $76Pdg = parcelRequire("76Pdg");

var $ex6Qm = parcelRequire("ex6Qm");

var $aLrTH = parcelRequire("aLrTH");

var $j1m4L = parcelRequire("j1m4L");

var $iLqaY = parcelRequire("iLqaY");

var $4eZez = parcelRequire("4eZez");
const $adc4c987989bb6aa$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $adc4c987989bb6aa$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $jVEGV.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $3cj4G.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $15WwJ.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $j1m4L.isControllingVariants)(props);
        this.isVariantNode = (0, $j1m4L.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $8XwwR.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $aLrTH.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $ex6Qm.hasReducedMotionListener).current) (0, $76Pdg.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $ex6Qm.prefersReducedMotion).current;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $15WwJ.cancelFrame)(this.notifyUpdate);
        (0, $15WwJ.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $3Vm0J.transformProps).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $15WwJ.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $ffgug.featureDefinitions){
            const featureDefinition = (0, $ffgug.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $k1gBv.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $adc4c987989bb6aa$var$propEventHandlers.length; i++){
            const key = $adc4c987989bb6aa$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $iLqaY.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $a8Cmn.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $cRw1i.isNumericalString)(value) || (0, $9Vqjg.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $bSiV3.findValueType)(value) && (0, $bxC6Y.complex).test(target)) value = (0, $dP8BU.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $8XwwR.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $8XwwR.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $4eZez.resolveVariantFromProps)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $8XwwR.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $8zNyL.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $ehNhG.microtask).render(this.render);
    }
}

});
parcelRegister("bSiV3", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $c009d62396cf6e2d$export$950e7e59ea1ffed7; });

var $gfwoY = parcelRequire("gfwoY");

var $bxC6Y = parcelRequire("bxC6Y");

var $axu4m = parcelRequire("axu4m");

var $2WUJq = parcelRequire("2WUJq");
/**
 * A list of all ValueTypes
 */ const $c009d62396cf6e2d$var$valueTypes = [
    ...(0, $axu4m.dimensionValueTypes),
    (0, $gfwoY.color),
    (0, $bxC6Y.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $c009d62396cf6e2d$export$950e7e59ea1ffed7 = (v)=>$c009d62396cf6e2d$var$valueTypes.find((0, $2WUJq.testValueType)(v));

});

parcelRegister("ehNhG", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $4e07f5df800192c4$export$bb76eed83315504c; });

var $5rb9Z = parcelRequire("5rb9Z");
const { schedule: $4e07f5df800192c4$export$bb76eed83315504c, cancel: $4e07f5df800192c4$export$3252729004b8456e } = /* @__PURE__ */ (0, $5rb9Z.createRenderBatcher)(queueMicrotask, false);

});

parcelRegister("a8Cmn", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $c30f51bf1f43ddba$export$ce8bdc721e76545f; });

var $8zNyL = parcelRequire("8zNyL");
var $cj3OQ = parcelRequire("cj3OQ");

var $3cj4G = parcelRequire("3cj4G");

var $15WwJ = parcelRequire("15WwJ");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $c30f51bf1f43ddba$var$MAX_VELOCITY_DELTA = 30;
const $c30f51bf1f43ddba$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $c30f51bf1f43ddba$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $c30f51bf1f43ddba$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $3cj4G.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $3cj4G.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $c30f51bf1f43ddba$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $8zNyL.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $15WwJ.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($c30f51bf1f43ddba$export$67fcd818a264039d.current) $c30f51bf1f43ddba$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $3cj4G.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $c30f51bf1f43ddba$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $c30f51bf1f43ddba$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $cj3OQ.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $c30f51bf1f43ddba$export$ce8bdc721e76545f(init, options) {
    return new $c30f51bf1f43ddba$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("8zNyL", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $0021a7ef4a1482ac$export$e7dff9482a5fd23c; });

var $cJpH9 = parcelRequire("cJpH9");
class $0021a7ef4a1482ac$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $cJpH9.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $cJpH9.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("cJpH9", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $b38667b825f47e69$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $b38667b825f47e69$export$fe2d9b4e03920b4c; });
function $b38667b825f47e69$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $b38667b825f47e69$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $b38667b825f47e69$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("cj3OQ", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $86f8be329c7fa3c5$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $86f8be329c7fa3c5$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});

parcelRegister("3cj4G", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $97e4cbd576bc27cc$export$2da9be4cfdb689b1; });

var $knqqV = parcelRequire("knqqV");

var $15WwJ = parcelRequire("15WwJ");
let $97e4cbd576bc27cc$var$now;
function $97e4cbd576bc27cc$var$clearTime() {
    $97e4cbd576bc27cc$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $97e4cbd576bc27cc$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($97e4cbd576bc27cc$var$now === undefined) $97e4cbd576bc27cc$export$2da9be4cfdb689b1.set((0, $15WwJ.frameData).isProcessing || (0, $knqqV.MotionGlobalConfig).useManualTiming ? (0, $15WwJ.frameData).timestamp : performance.now());
        return $97e4cbd576bc27cc$var$now;
    },
    set: (newTime)=>{
        $97e4cbd576bc27cc$var$now = newTime;
        queueMicrotask($97e4cbd576bc27cc$var$clearTime);
    }
};

});


parcelRegister("ffgug", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $5a0a8051c4f35b34$export$65570e08d843624d; });
const $5a0a8051c4f35b34$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $5a0a8051c4f35b34$export$65570e08d843624d = {};
for(const key in $5a0a8051c4f35b34$var$featureProps)$5a0a8051c4f35b34$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$5a0a8051c4f35b34$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("k1gBv", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $b09b56b69fb45a2e$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $b09b56b69fb45a2e$export$6459fc9e86be362e; });
const $b09b56b69fb45a2e$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $b09b56b69fb45a2e$export$3d227df54007d73a = ()=>({
        x: $b09b56b69fb45a2e$export$ff25708b37f72782(),
        y: $b09b56b69fb45a2e$export$ff25708b37f72782()
    });
const $b09b56b69fb45a2e$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $b09b56b69fb45a2e$export$6459fc9e86be362e = ()=>({
        x: $b09b56b69fb45a2e$export$6db76765312617ac(),
        y: $b09b56b69fb45a2e$export$6db76765312617ac()
    });

});

parcelRegister("76Pdg", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $ad2f41dcb12ec678$export$ca9f41fb23dded3d; });

var $68qS9 = parcelRequire("68qS9");

var $ex6Qm = parcelRequire("ex6Qm");
function $ad2f41dcb12ec678$export$ca9f41fb23dded3d() {
    (0, $ex6Qm.hasReducedMotionListener).current = true;
    if (!(0, $68qS9.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $ex6Qm.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $ex6Qm.prefersReducedMotion).current = false;
}

});
parcelRegister("68qS9", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $5794b0c359c0df2a$export$4e09c449d6c407f7; });
const $5794b0c359c0df2a$export$4e09c449d6c407f7 = typeof window !== "undefined";

});

parcelRegister("ex6Qm", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $bb31c45a6f3715cb$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $bb31c45a6f3715cb$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $bb31c45a6f3715cb$export$ff7706047246b98b = {
    current: null
};
const $bb31c45a6f3715cb$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("aLrTH", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $5692ab780c90094f$export$bc2a978a17abfdde; });
const $5692ab780c90094f$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("j1m4L", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $76a579e54fd11ded$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $76a579e54fd11ded$export$ce46fa4165cdec40; });

var $hk6sz = parcelRequire("hk6sz");

var $8VOWI = parcelRequire("8VOWI");

var $qy8WU = parcelRequire("qy8WU");
function $76a579e54fd11ded$export$4b3c3bd8d910d78d(props) {
    return (0, $hk6sz.isAnimationControls)(props.animate) || (0, $qy8WU.variantProps).some((name)=>(0, $8VOWI.isVariantLabel)(props[name]));
}
function $76a579e54fd11ded$export$ce46fa4165cdec40(props) {
    return Boolean($76a579e54fd11ded$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("hk6sz", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $6de7b8f399463036$export$aa71198ceeaf53ce; });
function $6de7b8f399463036$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("8VOWI", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $fb2b5f30e3d4bd58$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $fb2b5f30e3d4bd58$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("qy8WU", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $cc43113dbc6ff27b$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $cc43113dbc6ff27b$export$1405a65085f40b9; });
const $cc43113dbc6ff27b$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $cc43113dbc6ff27b$export$1405a65085f40b9 = [
    "initial",
    ...$cc43113dbc6ff27b$export$16e45afcc206d3a8
];

});


parcelRegister("iLqaY", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $c0d5e9da87b63ca5$export$9a552858d5197f6e; });

var $8XwwR = parcelRequire("8XwwR");
var $a8Cmn = parcelRequire("a8Cmn");
function $c0d5e9da87b63ca5$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $8XwwR.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $8XwwR.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $a8Cmn.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $a8Cmn.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("4eZez", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $ebca2401632df166$export$d68f140c4d9b48bc; });
function $ebca2401632df166$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $ebca2401632df166$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ebca2401632df166$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $ebca2401632df166$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});



parcelRegister("3v57z", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $bb2ff539a6497bd3$export$bb517f8b40f8e99d; });

var $gmOND = parcelRequire("gmOND");
var $7V3so = parcelRequire("7V3so");
var $dM90h = parcelRequire("dM90h");
var $3Vm0J = parcelRequire("3Vm0J");

var $al5GK = parcelRequire("al5GK");
function $bb2ff539a6497bd3$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $3Vm0J.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $7V3so.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $gmOND.getValueAsType)(value, (0, $dM90h.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $al5GK.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("gmOND", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $5875360cb5c978b7$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $5875360cb5c978b7$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("al5GK", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $fd33b87c502a2306$export$bdc96e0d5c8f914; });

var $gmOND = parcelRequire("gmOND");
var $dM90h = parcelRequire("dM90h");
var $3Vm0J = parcelRequire("3Vm0J");
const $fd33b87c502a2306$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $fd33b87c502a2306$var$numTransforms = (0, $3Vm0J.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $fd33b87c502a2306$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $fd33b87c502a2306$var$numTransforms; i++){
        const key = (0, $3Vm0J.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $gmOND.getValueAsType)(value, (0, $dM90h.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $fd33b87c502a2306$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("fmykX", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $3ecf9aae399587e0$export$1a32bf6229c258c0; });
function $3ecf9aae399587e0$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

});

parcelRegister("fS3sq", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $3bb8b534de1ab8f4$export$16da615486abaa45; });

var $8XwwR = parcelRequire("8XwwR");

var $7at7x = parcelRequire("7at7x");
function $3bb8b534de1ab8f4$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $8XwwR.isMotionValue)(style[key]) || prevProps.style && (0, $8XwwR.isMotionValue)(prevProps.style[key]) || (0, $7at7x.isForcedMotionValue)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("7at7x", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $29fb33cbac1ecf16$export$6d27ce8e3de1c3cf; });

var $3Vm0J = parcelRequire("3Vm0J");

var $2stVt = parcelRequire("2stVt");
function $29fb33cbac1ecf16$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $3Vm0J.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $2stVt.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("2stVt", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $41f30b85fcd25e73$export$91ddd985b97788d1; });

var $7V3so = parcelRequire("7V3so");

var $8faj4 = parcelRequire("8faj4");

var $9NuY5 = parcelRequire("9NuY5");
const $41f30b85fcd25e73$export$91ddd985b97788d1 = {
    borderRadius: {
        ...(0, $8faj4.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $8faj4.correctBorderRadius),
    borderTopRightRadius: (0, $8faj4.correctBorderRadius),
    borderBottomLeftRadius: (0, $8faj4.correctBorderRadius),
    borderBottomRightRadius: (0, $8faj4.correctBorderRadius),
    boxShadow: (0, $9NuY5.correctBoxShadow)
};
function $41f30b85fcd25e73$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $41f30b85fcd25e73$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $7V3so.isCSSVariableName)(key)) $41f30b85fcd25e73$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});
parcelRegister("8faj4", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $c4d275920599678f$export$5eafb6257a5844c; });

var $7mQ5b = parcelRequire("7mQ5b");
function $c4d275920599678f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $c4d275920599678f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $7mQ5b.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $c4d275920599678f$export$fafff692be55225d(latest, node.target.x);
        const y = $c4d275920599678f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("9NuY5", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $835000cc4fd674da$export$eb0bc629e74dcf8; });

var $bxC6Y = parcelRequire("bxC6Y");
var $bTGI6 = parcelRequire("bTGI6");
const $835000cc4fd674da$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $bxC6Y.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $bxC6Y.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $bTGI6.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});





parcelRegister("2sH6y", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $c06cda96db12d24d$export$86bcdffbaf733d84; });

var $5KEIp = parcelRequire("5KEIp");
var $3Vm0J = parcelRequire("3Vm0J");

var $k1gBv = parcelRequire("k1gBv");

var $dqCvj = parcelRequire("dqCvj");

var $iMerG = parcelRequire("iMerG");

var $1Yc0C = parcelRequire("1Yc0C");

var $hw734 = parcelRequire("hw734");

var $gyg6c = parcelRequire("gyg6c");

var $hVS4K = parcelRequire("hVS4K");

var $3jVOX = parcelRequire("3jVOX");
class $c06cda96db12d24d$export$86bcdffbaf733d84 extends (0, $dqCvj.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $k1gBv.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $3Vm0J.transformProps).has(key)) {
            const defaultType = (0, $5KEIp.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $hw734.camelCaseAttributes).has(key) ? (0, $iMerG.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $3jVOX.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $1Yc0C.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $hVS4K.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $gyg6c.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("iMerG", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $9d19f5cf96f60af5$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $9d19f5cf96f60af5$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});

parcelRegister("1Yc0C", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $141f6c79619d2142$export$5475d24f125d7053; });

var $3v57z = parcelRequire("3v57z");

var $7Ze1l = parcelRequire("7Ze1l");
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $141f6c79619d2142$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $3v57z.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $7Ze1l.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("7Ze1l", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $af1ff9d40e11cf7f$export$311b43f666da1d82; });

var $7mQ5b = parcelRequire("7mQ5b");
const $af1ff9d40e11cf7f$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $af1ff9d40e11cf7f$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $af1ff9d40e11cf7f$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $af1ff9d40e11cf7f$var$dashKeys : $af1ff9d40e11cf7f$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $7mQ5b.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $7mQ5b.px).transform(length);
    const pathSpacing = (0, $7mQ5b.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("hw734", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $534092b423d71182$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $534092b423d71182$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("gyg6c", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $e69de4800068261b$export$6328ce7565ea1049; });
const $e69de4800068261b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});

parcelRegister("hVS4K", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $470552e8fe1b0157$export$c5f8399d19a7394b; });

var $iMerG = parcelRequire("iMerG");

var $fmykX = parcelRequire("fmykX");

var $hw734 = parcelRequire("hw734");
function $470552e8fe1b0157$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $fmykX.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $hw734.camelCaseAttributes).has(key) ? (0, $iMerG.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("3jVOX", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $096669d855871313$export$16da615486abaa45; });

var $8XwwR = parcelRequire("8XwwR");
var $3Vm0J = parcelRequire("3Vm0J");

var $fS3sq = parcelRequire("fS3sq");
function $096669d855871313$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $fS3sq.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $8XwwR.isMotionValue)(props[key]) || (0, $8XwwR.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $3Vm0J.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});


parcelRegister("b85su", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $f867a3460fb2aef6$export$88f3fc2fd3766989; });

var $dsvMt = parcelRequire("dsvMt");
function $f867a3460fb2aef6$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $dsvMt.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("dsvMt", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $f4ff0cd227438508$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $f4ff0cd227438508$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});



parcelRegister("6tuCf", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $21dd3f7abad1fd24$export$a28d6df673050e18; });


var $8jGpS = parcelRequire("8jGpS");
function $21dd3f7abad1fd24$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $8jGpS.createMotionComponent;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $8jGpS.createMotionComponent)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $8jGpS.createMotionComponent)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}

});
parcelRegister("8jGpS", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $2cb52b0cccdc54dc$export$46b7e4b9dc6110c3; });

var $jk232 = parcelRequire("jk232");


var $4RFnf = parcelRequire("4RFnf");

var $3bZPm = parcelRequire("3bZPm");

var $iqVl9 = parcelRequire("iqVl9");

var $hZpxR = parcelRequire("hZpxR");

var $lpcXP = parcelRequire("lpcXP");

var $6gdam = parcelRequire("6gdam");

var $bcbQO = parcelRequire("bcbQO");

var $b85su = parcelRequire("b85su");

var $J6Ita = parcelRequire("J6Ita");

var $dfPLw = parcelRequire("dfPLw");

var $68qS9 = parcelRequire("68qS9");

var $ffgug = parcelRequire("ffgug");

var $7zESv = parcelRequire("7zESv");

var $f26Fp = parcelRequire("f26Fp");

var $1WYOn = parcelRequire("1WYOn");

var $1uSNp = parcelRequire("1uSNp");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $2cb52b0cccdc54dc$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $7zESv.loadFeatures)(preloadedFeatures);
    const useVisualState = (0, $b85su.isSVGComponent)(Component) ? (0, $dfPLw.useSVGVisualState) : (0, $J6Ita.useHTMLVisualState);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $4RFnf.useContext)((0, $hZpxR.MotionConfigContext)),
            ...props,
            layoutId: $2cb52b0cccdc54dc$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $6gdam.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $68qS9.isBrowser)) {
            $2cb52b0cccdc54dc$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $2cb52b0cccdc54dc$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $1uSNp.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $jk232.jsxs)((0, $lpcXP.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $jk232.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $bcbQO.useRender)(Component, props, (0, $1WYOn.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $4RFnf.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $f26Fp.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $2cb52b0cccdc54dc$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $4RFnf.useContext)((0, $3bZPm.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $2cb52b0cccdc54dc$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $4RFnf.useContext)((0, $iqVl9.LazyContext)).strict;
}
function $2cb52b0cccdc54dc$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $ffgug.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("3bZPm", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $2de44706e31e5789$export$a3579ca508007a95; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
const $2de44706e31e5789$export$a3579ca508007a95 = (0, $4RFnf.createContext)({});

});

parcelRegister("iqVl9", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $046171cebbf4e6c8$export$40f10139ecf1f171; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
const $046171cebbf4e6c8$export$40f10139ecf1f171 = (0, $4RFnf.createContext)({
    strict: false
});

});

parcelRegister("hZpxR", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $ef5f4beec67f2aae$export$22a697fb29aac98d; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
/**
 * @public
 */ const $ef5f4beec67f2aae$export$22a697fb29aac98d = (0, $4RFnf.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("lpcXP", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $2b5e1f3d2bd5bb63$export$2285bbca2c666415; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
const $2b5e1f3d2bd5bb63$export$2285bbca2c666415 = /* @__PURE__ */ (0, $4RFnf.createContext)({});

});

parcelRegister("6gdam", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $71a9351d8c0f9fb1$export$c5638d843b37a176; });

var $4RFnf = parcelRequire("4RFnf");

var $lpcXP = parcelRequire("lpcXP");

var $4KqR0 = parcelRequire("4KqR0");
"use client";
function $71a9351d8c0f9fb1$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $4KqR0.getCurrentTreeVariants)(props, (0, $4RFnf.useContext)((0, $lpcXP.MotionContext)));
    return (0, $4RFnf.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $71a9351d8c0f9fb1$var$variantLabelsAsDependency(initial),
        $71a9351d8c0f9fb1$var$variantLabelsAsDependency(animate)
    ]);
}
function $71a9351d8c0f9fb1$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("4KqR0", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $1e6acd731a549f5e$export$12fc32fc096a04a3; });

var $j1m4L = parcelRequire("j1m4L");

var $8VOWI = parcelRequire("8VOWI");
function $1e6acd731a549f5e$export$12fc32fc096a04a3(props, context) {
    if ((0, $j1m4L.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $8VOWI.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $8VOWI.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("bcbQO", function(module, exports) {

$parcel$export(module.exports, "useRender", function () { return $e687c8eab649fd83$export$e25bb1e5b53cbdff; });

var $8XwwR = parcelRequire("8XwwR");

var $4RFnf = parcelRequire("4RFnf");

var $fflxC = parcelRequire("fflxC");

var $kb7Nq = parcelRequire("kb7Nq");

var $f4bRC = parcelRequire("f4bRC");

var $b85su = parcelRequire("b85su");
"use client";
function $e687c8eab649fd83$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false) {
    const useVisualProps = (0, $b85su.isSVGComponent)(Component) ? (0, $kb7Nq.useSVGProps) : (0, $fflxC.useHTMLProps);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $f4bRC.filterProps)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $4RFnf.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $4RFnf.useMemo)(()=>(0, $8XwwR.isMotionValue)(children) ? children.get() : children, [
        children
    ]);
    return (0, $4RFnf.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}

});
parcelRegister("fflxC", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $929ac80712208d7c$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $929ac80712208d7c$export$57be0a314572d87d; });

var $8XwwR = parcelRequire("8XwwR");

var $4RFnf = parcelRequire("4RFnf");

var $7at7x = parcelRequire("7at7x");

var $3v57z = parcelRequire("3v57z");

var $afTGC = parcelRequire("afTGC");
"use client";
function $929ac80712208d7c$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $8XwwR.isMotionValue)(source[key]) && !(0, $7at7x.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $929ac80712208d7c$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $4RFnf.useMemo)(()=>{
        const state = (0, $afTGC.createHtmlRenderState)();
        (0, $3v57z.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $929ac80712208d7c$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $929ac80712208d7c$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $929ac80712208d7c$var$useInitialMotionValues(props, visualState));
    return style;
}
function $929ac80712208d7c$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $929ac80712208d7c$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("afTGC", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $e4cd2c6d0ce69070$export$8940b483cf52eeda; });
const $e4cd2c6d0ce69070$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("kb7Nq", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $9789da8f3e687c4c$export$84309c4f53cb1bd5; });

var $4RFnf = parcelRequire("4RFnf");

var $fflxC = parcelRequire("fflxC");

var $1Yc0C = parcelRequire("1Yc0C");

var $loDzK = parcelRequire("loDzK");

var $gyg6c = parcelRequire("gyg6c");
"use client";
function $9789da8f3e687c4c$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $4RFnf.useMemo)(()=>{
        const state = (0, $loDzK.createSvgRenderState)();
        (0, $1Yc0C.buildSVGAttrs)(state, visualState, (0, $gyg6c.isSVGTag)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $fflxC.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("loDzK", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $c0a966449f99707b$export$41be8b43e1c4d4f9; });

var $afTGC = parcelRequire("afTGC");
const $c0a966449f99707b$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $afTGC.createHtmlRenderState)(),
        attrs: {}
    });

});


parcelRegister("f4bRC", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $6c11f3121eec2b22$export$d697c39a2985a4c; });

var $e13qu = parcelRequire("e13qu");
let $6c11f3121eec2b22$var$shouldForward = (key)=>!(0, $e13qu.isValidMotionProp)(key);
function $6c11f3121eec2b22$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $6c11f3121eec2b22$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $e13qu.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $6c11f3121eec2b22$export$59d6962c470509a5($6c11f3121eec2b22$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $6c11f3121eec2b22$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($6c11f3121eec2b22$var$shouldForward(key) || forwardMotionProps === true && (0, $e13qu.isValidMotionProp)(key) || !isDom && !(0, $e13qu.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("e13qu", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $a55e81fe15c42ece$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a55e81fe15c42ece$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a55e81fe15c42ece$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a55e81fe15c42ece$var$validMotionProps.has(key);
}

});



parcelRegister("J6Ita", function(module, exports) {

$parcel$export(module.exports, "useHTMLVisualState", function () { return $2d38c54dc64f390d$export$851cf1f78cb3feac; });

var $kevNf = parcelRequire("kevNf");

var $afTGC = parcelRequire("afTGC");

var $fS3sq = parcelRequire("fS3sq");
"use client";
const $2d38c54dc64f390d$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $kevNf.makeUseVisualState)({
    scrapeMotionValuesFromProps: $fS3sq.scrapeMotionValuesFromProps,
    createRenderState: (0, $afTGC.createHtmlRenderState)
});

});
parcelRegister("kevNf", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $9d1ea57b959a61bc$export$e91e107bc6d03a8e; });

var $4RFnf = parcelRequire("4RFnf");

var $hk6sz = parcelRequire("hk6sz");

var $lpcXP = parcelRequire("lpcXP");

var $7S8DD = parcelRequire("7S8DD");

var $j1m4L = parcelRequire("j1m4L");

var $4eZez = parcelRequire("4eZez");

var $aZePl = parcelRequire("aZePl");

var $am8c1 = parcelRequire("am8c1");
"use client";
function $9d1ea57b959a61bc$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $9d1ea57b959a61bc$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $9d1ea57b959a61bc$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $am8c1.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $j1m4L.isControllingVariants)(props);
    const isVariantNode$1 = (0, $j1m4L.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $hk6sz.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $4eZez.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $9d1ea57b959a61bc$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $4RFnf.useContext)((0, $lpcXP.MotionContext));
        const presenceContext = (0, $4RFnf.useContext)((0, $7S8DD.PresenceContext));
        const make = ()=>$9d1ea57b959a61bc$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $aZePl.useConstant)(make);
    };

});
parcelRegister("7S8DD", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $33070f4719eb5d51$export$f224e4635b6f8ce2; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
/**
 * @public
 */ const $33070f4719eb5d51$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $4RFnf.createContext)(null);

});

parcelRegister("aZePl", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $bbfe989948ce7b0e$export$fe4300aa8eebea86; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $bbfe989948ce7b0e$export$fe4300aa8eebea86(init) {
    const ref = (0, $4RFnf.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("am8c1", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $818473550fb5c068$export$fcc2206ecb6d74b; });

var $8XwwR = parcelRequire("8XwwR");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $818473550fb5c068$export$fcc2206ecb6d74b(value) {
    return (0, $8XwwR.isMotionValue)(value) ? value.get() : value;
}

});



parcelRegister("dfPLw", function(module, exports) {

$parcel$export(module.exports, "useSVGVisualState", function () { return $763275880f355d39$export$9922240e40b88c48; });

var $kevNf = parcelRequire("kevNf");

var $loDzK = parcelRequire("loDzK");

var $3jVOX = parcelRequire("3jVOX");
"use client";
const $763275880f355d39$export$9922240e40b88c48 = /*@__PURE__*/ (0, $kevNf.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, $3jVOX.scrapeMotionValuesFromProps),
    createRenderState: (0, $loDzK.createSvgRenderState)
});

});

parcelRegister("7zESv", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $8a22383981c5eae9$export$449561ec5703cdc8; });

var $ffgug = parcelRequire("ffgug");
function $8a22383981c5eae9$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $ffgug.featureDefinitions)[key] = {
        ...(0, $ffgug.featureDefinitions)[key],
        ...features[key]
    };
}

});

parcelRegister("f26Fp", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $8f6dbd7fc1728432$export$28e2e4cce424ae23; });
const $8f6dbd7fc1728432$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("1WYOn", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $6d0bb4d2ccf61e66$export$c684914703d321fd; });

var $4RFnf = parcelRequire("4RFnf");

var $eknSB = parcelRequire("eknSB");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $6d0bb4d2ccf61e66$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $4RFnf.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $eknSB.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */ [
        visualElement
    ]);
}

});
parcelRegister("eknSB", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $6b5ba073424e98cd$export$dedd81df7bc1307; });
function $6b5ba073424e98cd$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("1uSNp", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $4d549596f18734ca$export$dc0335d73ab0b115; });

var $4RFnf = parcelRequire("4RFnf");

var $dMhG5 = parcelRequire("dMhG5");

var $iqVl9 = parcelRequire("iqVl9");

var $hZpxR = parcelRequire("hZpxR");

var $lpcXP = parcelRequire("lpcXP");

var $7S8DD = parcelRequire("7S8DD");

var $kDIQN = parcelRequire("kDIQN");

var $eknSB = parcelRequire("eknSB");

var $gj9yh = parcelRequire("gj9yh");
"use client";
function $4d549596f18734ca$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $4RFnf.useContext)((0, $lpcXP.MotionContext));
    const lazyContext = (0, $4RFnf.useContext)((0, $iqVl9.LazyContext));
    const presenceContext = (0, $4RFnf.useContext)((0, $7S8DD.PresenceContext));
    const reducedMotionConfig = (0, $4RFnf.useContext)((0, $hZpxR.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $4RFnf.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $4RFnf.useContext)((0, $kDIQN.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $4d549596f18734ca$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $4RFnf.useRef)(false);
    (0, $4RFnf.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $dMhG5.optimizedAppearDataAttribute];
    const wantsHandoff = (0, $4RFnf.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $gj9yh.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $4RFnf.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $4d549596f18734ca$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $4d549596f18734ca$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $eknSB.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $4d549596f18734ca$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $4d549596f18734ca$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("dMhG5", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $df031e97d26f68b8$export$8592e1c077c890a6; });

var $iMerG = parcelRequire("iMerG");
const $df031e97d26f68b8$export$ed7b8fa9dbf0105d = "framerAppearId";
const $df031e97d26f68b8$export$8592e1c077c890a6 = "data-" + (0, $iMerG.camelToDash)($df031e97d26f68b8$export$ed7b8fa9dbf0105d);

});

parcelRegister("kDIQN", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $37266df23f37f7d4$export$da5f7b802957459a; });

var $4RFnf = parcelRequire("4RFnf");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $37266df23f37f7d4$export$da5f7b802957459a = (0, $4RFnf.createContext)({});

});

parcelRegister("gj9yh", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $a43a8f7089d31bc5$export$700979bc83e7db82; });

var $4RFnf = parcelRequire("4RFnf");

var $68qS9 = parcelRequire("68qS9");
"use client";
const $a43a8f7089d31bc5$export$700979bc83e7db82 = (0, $68qS9.isBrowser) ? (0, $4RFnf.useLayoutEffect) : (0, $4RFnf.useEffect);

});




parcelRegister("dK2It", function(module, exports) {

$parcel$export(module.exports, "featureBundle", function () { return $f3901a8a4e98a090$export$d596cd8841d25433; });

var $9agav = parcelRequire("9agav");

var $3W5Lu = parcelRequire("3W5Lu");

var $5dC0T = parcelRequire("5dC0T");

var $9UlGk = parcelRequire("9UlGk");
const $f3901a8a4e98a090$export$d596cd8841d25433 = {
    ...(0, $9agav.animations),
    ...(0, $5dC0T.gestureAnimations),
    ...(0, $3W5Lu.drag),
    ...(0, $9UlGk.layout)
};

});
parcelRegister("9agav", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $9aaae9da0b269148$export$7f9953c70dacfd7f; });

var $55rH4 = parcelRequire("55rH4");

var $1krk5 = parcelRequire("1krk5");
const $9aaae9da0b269148$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $55rH4.AnimationFeature)
    },
    exit: {
        Feature: (0, $1krk5.ExitAnimationFeature)
    }
};

});
parcelRegister("55rH4", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $f2a5eb3c79767bd8$export$b45b3fe5caabdca; });

var $hk6sz = parcelRequire("hk6sz");

var $7r1Fa = parcelRequire("7r1Fa");

var $cDuTX = parcelRequire("cDuTX");
class $f2a5eb3c79767bd8$export$b45b3fe5caabdca extends (0, $cDuTX.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $7r1Fa.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $hk6sz.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}

});
parcelRegister("7r1Fa", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $ec8b1ae01cf402c0$export$bb53502b7a672aa8; });

var $1z0eb = parcelRequire("1z0eb");

var $irAra = parcelRequire("irAra");

var $hk6sz = parcelRequire("hk6sz");

var $4bBBq = parcelRequire("4bBBq");

var $3dQlT = parcelRequire("3dQlT");

var $4xv7A = parcelRequire("4xv7A");

var $8VOWI = parcelRequire("8VOWI");

var $e1uIa = parcelRequire("e1uIa");

var $qy8WU = parcelRequire("qy8WU");
const $ec8b1ae01cf402c0$var$reversePriorityOrder = [
    ...(0, $qy8WU.variantPriorityOrder)
].reverse();
const $ec8b1ae01cf402c0$var$numAnimationTypes = (0, $qy8WU.variantPriorityOrder).length;
function $ec8b1ae01cf402c0$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $1z0eb.animateVisualElement)(visualElement, animation, options)));
}
function $ec8b1ae01cf402c0$export$bb53502b7a672aa8(visualElement) {
    let animate = $ec8b1ae01cf402c0$var$animateList(visualElement);
    let state = $ec8b1ae01cf402c0$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $e1uIa.resolveVariant)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $4xv7A.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $ec8b1ae01cf402c0$var$numAnimationTypes; i++){
            const type = $ec8b1ae01cf402c0$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $8VOWI.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $hk6sz.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $ec8b1ae01cf402c0$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $4bBBq.isKeyframesTarget)(next) && (0, $4bBBq.isKeyframesTarget)(prev)) valueHasChanged = !(0, $3dQlT.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $e1uIa.resolveVariant)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $irAra.calcChildStagger)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $e1uIa.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $ec8b1ae01cf402c0$var$createState();
        /**
             * Temporarily disabling resetting this flag as it prevents components
             * with initial={false} from animating after being remounted, for instance
             * as the child of an Activity component.
             */ // isInitialRender = true
        }
    };
}
function $ec8b1ae01cf402c0$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $3dQlT.shallowCompare)(next, prev);
    return false;
}
function $ec8b1ae01cf402c0$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $ec8b1ae01cf402c0$var$createState() {
    return {
        animate: $ec8b1ae01cf402c0$var$createTypeState(true),
        whileInView: $ec8b1ae01cf402c0$var$createTypeState(),
        whileHover: $ec8b1ae01cf402c0$var$createTypeState(),
        whileTap: $ec8b1ae01cf402c0$var$createTypeState(),
        whileDrag: $ec8b1ae01cf402c0$var$createTypeState(),
        whileFocus: $ec8b1ae01cf402c0$var$createTypeState(),
        exit: $ec8b1ae01cf402c0$var$createTypeState()
    };
}

});
parcelRegister("1z0eb", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $bfef505f1f3b948a$export$ff62cf473653f109; });

var $e1uIa = parcelRequire("e1uIa");

var $bTPoI = parcelRequire("bTPoI");

var $15lzw = parcelRequire("15lzw");
function $bfef505f1f3b948a$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $15lzw.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $15lzw.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $e1uIa.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $bTPoI.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("e1uIa", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $b8ebc3db4383a2c6$export$7b1b1c981f4f0558; });

var $4eZez = parcelRequire("4eZez");
function $b8ebc3db4383a2c6$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $4eZez.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});

parcelRegister("bTPoI", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $c4f6463525e634b3$export$68cacfeee78d98d2; });

var $15WwJ = parcelRequire("15WwJ");
var $6srSR = parcelRequire("6srSR");
var $3d5As = parcelRequire("3d5As");

var $g6rx4 = parcelRequire("g6rx4");

var $jI3E2 = parcelRequire("jI3E2");

var $goCZw = parcelRequire("goCZw");

var $aFQbd = parcelRequire("aFQbd");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $c4f6463525e634b3$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $c4f6463525e634b3$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $c4f6463525e634b3$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $6srSR.getValueTransition)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $goCZw.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $15WwJ.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $jI3E2.addValueToWillChange)(visualElement, key);
        value.start((0, $aFQbd.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $3d5As.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $15WwJ.frame).update(()=>{
            transitionEnd && (0, $g6rx4.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("6srSR", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $f9d68d46b8f92475$export$7c1391340308742e; });
function $f9d68d46b8f92475$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}

});

parcelRegister("g6rx4", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $7eb8bf720ccae412$export$1f61c53461aff4a5; });

var $a8Cmn = parcelRequire("a8Cmn");

var $4bBBq = parcelRequire("4bBBq");

var $e1uIa = parcelRequire("e1uIa");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $7eb8bf720ccae412$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $a8Cmn.motionValue)(value));
}
function $7eb8bf720ccae412$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $4bBBq.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $7eb8bf720ccae412$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $e1uIa.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $7eb8bf720ccae412$var$resolveFinalValueInKeyframes(target[key]);
        $7eb8bf720ccae412$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("4bBBq", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $984866fe7468a54b$export$9153ad4c4999f4a0; });
const $984866fe7468a54b$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});


parcelRegister("jI3E2", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $74ae58d3f5b35b52$export$3ac5aed310be0bee; });

var $knqqV = parcelRequire("knqqV");

var $ffKWz = parcelRequire("ffKWz");
function $74ae58d3f5b35b52$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $ffKWz.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $knqqV.MotionGlobalConfig).WillChange) {
        const newWillChange = new (0, $knqqV.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("ffKWz", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $e313938ce597c753$export$98397f3adbf6259f; });

var $8XwwR = parcelRequire("8XwwR");
function $e313938ce597c753$export$98397f3adbf6259f(value) {
    return Boolean((0, $8XwwR.isMotionValue)(value) && value.add);
}

});


parcelRegister("goCZw", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $ad8903e341d31927$export$5f8d21e84d1d84fc; });

var $dMhG5 = parcelRequire("dMhG5");
function $ad8903e341d31927$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $dMhG5.optimizedAppearDataAttribute];
}

});

parcelRegister("aFQbd", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $b134bb1b8e4b9341$export$90b3dfc33ff3548; });

var $gthBr = parcelRequire("gthBr");
var $15WwJ = parcelRequire("15WwJ");
var $6srSR = parcelRequire("6srSR");
var $jPzHW = parcelRequire("jPzHW");
var $jDNek = parcelRequire("jDNek");

var $knqqV = parcelRequire("knqqV");
var $8V9Fg = parcelRequire("8V9Fg");

var $isv7O = parcelRequire("isv7O");

var $eMaO5 = parcelRequire("eMaO5");

var $baRHW = parcelRequire("baRHW");
const $b134bb1b8e4b9341$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $6srSR.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $8V9Fg.secondsToMilliseconds)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $baRHW.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $eMaO5.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $8V9Fg.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $8V9Fg.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $jDNek.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $knqqV.MotionGlobalConfig).instantAnimations || (0, $knqqV.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            (0, $jDNek.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $isv7O.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $15WwJ.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $jPzHW.JSAnimation)(options) : new (0, $gthBr.AsyncMotionValueAnimation)(options);
    };

});
parcelRegister("gthBr", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", function () { return $db2e5ccc9d67103e$export$b9855e2a7dee3dd2; });

var $knqqV = parcelRequire("knqqV");
var $hI3Mj = parcelRequire("hI3Mj");

var $3cj4G = parcelRequire("3cj4G");

var $jPzHW = parcelRequire("jPzHW");

var $iDBu4 = parcelRequire("iDBu4");

var $jVEGV = parcelRequire("jVEGV");

var $a360V = parcelRequire("a360V");

var $j8oML = parcelRequire("j8oML");

var $jDNek = parcelRequire("jDNek");

var $eKADm = parcelRequire("eKADm");

var $j2hbW = parcelRequire("j2hbW");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $db2e5ccc9d67103e$var$MAX_RESOLVE_DELAY = 40;
class $db2e5ccc9d67103e$export$b9855e2a7dee3dd2 extends (0, $eKADm.WithPromise) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $3cj4G.time).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $jVEGV.KeyframeResolver);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $3cj4G.time).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $j8oML.canAnimate)(keyframes, name, type, velocity)) {
            if ((0, $knqqV.MotionGlobalConfig).instantAnimations || !delay) onUpdate?.((0, $iDBu4.getFinalKeyframe)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $jDNek.makeAnimationInstant)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $db2e5ccc9d67103e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $j2hbW.supportsBrowserAnimation)(resolvedOptions) ? new (0, $a360V.NativeAnimationExtended)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $jPzHW.JSAnimation)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $hI3Mj.noop));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $jVEGV.flushKeyframeResolvers)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}

});
parcelRegister("jPzHW", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", function () { return $c4d709cd3524f6e0$export$3394f837405475c7; });

var $9M1og = parcelRequire("9M1og");
var $8V9Fg = parcelRequire("8V9Fg");
var $a3vIz = parcelRequire("a3vIz");

var $3cj4G = parcelRequire("3cj4G");

var $jjAtE = parcelRequire("jjAtE");

var $5T5bp = parcelRequire("5T5bp");

var $5573x = parcelRequire("5573x");

var $8vw8g = parcelRequire("8vw8g");

var $3wztL = parcelRequire("3wztL");

var $jVrEZ = parcelRequire("jVrEZ");

var $iDBu4 = parcelRequire("iDBu4");

var $kbMO9 = parcelRequire("kbMO9");

var $eKADm = parcelRequire("eKADm");
const $c4d709cd3524f6e0$var$percentToProgress = (percent)=>percent / 100;
class $c4d709cd3524f6e0$export$3394f837405475c7 extends (0, $eKADm.WithPromise) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $3cj4G.time).now()) this.tick((0, $3cj4G.time).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $jjAtE.activeAnimations).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $kbMO9.replaceTransitionType)(options);
        const { type: type = (0, $3wztL.keyframes), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $3wztL.keyframes);
        if (generatorFactory !== (0, $3wztL.keyframes) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $a3vIz.pipe)($c4d709cd3524f6e0$var$percentToProgress, (0, $5T5bp.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $jVrEZ.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $9M1og.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $8vw8g.inertia)) state.value = (0, $iDBu4.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $8V9Fg.millisecondsToSeconds)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $8V9Fg.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, $8V9Fg.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $8V9Fg.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $3cj4G.time).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $8V9Fg.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $5573x.frameloopDriver), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $3cj4G.time).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $jjAtE.activeAnimations).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $c4d709cd3524f6e0$export$ee9b76de7353d815(options) {
    return new $c4d709cd3524f6e0$export$3394f837405475c7(options);
}

});
parcelRegister("8V9Fg", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $22fb8a75e5f3648e$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $22fb8a75e5f3648e$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $22fb8a75e5f3648e$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $22fb8a75e5f3648e$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("a3vIz", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $dbc713c89cd89cb6$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $dbc713c89cd89cb6$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $dbc713c89cd89cb6$export$a4627e546088548d = (...transformers)=>transformers.reduce($dbc713c89cd89cb6$var$combineFunctions);

});

parcelRegister("jjAtE", function(module, exports) {

$parcel$export(module.exports, "activeAnimations", function () { return $de8c3029e4fb7434$export$d921fb2475e2900c; });
const $de8c3029e4fb7434$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

});

parcelRegister("5T5bp", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $f80cc8b0d8ab59fa$export$2c9e8a9632a706b2; });

var $d5C8U = parcelRequire("d5C8U");

var $bTGI6 = parcelRequire("bTGI6");
function $f80cc8b0d8ab59fa$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $bTGI6.mixNumber)(from, to, p);
    const mixer = (0, $d5C8U.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("d5C8U", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $8c0bf60bf1399d44$export$36ec24672cd098e0; });

var $a3vIz = parcelRequire("a3vIz");
var $5ygSW = parcelRequire("5ygSW");

var $7V3so = parcelRequire("7V3so");

var $gfwoY = parcelRequire("gfwoY");

var $bxC6Y = parcelRequire("bxC6Y");

var $cPJpx = parcelRequire("cPJpx");

var $kTask = parcelRequire("kTask");

var $bTGI6 = parcelRequire("bTGI6");

var $gy2ss = parcelRequire("gy2ss");
function $8c0bf60bf1399d44$var$mixNumber(a, b) {
    return (p)=>(0, $bTGI6.mixNumber)(a, b, p);
}
function $8c0bf60bf1399d44$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $8c0bf60bf1399d44$var$mixNumber;
    else if (typeof a === "string") return (0, $7V3so.isCSSVariableToken)(a) ? (0, $kTask.mixImmediate) : (0, $gfwoY.color).test(a) ? (0, $cPJpx.mixColor) : $8c0bf60bf1399d44$export$65516310a87d8205;
    else if (Array.isArray(a)) return $8c0bf60bf1399d44$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $gfwoY.color).test(a) ? (0, $cPJpx.mixColor) : $8c0bf60bf1399d44$export$ebc23b6840c51ba1;
    return 0, $kTask.mixImmediate;
}
function $8c0bf60bf1399d44$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$8c0bf60bf1399d44$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $8c0bf60bf1399d44$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $8c0bf60bf1399d44$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $8c0bf60bf1399d44$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $8c0bf60bf1399d44$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $bxC6Y.complex).createTransformer(target);
    const originStats = (0, $bxC6Y.analyseComplexValue)(origin);
    const targetStats = (0, $bxC6Y.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $gy2ss.invisibleValues).has(origin) && !targetStats.values.length || (0, $gy2ss.invisibleValues).has(target) && !originStats.values.length) return (0, $gy2ss.mixVisibility)(origin, target);
        return (0, $a3vIz.pipe)($8c0bf60bf1399d44$export$3bbefa2f402845c4($8c0bf60bf1399d44$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $5ygSW.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $kTask.mixImmediate)(origin, target);
    }
};

});
parcelRegister("cPJpx", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $9f4fd74223ef39d2$export$51e568cf5c039bac; });

var $5ygSW = parcelRequire("5ygSW");

var $f255w = parcelRequire("f255w");

var $cKWhy = parcelRequire("cKWhy");

var $rldLT = parcelRequire("rldLT");

var $cDMAl = parcelRequire("cDMAl");

var $kTask = parcelRequire("kTask");

var $bTGI6 = parcelRequire("bTGI6");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $9f4fd74223ef39d2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $9f4fd74223ef39d2$var$colorTypes = [
    (0, $f255w.hex),
    (0, $cDMAl.rgba),
    (0, $cKWhy.hsla)
];
const $9f4fd74223ef39d2$var$getColorType = (v)=>$9f4fd74223ef39d2$var$colorTypes.find((type)=>type.test(v));
function $9f4fd74223ef39d2$var$asRGBA(color) {
    const type = $9f4fd74223ef39d2$var$getColorType(color);
    (0, $5ygSW.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $cKWhy.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $rldLT.hslaToRgba)(model);
    return model;
}
const $9f4fd74223ef39d2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $9f4fd74223ef39d2$var$asRGBA(from);
    const toRGBA = $9f4fd74223ef39d2$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $kTask.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $9f4fd74223ef39d2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $9f4fd74223ef39d2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $9f4fd74223ef39d2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $bTGI6.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $cDMAl.rgba).transform(blended);
    };
};

});
parcelRegister("rldLT", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $e7c724b9e222f2cf$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $e7c724b9e222f2cf$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $e7c724b9e222f2cf$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $e7c724b9e222f2cf$var$hueToRgb(p, q, hue + 1 / 3);
        green = $e7c724b9e222f2cf$var$hueToRgb(p, q, hue);
        blue = $e7c724b9e222f2cf$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("kTask", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $0dbbe932dd61c65b$export$a6f92d4bae65c0f1; });
function $0dbbe932dd61c65b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("gy2ss", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $49e27c8902fd3d4b$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $49e27c8902fd3d4b$export$fed62ccc3fb1a568; });
const $49e27c8902fd3d4b$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $49e27c8902fd3d4b$export$fed62ccc3fb1a568(origin, target) {
    if ($49e27c8902fd3d4b$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});



parcelRegister("5573x", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $ee1565d99f18e86f$export$c1033964b5ad7fef; });

var $3cj4G = parcelRequire("3cj4G");

var $15WwJ = parcelRequire("15WwJ");
const $ee1565d99f18e86f$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $15WwJ.frame).update(passTimestamp, keepAlive),
        stop: ()=>(0, $15WwJ.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $15WwJ.frameData).isProcessing ? (0, $15WwJ.frameData).timestamp : (0, $3cj4G.time).now()
    };
};

});

parcelRegister("8vw8g", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $10d545ca2f270a31$export$ee3ff3a17106998; });

var $6MV3x = parcelRequire("6MV3x");

var $lyrGg = parcelRequire("lyrGg");
function $10d545ca2f270a31$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $6MV3x.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $lyrGg.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("6MV3x", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $e40ab1b50203dde6$export$b36281d89752ae66; });

var $9M1og = parcelRequire("9M1og");
var $8V9Fg = parcelRequire("8V9Fg");

var $2bE5n = parcelRequire("2bE5n");

var $jVrEZ = parcelRequire("jVrEZ");

var $7VscK = parcelRequire("7VscK");

var $lyrGg = parcelRequire("lyrGg");

var $i9DKk = parcelRequire("i9DKk");

var $1TjpR = parcelRequire("1TjpR");
const $e40ab1b50203dde6$var$durationKeys = [
    "duration",
    "bounce"
];
const $e40ab1b50203dde6$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $e40ab1b50203dde6$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $e40ab1b50203dde6$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $i9DKk.springDefaults).velocity,
        stiffness: (0, $i9DKk.springDefaults).stiffness,
        damping: (0, $i9DKk.springDefaults).damping,
        mass: (0, $i9DKk.springDefaults).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$e40ab1b50203dde6$var$isSpringType(options, $e40ab1b50203dde6$var$physicsKeys) && $e40ab1b50203dde6$var$isSpringType(options, $e40ab1b50203dde6$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $9M1og.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $i9DKk.springDefaults).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $1TjpR.findSpring)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $i9DKk.springDefaults).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $e40ab1b50203dde6$export$b36281d89752ae66(optionsOrVisualDuration = (0, $i9DKk.springDefaults).visualDuration, bounce = (0, $i9DKk.springDefaults).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $e40ab1b50203dde6$var$getSpringOptions({
        ...options,
        velocity: -(0, $8V9Fg.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $8V9Fg.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $i9DKk.springDefaults).restSpeed.granular : (0, $i9DKk.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $i9DKk.springDefaults).restDelta.granular : (0, $i9DKk.springDefaults).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $1TjpR.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $8V9Fg.secondsToMilliseconds)(initialVelocity) : (0, $lyrGg.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $jVrEZ.calcGeneratorDuration)(generator), (0, $jVrEZ.maxGeneratorDuration));
            const easing = (0, $2bE5n.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$e40ab1b50203dde6$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $7VscK.createGeneratorEasing)(options, 100, $e40ab1b50203dde6$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $8V9Fg.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("2bE5n", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $a29f5bde92262982$export$66d3851e2b1ec912; });
const $a29f5bde92262982$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});

parcelRegister("jVrEZ", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $b7ae6e3e8ce4e330$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $b7ae6e3e8ce4e330$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $b7ae6e3e8ce4e330$export$f4ff70a5b4808fd8 = 20000;
function $b7ae6e3e8ce4e330$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $b7ae6e3e8ce4e330$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $b7ae6e3e8ce4e330$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("7VscK", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $1acb49d09c9e732e$export$7f1511d09ee75a99; });

var $8V9Fg = parcelRequire("8V9Fg");

var $jVrEZ = parcelRequire("jVrEZ");
/**
 * Create a progress => progress easing function from a generator.
 */ function $1acb49d09c9e732e$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $jVrEZ.calcGeneratorDuration)(generator), (0, $jVrEZ.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $8V9Fg.millisecondsToSeconds)(duration)
    };
}

});

parcelRegister("lyrGg", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $b66fab257cab63c5$export$854187271d233eb5; });

var $cj3OQ = parcelRequire("cj3OQ");
const $b66fab257cab63c5$var$velocitySampleDuration = 5; // ms
function $b66fab257cab63c5$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $b66fab257cab63c5$var$velocitySampleDuration, 0);
    return (0, $cj3OQ.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});

parcelRegister("i9DKk", function(module, exports) {

$parcel$export(module.exports, "springDefaults", function () { return $c55359c25fc448be$export$86436497e7b05d16; });
const $c55359c25fc448be$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

});

parcelRegister("1TjpR", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $fbe46d448d6f7cf9$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $fbe46d448d6f7cf9$export$5f679887c3a78b15; });

var $9M1og = parcelRequire("9M1og");
var $8V9Fg = parcelRequire("8V9Fg");
var $5ygSW = parcelRequire("5ygSW");

var $i9DKk = parcelRequire("i9DKk");
const $fbe46d448d6f7cf9$var$safeMin = 0.001;
function $fbe46d448d6f7cf9$export$b15f158dc6d6f458({ duration: duration = (0, $i9DKk.springDefaults).duration, bounce: bounce = (0, $i9DKk.springDefaults).bounce, velocity: velocity = (0, $i9DKk.springDefaults).velocity, mass: mass = (0, $i9DKk.springDefaults).mass }) {
    let envelope;
    let derivative;
    (0, $5ygSW.warning)(duration <= (0, $8V9Fg.secondsToMilliseconds)((0, $i9DKk.springDefaults).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $9M1og.clamp)((0, $i9DKk.springDefaults).minDamping, (0, $i9DKk.springDefaults).maxDamping, dampingRatio);
    duration = (0, $9M1og.clamp)((0, $i9DKk.springDefaults).minDuration, (0, $i9DKk.springDefaults).maxDuration, (0, $8V9Fg.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $fbe46d448d6f7cf9$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $fbe46d448d6f7cf9$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $fbe46d448d6f7cf9$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $fbe46d448d6f7cf9$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$fbe46d448d6f7cf9$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $fbe46d448d6f7cf9$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $8V9Fg.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $i9DKk.springDefaults).stiffness,
        damping: (0, $i9DKk.springDefaults).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $fbe46d448d6f7cf9$var$rootIterations = 12;
function $fbe46d448d6f7cf9$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $fbe46d448d6f7cf9$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $fbe46d448d6f7cf9$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});



parcelRegister("3wztL", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $d5fe8044b04d018f$export$d25ddfdf17c3ad3e; });

var $dngrS = parcelRequire("dngrS");
var $2yyjg = parcelRequire("2yyjg");
var $8vClk = parcelRequire("8vClk");

var $kEGim = parcelRequire("kEGim");

var $43DE3 = parcelRequire("43DE3");

var $j17w3 = parcelRequire("j17w3");
function $d5fe8044b04d018f$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $dngrS.easeInOut)).splice(0, values.length - 1);
}
function $d5fe8044b04d018f$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $8vClk.isEasingArray)(ease) ? ease.map((0, $2yyjg.easingDefinitionToFunction)) : (0, $2yyjg.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $j17w3.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $43DE3.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $kEGim.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $d5fe8044b04d018f$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("dngrS", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $c84441655716ed46$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $c84441655716ed46$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $c84441655716ed46$export$c07234257a03d5e9; });

var $7jMwh = parcelRequire("7jMwh");
const $c84441655716ed46$export$929e5a82286172a6 = /*@__PURE__*/ (0, $7jMwh.cubicBezier)(0.42, 0, 1, 1);
const $c84441655716ed46$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $7jMwh.cubicBezier)(0, 0, 0.58, 1);
const $c84441655716ed46$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $7jMwh.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("7jMwh", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $b718c7ef11af017b$export$2c575fa1d20488bd; });

var $hI3Mj = parcelRequire("hI3Mj");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b718c7ef11af017b$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b718c7ef11af017b$var$subdivisionPrecision = 0.0000001;
const $b718c7ef11af017b$var$subdivisionMaxIterations = 12;
function $b718c7ef11af017b$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b718c7ef11af017b$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b718c7ef11af017b$var$subdivisionPrecision && ++i < $b718c7ef11af017b$var$subdivisionMaxIterations);
    return currentT;
}
function $b718c7ef11af017b$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $hI3Mj.noop;
    const getTForX = (aX)=>$b718c7ef11af017b$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b718c7ef11af017b$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("2yyjg", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $6ac0a3a89308b189$export$ef97fe084f156ca4; });

var $5ygSW = parcelRequire("5ygSW");

var $hI3Mj = parcelRequire("hI3Mj");

var $d9Umf = parcelRequire("d9Umf");

var $4o85a = parcelRequire("4o85a");

var $8xI0K = parcelRequire("8xI0K");

var $7jMwh = parcelRequire("7jMwh");

var $dngrS = parcelRequire("dngrS");

var $bw3he = parcelRequire("bw3he");
const $6ac0a3a89308b189$var$easingLookup = {
    linear: (0, $hI3Mj.noop),
    easeIn: $dngrS.easeIn,
    easeInOut: $dngrS.easeInOut,
    easeOut: $dngrS.easeOut,
    circIn: $8xI0K.circIn,
    circInOut: $8xI0K.circInOut,
    circOut: $8xI0K.circOut,
    backIn: $4o85a.backIn,
    backInOut: $4o85a.backInOut,
    backOut: $4o85a.backOut,
    anticipate: $d9Umf.anticipate
};
const $6ac0a3a89308b189$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $6ac0a3a89308b189$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $bw3he.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $5ygSW.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $7jMwh.cubicBezier)(x1, y1, x2, y2);
    } else if ($6ac0a3a89308b189$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $5ygSW.invariant)($6ac0a3a89308b189$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $6ac0a3a89308b189$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("d9Umf", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $1c72b5ca9f54e8b7$export$6b0af63b873d419e; });

var $4o85a = parcelRequire("4o85a");
const $1c72b5ca9f54e8b7$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $4o85a.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("4o85a", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $2ca0872539c032a8$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $2ca0872539c032a8$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $2ca0872539c032a8$export$ddc5fd596f6c71b2; });

var $7jMwh = parcelRequire("7jMwh");

var $kif05 = parcelRequire("kif05");

var $2iwk4 = parcelRequire("2iwk4");
const $2ca0872539c032a8$export$77edfce482316a60 = /*@__PURE__*/ (0, $7jMwh.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $2ca0872539c032a8$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $2iwk4.reverseEasing)($2ca0872539c032a8$export$77edfce482316a60);
const $2ca0872539c032a8$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $kif05.mirrorEasing)($2ca0872539c032a8$export$b01116c84cdfe1a2);

});
parcelRegister("kif05", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $a3b9ac50894fe8ad$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $a3b9ac50894fe8ad$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("2iwk4", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $b4a418a51793518c$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $b4a418a51793518c$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});



parcelRegister("8xI0K", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $3282c31e0d7d5ed0$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $3282c31e0d7d5ed0$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $3282c31e0d7d5ed0$export$30d3455eee55bed5; });

var $kif05 = parcelRequire("kif05");

var $2iwk4 = parcelRequire("2iwk4");
const $3282c31e0d7d5ed0$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $3282c31e0d7d5ed0$export$c8d67a19199d1a50 = (0, $2iwk4.reverseEasing)($3282c31e0d7d5ed0$export$e444123e42d03385);
const $3282c31e0d7d5ed0$export$30d3455eee55bed5 = (0, $kif05.mirrorEasing)($3282c31e0d7d5ed0$export$e444123e42d03385);

});

parcelRegister("bw3he", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $00b8f11dee0e0b9d$export$ff43f99925d7366b; });
const $00b8f11dee0e0b9d$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});


parcelRegister("8vClk", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $de3c9dd35f93e254$export$216948827bbdc797; });
const $de3c9dd35f93e254$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("kEGim", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $5c7494c16cf532b6$export$89e29e4ab65e70a9; });

var $9M1og = parcelRequire("9M1og");
var $5ygSW = parcelRequire("5ygSW");
var $knqqV = parcelRequire("knqqV");
var $hI3Mj = parcelRequire("hI3Mj");
var $a3vIz = parcelRequire("a3vIz");
var $fho6m = parcelRequire("fho6m");

var $5T5bp = parcelRequire("5T5bp");
function $5c7494c16cf532b6$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $knqqV.MotionGlobalConfig).mix || (0, $5T5bp.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $hI3Mj.noop) : ease;
            mixer = (0, $a3vIz.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5c7494c16cf532b6$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $5ygSW.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5c7494c16cf532b6$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $fho6m.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $9M1og.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("fho6m", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $eeb7d28cf170a58e$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $eeb7d28cf170a58e$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});


parcelRegister("43DE3", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $90a80192d6886f60$export$24dbcec0b26e6d9d; });

var $5Kq0i = parcelRequire("5Kq0i");
function $90a80192d6886f60$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $5Kq0i.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("5Kq0i", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $8bbda722b2c77bd2$export$dafee61230cf05c6; });

var $fho6m = parcelRequire("fho6m");

var $bTGI6 = parcelRequire("bTGI6");
function $8bbda722b2c77bd2$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $fho6m.progress)(0, remaining, i);
        offset.push((0, $bTGI6.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("j17w3", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $ebf68af0a15e89e7$export$2a91b4e3a4539316; });
function $ebf68af0a15e89e7$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("iDBu4", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $3b1469e5da4833b3$export$14de59408fad90b; });
const $3b1469e5da4833b3$var$isNotNull = (value)=>value !== null;
function $3b1469e5da4833b3$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($3b1469e5da4833b3$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("kbMO9", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", function () { return $bff797b8fec89837$export$98db6ef1242dfa2; });

var $8vw8g = parcelRequire("8vw8g");

var $3wztL = parcelRequire("3wztL");

var $6MV3x = parcelRequire("6MV3x");
const $bff797b8fec89837$var$transitionTypeMap = {
    decay: (0, $8vw8g.inertia),
    inertia: $8vw8g.inertia,
    tween: (0, $3wztL.keyframes),
    keyframes: (0, $3wztL.keyframes),
    spring: $6MV3x.spring
};
function $bff797b8fec89837$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $bff797b8fec89837$var$transitionTypeMap[transition.type];
}

});

parcelRegister("eKADm", function(module, exports) {

$parcel$export(module.exports, "WithPromise", function () { return $ac7e8730df9c2607$export$655db786091c33e0; });
class $ac7e8730df9c2607$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}

});


parcelRegister("a360V", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", function () { return $c62c2448ac312480$export$bd2cd6a048093d96; });

var $8V9Fg = parcelRequire("8V9Fg");

var $jPzHW = parcelRequire("jPzHW");

var $3VjZr = parcelRequire("3VjZr");

var $kbMO9 = parcelRequire("kbMO9");

var $j38Fl = parcelRequire("j38Fl");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $c62c2448ac312480$var$sampleDelta = 10; //ms
class $c62c2448ac312480$export$bd2cd6a048093d96 extends (0, $3VjZr.NativeAnimation) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $j38Fl.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $kbMO9.replaceTransitionType)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $jPzHW.JSAnimation)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $8V9Fg.secondsToMilliseconds)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $c62c2448ac312480$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $c62c2448ac312480$var$sampleDelta);
        sampleAnimation.stop();
    }
}

});
parcelRegister("3VjZr", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", function () { return $3853a68355647d44$export$6c0f9803d8aa7219; });

var $5ygSW = parcelRequire("5ygSW");
var $8V9Fg = parcelRequire("8V9Fg");
var $hI3Mj = parcelRequire("hI3Mj");

var $i2RF0 = parcelRequire("i2RF0");

var $8pb5G = parcelRequire("8pb5G");

var $iDBu4 = parcelRequire("iDBu4");

var $eKADm = parcelRequire("eKADm");

var $5oJU9 = parcelRequire("5oJU9");

var $bjWXh = parcelRequire("bjWXh");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $3853a68355647d44$export$6c0f9803d8aa7219 extends (0, $eKADm.WithPromise) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $5ygSW.invariant)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $bjWXh.applyGeneratorOptions)(options);
        this.animation = (0, $5oJU9.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $iDBu4.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $i2RF0.setStyle)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $8V9Fg.millisecondsToSeconds)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $8V9Fg.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, $8V9Fg.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $8V9Fg.secondsToMilliseconds)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $8pb5G.supportsScrollTimeline)()) {
            this.animation.timeline = timeline;
            return 0, $hI3Mj.noop;
        } else return observe(this);
    }
}

});
parcelRegister("i2RF0", function(module, exports) {

$parcel$export(module.exports, "setStyle", function () { return $c5b9f9a2d5f06bac$export$37a5fde709c1db82; });

var $65JZs = parcelRequire("65JZs");
function $c5b9f9a2d5f06bac$export$37a5fde709c1db82(element, name, value) {
    (0, $65JZs.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("65JZs", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", function () { return $08d582122db82679$export$c9f584638d388483; });
const $08d582122db82679$export$c9f584638d388483 = (name)=>name.startsWith("--");

});


parcelRegister("8pb5G", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $a904286528144860$export$20d68f04f30763a5; });

var $aC3Cs = parcelRequire("aC3Cs");
const $a904286528144860$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $aC3Cs.memo)(()=>window.ScrollTimeline !== undefined);

});
parcelRegister("aC3Cs", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $e60ecbabedf57096$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $e60ecbabedf57096$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});


parcelRegister("5oJU9", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $3f9b3398abcda9fc$export$d896de52f97cb615; });

var $jjAtE = parcelRequire("jjAtE");

var $cgohm = parcelRequire("cgohm");

var $9VWEV = parcelRequire("9VWEV");
function $3f9b3398abcda9fc$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $9VWEV.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $cgohm.statsBuffer).value) (0, $jjAtE.activeAnimations).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $cgohm.statsBuffer).value) animation.finished.finally(()=>{
        (0, $jjAtE.activeAnimations).waapi--;
    });
    return animation;
}

});
parcelRegister("9VWEV", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $a03467e3d354993c$export$916ea73bcd3a6030; });

var $bw3he = parcelRequire("bw3he");

var $iypOp = parcelRequire("iypOp");

var $2bE5n = parcelRequire("2bE5n");

var $ktoKc = parcelRequire("ktoKc");

var $6EtwC = parcelRequire("6EtwC");
function $a03467e3d354993c$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $iypOp.supportsLinearEasing)() ? (0, $2bE5n.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $bw3he.isBezierDefinition)(easing)) return (0, $ktoKc.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$a03467e3d354993c$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $6EtwC.supportedWaapiEasing).easeOut);
    else return (0, $6EtwC.supportedWaapiEasing)[easing];
}

});
parcelRegister("iypOp", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $f64850100535fdbe$export$866c1d07a1ac2ab; });

var $6Hwzo = parcelRequire("6Hwzo");
const $f64850100535fdbe$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $6Hwzo.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("6Hwzo", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $8fd02eac89304836$export$1964673d5ec13c3a; });

var $aC3Cs = parcelRequire("aC3Cs");

var $abkrL = parcelRequire("abkrL");
function $8fd02eac89304836$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $aC3Cs.memo)(callback);
    return ()=>(0, $abkrL.supportsFlags)[supportsFlag] ?? memoized();
}

});
parcelRegister("abkrL", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $f430f2b29b49dc64$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $f430f2b29b49dc64$export$e3ad02c335474dee = {};

});



parcelRegister("ktoKc", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", function () { return $633d53353926322e$export$2523b8f0bd8f44cb; });
const $633d53353926322e$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

});

parcelRegister("6EtwC", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", function () { return $e99b032d7d3ae835$export$2cf569f5e2221176; });

var $ktoKc = parcelRequire("ktoKc");
const $e99b032d7d3ae835$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $ktoKc.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $ktoKc.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $ktoKc.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $ktoKc.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("bjWXh", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $c2f354cd94456dc8$export$a31269144d66b4a; });

var $iypOp = parcelRequire("iypOp");

var $9OjJq = parcelRequire("9OjJq");
function $c2f354cd94456dc8$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $9OjJq.isGenerator)(type) && (0, $iypOp.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}

});
parcelRegister("9OjJq", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $b2c1543d1ad8412c$export$6ab7812f1bac68be; });
function $b2c1543d1ad8412c$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});



parcelRegister("j38Fl", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", function () { return $62b70a928af8eaac$export$5195f232c29d1f82; });

var $d9Umf = parcelRequire("d9Umf");
var $4o85a = parcelRequire("4o85a");
var $8xI0K = parcelRequire("8xI0K");
const $62b70a928af8eaac$var$unsupportedEasingFunctions = {
    anticipate: $d9Umf.anticipate,
    backInOut: $4o85a.backInOut,
    circInOut: $8xI0K.circInOut
};
function $62b70a928af8eaac$var$isUnsupportedEase(key) {
    return key in $62b70a928af8eaac$var$unsupportedEasingFunctions;
}
function $62b70a928af8eaac$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $62b70a928af8eaac$var$isUnsupportedEase(transition.ease)) transition.ease = $62b70a928af8eaac$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("j8oML", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $5e97d4ad2594237b$export$1b109e6c9968df4f; });

var $5ygSW = parcelRequire("5ygSW");

var $9OjJq = parcelRequire("9OjJq");

var $a2NWP = parcelRequire("a2NWP");
function $5e97d4ad2594237b$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $5e97d4ad2594237b$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $a2NWP.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $a2NWP.isAnimatable)(targetKeyframe, name);
    (0, $5ygSW.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $5e97d4ad2594237b$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $9OjJq.isGenerator)(type)) && velocity;
}

});
parcelRegister("a2NWP", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $7f1b8d523f76e750$export$65676b58b122bc38; });

var $bxC6Y = parcelRequire("bxC6Y");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $7f1b8d523f76e750$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $bxC6Y.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("jDNek", function(module, exports) {

$parcel$export(module.exports, "makeAnimationInstant", function () { return $f72ac493105576f3$export$b2585dd3c345da47; });
function $f72ac493105576f3$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}

});

parcelRegister("j2hbW", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", function () { return $749f82ae5201684e$export$ea92bde116fda821; });

var $aC3Cs = parcelRequire("aC3Cs");
/**
 * A list of values that can be hardware-accelerated.
 */ const $749f82ae5201684e$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $749f82ae5201684e$var$supportsWaapi = /*@__PURE__*/ (0, $aC3Cs.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $749f82ae5201684e$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $749f82ae5201684e$var$supportsWaapi() && name && $749f82ae5201684e$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});


parcelRegister("isv7O", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $0ad09dba1569a4f5$export$14de59408fad90b; });
const $0ad09dba1569a4f5$var$isNotNull = (value)=>value !== null;
function $0ad09dba1569a4f5$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($0ad09dba1569a4f5$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("eMaO5", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $7e9801037a423de8$export$262124b154b9f1c0; });

var $3Vm0J = parcelRequire("3Vm0J");
const $7e9801037a423de8$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $7e9801037a423de8$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $7e9801037a423de8$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $7e9801037a423de8$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $7e9801037a423de8$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $7e9801037a423de8$var$keyframesTransition;
    else if ((0, $3Vm0J.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $7e9801037a423de8$var$criticallyDampedSpring(keyframes[1]) : $7e9801037a423de8$var$underDampedSpring;
    return $7e9801037a423de8$var$ease;
};

});

parcelRegister("baRHW", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $b16c10aeec08f3b8$export$ca8e47dc8ed5a9d7; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $b16c10aeec08f3b8$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

});



parcelRegister("15lzw", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $6d3995c96783b8b9$export$4709dc300705b2af; });

var $e1uIa = parcelRequire("e1uIa");

var $irAra = parcelRequire("irAra");

var $bTPoI = parcelRequire("bTPoI");
function $6d3995c96783b8b9$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $e1uIa.resolveVariant)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $bTPoI.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $6d3995c96783b8b9$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $6d3995c96783b8b9$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($6d3995c96783b8b9$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $irAra.calcChildStagger)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}

});
parcelRegister("irAra", function(module, exports) {

$parcel$export(module.exports, "calcChildStagger", function () { return $6ddd9b834d6f142f$export$6e01cb2cb232d79b; });
function $6ddd9b834d6f142f$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}

});



parcelRegister("3dQlT", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $87a8e5322f11d485$export$90e866afbd6b9f1a; });
function $87a8e5322f11d485$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("4xv7A", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $3209bfc0042f107d$export$6669f52f7ffa343b; });

var $8VOWI = parcelRequire("8VOWI");

var $qy8WU = parcelRequire("qy8WU");
const $3209bfc0042f107d$var$numVariantProps = (0, $qy8WU.variantProps).length;
function $3209bfc0042f107d$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $3209bfc0042f107d$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $3209bfc0042f107d$var$numVariantProps; i++){
        const name = (0, $qy8WU.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, $8VOWI.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

});


parcelRegister("cDuTX", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $eb8e3110567b1372$export$6e91cf7616333d5; });
class $eb8e3110567b1372$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("1krk5", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $1ee6d4ab4a7be431$export$4989d1eb6104cc6c; });

var $cDuTX = parcelRequire("cDuTX");
let $1ee6d4ab4a7be431$var$id = 0;
class $1ee6d4ab4a7be431$export$4989d1eb6104cc6c extends (0, $cDuTX.Feature) {
    constructor(){
        super(...arguments);
        this.id = $1ee6d4ab4a7be431$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("3W5Lu", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $111e6a15a4275ca3$export$d7d5d435647ed5a0; });

var $5GqRo = parcelRequire("5GqRo");

var $ap0Tt = parcelRequire("ap0Tt");

var $9yyOy = parcelRequire("9yyOy");

var $hHbE9 = parcelRequire("hHbE9");
const $111e6a15a4275ca3$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $ap0Tt.PanGesture)
    },
    drag: {
        Feature: (0, $5GqRo.DragGesture),
        ProjectionNode: (0, $hHbE9.HTMLProjectionNode),
        MeasureLayout: $9yyOy.MeasureLayout
    }
};

});
parcelRegister("5GqRo", function(module, exports) {

$parcel$export(module.exports, "DragGesture", function () { return $5797968f0551daae$export$5d97dc2872682820; });

var $cDuTX = parcelRequire("cDuTX");

var $hI3Mj = parcelRequire("hI3Mj");

var $9KdX4 = parcelRequire("9KdX4");
class $5797968f0551daae$export$5d97dc2872682820 extends (0, $cDuTX.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $hI3Mj.noop);
        this.removeListeners = (0, $hI3Mj.noop);
        this.controls = new (0, $9KdX4.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $hI3Mj.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("9KdX4", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $3ac618b544678fdd$export$86bff71f18910307; });

var $15WwJ = parcelRequire("15WwJ");
var $bTGI6 = parcelRequire("bTGI6");
var $7mQ5b = parcelRequire("7mQ5b");
var $6PCgq = parcelRequire("6PCgq");

var $5ygSW = parcelRequire("5ygSW");

var $aFQbd = parcelRequire("aFQbd");

var $1hKHW = parcelRequire("1hKHW");

var $cR01A = parcelRequire("cR01A");

var $dso4d = parcelRequire("dso4d");

var $eIYTw = parcelRequire("eIYTw");

var $ky1rD = parcelRequire("ky1rD");

var $k1gBv = parcelRequire("k1gBv");

var $7bUbn = parcelRequire("7bUbn");

var $hQqmZ = parcelRequire("hQqmZ");

var $nN63y = parcelRequire("nN63y");

var $eknSB = parcelRequire("eknSB");

var $jI3E2 = parcelRequire("jI3E2");

var $dWUnB = parcelRequire("dWUnB");

var $2q0ER = parcelRequire("2q0ER");
const $3ac618b544678fdd$export$f0a15892c27dc07c = new WeakMap();
class $3ac618b544678fdd$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $k1gBv.createBox)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $dso4d.extractEventInfo)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $6PCgq.setDragLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $7bUbn.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $7mQ5b.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $ky1rD.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $15WwJ.frame).postRender(()=>onDragStart(event, info));
            (0, $jI3E2.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $3ac618b544678fdd$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>(0, $7bUbn.eachAxis)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $dWUnB.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $nN63y.getContextWindow)(this.visualElement)
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $15WwJ.frame).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2q0ER.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $eknSB.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2q0ER.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2q0ER.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $7bUbn.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2q0ER.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $eknSB.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $5ygSW.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $hQqmZ.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2q0ER.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $eIYTw.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $eIYTw.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $7bUbn.eachAxis)((axis)=>{
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $jI3E2.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, $aFQbd.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $7bUbn.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $7bUbn.eachAxis)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $7bUbn.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $bTGI6.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $eknSB.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $7bUbn.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2q0ER.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $7bUbn.eachAxis)((axis)=>{
            if (!$3ac618b544678fdd$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $bTGI6.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $3ac618b544678fdd$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $cR01A.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $eknSB.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $15WwJ.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $1hKHW.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $7bUbn.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2q0ER.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $3ac618b544678fdd$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3ac618b544678fdd$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("6PCgq", function(module, exports) {

$parcel$export(module.exports, "setDragLock", function () { return $b126b5e1cc92c214$export$64d8a3fd7eb621d5; });

var $lPvVT = parcelRequire("lPvVT");
function $b126b5e1cc92c214$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $lPvVT.isDragging)[axis]) return null;
        else {
            (0, $lPvVT.isDragging)[axis] = true;
            return ()=>{
                (0, $lPvVT.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, $lPvVT.isDragging).x || (0, $lPvVT.isDragging).y) return null;
        else {
            (0, $lPvVT.isDragging).x = (0, $lPvVT.isDragging).y = true;
            return ()=>{
                (0, $lPvVT.isDragging).x = (0, $lPvVT.isDragging).y = false;
            };
        }
    }
}

});
parcelRegister("lPvVT", function(module, exports) {

$parcel$export(module.exports, "isDragging", function () { return $ad0aa5d36da76a99$export$9e9bc3c487fccc00; });
$parcel$export(module.exports, "isDragActive", function () { return $ad0aa5d36da76a99$export$1b3dd616664938e4; });
const $ad0aa5d36da76a99$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $ad0aa5d36da76a99$export$1b3dd616664938e4() {
    return $ad0aa5d36da76a99$export$9e9bc3c487fccc00.x || $ad0aa5d36da76a99$export$9e9bc3c487fccc00.y;
}

});


parcelRegister("1hKHW", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $77e2c87f7317172d$export$b1d829ddf82884aa; });
function $77e2c87f7317172d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("cR01A", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $0249e0418812713d$export$fcff2e64e6676b81; });

var $1hKHW = parcelRequire("1hKHW");

var $dso4d = parcelRequire("dso4d");
function $0249e0418812713d$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $1hKHW.addDomEvent)(target, eventName, (0, $dso4d.addPointerInfo)(handler), options);
}

});
parcelRegister("dso4d", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $352f162696a87216$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $352f162696a87216$export$c404e80f92c98d29; });

var $3sEWO = parcelRequire("3sEWO");
function $352f162696a87216$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $352f162696a87216$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $3sEWO.isPrimaryPointer)(event) && handler(event, $352f162696a87216$export$12f84bb882d06e1a(event));
};

});
parcelRegister("3sEWO", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $8b51de90b274ddc4$export$a4cf9c8a4b063a6e; });
const $8b51de90b274ddc4$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("ky1rD", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $fbf8656879722a5e$export$c1c127004b72a37; });
$parcel$export(module.exports, "isNear", function () { return $fbf8656879722a5e$export$28d0384c4b79bde2; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $fbf8656879722a5e$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $fbf8656879722a5e$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $fbf8656879722a5e$export$2785bfcc929c5650; });

var $bTGI6 = parcelRequire("bTGI6");
const $fbf8656879722a5e$var$SCALE_PRECISION = 0.0001;
const $fbf8656879722a5e$var$SCALE_MIN = 1 - $fbf8656879722a5e$var$SCALE_PRECISION;
const $fbf8656879722a5e$var$SCALE_MAX = 1 + $fbf8656879722a5e$var$SCALE_PRECISION;
const $fbf8656879722a5e$var$TRANSLATE_PRECISION = 0.01;
const $fbf8656879722a5e$var$TRANSLATE_MIN = 0 - $fbf8656879722a5e$var$TRANSLATE_PRECISION;
const $fbf8656879722a5e$var$TRANSLATE_MAX = 0 + $fbf8656879722a5e$var$TRANSLATE_PRECISION;
function $fbf8656879722a5e$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $fbf8656879722a5e$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $bTGI6.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $fbf8656879722a5e$export$c1c127004b72a37(target) / $fbf8656879722a5e$export$c1c127004b72a37(source);
    delta.translate = (0, $bTGI6.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $fbf8656879722a5e$var$SCALE_MIN && delta.scale <= $fbf8656879722a5e$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $fbf8656879722a5e$var$TRANSLATE_MIN && delta.translate <= $fbf8656879722a5e$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $fbf8656879722a5e$export$c0d25e96fc67d310(delta, source, target, origin) {
    $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $fbf8656879722a5e$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $fbf8656879722a5e$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $fbf8656879722a5e$export$c1c127004b72a37(relative);
}
function $fbf8656879722a5e$export$426154f9d100f99(target, relative, parent) {
    $fbf8656879722a5e$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $fbf8656879722a5e$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $fbf8656879722a5e$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $fbf8656879722a5e$export$c1c127004b72a37(layout);
}
function $fbf8656879722a5e$export$2785bfcc929c5650(target, layout, parent) {
    $fbf8656879722a5e$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $fbf8656879722a5e$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});

parcelRegister("7bUbn", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $b328923997b880e2$export$b789de563eb43b1; });
function $b328923997b880e2$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("nN63y", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", function () { return $619c36f92ed2d250$export$d533d84f9871c879; });
// Fixes https://github.com/motiondivision/motion/issues/2270
const $619c36f92ed2d250$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});

parcelRegister("dWUnB", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $a96c951350c710a6$export$d9c66232c9c4689c; });

var $15WwJ = parcelRequire("15WwJ");
var $3sEWO = parcelRequire("3sEWO");

var $8V9Fg = parcelRequire("8V9Fg");
var $a3vIz = parcelRequire("a3vIz");

var $cR01A = parcelRequire("cR01A");

var $dso4d = parcelRequire("dso4d");

var $dG7Ok = parcelRequire("dG7Ok");
/**
 * @internal
 */ class $a96c951350c710a6$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3 } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $a96c951350c710a6$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $dG7Ok.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $15WwJ.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $15WwJ.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $a96c951350c710a6$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $3sEWO.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $dso4d.extractEventInfo)(event);
        const initialInfo = $a96c951350c710a6$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $15WwJ.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $a96c951350c710a6$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $a3vIz.pipe)((0, $cR01A.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $cR01A.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $cR01A.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $15WwJ.cancelFrame)(this.updatePoint);
    }
}
function $a96c951350c710a6$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $a96c951350c710a6$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $a96c951350c710a6$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $a96c951350c710a6$var$subtractPoint(point, $a96c951350c710a6$var$lastDevicePoint(history)),
        offset: $a96c951350c710a6$var$subtractPoint(point, $a96c951350c710a6$var$startDevicePoint(history)),
        velocity: $a96c951350c710a6$var$getVelocity(history, 0.1)
    };
}
function $a96c951350c710a6$var$startDevicePoint(history) {
    return history[0];
}
function $a96c951350c710a6$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $a96c951350c710a6$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $a96c951350c710a6$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $8V9Fg.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $8V9Fg.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("dG7Ok", function(module, exports) {

$parcel$export(module.exports, "distance2D", function () { return $243d4ba06004d04f$export$503a1d513f12e38b; });
const $243d4ba06004d04f$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $243d4ba06004d04f$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $243d4ba06004d04f$export$9f17032d917177de(a.x, b.x);
    const yDelta = $243d4ba06004d04f$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("2q0ER", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $98bb42ec913936c2$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $98bb42ec913936c2$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $98bb42ec913936c2$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $98bb42ec913936c2$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $98bb42ec913936c2$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $98bb42ec913936c2$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $98bb42ec913936c2$export$7c5eaef8f4723d22; });

var $bTGI6 = parcelRequire("bTGI6");

var $9M1og = parcelRequire("9M1og");
var $fho6m = parcelRequire("fho6m");

var $ky1rD = parcelRequire("ky1rD");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $98bb42ec913936c2$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $bTGI6.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $bTGI6.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $98bb42ec913936c2$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $98bb42ec913936c2$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $98bb42ec913936c2$export$690c180aa5775042(layoutBox.x, left, right),
        y: $98bb42ec913936c2$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $98bb42ec913936c2$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $98bb42ec913936c2$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $98bb42ec913936c2$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $98bb42ec913936c2$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $98bb42ec913936c2$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $ky1rD.calcLength)(source);
    const targetLength = (0, $ky1rD.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $fho6m.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $fho6m.progress)(source.min, source.max - targetLength, target.min);
    return (0, $9M1og.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $98bb42ec913936c2$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $98bb42ec913936c2$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $98bb42ec913936c2$export$7c5eaef8f4723d22(dragElastic = $98bb42ec913936c2$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $98bb42ec913936c2$export$a3366d3bac43a742;
    return {
        x: $98bb42ec913936c2$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $98bb42ec913936c2$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $98bb42ec913936c2$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $98bb42ec913936c2$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});



parcelRegister("ap0Tt", function(module, exports) {

$parcel$export(module.exports, "PanGesture", function () { return $11464e390de2be0d$export$b4f8f1ee75ce5859; });

var $15WwJ = parcelRequire("15WwJ");

var $hI3Mj = parcelRequire("hI3Mj");

var $cR01A = parcelRequire("cR01A");

var $cDuTX = parcelRequire("cDuTX");

var $nN63y = parcelRequire("nN63y");

var $dWUnB = parcelRequire("dWUnB");
const $11464e390de2be0d$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $15WwJ.frame).postRender(()=>handler(event, info));
    };
class $11464e390de2be0d$export$b4f8f1ee75ce5859 extends (0, $cDuTX.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $hI3Mj.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $dWUnB.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $nN63y.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $11464e390de2be0d$var$asyncHandler(onPanSessionStart),
            onStart: $11464e390de2be0d$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $15WwJ.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $cR01A.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("9yyOy", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $370ac8a012d5732d$export$779f5fb01ad751cd; });

var $jk232 = parcelRequire("jk232");

var $15WwJ = parcelRequire("15WwJ");
var $ehNhG = parcelRequire("ehNhG");

var $4RFnf = parcelRequire("4RFnf");

var $cjQCv = parcelRequire("cjQCv");

var $3bZPm = parcelRequire("3bZPm");

var $kDIQN = parcelRequire("kDIQN");

var $9W5rG = parcelRequire("9W5rG");
"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $370ac8a012d5732d$var$hasTakenAnySnapshot = false;
class $370ac8a012d5732d$var$MeasureLayoutWithContext extends (0, $4RFnf.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($370ac8a012d5732d$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $9W5rG.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        $370ac8a012d5732d$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $15WwJ.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $ehNhG.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $370ac8a012d5732d$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $370ac8a012d5732d$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $cjQCv.usePresence)();
    const layoutGroup = (0, $4RFnf.useContext)((0, $3bZPm.LayoutGroupContext));
    return (0, $jk232.jsx)($370ac8a012d5732d$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $4RFnf.useContext)((0, $kDIQN.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}

});
parcelRegister("cjQCv", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $d632bff0bbad0e32$export$2a8c16d82a0a0e26; });

var $4RFnf = parcelRequire("4RFnf");

var $7S8DD = parcelRequire("7S8DD");
"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $d632bff0bbad0e32$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $4RFnf.useContext)((0, $7S8DD.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $4RFnf.useId)();
    (0, $4RFnf.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $4RFnf.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $d632bff0bbad0e32$export$8249053f690ea39a() {
    return $d632bff0bbad0e32$export$ee27c052bca048fb((0, $4RFnf.useContext)((0, $7S8DD.PresenceContext)));
}
function $d632bff0bbad0e32$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("9W5rG", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $8aa27fa37088906f$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $8aa27fa37088906f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});


parcelRegister("hHbE9", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $ba7872bc9d278845$export$b61a9eb3dbde8858; });

var $4AA5O = parcelRequire("4AA5O");

var $ht5UM = parcelRequire("ht5UM");
const $ba7872bc9d278845$export$b91509fcf893b648 = {
    current: undefined
};
const $ba7872bc9d278845$export$b61a9eb3dbde8858 = (0, $4AA5O.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$ba7872bc9d278845$export$b91509fcf893b648.current) {
            const documentNode = new (0, $ht5UM.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $ba7872bc9d278845$export$b91509fcf893b648.current = documentNode;
        }
        return $ba7872bc9d278845$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("4AA5O", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $1a5f10f811306b92$export$a84b61f69daa9da0; });

var $jjAtE = parcelRequire("jjAtE");
var $15WwJ = parcelRequire("15WwJ");
var $6srSR = parcelRequire("6srSR");
var $8nsyW = parcelRequire("8nsyW");
var $vEAq6 = parcelRequire("vEAq6");
var $ehNhG = parcelRequire("ehNhG");
var $bTGI6 = parcelRequire("bTGI6");
var $a8Cmn = parcelRequire("a8Cmn");
var $cgohm = parcelRequire("cgohm");
var $3cj4G = parcelRequire("3cj4G");

var $9M1og = parcelRequire("9M1og");
var $hI3Mj = parcelRequire("hI3Mj");
var $8zNyL = parcelRequire("8zNyL");

var $eWClT = parcelRequire("eWClT");

var $goCZw = parcelRequire("goCZw");

var $4DmxN = parcelRequire("4DmxN");

var $cwzP1 = parcelRequire("cwzP1");

var $am8c1 = parcelRequire("am8c1");

var $5M2Yl = parcelRequire("5M2Yl");

var $gBlQT = parcelRequire("gBlQT");

var $9J9kF = parcelRequire("9J9kF");

var $ky1rD = parcelRequire("ky1rD");

var $gNuwK = parcelRequire("gNuwK");

var $k1gBv = parcelRequire("k1gBv");

var $aRGkt = parcelRequire("aRGkt");

var $7x5lH = parcelRequire("7x5lH");

var $2stVt = parcelRequire("2stVt");

var $dybfm = parcelRequire("dybfm");

var $7bUbn = parcelRequire("7bUbn");

var $1Xmdc = parcelRequire("1Xmdc");

var $9W5rG = parcelRequire("9W5rG");
const $1a5f10f811306b92$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $1a5f10f811306b92$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $1a5f10f811306b92$var$animationTarget = 1000;
let $1a5f10f811306b92$var$id = 0;
function $1a5f10f811306b92$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $1a5f10f811306b92$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $goCZw.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $15WwJ.frame), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $1a5f10f811306b92$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $1a5f10f811306b92$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $1a5f10f811306b92$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $cgohm.statsBuffer).value) $1a5f10f811306b92$var$metrics.nodes = $1a5f10f811306b92$var$metrics.calculatedTargetDeltas = $1a5f10f811306b92$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($1a5f10f811306b92$export$131f2f0cc5fe9609);
                this.nodes.forEach($1a5f10f811306b92$var$resolveTargetDelta);
                this.nodes.forEach($1a5f10f811306b92$var$calcProjection);
                this.nodes.forEach($1a5f10f811306b92$export$c2664f37bc951031);
                if ((0, $cgohm.statsBuffer).addProjectionMetrics) (0, $cgohm.statsBuffer).addProjectionMetrics($1a5f10f811306b92$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $4DmxN.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $8zNyL.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $8nsyW.isSVGElement)(instance) && !(0, $vEAq6.isSVGSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $15WwJ.frame).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $cwzP1.delay)(resizeUnblockUpdate, 250);
                    if ((0, $9W5rG.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $9W5rG.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($1a5f10f811306b92$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $1a5f10f811306b92$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $aRGkt.boxEqualsRounded)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $6srSR.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $1a5f10f811306b92$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $15WwJ.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($1a5f10f811306b92$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $1a5f10f811306b92$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($1a5f10f811306b92$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($1a5f10f811306b92$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($1a5f10f811306b92$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Write
                 */ this.nodes.forEach($1a5f10f811306b92$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($1a5f10f811306b92$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($1a5f10f811306b92$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $3cj4G.time).now();
            (0, $15WwJ.frameData).delta = (0, $9M1og.clamp)(0, 1000 / 60, now - (0, $15WwJ.frameData).timestamp);
            (0, $15WwJ.frameData).timestamp = now;
            (0, $15WwJ.frameData).isProcessing = true;
            (0, $15WwJ.frameSteps).update.process((0, $15WwJ.frameData));
            (0, $15WwJ.frameSteps).preRender.process((0, $15WwJ.frameData));
            (0, $15WwJ.frameSteps).render.process((0, $15WwJ.frameData));
            (0, $15WwJ.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $ehNhG.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($1a5f10f811306b92$var$clearSnapshot);
            this.sharedNodes.forEach($1a5f10f811306b92$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $15WwJ.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $15WwJ.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $ky1rD.calcLength)(this.snapshot.measuredBox.x) && !(0, $ky1rD.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            this.layoutCorrected = (0, $k1gBv.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $aRGkt.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $1Xmdc.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $1a5f10f811306b92$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $k1gBv.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($1a5f10f811306b92$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $9J9kF.translateAxis)(box.x, scroll.offset.x);
                    (0, $9J9kF.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $k1gBv.createBox)();
            (0, $gBlQT.copyBoxInto)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $gBlQT.copyBoxInto)(boxWithoutScroll, box);
                    (0, $9J9kF.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $9J9kF.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $k1gBv.createBox)();
            (0, $gBlQT.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $9J9kF.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $1Xmdc.hasTransform)(node.latestValues)) continue;
                (0, $9J9kF.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $1Xmdc.hasTransform)(this.latestValues)) (0, $9J9kF.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $k1gBv.createBox)();
            (0, $gBlQT.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $1Xmdc.hasTransform)(node.latestValues)) continue;
                (0, $1Xmdc.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $k1gBv.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $gBlQT.copyBoxInto)(sourceBox, nodeBox);
                (0, $gNuwK.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $1Xmdc.hasTransform)(this.latestValues)) (0, $gNuwK.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $15WwJ.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $15WwJ.frameData).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $k1gBv.createBox)();
                this.targetWithTransforms = (0, $k1gBv.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $ky1rD.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $gBlQT.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $9J9kF.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $gBlQT.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $cgohm.statsBuffer).value) $1a5f10f811306b92$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $1Xmdc.hasScale)(this.parent.latestValues) || (0, $1Xmdc.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $k1gBv.createBox)();
            this.relativeTargetOrigin = (0, $k1gBv.createBox)();
            (0, $ky1rD.calcRelativePosition)(this.relativeTargetOrigin, layout, parentLayout);
            (0, $gBlQT.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $15WwJ.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $gBlQT.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $9J9kF.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $k1gBv.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $gBlQT.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $gBlQT.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $ky1rD.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $aRGkt.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $aRGkt.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $cgohm.statsBuffer).value) $1a5f10f811306b92$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $k1gBv.createDelta)();
            this.projectionDelta = (0, $k1gBv.createDelta)();
            this.projectionDeltaWithTransform = (0, $k1gBv.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $k1gBv.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $k1gBv.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($1a5f10f811306b92$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $1a5f10f811306b92$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $1a5f10f811306b92$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $ky1rD.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $1a5f10f811306b92$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $aRGkt.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $k1gBv.createBox)();
                    (0, $gBlQT.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $5M2Yl.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $15WwJ.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $15WwJ.frame).update(()=>{
                (0, $9W5rG.globalProjectionState).hasAnimatedSinceResize = true;
                (0, $jjAtE.activeAnimations).layout++;
                this.motionValue || (this.motionValue = (0, $a8Cmn.motionValue)(0));
                this.currentAnimation = (0, $eWClT.animateSingleValue)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $jjAtE.activeAnimations).layout--;
                    },
                    onComplete: ()=>{
                        (0, $jjAtE.activeAnimations).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($1a5f10f811306b92$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $1a5f10f811306b92$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $k1gBv.createBox)();
                const xLength = (0, $ky1rD.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $ky1rD.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $gBlQT.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $9J9kF.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $ky1rD.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $7x5lH.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $1a5f10f811306b92$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $1a5f10f811306b92$var$transformAxes.length; i++){
                $1a5f10f811306b92$var$resetDistortingTransform(`rotate${$1a5f10f811306b92$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $1a5f10f811306b92$var$resetDistortingTransform(`skew${$1a5f10f811306b92$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $am8c1.resolveMotionValue)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $am8c1.resolveMotionValue)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $1Xmdc.hasTransform)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $dybfm.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $2stVt.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $2stVt.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $am8c1.resolveMotionValue)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($1a5f10f811306b92$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $1a5f10f811306b92$var$updateLayout(node) {
    node.updateLayout();
}
function $1a5f10f811306b92$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $7bUbn.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ky1rD.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($1a5f10f811306b92$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $7bUbn.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ky1rD.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $k1gBv.createDelta)();
        (0, $ky1rD.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $k1gBv.createDelta)();
        if (isShared) (0, $ky1rD.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $ky1rD.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $aRGkt.isDeltaZero)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $k1gBv.createBox)();
                    (0, $ky1rD.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $k1gBv.createBox)();
                    (0, $ky1rD.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $aRGkt.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $1a5f10f811306b92$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $cgohm.statsBuffer).value) $1a5f10f811306b92$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $1a5f10f811306b92$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $1a5f10f811306b92$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $1a5f10f811306b92$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $1a5f10f811306b92$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $1a5f10f811306b92$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $1a5f10f811306b92$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $1a5f10f811306b92$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $1a5f10f811306b92$var$calcProjection(node) {
    node.calcProjection();
}
function $1a5f10f811306b92$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $1a5f10f811306b92$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $1a5f10f811306b92$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $bTGI6.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $bTGI6.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $1a5f10f811306b92$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $bTGI6.mixNumber)(from.min, to.min, p);
    output.max = (0, $bTGI6.mixNumber)(from.max, to.max, p);
}
function $1a5f10f811306b92$export$6ffd3e6ae339a132(output, from, to, p) {
    $1a5f10f811306b92$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $1a5f10f811306b92$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $1a5f10f811306b92$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $1a5f10f811306b92$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $1a5f10f811306b92$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $1a5f10f811306b92$var$roundPoint = $1a5f10f811306b92$var$userAgentContains("applewebkit/") && !$1a5f10f811306b92$var$userAgentContains("chrome/") ? Math.round : (0, $hI3Mj.noop);
function $1a5f10f811306b92$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $1a5f10f811306b92$var$roundPoint(axis.min);
    axis.max = $1a5f10f811306b92$var$roundPoint(axis.max);
}
function $1a5f10f811306b92$var$roundBox(box) {
    $1a5f10f811306b92$var$roundAxis(box.x);
    $1a5f10f811306b92$var$roundAxis(box.y);
}
function $1a5f10f811306b92$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $ky1rD.isNear)((0, $aRGkt.aspectRatio)(snapshot), (0, $aRGkt.aspectRatio)(layout), 0.2);
}
function $1a5f10f811306b92$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}

});
parcelRegister("8nsyW", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $fdb29f06d2a5fb66$export$17eda790a720ec57; });

var $xqlHL = parcelRequire("xqlHL");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $fdb29f06d2a5fb66$export$17eda790a720ec57(element) {
    return (0, $xqlHL.isObject)(element) && "ownerSVGElement" in element;
}

});
parcelRegister("xqlHL", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $fc60222c33dd1d92$export$a6cdc56e425d0d0a; });
function $fc60222c33dd1d92$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}

});


parcelRegister("vEAq6", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", function () { return $69b4f1dbce82ce91$export$66957ea77182581d; });

var $8nsyW = parcelRequire("8nsyW");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $69b4f1dbce82ce91$export$66957ea77182581d(element) {
    return (0, $8nsyW.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("eWClT", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $5844f2927987a154$export$335a17c977067b99; });

var $8XwwR = parcelRequire("8XwwR");
var $a8Cmn = parcelRequire("a8Cmn");

var $aFQbd = parcelRequire("aFQbd");
function $5844f2927987a154$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $8XwwR.isMotionValue)(value) ? value : (0, $a8Cmn.motionValue)(value);
    motionValue$1.start((0, $aFQbd.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});

parcelRegister("4DmxN", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $557b65fe81ce40e5$export$1465d17e3de78a96; });

var $cJpH9 = parcelRequire("cJpH9");

var $lCkYb = parcelRequire("lCkYb");
class $557b65fe81ce40e5$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $cJpH9.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $cJpH9.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $lCkYb.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("lCkYb", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $be5918dc4ca5c398$export$d689d9dec5ad338; });
const $be5918dc4ca5c398$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("cwzP1", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $60b54120d33b237f$export$1391212d75b2ee65; });

var $15WwJ = parcelRequire("15WwJ");
var $3cj4G = parcelRequire("3cj4G");

var $8V9Fg = parcelRequire("8V9Fg");
/**
 * Timeout defined in ms
 */ function $60b54120d33b237f$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $3cj4G.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $15WwJ.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $15WwJ.frame).setup(checkElapsed, true);
    return ()=>(0, $15WwJ.cancelFrame)(checkElapsed);
}
function $60b54120d33b237f$export$fcd451ca460f8a2a(callback, timeout) {
    return $60b54120d33b237f$export$1391212d75b2ee65(callback, (0, $8V9Fg.secondsToMilliseconds)(timeout));
}

});

parcelRegister("5M2Yl", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $b8b8ef99307b7dfb$export$739e279c17d51c3d; });

var $bTGI6 = parcelRequire("bTGI6");
var $7mQ5b = parcelRequire("7mQ5b");

var $8xI0K = parcelRequire("8xI0K");
var $hI3Mj = parcelRequire("hI3Mj");
var $fho6m = parcelRequire("fho6m");
const $b8b8ef99307b7dfb$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $b8b8ef99307b7dfb$var$numBorders = $b8b8ef99307b7dfb$var$borders.length;
const $b8b8ef99307b7dfb$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $b8b8ef99307b7dfb$var$isPx = (value)=>typeof value === "number" || (0, $7mQ5b.px).test(value);
function $b8b8ef99307b7dfb$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $bTGI6.mixNumber)(0, lead.opacity ?? 1, $b8b8ef99307b7dfb$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $bTGI6.mixNumber)(follow.opacity ?? 1, 0, $b8b8ef99307b7dfb$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $bTGI6.mixNumber)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $b8b8ef99307b7dfb$var$numBorders; i++){
        const borderLabel = `border${$b8b8ef99307b7dfb$var$borders[i]}Radius`;
        let followRadius = $b8b8ef99307b7dfb$var$getRadius(follow, borderLabel);
        let leadRadius = $b8b8ef99307b7dfb$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $b8b8ef99307b7dfb$var$isPx(followRadius) === $b8b8ef99307b7dfb$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $bTGI6.mixNumber)($b8b8ef99307b7dfb$var$asNumber(followRadius), $b8b8ef99307b7dfb$var$asNumber(leadRadius), progress), 0);
            if ((0, $7mQ5b.percent).test(leadRadius) || (0, $7mQ5b.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $bTGI6.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $b8b8ef99307b7dfb$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $b8b8ef99307b7dfb$var$easeCrossfadeIn = /*@__PURE__*/ $b8b8ef99307b7dfb$var$compress(0, 0.5, (0, $8xI0K.circOut));
const $b8b8ef99307b7dfb$var$easeCrossfadeOut = /*@__PURE__*/ $b8b8ef99307b7dfb$var$compress(0.5, 0.95, (0, $hI3Mj.noop));
function $b8b8ef99307b7dfb$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $fho6m.progress)(min, max, p));
    };
}

});

parcelRegister("gBlQT", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $6012b031071d0197$export$c53fd88f45d77e4b; });
$parcel$export(module.exports, "copyAxisDeltaInto", function () { return $6012b031071d0197$export$8ead6a7d6b225ef; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $6012b031071d0197$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $6012b031071d0197$export$c53fd88f45d77e4b(box, originBox) {
    $6012b031071d0197$export$a0230ae482601ae8(box.x, originBox.x);
    $6012b031071d0197$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $6012b031071d0197$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("gNuwK", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $052337095e55c9d7$export$73e1ad0a9694e25c; });

var $bTGI6 = parcelRequire("bTGI6");
var $7mQ5b = parcelRequire("7mQ5b");

var $9J9kF = parcelRequire("9J9kF");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $052337095e55c9d7$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $9J9kF.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $9J9kF.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $052337095e55c9d7$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $7mQ5b.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $bTGI6.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $bTGI6.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $052337095e55c9d7$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $052337095e55c9d7$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $052337095e55c9d7$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $052337095e55c9d7$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $052337095e55c9d7$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $052337095e55c9d7$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $052337095e55c9d7$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $052337095e55c9d7$export$42b76f1d0d16d5b(box.x, transforms, $052337095e55c9d7$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $052337095e55c9d7$export$42b76f1d0d16d5b(box.y, transforms, $052337095e55c9d7$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("aRGkt", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $356b7218a819f537$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $356b7218a819f537$export$8d5cf76bb7daff09; });
$parcel$export(module.exports, "boxEqualsRounded", function () { return $356b7218a819f537$export$ef641b782d85522; });
$parcel$export(module.exports, "aspectRatio", function () { return $356b7218a819f537$export$c5706146bc63213; });
$parcel$export(module.exports, "axisDeltaEquals", function () { return $356b7218a819f537$export$444620505e28fe92; });

var $ky1rD = parcelRequire("ky1rD");
function $356b7218a819f537$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $356b7218a819f537$export$a7ec7642fe550fb6(delta) {
    return $356b7218a819f537$var$isAxisDeltaZero(delta.x) && $356b7218a819f537$var$isAxisDeltaZero(delta.y);
}
function $356b7218a819f537$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $356b7218a819f537$export$8d5cf76bb7daff09(a, b) {
    return $356b7218a819f537$export$7a9a6f114ddd0fdb(a.x, b.x) && $356b7218a819f537$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $356b7218a819f537$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $356b7218a819f537$export$ef641b782d85522(a, b) {
    return $356b7218a819f537$export$22adf28bfca1c186(a.x, b.x) && $356b7218a819f537$export$22adf28bfca1c186(a.y, b.y);
}
function $356b7218a819f537$export$c5706146bc63213(box) {
    return (0, $ky1rD.calcLength)(box.x) / (0, $ky1rD.calcLength)(box.y);
}
function $356b7218a819f537$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("7x5lH", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $cc70679c2b0a68c5$export$39be5b2d82fc9dc7; });

var $cJpH9 = parcelRequire("cJpH9");
class $cc70679c2b0a68c5$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $cJpH9.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $cJpH9.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("dybfm", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $aac13bd7ac0878d9$export$d33653b270fe725c; });
function $aac13bd7ac0878d9$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});


parcelRegister("ht5UM", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $355591a4cde6cb1c$export$2d029a49a09b6177; });

var $1hKHW = parcelRequire("1hKHW");

var $4AA5O = parcelRequire("4AA5O");
const $355591a4cde6cb1c$export$2d029a49a09b6177 = (0, $4AA5O.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $1hKHW.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("5dC0T", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $cb98cd5a424f6ffb$export$e5b72898e5a201f1; });

var $7Bth9 = parcelRequire("7Bth9");

var $eNIBK = parcelRequire("eNIBK");

var $i1JGP = parcelRequire("i1JGP");

var $b0LZL = parcelRequire("b0LZL");
const $cb98cd5a424f6ffb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $b0LZL.InViewFeature)
    },
    tap: {
        Feature: (0, $i1JGP.PressGesture)
    },
    focus: {
        Feature: (0, $eNIBK.FocusGesture)
    },
    hover: {
        Feature: (0, $7Bth9.HoverGesture)
    }
};

});
parcelRegister("7Bth9", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $6922ef6f005de1cb$export$93a81ea037eac456; });

var $15WwJ = parcelRequire("15WwJ");
var $4FLqo = parcelRequire("4FLqo");

var $dso4d = parcelRequire("dso4d");

var $cDuTX = parcelRequire("cDuTX");
function $6922ef6f005de1cb$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $15WwJ.frame).postRender(()=>callback(event, (0, $dso4d.extractEventInfo)(event)));
}
class $6922ef6f005de1cb$export$93a81ea037eac456 extends (0, $cDuTX.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $4FLqo.hover)(current, (_element, startEvent)=>{
            $6922ef6f005de1cb$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$6922ef6f005de1cb$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

});
parcelRegister("4FLqo", function(module, exports) {

$parcel$export(module.exports, "hover", function () { return $e65f0be6fb5d9d84$export$3f60957f5dbf3876; });

var $lPvVT = parcelRequire("lPvVT");

var $bYMaa = parcelRequire("bYMaa");
function $e65f0be6fb5d9d84$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $lPvVT.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $e65f0be6fb5d9d84$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $bYMaa.setupGesture)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$e65f0be6fb5d9d84$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$e65f0be6fb5d9d84$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

});
parcelRegister("bYMaa", function(module, exports) {

$parcel$export(module.exports, "setupGesture", function () { return $7175889ab9634a8a$export$edc0ace9d5e7e842; });

var $e4ZMW = parcelRequire("e4ZMW");
function $7175889ab9634a8a$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $e4ZMW.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});
parcelRegister("e4ZMW", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $30f1250ff8b41941$export$90ceba2564a894f8; });
function $30f1250ff8b41941$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

});




parcelRegister("eNIBK", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $0eb79481ee574ab9$export$d4826db40d47595b; });

var $a3vIz = parcelRequire("a3vIz");

var $1hKHW = parcelRequire("1hKHW");

var $cDuTX = parcelRequire("cDuTX");
class $0eb79481ee574ab9$export$d4826db40d47595b extends (0, $cDuTX.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $a3vIz.pipe)((0, $1hKHW.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $1hKHW.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("i1JGP", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $d909611b2456935b$export$f026abdbba7f0c9e; });

var $15WwJ = parcelRequire("15WwJ");
var $hRfo9 = parcelRequire("hRfo9");

var $dso4d = parcelRequire("dso4d");

var $cDuTX = parcelRequire("cDuTX");
function $d909611b2456935b$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $15WwJ.frame).postRender(()=>callback(event, (0, $dso4d.extractEventInfo)(event)));
}
class $d909611b2456935b$export$f026abdbba7f0c9e extends (0, $cDuTX.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $hRfo9.press)(current, (_element, startEvent)=>{
            $d909611b2456935b$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$d909611b2456935b$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}

});
parcelRegister("hRfo9", function(module, exports) {

$parcel$export(module.exports, "press", function () { return $2a674f3b6443c996$export$dbe9198142dace0c; });

var $hZjiu = parcelRequire("hZjiu");

var $lPvVT = parcelRequire("lPvVT");

var $fRH0z = parcelRequire("fRH0z");

var $3sEWO = parcelRequire("3sEWO");

var $bYMaa = parcelRequire("bYMaa");

var $lJd5C = parcelRequire("lJd5C");

var $04QCb = parcelRequire("04QCb");

var $9J8pP = parcelRequire("9J8pP");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $2a674f3b6443c996$var$isValidPressEvent(event) {
    return (0, $3sEWO.isPrimaryPointer)(event) && !(0, $lPvVT.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $2a674f3b6443c996$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $bYMaa.setupGesture)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$2a674f3b6443c996$var$isValidPressEvent(startEvent)) return;
        (0, $9J8pP.isPressing).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $9J8pP.isPressing).has(target)) (0, $9J8pP.isPressing).delete(target);
            if (!$2a674f3b6443c996$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $fRH0z.isNodeOrChild)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $hZjiu.isHTMLElement)(target)) {
            target.addEventListener("focus", (event)=>(0, $04QCb.enableKeyboardPress)(event, eventOptions));
            if (!(0, $lJd5C.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

});
parcelRegister("hZjiu", function(module, exports) {

$parcel$export(module.exports, "isHTMLElement", function () { return $98413ca6c7b6f3ff$export$1b3bfaa9684536aa; });

var $xqlHL = parcelRequire("xqlHL");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $98413ca6c7b6f3ff$export$1b3bfaa9684536aa(element) {
    return (0, $xqlHL.isObject)(element) && "offsetHeight" in element;
}

});

parcelRegister("fRH0z", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $cb70c2b5ad3fc422$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $cb70c2b5ad3fc422$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $cb70c2b5ad3fc422$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("lJd5C", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", function () { return $89b665e1a7e1b46a$export$5f6976e2f961e8b7; });
const $89b665e1a7e1b46a$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $89b665e1a7e1b46a$export$5f6976e2f961e8b7(element) {
    return $89b665e1a7e1b46a$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

});

parcelRegister("04QCb", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", function () { return $ec4f7c755681b3ff$export$4b5790288fe12a79; });

var $9J8pP = parcelRequire("9J8pP");
/**
 * Filter out events that are not "Enter" keys.
 */ function $ec4f7c755681b3ff$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $ec4f7c755681b3ff$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $ec4f7c755681b3ff$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $ec4f7c755681b3ff$var$filterEvents(()=>{
        if ((0, $9J8pP.isPressing).has(element)) return;
        $ec4f7c755681b3ff$var$firePointerEvent(element, "down");
        const handleKeyup = $ec4f7c755681b3ff$var$filterEvents(()=>{
            $ec4f7c755681b3ff$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$ec4f7c755681b3ff$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

});
parcelRegister("9J8pP", function(module, exports) {

$parcel$export(module.exports, "isPressing", function () { return $cabd671294128c43$export$7987404a4e35b84b; });
const $cabd671294128c43$export$7987404a4e35b84b = new WeakSet();

});




parcelRegister("b0LZL", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $16d57ecf081a35f6$export$150851c8cc2f0c72; });

var $cDuTX = parcelRequire("cDuTX");

var $fLhSD = parcelRequire("fLhSD");
const $16d57ecf081a35f6$var$thresholdNames = {
    some: 0,
    all: 1
};
class $16d57ecf081a35f6$export$150851c8cc2f0c72 extends (0, $cDuTX.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $16d57ecf081a35f6$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $fLhSD.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($16d57ecf081a35f6$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $16d57ecf081a35f6$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("fLhSD", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $6691a380ec8073ef$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $6691a380ec8073ef$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $6691a380ec8073ef$var$observers = new WeakMap();
const $6691a380ec8073ef$var$fireObserverCallback = (entry)=>{
    const callback = $6691a380ec8073ef$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $6691a380ec8073ef$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($6691a380ec8073ef$var$fireObserverCallback);
};
function $6691a380ec8073ef$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$6691a380ec8073ef$var$observers.has(lookupRoot)) $6691a380ec8073ef$var$observers.set(lookupRoot, {});
    const rootObservers = $6691a380ec8073ef$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($6691a380ec8073ef$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $6691a380ec8073ef$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $6691a380ec8073ef$var$initIntersectionObserver(options);
    $6691a380ec8073ef$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $6691a380ec8073ef$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("9UlGk", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $ee379c5f20422af9$export$b3219800bda33a1f; });

var $hHbE9 = parcelRequire("hHbE9");

var $9yyOy = parcelRequire("9yyOy");
const $ee379c5f20422af9$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $hHbE9.HTMLProjectionNode),
        MeasureLayout: $9yyOy.MeasureLayout
    }
};

});



parcelRegister("b1rvU", function(module, exports) {
module.exports = $parcel$import("2RjDP").then(()=>parcelRequire('bWqV0'));

});

var $d8fbff85c2abd97c$exports = {};
$parcel$extendImportMap({
    "2RjDP": "Grocery.8b5eaed1.js"
});


var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");
var $e6901a497e5ba7f6$exports = {};

$parcel$export($e6901a497e5ba7f6$exports, "createRoot", function () { return $e6901a497e5ba7f6$export$882461b6382ed46c; }, function (v) { return $e6901a497e5ba7f6$export$882461b6382ed46c = v; });
$parcel$export($e6901a497e5ba7f6$exports, "hydrateRoot", function () { return $e6901a497e5ba7f6$export$757ceba2d55c277e; }, function (v) { return $e6901a497e5ba7f6$export$757ceba2d55c277e = v; });
var $e6901a497e5ba7f6$export$882461b6382ed46c;
var $e6901a497e5ba7f6$export$757ceba2d55c277e;
'use strict';
var $6ce1434187f7101c$exports = {};
'use strict';
function $6ce1434187f7101c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6ce1434187f7101c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6ce1434187f7101c$var$checkDCE();

$6ce1434187f7101c$exports = (parcelRequire("bwgJJ"));


var $e6901a497e5ba7f6$var$i;
$e6901a497e5ba7f6$export$882461b6382ed46c = $6ce1434187f7101c$exports.createRoot;
$e6901a497e5ba7f6$export$757ceba2d55c277e = $6ce1434187f7101c$exports.hydrateRoot;


/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e352e4bbcb5a39c7$var$_extends() {
    $e352e4bbcb5a39c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e352e4bbcb5a39c7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e352e4bbcb5a39c7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e352e4bbcb5a39c7$export$e19cd5f9376f8cee || ($e352e4bbcb5a39c7$export$e19cd5f9376f8cee = {}));
const $e352e4bbcb5a39c7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e352e4bbcb5a39c7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e352e4bbcb5a39c7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e352e4bbcb5a39c7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e352e4bbcb5a39c7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e352e4bbcb5a39c7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e352e4bbcb5a39c7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e352e4bbcb5a39c7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e352e4bbcb5a39c7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e352e4bbcb5a39c7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e352e4bbcb5a39c7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e352e4bbcb5a39c7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e352e4bbcb5a39c7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e352e4bbcb5a39c7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e352e4bbcb5a39c7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e352e4bbcb5a39c7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let location = $e352e4bbcb5a39c7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e352e4bbcb5a39c7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e352e4bbcb5a39c7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e352e4bbcb5a39c7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e352e4bbcb5a39c7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e352e4bbcb5a39c7$var$ResultType || ($e352e4bbcb5a39c7$var$ResultType = {}));
const $e352e4bbcb5a39c7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e352e4bbcb5a39c7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e352e4bbcb5a39c7$var$isIndexRoute(route)) {
            let indexRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e352e4bbcb5a39c7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e352e4bbcb5a39c7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e352e4bbcb5a39c7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e352e4bbcb5a39c7$var$flattenRoutes(routes);
    $e352e4bbcb5a39c7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e352e4bbcb5a39c7$export$30d21fd6d7295f52(pathname);
        matches = $e352e4bbcb5a39c7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $e352e4bbcb5a39c7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e352e4bbcb5a39c7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e352e4bbcb5a39c7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e352e4bbcb5a39c7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e352e4bbcb5a39c7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e352e4bbcb5a39c7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e352e4bbcb5a39c7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e352e4bbcb5a39c7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e352e4bbcb5a39c7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e352e4bbcb5a39c7$var$paramRe = /^:[\w-]+$/;
const $e352e4bbcb5a39c7$var$dynamicSegmentValue = 3;
const $e352e4bbcb5a39c7$var$indexRouteValue = 2;
const $e352e4bbcb5a39c7$var$emptySegmentValue = 1;
const $e352e4bbcb5a39c7$var$staticSegmentValue = 10;
const $e352e4bbcb5a39c7$var$splatPenalty = -2;
const $e352e4bbcb5a39c7$var$isSplat = (s)=>s === "*";
function $e352e4bbcb5a39c7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e352e4bbcb5a39c7$var$isSplat)) initialScore += $e352e4bbcb5a39c7$var$splatPenalty;
    if (index) initialScore += $e352e4bbcb5a39c7$var$indexRouteValue;
    return segments.filter((s)=>!$e352e4bbcb5a39c7$var$isSplat(s)).reduce((score, segment)=>score + ($e352e4bbcb5a39c7$var$paramRe.test(segment) ? $e352e4bbcb5a39c7$var$dynamicSegmentValue : segment === "" ? $e352e4bbcb5a39c7$var$emptySegmentValue : $e352e4bbcb5a39c7$var$staticSegmentValue), initialScore);
}
function $e352e4bbcb5a39c7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e352e4bbcb5a39c7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e352e4bbcb5a39c7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e352e4bbcb5a39c7$export$a5c6d149b50c1d86($e352e4bbcb5a39c7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e352e4bbcb5a39c7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e352e4bbcb5a39c7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e352e4bbcb5a39c7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e352e4bbcb5a39c7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e352e4bbcb5a39c7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e352e4bbcb5a39c7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e352e4bbcb5a39c7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e352e4bbcb5a39c7$var$isAbsoluteUrl = (url)=>$e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($e352e4bbcb5a39c7$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $e352e4bbcb5a39c7$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $e352e4bbcb5a39c7$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e352e4bbcb5a39c7$var$normalizeSearch(search),
        hash: $e352e4bbcb5a39c7$var$normalizeHash(hash)
    };
}
function $e352e4bbcb5a39c7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e352e4bbcb5a39c7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e352e4bbcb5a39c7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e352e4bbcb5a39c7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e352e4bbcb5a39c7$var$_extends({}, toArg);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e352e4bbcb5a39c7$var$getInvalidPathError("?", "pathname", "search", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "pathname", "hash", to));
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e352e4bbcb5a39c7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e352e4bbcb5a39c7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e352e4bbcb5a39c7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e352e4bbcb5a39c7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e352e4bbcb5a39c7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e352e4bbcb5a39c7$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e352e4bbcb5a39c7$export$4051a07651545597(data, init) {
    return new $e352e4bbcb5a39c7$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a extends Error {
}
class $e352e4bbcb5a39c7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e352e4bbcb5a39c7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e352e4bbcb5a39c7$var$unwrapTrackedPromise(value) {
    if (!$e352e4bbcb5a39c7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e352e4bbcb5a39c7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e352e4bbcb5a39c7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e352e4bbcb5a39c7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e352e4bbcb5a39c7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e352e4bbcb5a39c7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e352e4bbcb5a39c7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e352e4bbcb5a39c7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e352e4bbcb5a39c7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e352e4bbcb5a39c7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e352e4bbcb5a39c7$var$validMutationMethods = new Set($e352e4bbcb5a39c7$var$validMutationMethodsArr);
const $e352e4bbcb5a39c7$var$validRequestMethodsArr = [
    "get",
    ...$e352e4bbcb5a39c7$var$validMutationMethodsArr
];
const $e352e4bbcb5a39c7$var$validRequestMethods = new Set($e352e4bbcb5a39c7$var$validRequestMethodsArr);
const $e352e4bbcb5a39c7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e352e4bbcb5a39c7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e352e4bbcb5a39c7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e352e4bbcb5a39c7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e352e4bbcb5a39c7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e352e4bbcb5a39c7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e352e4bbcb5a39c7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e352e4bbcb5a39c7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e352e4bbcb5a39c7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e352e4bbcb5a39c7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e352e4bbcb5a39c7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e352e4bbcb5a39c7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e352e4bbcb5a39c7$var$findNearestBoundary(matches).route.id,
            {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e352e4bbcb5a39c7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e352e4bbcb5a39c7$var$isErrorResult(result) && $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
            matches: updatedMatches || matches
        }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e352e4bbcb5a39c7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e352e4bbcb5a39c7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e352e4bbcb5a39c7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e352e4bbcb5a39c7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e352e4bbcb5a39c7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e352e4bbcb5a39c7$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e352e4bbcb5a39c7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e352e4bbcb5a39c7$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e352e4bbcb5a39c7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e352e4bbcb5a39c7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e352e4bbcb5a39c7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult) || $e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e352e4bbcb5a39c7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e352e4bbcb5a39c7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e352e4bbcb5a39c7$var$isDeferredResult(actionResult)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e352e4bbcb5a39c7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e352e4bbcb5a39c7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e352e4bbcb5a39c7$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e352e4bbcb5a39c7$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e352e4bbcb5a39c7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e352e4bbcb5a39c7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) result = await $e352e4bbcb5a39c7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e352e4bbcb5a39c7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $e352e4bbcb5a39c7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Replace : $e352e4bbcb5a39c7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e352e4bbcb5a39c7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e352e4bbcb5a39c7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e352e4bbcb5a39c7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e352e4bbcb5a39c7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e352e4bbcb5a39c7$var$ResultType.redirect,
                response: $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e352e4bbcb5a39c7$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e352e4bbcb5a39c7$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e352e4bbcb5a39c7$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e352e4bbcb5a39c7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e352e4bbcb5a39c7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e352e4bbcb5a39c7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e352e4bbcb5a39c7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e352e4bbcb5a39c7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e352e4bbcb5a39c7$export$4d0306f8f6a4585b = Symbol("deferred");
function $e352e4bbcb5a39c7$export$3336b097a6fbc59a(routes, opts) {
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e352e4bbcb5a39c7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e352e4bbcb5a39c7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e352e4bbcb5a39c7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e352e4bbcb5a39c7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e352e4bbcb5a39c7$var$createLocation("", $e352e4bbcb5a39c7$export$fe53371bee54353d(url), null, "default");
        let matches = $e352e4bbcb5a39c7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e352e4bbcb5a39c7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e352e4bbcb5a39c7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e352e4bbcb5a39c7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e352e4bbcb5a39c7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e352e4bbcb5a39c7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e352e4bbcb5a39c7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e352e4bbcb5a39c7$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e352e4bbcb5a39c7$var$isResponse(result) ? result : $e352e4bbcb5a39c7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e352e4bbcb5a39c7$var$isDataStrategyResult(e) && $e352e4bbcb5a39c7$var$isResponse(e.result)) {
                if (e.type === $e352e4bbcb5a39c7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e352e4bbcb5a39c7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            let error = $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e352e4bbcb5a39c7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e352e4bbcb5a39c7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e352e4bbcb5a39c7$var$_extends({}, context, {
                statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e352e4bbcb5a39c7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e352e4bbcb5a39c7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategy || $e352e4bbcb5a39c7$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e352e4bbcb5a39c7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e352e4bbcb5a39c7$export$fec11da027c70692(routes, context, error) {
    let newContext = $e352e4bbcb5a39c7$var$_extends({}, context, {
        statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e352e4bbcb5a39c7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e352e4bbcb5a39c7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e352e4bbcb5a39c7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e352e4bbcb5a39c7$export$cae722b0cc860f13(to ? to : ".", $e352e4bbcb5a39c7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e352e4bbcb5a39c7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e352e4bbcb5a39c7$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e352e4bbcb5a39c7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e352e4bbcb5a39c7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e352e4bbcb5a39c7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e352e4bbcb5a39c7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e352e4bbcb5a39c7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e352e4bbcb5a39c7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e352e4bbcb5a39c7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e352e4bbcb5a39c7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e352e4bbcb5a39c7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e352e4bbcb5a39c7$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e352e4bbcb5a39c7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e352e4bbcb5a39c7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e352e4bbcb5a39c7$var$shouldRevalidateLoader(match, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e352e4bbcb5a39c7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e352e4bbcb5a39c7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e352e4bbcb5a39c7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e352e4bbcb5a39c7$var$shouldRevalidateLoader(fetcherMatch, $e352e4bbcb5a39c7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e352e4bbcb5a39c7$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e352e4bbcb5a39c7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e352e4bbcb5a39c7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e352e4bbcb5a39c7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e352e4bbcb5a39c7$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e352e4bbcb5a39c7$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e352e4bbcb5a39c7$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e352e4bbcb5a39c7$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e352e4bbcb5a39c7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e352e4bbcb5a39c7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e352e4bbcb5a39c7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e352e4bbcb5a39c7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e352e4bbcb5a39c7$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e352e4bbcb5a39c7$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e352e4bbcb5a39c7$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e352e4bbcb5a39c7$var$ResultType.data,
                result: undefined
            });
        };
        return $e352e4bbcb5a39c7$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e352e4bbcb5a39c7$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e352e4bbcb5a39c7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e352e4bbcb5a39c7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e352e4bbcb5a39c7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e352e4bbcb5a39c7$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e352e4bbcb5a39c7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: e
            };
        }
        if (type === $e352e4bbcb5a39c7$var$ResultType.error) return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: new $e352e4bbcb5a39c7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e352e4bbcb5a39c7$var$ResultType.error) {
        if ($e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e352e4bbcb5a39c7$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e352e4bbcb5a39c7$var$ResultType.error,
                error: new $e352e4bbcb5a39c7$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: result,
            statusCode: $e352e4bbcb5a39c7$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e352e4bbcb5a39c7$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e352e4bbcb5a39c7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e352e4bbcb5a39c7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e352e4bbcb5a39c7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e352e4bbcb5a39c7$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($e352e4bbcb5a39c7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $e352e4bbcb5a39c7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e352e4bbcb5a39c7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e352e4bbcb5a39c7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e352e4bbcb5a39c7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e352e4bbcb5a39c7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e352e4bbcb5a39c7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(!$e352e4bbcb5a39c7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e352e4bbcb5a39c7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e352e4bbcb5a39c7$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e352e4bbcb5a39c7$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e352e4bbcb5a39c7$var$isErrorResult(result)) {
            let boundaryMatch = $e352e4bbcb5a39c7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e352e4bbcb5a39c7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e352e4bbcb5a39c7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e352e4bbcb5a39c7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e352e4bbcb5a39c7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e352e4bbcb5a39c7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e352e4bbcb5a39c7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e352e4bbcb5a39c7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e352e4bbcb5a39c7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e352e4bbcb5a39c7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e352e4bbcb5a39c7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e352e4bbcb5a39c7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e352e4bbcb5a39c7$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e352e4bbcb5a39c7$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e352e4bbcb5a39c7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(path) : path;
    return $e352e4bbcb5a39c7$export$fe53371bee54353d($e352e4bbcb5a39c7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e352e4bbcb5a39c7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e352e4bbcb5a39c7$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e352e4bbcb5a39c7$var$ResultType.data || result.type === $e352e4bbcb5a39c7$var$ResultType.error);
}
function $e352e4bbcb5a39c7$var$isRedirectDataStrategyResultResult(result) {
    return $e352e4bbcb5a39c7$var$isResponse(result.result) && $e352e4bbcb5a39c7$var$redirectStatusCodes.has(result.result.status);
}
function $e352e4bbcb5a39c7$var$isDeferredResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.deferred;
}
function $e352e4bbcb5a39c7$var$isErrorResult(result) {
    return result.type === $e352e4bbcb5a39c7$var$ResultType.error;
}
function $e352e4bbcb5a39c7$var$isRedirectResult(result) {
    return (result && result.type) === $e352e4bbcb5a39c7$var$ResultType.redirect;
}
function $e352e4bbcb5a39c7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e352e4bbcb5a39c7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e352e4bbcb5a39c7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e352e4bbcb5a39c7$var$isRedirectResponse(result) {
    if (!$e352e4bbcb5a39c7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e352e4bbcb5a39c7$var$isValidMethod(method) {
    return $e352e4bbcb5a39c7$var$validRequestMethods.has(method.toLowerCase());
}
function $e352e4bbcb5a39c7$var$isMutationMethod(method) {
    return $e352e4bbcb5a39c7$var$validMutationMethods.has(method.toLowerCase());
}
async function $e352e4bbcb5a39c7$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e352e4bbcb5a39c7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e352e4bbcb5a39c7$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e352e4bbcb5a39c7$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e352e4bbcb5a39c7$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e352e4bbcb5a39c7$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e352e4bbcb5a39c7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e352e4bbcb5a39c7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e352e4bbcb5a39c7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e352e4bbcb5a39c7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e352e4bbcb5a39c7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e352e4bbcb5a39c7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e352e4bbcb5a39c7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e352e4bbcb5a39c7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e352e4bbcb5a39c7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e352e4bbcb5a39c7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e352e4bbcb5a39c7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e352e4bbcb5a39c7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e352e4bbcb5a39c7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e352e4bbcb5a39c7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e352e4bbcb5a39c7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4RFnf = parcelRequire("4RFnf");

function $2dda13c5d6544900$var$_extends() {
    $2dda13c5d6544900$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2dda13c5d6544900$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2dda13c5d6544900$export$3add0d5dce533e2e = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$145dfa71566a64dc = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$var$AwaitContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2dda13c5d6544900$export$26749e8557646306 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$c7914228fb69b0f5 = /*#__PURE__*/ $4RFnf.createContext(null);
const $2dda13c5d6544900$export$9072aa6dd1f93057 = /*#__PURE__*/ $4RFnf.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2dda13c5d6544900$var$RouteErrorContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $2dda13c5d6544900$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $2dda13c5d6544900$export$9c954a9d03d32f4a() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $2dda13c5d6544900$export$45d76561a5302f2b() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $2dda13c5d6544900$export$1b3f31771c5d07c() {
    return $4RFnf.useContext($2dda13c5d6544900$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $2dda13c5d6544900$export$6c330e8992e8a295(pattern) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    return $4RFnf.useMemo(()=>(0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(pattern, (0, $e352e4bbcb5a39c7$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2dda13c5d6544900$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2dda13c5d6544900$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4RFnf.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $2dda13c5d6544900$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2dda13c5d6544900$var$useNavigateStable() : $2dda13c5d6544900$var$useNavigateUnstable();
}
function $2dda13c5d6544900$var$useNavigateUnstable() {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$OutletContext = /*#__PURE__*/ $4RFnf.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $2dda13c5d6544900$export$4138103a3ae699cc() {
    return $4RFnf.useContext($2dda13c5d6544900$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $2dda13c5d6544900$export$a3be3530d8e40d0b(context) {
    let outlet = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $2dda13c5d6544900$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $2dda13c5d6544900$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4RFnf.useMemo(()=>(0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $2dda13c5d6544900$export$5d3fca4a98652595(routes, locationArg) {
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2dda13c5d6544900$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: parentMatches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2dda13c5d6544900$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e352e4bbcb5a39c7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e352e4bbcb5a39c7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2dda13c5d6544900$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2dda13c5d6544900$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e352e4bbcb5a39c7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2dda13c5d6544900$var$DefaultErrorComponent() {
    let error = $2dda13c5d6544900$export$ed527bf60f6e05f2();
    let message = (0, $e352e4bbcb5a39c7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4RFnf.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4RFnf.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2dda13c5d6544900$var$defaultErrorElement = /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DefaultErrorComponent, null);
class $2dda13c5d6544900$var$RenderErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2dda13c5d6544900$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2dda13c5d6544900$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2dda13c5d6544900$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2dda13c5d6544900$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4RFnf.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2dda13c5d6544900$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2dda13c5d6544900$var$DataRouterHook || {});
var $2dda13c5d6544900$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2dda13c5d6544900$var$DataRouterStateHook || {});
function $2dda13c5d6544900$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $2dda13c5d6544900$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext($2dda13c5d6544900$export$3add0d5dce533e2e);
    !ctx && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2dda13c5d6544900$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext($2dda13c5d6544900$export$145dfa71566a64dc);
    !state && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return state;
}
function $2dda13c5d6544900$var$useRouteContext(hookName) {
    let route = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    !route && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2dda13c5d6544900$var$useCurrentRouteId(hookName) {
    let route = $2dda13c5d6544900$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2dda13c5d6544900$export$5fc8298006ad9e58() {
    return $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2dda13c5d6544900$export$d0fd4b7106de2769() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2dda13c5d6544900$export$600dc272ed516c15() {
    let dataRouterContext = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseRevalidator);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRevalidator);
    return $4RFnf.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2dda13c5d6544900$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseMatches);
    return $4RFnf.useMemo(()=>matches.map((m)=>(0, $e352e4bbcb5a39c7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2dda13c5d6544900$export$1448a5050d252c4d() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2dda13c5d6544900$export$fd5d37484eab868d(routeId) {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2dda13c5d6544900$export$fdc00f3f26066d5e() {
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseActionData);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2dda13c5d6544900$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4RFnf.useContext($2dda13c5d6544900$var$RouteErrorContext);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    let routeId = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$78a72ddb39bdd145() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2dda13c5d6544900$export$17f53340677d5831() {
    let value = $4RFnf.useContext($2dda13c5d6544900$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2dda13c5d6544900$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2dda13c5d6544900$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseBlocker);
    let state = $2dda13c5d6544900$var$useDataRouterState($2dda13c5d6544900$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4RFnf.useState("");
    let blockerFunction = $4RFnf.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2dda13c5d6544900$var$_extends({}, currentLocation, {
                pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2dda13c5d6544900$var$_extends({}, nextLocation, {
                pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4RFnf.useEffect(()=>{
        let key = String(++$2dda13c5d6544900$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4RFnf.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e352e4bbcb5a39c7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2dda13c5d6544900$var$useNavigateStable() {
    let { router: router } = $2dda13c5d6544900$var$useDataRouterContext($2dda13c5d6544900$var$DataRouterHook.UseNavigateStable);
    let id = $2dda13c5d6544900$var$useCurrentRouteId($2dda13c5d6544900$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4RFnf.useRef(false);
    $2dda13c5d6544900$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4RFnf.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2dda13c5d6544900$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2dda13c5d6544900$var$alreadyWarned$1 = {};
function $2dda13c5d6544900$var$warningOnce(key, cond, message) {
    if (!cond && !$2dda13c5d6544900$var$alreadyWarned$1[key]) $2dda13c5d6544900$var$alreadyWarned$1[key] = true;
}
const $2dda13c5d6544900$var$alreadyWarned = {};
function $2dda13c5d6544900$var$warnOnce(key, message) {}
const $2dda13c5d6544900$var$logDeprecation = (flag, msg, link)=>$2dda13c5d6544900$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $2dda13c5d6544900$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $2dda13c5d6544900$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $2dda13c5d6544900$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $2dda13c5d6544900$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $2dda13c5d6544900$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $2dda13c5d6544900$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $2dda13c5d6544900$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2dda13c5d6544900$var$START_TRANSITION = "startTransition";
const $2dda13c5d6544900$var$startTransitionImpl = $4RFnf[$2dda13c5d6544900$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2dda13c5d6544900$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        if (v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl) $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $4RFnf.useEffect(()=>$2dda13c5d6544900$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2dda13c5d6544900$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2dda13c5d6544900$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $2dda13c5d6544900$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $2dda13c5d6544900$var$startTransitionImpl ? $2dda13c5d6544900$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>$2dda13c5d6544900$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $2dda13c5d6544900$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4RFnf.useContext($2dda13c5d6544900$export$26749e8557646306);
    let { matches: matches } = $4RFnf.useContext($2dda13c5d6544900$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2dda13c5d6544900$export$45d76561a5302f2b();
    let navigate = $2dda13c5d6544900$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e352e4bbcb5a39c7$export$cae722b0cc860f13)(to, (0, $e352e4bbcb5a39c7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4RFnf.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $2dda13c5d6544900$export$910ae8079b2c2852(props) {
    return $2dda13c5d6544900$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $2dda13c5d6544900$export$e7b0ac011bb776c6(_props) {
    (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $2dda13c5d6544900$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e352e4bbcb5a39c7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2dda13c5d6544900$export$9c954a9d03d32f4a() && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4RFnf.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2dda13c5d6544900$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e352e4bbcb5a39c7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4RFnf.useMemo(()=>{
        let trailingPathname = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $2dda13c5d6544900$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2dda13c5d6544900$export$5d3fca4a98652595($2dda13c5d6544900$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2dda13c5d6544900$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$ResolveAwait, null, children));
}
var $2dda13c5d6544900$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2dda13c5d6544900$var$AwaitRenderStatus || {});
const $2dda13c5d6544900$var$neverSettledPromise = new Promise(()=>{});
class $2dda13c5d6544900$var$AwaitErrorBoundary extends $4RFnf.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2dda13c5d6544900$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.error : "_data" in promise ? $2dda13c5d6544900$var$AwaitRenderStatus.success : $2dda13c5d6544900$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2dda13c5d6544900$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && promise._error instanceof (0, $e352e4bbcb5a39c7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2dda13c5d6544900$var$neverSettledPromise;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2dda13c5d6544900$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4RFnf.createElement($2dda13c5d6544900$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2dda13c5d6544900$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2dda13c5d6544900$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $2dda13c5d6544900$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4RFnf.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4RFnf.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4RFnf.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2dda13c5d6544900$export$e7b0ac011bb776c6) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2dda13c5d6544900$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2dda13c5d6544900$export$daf73786167a7f72(matches) {
    return $2dda13c5d6544900$var$_renderMatches(matches);
}
function $2dda13c5d6544900$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4RFnf.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4RFnf.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4RFnf.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2dda13c5d6544900$export$f30f7e456d254e83(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2dda13c5d6544900$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2dda13c5d6544900$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $ab1c2d1a5ff1b7e8$var$_extends() {
    $ab1c2d1a5ff1b7e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1c2d1a5ff1b7e8$var$_extends.apply(this, arguments);
}
function $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $ab1c2d1a5ff1b7e8$var$defaultMethod = "get";
const $ab1c2d1a5ff1b7e8$var$defaultEncType = "application/x-www-form-urlencoded";
function $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ab1c2d1a5ff1b7e8$var$isButtonElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ab1c2d1a5ff1b7e8$var$isFormElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ab1c2d1a5ff1b7e8$var$isInputElement(object) {
    return $ab1c2d1a5ff1b7e8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ab1c2d1a5ff1b7e8$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = null;
function $ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported() {
    if ($ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter = true;
    }
    return $ab1c2d1a5ff1b7e8$var$_formDataSupportsSubmitter;
}
const $ab1c2d1a5ff1b7e8$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ab1c2d1a5ff1b7e8$var$getFormEncType(encType) {
    if (encType != null && !$ab1c2d1a5ff1b7e8$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ab1c2d1a5ff1b7e8$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ab1c2d1a5ff1b7e8$var$isButtonElement(target) || $ab1c2d1a5ff1b7e8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ab1c2d1a5ff1b7e8$var$defaultMethod;
        encType = $ab1c2d1a5ff1b7e8$var$getFormEncType(target.getAttribute("formenctype")) || $ab1c2d1a5ff1b7e8$var$getFormEncType(form.getAttribute("enctype")) || $ab1c2d1a5ff1b7e8$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$ab1c2d1a5ff1b7e8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ab1c2d1a5ff1b7e8$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $ab1c2d1a5ff1b7e8$var$defaultMethod;
        action = null;
        encType = $ab1c2d1a5ff1b7e8$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $ab1c2d1a5ff1b7e8$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $ab1c2d1a5ff1b7e8$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $ab1c2d1a5ff1b7e8$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $ab1c2d1a5ff1b7e8$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2dda13c5d6544900$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e352e4bbcb5a39c7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $ab1c2d1a5ff1b7e8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e352e4bbcb5a39c7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $ab1c2d1a5ff1b7e8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2dda13c5d6544900$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $ab1c2d1a5ff1b7e8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $ab1c2d1a5ff1b7e8$var$_extends({}, state, {
        errors: $ab1c2d1a5ff1b7e8$var$deserializeErrors(state.errors)
    });
    return state;
}
function $ab1c2d1a5ff1b7e8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e352e4bbcb5a39c7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4RFnf.createContext({
    isTransitioning: false
});
const $ab1c2d1a5ff1b7e8$export$148fd98d095596d4 = /*#__PURE__*/ $4RFnf.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $ab1c2d1a5ff1b7e8$var$START_TRANSITION = "startTransition";
const $ab1c2d1a5ff1b7e8$var$startTransitionImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$START_TRANSITION];
const $ab1c2d1a5ff1b7e8$var$FLUSH_SYNC = "flushSync";
const $ab1c2d1a5ff1b7e8$var$flushSyncImpl = $6ce1434187f7101c$exports[$ab1c2d1a5ff1b7e8$var$FLUSH_SYNC];
const $ab1c2d1a5ff1b7e8$var$USE_ID = "useId";
const $ab1c2d1a5ff1b7e8$var$useIdImpl = $4RFnf[$ab1c2d1a5ff1b7e8$var$USE_ID];
function $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$startTransitionImpl) $ab1c2d1a5ff1b7e8$var$startTransitionImpl(cb);
    else cb();
}
function $ab1c2d1a5ff1b7e8$var$flushSyncSafe(cb) {
    if ($ab1c2d1a5ff1b7e8$var$flushSyncImpl) $ab1c2d1a5ff1b7e8$var$flushSyncImpl(cb);
    else cb();
}
class $ab1c2d1a5ff1b7e8$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4RFnf.useState(router.state);
    let [pendingState, setPendingState] = $4RFnf.useState();
    let [vtContext, setVtContext] = $4RFnf.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4RFnf.useState();
    let [transition, setTransition] = $4RFnf.useState();
    let [interruption, setInterruption] = $4RFnf.useState();
    let fetcherData = $4RFnf.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4RFnf.useCallback((cb)=>{
        if (v7_startTransition) $ab1c2d1a5ff1b7e8$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4RFnf.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $ab1c2d1a5ff1b7e8$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4RFnf.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4RFnf.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ab1c2d1a5ff1b7e8$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4RFnf.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4RFnf.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4RFnf.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4RFnf.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4RFnf.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4RFnf.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $4RFnf.useEffect(()=>(0, $2dda13c5d6544900$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4RFnf.createElement($4RFnf.Fragment, null, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $ab1c2d1a5ff1b7e8$var$MemoizedDataRoutes = /*#__PURE__*/ $4RFnf.memo($ab1c2d1a5ff1b7e8$var$DataRoutes);
function $ab1c2d1a5ff1b7e8$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $2dda13c5d6544900$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $ab1c2d1a5ff1b7e8$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $2dda13c5d6544900$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $ab1c2d1a5ff1b7e8$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4RFnf.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e352e4bbcb5a39c7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $2dda13c5d6544900$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $ab1c2d1a5ff1b7e8$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4RFnf.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4RFnf.useCallback((newState)=>{
        v7_startTransition && $ab1c2d1a5ff1b7e8$var$startTransitionImpl ? $ab1c2d1a5ff1b7e8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4RFnf.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $4RFnf.useEffect(()=>(0, $2dda13c5d6544900$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $4RFnf.createElement((0, $2dda13c5d6544900$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $ab1c2d1a5ff1b7e8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4RFnf.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref7, $ab1c2d1a5ff1b7e8$var$_excluded);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $ab1c2d1a5ff1b7e8$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($ab1c2d1a5ff1b7e8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $2dda13c5d6544900$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4RFnf.createElement("a", $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $ab1c2d1a5ff1b7e8$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4RFnf.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref8, $ab1c2d1a5ff1b7e8$var$_excluded2);
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let routerState = $4RFnf.useContext((0, $2dda13c5d6544900$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ab1c2d1a5ff1b7e8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a, $ab1c2d1a5ff1b7e8$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4RFnf.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $ab1c2d1a5ff1b7e8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $ab1c2d1a5ff1b7e8$var$_objectWithoutPropertiesLoose(_ref9, $ab1c2d1a5ff1b7e8$var$_excluded3);
    let submit = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let formAction = $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $4RFnf.createElement("form", $ab1c2d1a5ff1b7e8$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $ab1c2d1a5ff1b7e8$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $ab1c2d1a5ff1b7e8$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($ab1c2d1a5ff1b7e8$var$DataRouterHook || ($ab1c2d1a5ff1b7e8$var$DataRouterHook = {}));
var $ab1c2d1a5ff1b7e8$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($ab1c2d1a5ff1b7e8$var$DataRouterStateHook || ($ab1c2d1a5ff1b7e8$var$DataRouterStateHook = {}));
// Internal hooks
function $ab1c2d1a5ff1b7e8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterContext(hookName) {
    let ctx = $4RFnf.useContext((0, $2dda13c5d6544900$export$3add0d5dce533e2e));
    !ctx && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $ab1c2d1a5ff1b7e8$var$useDataRouterState(hookName) {
    let state = $4RFnf.useContext((0, $2dda13c5d6544900$export$145dfa71566a64dc));
    !state && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $ab1c2d1a5ff1b7e8$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4RFnf.useCallback((event)=>{
        if ($ab1c2d1a5ff1b7e8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(location) === (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $ab1c2d1a5ff1b7e8$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4RFnf.useRef($ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4RFnf.useRef(false);
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let searchParams = $4RFnf.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ab1c2d1a5ff1b7e8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    let setSearchParams = $4RFnf.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ab1c2d1a5ff1b7e8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $ab1c2d1a5ff1b7e8$var$fetcherId = 0;
let $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId = ()=>"__" + String(++$ab1c2d1a5ff1b7e8$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3() {
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let currentRouteId = (0, $2dda13c5d6544900$export$5fc8298006ad9e58)();
    return $4RFnf.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $ab1c2d1a5ff1b7e8$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ab1c2d1a5ff1b7e8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ab1c2d1a5ff1b7e8$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $ab1c2d1a5ff1b7e8$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let routeContext = $4RFnf.useContext((0, $2dda13c5d6544900$export$9072aa6dd1f93057));
    !routeContext && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $ab1c2d1a5ff1b7e8$var$_extends({}, (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e352e4bbcb5a39c7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e352e4bbcb5a39c7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $ab1c2d1a5ff1b7e8$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseFetcher);
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$148fd98d095596d4);
    let route = $4RFnf.useContext((0, $2dda13c5d6544900$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    !route && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $ab1c2d1a5ff1b7e8$var$useIdImpl ? $ab1c2d1a5ff1b7e8$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4RFnf.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($ab1c2d1a5ff1b7e8$var$getUniqueFetcherId());
    // Registration/cleanup
    $4RFnf.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4RFnf.useCallback((href, opts)=>{
        !routeId && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ab1c2d1a5ff1b7e8$export$47c85c6e3a081d3();
    let submit = $4RFnf.useCallback((target, opts)=>{
        submitImpl(target, $ab1c2d1a5ff1b7e8$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4RFnf.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4RFnf.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4RFnf.createElement($ab1c2d1a5ff1b7e8$export$a7fed597f4b8afd8, $ab1c2d1a5ff1b7e8$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e352e4bbcb5a39c7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4RFnf.useMemo(()=>$ab1c2d1a5ff1b7e8$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $ab1c2d1a5ff1b7e8$export$fa996778a3a31087() {
    let state = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $ab1c2d1a5ff1b7e8$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $ab1c2d1a5ff1b7e8$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $ab1c2d1a5ff1b7e8$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ab1c2d1a5ff1b7e8$var$useDataRouterState($ab1c2d1a5ff1b7e8$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4RFnf.useContext((0, $2dda13c5d6544900$export$26749e8557646306));
    let location = (0, $2dda13c5d6544900$export$45d76561a5302f2b)();
    let matches = (0, $2dda13c5d6544900$export$2378eb7f5ff86053)();
    let navigation = (0, $2dda13c5d6544900$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4RFnf.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $ab1c2d1a5ff1b7e8$var$usePageHide($4RFnf.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $ab1c2d1a5ff1b7e8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ab1c2d1a5ff1b7e8$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ab1c2d1a5ff1b7e8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ab1c2d1a5ff1b7e8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($ab1c2d1a5ff1b7e8$var$_extends({}, location, {
                    pathname: (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($ab1c2d1a5ff1b7e8$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4RFnf.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $ab1c2d1a5ff1b7e8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4RFnf.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $ab1c2d1a5ff1b7e8$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $2dda13c5d6544900$export$b273b3273281a049)(when);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4RFnf.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $ab1c2d1a5ff1b7e8$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4RFnf.useContext($ab1c2d1a5ff1b7e8$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e352e4bbcb5a39c7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $ab1c2d1a5ff1b7e8$var$useDataRouterContext($ab1c2d1a5ff1b7e8$var$DataRouterHook.useViewTransitionState);
    let path = (0, $2dda13c5d6544900$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e352e4bbcb5a39c7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e352e4bbcb5a39c7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $jk232 = parcelRequire("jk232");
// This file contain all hard code data which fetch the data from swiggy website
const $8346a428114e1bc6$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $8346a428114e1bc6$export$8878ead86ed0da0b = "https://graphicdesigneye.com/images/rastaurant-logo-design-service.png";



var $4RFnf = parcelRequire("4RFnf");


var $4RFnf = parcelRequire("4RFnf");
const $44a0c7c391aa02cf$var$useOnlineStatus = ()=>{
    // check if online
    const [onlineStatus, setOnlineStatus] = (0, $4RFnf.useState)(true);
    (0, $4RFnf.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    // boolean value
    return onlineStatus;
};
var $44a0c7c391aa02cf$export$2e2bcd8739ae039 = $44a0c7c391aa02cf$var$useOnlineStatus;


// UserContext => Keep the information of loggedIn User

var $4RFnf = parcelRequire("4RFnf");
const $ea3f38a28bd03b5e$var$UserContext = /*#__PURE__*/ (0, $4RFnf.createContext)({
    loggedInUser: "Default User"
});
var $ea3f38a28bd03b5e$export$2e2bcd8739ae039 = $ea3f38a28bd03b5e$var$UserContext;



var $4RFnf = parcelRequire("4RFnf");
var $bd80854d1f7ebeed$exports = {};
'use strict';

$bd80854d1f7ebeed$exports = (parcelRequire("j11Is"));


var $99aed3ab2dc6c7d9$var$__defProp = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$__defProps = Object.defineProperties;
var $99aed3ab2dc6c7d9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $99aed3ab2dc6c7d9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $99aed3ab2dc6c7d9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $99aed3ab2dc6c7d9$var$__defNormalProp = (obj, key, value)=>key in obj ? $99aed3ab2dc6c7d9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $99aed3ab2dc6c7d9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    if ($99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(b))if ($99aed3ab2dc6c7d9$var$__propIsEnum.call(b, prop)) $99aed3ab2dc6c7d9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $99aed3ab2dc6c7d9$var$__spreadProps = (a, b)=>$99aed3ab2dc6c7d9$var$__defProps(a, $99aed3ab2dc6c7d9$var$__getOwnPropDescs(b));
var $99aed3ab2dc6c7d9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($99aed3ab2dc6c7d9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $99aed3ab2dc6c7d9$var$__getOwnPropSymbols) {
        for (var prop of $99aed3ab2dc6c7d9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $99aed3ab2dc6c7d9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $99aed3ab2dc6c7d9$var$IS_REACT_19 = /* @__PURE__ */ $4RFnf.version.startsWith("19");
var $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($99aed3ab2dc6c7d9$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $99aed3ab2dc6c7d9$var$ForwardRef = $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE;
var $99aed3ab2dc6c7d9$var$Memo = $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
function $99aed3ab2dc6c7d9$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE || type === $99aed3ab2dc6c7d9$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $99aed3ab2dc6c7d9$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $99aed3ab2dc6c7d9$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $99aed3ab2dc6c7d9$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $99aed3ab2dc6c7d9$var$REACT_FRAGMENT_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_PROFILER_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_STRICT_MODE_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_TYPE:
                    case $99aed3ab2dc6c7d9$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_FORWARD_REF_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_LAZY_TYPE:
                            case $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE:
                                return object;
                            case $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $99aed3ab2dc6c7d9$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $99aed3ab2dc6c7d9$var$isContextConsumer(object) {
    return $99aed3ab2dc6c7d9$var$IS_REACT_19 ? $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_CONSUMER_TYPE : $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_CONTEXT_TYPE;
}
function $99aed3ab2dc6c7d9$var$isMemo(object) {
    return $99aed3ab2dc6c7d9$var$typeOf(object) === $99aed3ab2dc6c7d9$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $99aed3ab2dc6c7d9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $99aed3ab2dc6c7d9$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $99aed3ab2dc6c7d9$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $99aed3ab2dc6c7d9$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $99aed3ab2dc6c7d9$var$verify(mapStateToProps, "mapStateToProps");
    $99aed3ab2dc6c7d9$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $99aed3ab2dc6c7d9$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $99aed3ab2dc6c7d9$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $99aed3ab2dc6c7d9$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $99aed3ab2dc6c7d9$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $99aed3ab2dc6c7d9$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $99aed3ab2dc6c7d9$var$verifyPlainObject(value, displayName, methodName) {
    if (!$99aed3ab2dc6c7d9$var$isPlainObject(value)) $99aed3ab2dc6c7d9$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $99aed3ab2dc6c7d9$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $99aed3ab2dc6c7d9$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $99aed3ab2dc6c7d9$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $99aed3ab2dc6c7d9$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $99aed3ab2dc6c7d9$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $99aed3ab2dc6c7d9$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues($99aed3ab2dc6c7d9$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$99aed3ab2dc6c7d9$var$defaultMergeProps : typeof mergeProps === "function" ? $99aed3ab2dc6c7d9$var$wrapMergePropsFunc(mergeProps) : $99aed3ab2dc6c7d9$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $99aed3ab2dc6c7d9$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $99aed3ab2dc6c7d9$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $99aed3ab2dc6c7d9$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $99aed3ab2dc6c7d9$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $99aed3ab2dc6c7d9$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $99aed3ab2dc6c7d9$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $99aed3ab2dc6c7d9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $99aed3ab2dc6c7d9$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $99aed3ab2dc6c7d9$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $99aed3ab2dc6c7d9$var$isDOM = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$canUseDOM();
var $99aed3ab2dc6c7d9$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $99aed3ab2dc6c7d9$var$isReactNative = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$isRunningInReactNative();
var $99aed3ab2dc6c7d9$var$getUseIsomorphicLayoutEffect = ()=>$99aed3ab2dc6c7d9$var$isDOM || $99aed3ab2dc6c7d9$var$isReactNative ? $4RFnf.useLayoutEffect : $4RFnf.useEffect;
var $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $99aed3ab2dc6c7d9$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $99aed3ab2dc6c7d9$export$d36bdfa510afb180(objA, objB) {
    if ($99aed3ab2dc6c7d9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$99aed3ab2dc6c7d9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $99aed3ab2dc6c7d9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $99aed3ab2dc6c7d9$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $99aed3ab2dc6c7d9$var$TYPE_STATICS = {
    [$99aed3ab2dc6c7d9$var$ForwardRef]: $99aed3ab2dc6c7d9$var$FORWARD_REF_STATICS,
    [$99aed3ab2dc6c7d9$var$Memo]: $99aed3ab2dc6c7d9$var$MEMO_STATICS
};
function $99aed3ab2dc6c7d9$var$getStatics(component) {
    if ($99aed3ab2dc6c7d9$var$isMemo(component)) return $99aed3ab2dc6c7d9$var$MEMO_STATICS;
    return $99aed3ab2dc6c7d9$var$TYPE_STATICS[component["$$typeof"]] || $99aed3ab2dc6c7d9$var$REACT_STATICS;
}
var $99aed3ab2dc6c7d9$var$defineProperty = Object.defineProperty;
var $99aed3ab2dc6c7d9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $99aed3ab2dc6c7d9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $99aed3ab2dc6c7d9$var$getPrototypeOf = Object.getPrototypeOf;
var $99aed3ab2dc6c7d9$var$objectPrototype = Object.prototype;
function $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($99aed3ab2dc6c7d9$var$objectPrototype) {
            const inheritedComponent = $99aed3ab2dc6c7d9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $99aed3ab2dc6c7d9$var$objectPrototype) $99aed3ab2dc6c7d9$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $99aed3ab2dc6c7d9$var$getOwnPropertyNames(sourceComponent);
        if ($99aed3ab2dc6c7d9$var$getOwnPropertySymbols) keys = keys.concat($99aed3ab2dc6c7d9$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $99aed3ab2dc6c7d9$var$getStatics(targetComponent);
        const sourceStatics = $99aed3ab2dc6c7d9$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$99aed3ab2dc6c7d9$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $99aed3ab2dc6c7d9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $99aed3ab2dc6c7d9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $99aed3ab2dc6c7d9$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $99aed3ab2dc6c7d9$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $99aed3ab2dc6c7d9$var$getContext() {
    var _a;
    if (!$4RFnf.createContext) return {};
    const contextMap = (_a = $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey]) != null ? _a : $99aed3ab2dc6c7d9$var$gT[$99aed3ab2dc6c7d9$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($4RFnf.createContext);
    if (!realContext) {
        realContext = $4RFnf.createContext(null);
        contextMap.set($4RFnf.createContext, realContext);
    }
    return realContext;
}
var $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$getContext();
// src/components/connect.tsx
var $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $99aed3ab2dc6c7d9$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $99aed3ab2dc6c7d9$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $99aed3ab2dc6c7d9$var$strictEqual(a, b) {
    return a === b;
}
var $99aed3ab2dc6c7d9$var$hasWarnedAboutDeprecatedPureOption = false;
function $99aed3ab2dc6c7d9$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $99aed3ab2dc6c7d9$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $99aed3ab2dc6c7d9$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $99aed3ab2dc6c7d9$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $99aed3ab2dc6c7d9$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $99aed3ab2dc6c7d9$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $4RFnf.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $99aed3ab2dc6c7d9$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $4RFnf.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $4RFnf.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $4RFnf.useMemo(()=>{
                return $99aed3ab2dc6c7d9$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $4RFnf.useMemo(()=>{
                if (!shouldHandleStateChanges) return $99aed3ab2dc6c7d9$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $99aed3ab2dc6c7d9$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $4RFnf.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $4RFnf.useRef(void 0);
            const lastWrapperProps = $4RFnf.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $4RFnf.useRef(void 0);
            const renderIsScheduled = $4RFnf.useRef(false);
            const isMounted = $4RFnf.useRef(false);
            const latestSubscriptionCallbackError = $4RFnf.useRef(void 0);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $4RFnf.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $4RFnf.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $99aed3ab2dc6c7d9$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffectWithArgs($99aed3ab2dc6c7d9$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $4RFnf.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $4RFnf.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $4RFnf.createElement(WrappedComponent, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $4RFnf.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $4RFnf.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $4RFnf.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $4RFnf.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $4RFnf.createElement(Connect, $99aed3ab2dc6c7d9$var$__spreadProps($99aed3ab2dc6c7d9$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $99aed3ab2dc6c7d9$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $99aed3ab2dc6c7d9$export$64605811ab45167f = $99aed3ab2dc6c7d9$var$connect;
// src/components/Provider.tsx
function $99aed3ab2dc6c7d9$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $4RFnf.useMemo(()=>{
        const subscription = $99aed3ab2dc6c7d9$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $4RFnf.useMemo(()=>store.getState(), [
        store
    ]);
    $99aed3ab2dc6c7d9$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $4RFnf.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $99aed3ab2dc6c7d9$export$2881499e37b75b9a = $99aed3ab2dc6c7d9$var$Provider;
// src/hooks/useReduxContext.ts
function $99aed3ab2dc6c7d9$var$createReduxContextHook(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $4RFnf.useContext(context);
        return contextValue;
    };
}
var $99aed3ab2dc6c7d9$var$useReduxContext = /* @__PURE__ */ $99aed3ab2dc6c7d9$var$createReduxContextHook();
// src/hooks/useStore.ts
function $99aed3ab2dc6c7d9$export$671dba69185d0304(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : // @ts-ignore
    $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $99aed3ab2dc6c7d9$export$bc9b55530897c558(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useStore2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$export$6ccbb43953eebf8 : $99aed3ab2dc6c7d9$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8 = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$bc9b55530897c558();
var $99aed3ab2dc6c7d9$var$refEquality = (a, b)=>a === b;
function $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb(context = $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $99aed3ab2dc6c7d9$export$cc80c08dc91f1c00 ? $99aed3ab2dc6c7d9$var$useReduxContext : $99aed3ab2dc6c7d9$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $99aed3ab2dc6c7d9$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $4RFnf.useRef(true);
        const wrappedSelector = $4RFnf.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $bd80854d1f7ebeed$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $4RFnf.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $99aed3ab2dc6c7d9$export$2105062e25df4afe = /* @__PURE__ */ $99aed3ab2dc6c7d9$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $99aed3ab2dc6c7d9$export$712ea50be43a7858 = $99aed3ab2dc6c7d9$var$defaultNoopBatch;


const $323bf0bf7dab78c2$var$Header = ()=>{
    const [btnNameReact, setBtnNameReact] = (0, $4RFnf.useState)("Login");
    const onlineStatus = (0, $44a0c7c391aa02cf$export$2e2bcd8739ae039)();
    const { loggedInUser: loggedInUser } = (0, $4RFnf.useContext)((0, $ea3f38a28bd03b5e$export$2e2bcd8739ae039));
    // Subscribing to the store using a selector
    const cartItems = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((store)=>store.cart.items);
    return /*#__PURE__*/ (0, $jk232.jsxs)("header", {
        className: "flex justify-between items-center px-[50px] py-2 bg-[#f1f1f1] shadow-transparent rounded-[15px]",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("img", {
                src: (0, $8346a428114e1bc6$export$8878ead86ed0da0b),
                alt: "Food App Logo",
                className: "w-[180px] h-[90px] sm:w-[220px] sm:h-[110px] md:w-[260px] md:h-[130px] object-contain"
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("ul", {
                className: "flex items-center gap-[35px] text-[18px] list-none p-0 m-0",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("li", {
                        children: [
                            "Online Status: ",
                            onlineStatus ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            to: "/about",
                            children: "About"
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            to: "/contact",
                            children: "Contact"
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        children: /*#__PURE__*/ (0, $jk232.jsx)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            to: "/grocery",
                            children: "Grocery"
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        children: /*#__PURE__*/ (0, $jk232.jsxs)((0, $ab1c2d1a5ff1b7e8$export$a6c7ac8248d6e38a), {
                            to: "/cart",
                            children: [
                                "Cart (",
                                cartItems.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        onClick: ()=>setBtnNameReact(btnNameReact === "Login" ? "Logout" : "Login"),
                        className: "px-6 py-2 border rounded hover:bg-orange-500 hover:text-white",
                        children: btnNameReact
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("li", {
                        className: "px-4 font-bold",
                        children: loggedInUser
                    })
                ]
            })
        ]
    });
};
var $323bf0bf7dab78c2$export$2e2bcd8739ae039 = $323bf0bf7dab78c2$var$Header;



var $jk232 = parcelRequire("jk232");

var $4RFnf = parcelRequire("4RFnf");
// RestaurantCard.jsx
// Reusable component to display a single restaurant card

var $jk232 = parcelRequire("jk232");
parcelRequire("4RFnf");

const $ee231ffd866cc86a$var$RestaurantCard = ({ resData: resData })=>{
    const info = resData?.info;
    return(// OLD: rest-card
    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        "data-testid": "resCard",
        className: " w-[280px] bg-[#ffffff] hover:bg-[#e3e3e3] rounded-[12px] overflow-hidden shadow-md text-center cursor-pointer transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:scale-[1.02] ",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("img", {
                className: "w-full h-[180px] object-cover",
                alt: "restaurant",
                src: (0, $8346a428114e1bc6$export$31adfacaf07ffe63) + info?.cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                        className: "text-[17px] font-semibold text-gray-800 mb-1",
                        children: info?.name
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("h4", {
                        className: "text-[14px] text-gray-600 mb-1",
                        children: info?.cuisines?.join(", ")
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                        className: "inline-block text-[13px] text-gray-800 px-2 py-1 rounded-md mb-1 bg-orange-100",
                        children: [
                            info?.avgRating ?? info?.avgRatingString,
                            " \u2B50"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("h4", {
                        className: "text-[14px] text-gray-600",
                        children: info?.costForTwo
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("h4", {
                        className: "text-[14px] text-gray-600",
                        children: [
                            info?.sla?.deliveryTime,
                            " minutes"
                        ]
                    })
                ]
            })
        ]
    }));
};
var $ee231ffd866cc86a$export$2e2bcd8739ae039 = $ee231ffd866cc86a$var$RestaurantCard;
const $ee231ffd866cc86a$export$ccb02a230af14023 = (RestaurantCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $jk232.jsx)("label", {
                    className: " absolute top-2 left-2 bg-black text-white text-xs font-semibold px-2 py-1 rounded z-10 ",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $jk232.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};



var $jk232 = parcelRequire("jk232");
parcelRequire("4RFnf");
const $cc5aede9e6f101a2$var$ShimmerCard = ()=>{
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "relative w-[280px] h-[360px] rounded-[12px] bg-[#e0e0e0] overflow-hidden",
        children: /*#__PURE__*/ (0, $jk232.jsx)("div", {
            className: " absolute inset-0 -translate-x-full bg-[linear-gradient(90deg,#e0e0e0_25%,#f5f5f5_37%,#e0e0e0_63%)] animate-[shimmer_2.4s_infinite] "
        })
    });
};
const $cc5aede9e6f101a2$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "flex flex-wrap justify-center gap-[25px] px-[40px] py-[30px] bg-[#f8f8f8]",
        children: Array.from({
            length: 8
        }).map((_, i)=>/*#__PURE__*/ (0, $jk232.jsx)($cc5aede9e6f101a2$var$ShimmerCard, {}, i))
    });
};
var $cc5aede9e6f101a2$export$2e2bcd8739ae039 = $cc5aede9e6f101a2$var$Shimmer;




const $1943c5ad6ae77e9b$var$Body = ()=>{
    const [listOfRestaurants, setListOfRestaurants] = (0, $4RFnf.useState)([]);
    const [filteredRestaurants, setFilteredRestaurants] = (0, $4RFnf.useState)([]);
    const [searchText, setSearchText] = (0, $4RFnf.useState)("");
    const RestaurantCardPromoted = (0, $ee231ffd866cc86a$export$ccb02a230af14023)((0, $ee231ffd866cc86a$export$2e2bcd8739ae039));
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    (0, $4RFnf.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        try {
            const response = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=22.653564&lng=88.4450847&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
            const json = await response.json();
            const restaurantsData = json?.data?.cards?.find((item)=>item?.card?.card?.id?.includes("restaurant_grid_listing_v2"))?.card?.card?.gridElements?.infoWithStyle?.restaurants || [];
            setListOfRestaurants(restaurantsData);
            setFilteredRestaurants(restaurantsData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const onlineStatus = (0, $44a0c7c391aa02cf$export$2e2bcd8739ae039)();
    if (!onlineStatus) return /*#__PURE__*/ (0, $jk232.jsx)("h1", {
        className: "text-center text-xl font-semibold mt-10 text-red-500",
        children: "Looks like you're offline!!! Please check your internet connection"
    });
    //  Show shimmer while loading API data
    if (listOfRestaurants.length === 0) return /*#__PURE__*/ (0, $jk232.jsx)((0, $cc5aede9e6f101a2$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "bg-white min-h-screen",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "flex justify-center flex-wrap m-[19px] px-[40px] py-[14px] gap-6",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                className: "px-[40px] py-[14px] rounded-l-[15px] border border-black outline-none",
                                type: "text",
                                "data-testid": "searchInput",
                                value: searchText,
                                onChange: (e)=>setSearchText(e.target.value),
                                placeholder: "Search restaurants..."
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                className: "px-[40px] py-[14px] rounded-r-[15px] bg-gray-100 hover:bg-gray-200 transition",
                                onClick: ()=>{
                                    const filtered = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));
                                    setFilteredRestaurants(filtered);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        className: "px-[40px] py-[14px] rounded-[15px] bg-gray-100 hover:bg-gray-200 transition",
                        onClick: ()=>{
                            const filtered = listOfRestaurants.filter((res)=>res.info.avgRating > 4.2);
                            setFilteredRestaurants(filtered);
                        },
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                className: "flex flex-wrap justify-center gap-[25px] px-[40px] py-[30px] bg-[#f1f1f1]",
                children: filteredRestaurants.map((restaurant)=>{
                    const id = restaurant.info.id;
                    const CardComponent = restaurant?.info?.promoted ? RestaurantCardPromoted : (0, $ee231ffd866cc86a$export$2e2bcd8739ae039);
                    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        onClick: ()=>navigate(`/restaurants/${id}`),
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0, $jk232.jsx)(CardComponent, {
                            resData: restaurant
                        })
                    }, id);
                })
            })
        ]
    });
};
var $1943c5ad6ae77e9b$export$2e2bcd8739ae039 = $1943c5ad6ae77e9b$var$Body;



var $jk232 = parcelRequire("jk232");

var $7WqRZ = parcelRequire("7WqRZ");
const $8fcb7774a519ed55$var$features = [
    {
        title: "Precision Delivery",
        desc: "Smart routing and preparation workflows ensure every meal reaches you hot, fresh, and right on time."
    },
    {
        title: "Farm-to-Fork Sourcing",
        desc: "We work directly with trusted local Bokaro growers to source fresh, seasonal, and responsibly grown ingredients."
    },
    {
        title: "Chef-Led Standards",
        desc: "Every recipe is designed, tested, and refined by experienced chefs to meet consistent quality benchmarks."
    },
    {
        title: "Human Support",
        desc: "Real people, real help. Our support team is available 24/7 to assist you without automated bots."
    }
];
const $8fcb7774a519ed55$var$About = ()=>{
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "bg-[#F8FAFC] text-slate-900 antialiased font-sans",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "max-w-[1300px] mx-auto px-6 pt-20 md:pt-28 pb-24 md:pb-32 grid lg:grid-cols-12 gap-16 items-center",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)((0, $7WqRZ.motion).div, {
                        initial: {
                            opacity: 0,
                            y: 30
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        transition: {
                            duration: 0.8
                        },
                        className: "lg:col-span-7 space-y-10",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("h1", {
                                className: "text-6xl md:text-[5.5rem] font-black leading-[0.9] tracking-tighter",
                                children: [
                                    "ChefMaster: Where Precision Creates Excellence ",
                                    /*#__PURE__*/ (0, $jk232.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "text-transparent bg-clip-text bg-linear-to-r from-orange-500 to-red-600",
                                        children: "Delivered with purpose."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "text-xl text-slate-500 max-w-xl leading-relaxed font-medium",
                                children: "ChefMaster is a chef-driven restaurant brand from Bokaro, built on precision, freshness, and respect for food. We combine culinary expertise with operational discipline to deliver restaurant-quality meals consistently at your doorstep."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)((0, $7WqRZ.motion).div, {
                        initial: {
                            opacity: 0,
                            scale: 0.95
                        },
                        animate: {
                            opacity: 1,
                            scale: 1
                        },
                        transition: {
                            duration: 0.9
                        },
                        className: "lg:col-span-5 relative",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                className: "absolute -inset-6 bg-orange-100/60 rounded-[4rem] -rotate-3 -z-10"
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("img", {
                                src: "https://images.unsplash.com/photo-1552566626-52f8b828add9",
                                alt: "ChefMaster Kitchen",
                                className: "w-full h-[420px] md:h-[600px] object-cover rounded-[3.5rem] shadow-[0_40px_80px_-15px_rgba(0,0,0,0.2)]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("section", {
                className: "max-w-[1300px] mx-auto px-6 py-24",
                children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-4 gap-6",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "md:col-span-2 bg-white rounded-[3rem] p-12 flex flex-col justify-center items-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: [
                                        "05",
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "text-orange-500 text-3xl",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "Years of Operational Excellence"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "bg-white rounded-[3rem] p-12 flex flex-col justify-center items-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: [
                                        "50K",
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "text-orange-500 text-3xl",
                                            children: "+"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "Orders Delivered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "bg-white rounded-[3rem] p-12 flex flex-col items-center justify-center text-center shadow-[0_20px_60px_rgba(0,0,0,0.12)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.18)] transition-all duration-500 hover:-translate-y-2",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                    className: "text-5xl font-black text-slate-900",
                                    children: "4.8 \u2B50"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                    className: "text-slate-500 font-bold uppercase tracking-[0.25em] text-[10px] mt-3",
                                    children: "App Store Rating"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("section", {
                className: "relative max-w-[1300px] mx-auto px-6 py-32",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "absolute inset-0 -z-10",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("div", {
                            className: "absolute top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-orange-400/10 blur-[120px] rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "text-center mb-24",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                                className: "text-5xl md:text-6xl font-black tracking-tight mb-6",
                                children: [
                                    "The system behind the",
                                    " ",
                                    /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                        className: "text-orange-500",
                                        children: "flavor."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "text-xl text-slate-500 max-w-2xl mx-auto",
                                children: "ChefMaster is engineered like a restaurant and operated like a system \u2014 ensuring quality, speed, and consistency at scale."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "grid md:grid-cols-2 lg:grid-cols-4 gap-10",
                        children: $8fcb7774a519ed55$var$features.map((item, i)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $7WqRZ.motion).div, {
                                initial: {
                                    opacity: 0,
                                    y: 30
                                },
                                whileInView: {
                                    opacity: 1,
                                    y: 0
                                },
                                viewport: {
                                    once: true
                                },
                                transition: {
                                    duration: 0.6,
                                    delay: i * 0.1
                                },
                                className: " group relative rounded-[2.8rem] p-px bg-linear-to-br from-orange-400/40 via-transparent to-slate-200 hover:scale-[1.03] transition-all duration-500 ",
                                children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: " h-full rounded-[2.7rem] p-10 bg-white/80 backdrop-blur-xl shadow-[0_20px_60px_rgba(0,0,0,0.08)] group-hover:shadow-[0_30px_90px_rgba(0,0,0,0.18)] transition-all duration-500 ",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("div", {
                                            className: " w-16 h-16 mb-8 rounded-2xl bg-linear-to-br from-orange-400 to-orange-600 text-white text-3xl flex items-center justify-center shadow-lg group-hover:scale-90 transition-transform duration-500 ",
                                            children: item.icon
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("h4", {
                                            className: "text-2xl font-black mb-4 text-slate-900",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            className: "text-slate-600 leading-relaxed",
                                            children: item.desc
                                        })
                                    ]
                                })
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $8fcb7774a519ed55$export$2e2bcd8739ae039 = $8fcb7774a519ed55$var$About;



var $jk232 = parcelRequire("jk232");
const $c30866d045584b89$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "min-h-screen bg-[#ffffff] py-[40px]",
        children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
            className: "max-w-[1100px] mx-auto px-6",
            children: [
                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "text-center mb-12",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                            className: "text-[38px] text-[#222] font-semibold",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            className: "text-[#666] mt-2",
                            children: "We\u2019d love to hear from you. Get in touch with us!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "flex gap-14 bg-[#e6e5e5] rounded-[24px] p-12  shadow-[0_30px_70px_rgba(0,0,0,0.12)] max-[900px]:flex-col",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                    className: "mb-6 text-xl font-semibold",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-5 text-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "text-[20px]",
                                            children: "\uD83D\uDCCD"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            children: "Bokaro Steel City, Jharkhand, India"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "mt-3 text-sm text-gray-700 space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            children: "\u23F0 Mon \u2013 Sat: 9:00 AM \u2013 8:00 PM"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            children: "\u26A1 Response within 24 hours"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                                    className: "flex items-center gap-3 mt-4 text-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                            className: "text-[20px]",
                                            children: "\uD83D\uDCE7"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                            children: "support@chefmaster.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("iframe", {
                                    title: "map",
                                    src: "https://www.google.com/maps?q=Bokaro%20Steel%20City,%20Jharkhand&output=embed",
                                    loading: "lazy",
                                    className: "mt-6 w-full h-[180px] rounded-[14px] shadow-sm border-0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                                    className: "mb-6 text-xl font-semibold",
                                    children: "Send Message"
                                }),
                                /*#__PURE__*/ (0, $jk232.jsxs)("form", {
                                    className: "flex flex-col gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                            type: "text",
                                            placeholder: "Your Name",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("input", {
                                            type: "email",
                                            placeholder: "Your Email",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("textarea", {
                                            rows: "5",
                                            placeholder: "Your Message",
                                            required: true,
                                            className: "px-[16px] py-[13px] rounded-[12px] border border-[#ddd] text-[15px] outline-none focus:border-black resize-none"
                                        }),
                                        /*#__PURE__*/ (0, $jk232.jsx)("button", {
                                            type: "submit",
                                            className: "mt-2 bg-linear-to-r from-[#ffffff] to-[#d5d4d4] text-white py-3 rounded-[14px] text-[16px] font-medium transition",
                                            children: "Send Message"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $c30866d045584b89$export$2e2bcd8739ae039 = $c30866d045584b89$var$Contact;



var $jk232 = parcelRequire("jk232");

const $66b3ab631caa5778$var$Error = ()=>{
    const navigate = (0, $2dda13c5d6544900$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: " min-h-screen flex flex-col justify-center items-center text-center px-4 bg-linear-to-br from-orange-50 to-white dark:from-gray-800 dark:to-gray-900 ",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                className: "text-4xl sm:text-5xl font-bold text-red-500",
                children: "Oops! Something broke \uD83D\uDE35"
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("h2", {
                className: "mt-3 text-xl sm:text-2xl font-semibold text-gray-800 dark:text-gray-200",
                children: "We can\u2019t find the page you\u2019re looking for"
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "flex gap-4 flex-wrap justify-center",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        onClick: ()=>navigate("/"),
                        className: " px-6 py-3 rounded-full font-medium bg-orange-500 text-white hover:bg-orange-600 transition-transform hover:scale-105  ",
                        children: "Go Home \uD83C\uDFE0"
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        onClick: ()=>window.location.reload(),
                        className: " px-6 py-3 rounded-full font-medium bg-orange-500 text-white hover:bg-orange-600 transition-transform hover:scale-105  ",
                        children: "Try Again \uD83D\uDD04"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                className: "mt-6 text-sm text-gray-500 dark:text-gray-400",
                children: "Still stuck? Check your internet connection or try again later."
            })
        ]
    });
};
var $66b3ab631caa5778$export$2e2bcd8739ae039 = $66b3ab631caa5778$var$Error;



var $jk232 = parcelRequire("jk232");


var $4RFnf = parcelRequire("4RFnf");


var $jk232 = parcelRequire("jk232");

var $jk232 = parcelRequire("jk232");

// Import createSlice from Redux Toolkit
// createSlice helps us create reducers + actions in a clean way
// src/utils/formatProdErrorMessage.ts
function $876d8277641f3cc3$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $876d8277641f3cc3$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $876d8277641f3cc3$var$symbol_observable_default = $876d8277641f3cc3$var$$$observable;
// src/utils/actionTypes.ts
var $876d8277641f3cc3$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $876d8277641f3cc3$var$ActionTypes = {
    INIT: `@@redux/INIT${$876d8277641f3cc3$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$876d8277641f3cc3$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$876d8277641f3cc3$var$randomString()}`
};
var $876d8277641f3cc3$export$4219e499db7ca678 = $876d8277641f3cc3$var$ActionTypes;
// src/utils/isPlainObject.ts
function $876d8277641f3cc3$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $876d8277641f3cc3$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($876d8277641f3cc3$var$isDate(val)) return "date";
    if ($876d8277641f3cc3$var$isError(val)) return "error";
    const constructorName = $876d8277641f3cc3$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $876d8277641f3cc3$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $876d8277641f3cc3$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $876d8277641f3cc3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $876d8277641f3cc3$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(1));
        return enhancer($876d8277641f3cc3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$876d8277641f3cc3$export$53b83ca8eaab0383(action)) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $876d8277641f3cc3$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$876d8277641f3cc3$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$876d8277641f3cc3$var$symbol_observable_default]: observable
    };
    return store;
}
function $876d8277641f3cc3$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $876d8277641f3cc3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $876d8277641f3cc3$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $876d8277641f3cc3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$876d8277641f3cc3$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$876d8277641f3cc3$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $876d8277641f3cc3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $876d8277641f3cc3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $876d8277641f3cc3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(13));
    });
}
function $876d8277641f3cc3$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $876d8277641f3cc3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $876d8277641f3cc3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $876d8277641f3cc3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $876d8277641f3cc3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $876d8277641f3cc3$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $876d8277641f3cc3$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($876d8277641f3cc3$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $876d8277641f3cc3$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $876d8277641f3cc3$export$b956e38827fca970(action) {
    return $876d8277641f3cc3$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $3fcdd01f4bd90a60$var$__defProp = Object.defineProperty;
var $3fcdd01f4bd90a60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3fcdd01f4bd90a60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3fcdd01f4bd90a60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3fcdd01f4bd90a60$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fcdd01f4bd90a60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fcdd01f4bd90a60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3fcdd01f4bd90a60$var$__hasOwnProp.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    if ($3fcdd01f4bd90a60$var$__getOwnPropSymbols) {
        for (var prop of $3fcdd01f4bd90a60$var$__getOwnPropSymbols(b))if ($3fcdd01f4bd90a60$var$__propIsEnum.call(b, prop)) $3fcdd01f4bd90a60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $3fcdd01f4bd90a60$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $3fcdd01f4bd90a60$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $3fcdd01f4bd90a60$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $3fcdd01f4bd90a60$var$errors = [];
function $3fcdd01f4bd90a60$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $3fcdd01f4bd90a60$var$O = Object;
var $3fcdd01f4bd90a60$var$getPrototypeOf = $3fcdd01f4bd90a60$var$O.getPrototypeOf;
var $3fcdd01f4bd90a60$var$CONSTRUCTOR = "constructor";
var $3fcdd01f4bd90a60$var$PROTOTYPE = "prototype";
var $3fcdd01f4bd90a60$var$CONFIGURABLE = "configurable";
var $3fcdd01f4bd90a60$var$ENUMERABLE = "enumerable";
var $3fcdd01f4bd90a60$var$WRITABLE = "writable";
var $3fcdd01f4bd90a60$var$VALUE = "value";
var $3fcdd01f4bd90a60$export$541ac630993a4c84 = (value)=>!!value && !!value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
function $3fcdd01f4bd90a60$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $3fcdd01f4bd90a60$var$isPlainObject(value) || $3fcdd01f4bd90a60$var$isArray(value) || !!value[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] || !!((_a = value[$3fcdd01f4bd90a60$var$CONSTRUCTOR]) == null ? void 0 : _a[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee]) || $3fcdd01f4bd90a60$var$isMap(value) || $3fcdd01f4bd90a60$var$isSet(value);
}
var $3fcdd01f4bd90a60$var$objectCtorString = $3fcdd01f4bd90a60$var$O[$3fcdd01f4bd90a60$var$PROTOTYPE][$3fcdd01f4bd90a60$var$CONSTRUCTOR].toString();
var $3fcdd01f4bd90a60$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $3fcdd01f4bd90a60$var$isPlainObject(value) {
    if (!value || !$3fcdd01f4bd90a60$var$isObjectish(value)) return false;
    const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(value);
    if (proto === null || proto === $3fcdd01f4bd90a60$var$O[$3fcdd01f4bd90a60$var$PROTOTYPE]) return true;
    const Ctor = $3fcdd01f4bd90a60$var$O.hasOwnProperty.call(proto, $3fcdd01f4bd90a60$var$CONSTRUCTOR) && proto[$3fcdd01f4bd90a60$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$3fcdd01f4bd90a60$var$isFunction(Ctor)) return false;
    let ctorString = $3fcdd01f4bd90a60$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $3fcdd01f4bd90a60$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $3fcdd01f4bd90a60$var$objectCtorString;
}
function $3fcdd01f4bd90a60$export$22e8af3f75a010e3(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(15, value);
    return value[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_;
}
function $3fcdd01f4bd90a60$var$each(obj, iter, strict = true) {
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $3fcdd01f4bd90a60$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $3fcdd01f4bd90a60$var$getArchtype(thing) {
    const state = thing[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    return state ? state.type_ : $3fcdd01f4bd90a60$var$isArray(thing) ? 1 /* Array */  : $3fcdd01f4bd90a60$var$isMap(thing) ? 2 /* Map */  : $3fcdd01f4bd90a60$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $3fcdd01f4bd90a60$var$has = (thing, prop, type = $3fcdd01f4bd90a60$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $3fcdd01f4bd90a60$var$O[$3fcdd01f4bd90a60$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $3fcdd01f4bd90a60$var$get = (thing, prop, type = $3fcdd01f4bd90a60$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $3fcdd01f4bd90a60$var$set = (thing, propOrOldValue, value, type = $3fcdd01f4bd90a60$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $3fcdd01f4bd90a60$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $3fcdd01f4bd90a60$var$isArray = Array.isArray;
var $3fcdd01f4bd90a60$var$isMap = (target)=>target instanceof Map;
var $3fcdd01f4bd90a60$var$isSet = (target)=>target instanceof Set;
var $3fcdd01f4bd90a60$var$isObjectish = (target)=>typeof target === "object";
var $3fcdd01f4bd90a60$var$isFunction = (target)=>typeof target === "function";
var $3fcdd01f4bd90a60$var$isBoolean = (target)=>typeof target === "boolean";
function $3fcdd01f4bd90a60$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $3fcdd01f4bd90a60$var$getProxyDraft = (value)=>{
    if (!$3fcdd01f4bd90a60$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
};
var $3fcdd01f4bd90a60$var$latest = (state)=>state.copy_ || state.base_;
var $3fcdd01f4bd90a60$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $3fcdd01f4bd90a60$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $3fcdd01f4bd90a60$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $3fcdd01f4bd90a60$var$shallowCopy(base, strict) {
    if ($3fcdd01f4bd90a60$var$isMap(base)) return new Map(base);
    if ($3fcdd01f4bd90a60$var$isSet(base)) return new Set(base);
    if ($3fcdd01f4bd90a60$var$isArray(base)) return Array[$3fcdd01f4bd90a60$var$PROTOTYPE].slice.call(base);
    const isPlain = $3fcdd01f4bd90a60$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $3fcdd01f4bd90a60$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$3fcdd01f4bd90a60$var$WRITABLE] === false) {
                desc[$3fcdd01f4bd90a60$var$WRITABLE] = true;
                desc[$3fcdd01f4bd90a60$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$3fcdd01f4bd90a60$var$CONFIGURABLE]: true,
                [$3fcdd01f4bd90a60$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$3fcdd01f4bd90a60$var$ENUMERABLE]: desc[$3fcdd01f4bd90a60$var$ENUMERABLE],
                [$3fcdd01f4bd90a60$var$VALUE]: base[key]
            };
        }
        return $3fcdd01f4bd90a60$var$O.create($3fcdd01f4bd90a60$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $3fcdd01f4bd90a60$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $3fcdd01f4bd90a60$var$__spreadValues({}, base);
        const obj = $3fcdd01f4bd90a60$var$O.create(proto);
        return $3fcdd01f4bd90a60$var$O.assign(obj, base);
    }
}
function $3fcdd01f4bd90a60$export$792f3d81ea979f55(obj, deep = false) {
    if ($3fcdd01f4bd90a60$var$isFrozen(obj) || $3fcdd01f4bd90a60$export$541ac630993a4c84(obj) || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
    if ($3fcdd01f4bd90a60$var$getArchtype(obj) > 1) $3fcdd01f4bd90a60$var$O.defineProperties(obj, {
        set: $3fcdd01f4bd90a60$var$dontMutateMethodOverride,
        add: $3fcdd01f4bd90a60$var$dontMutateMethodOverride,
        clear: $3fcdd01f4bd90a60$var$dontMutateMethodOverride,
        delete: $3fcdd01f4bd90a60$var$dontMutateMethodOverride
    });
    $3fcdd01f4bd90a60$var$O.freeze(obj);
    if (deep) $3fcdd01f4bd90a60$var$each(obj, (_key, value)=>{
        $3fcdd01f4bd90a60$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $3fcdd01f4bd90a60$var$dontMutateFrozenCollections() {
    $3fcdd01f4bd90a60$var$die(2);
}
var $3fcdd01f4bd90a60$var$dontMutateMethodOverride = {
    [$3fcdd01f4bd90a60$var$VALUE]: $3fcdd01f4bd90a60$var$dontMutateFrozenCollections
};
function $3fcdd01f4bd90a60$var$isFrozen(obj) {
    if (obj === null || !$3fcdd01f4bd90a60$var$isObjectish(obj)) return true;
    return $3fcdd01f4bd90a60$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $3fcdd01f4bd90a60$var$PluginMapSet = "MapSet";
var $3fcdd01f4bd90a60$var$PluginPatches = "Patches";
var $3fcdd01f4bd90a60$var$PluginArrayMethods = "ArrayMethods";
var $3fcdd01f4bd90a60$var$plugins = {};
function $3fcdd01f4bd90a60$var$getPlugin(pluginKey) {
    const plugin = $3fcdd01f4bd90a60$var$plugins[pluginKey];
    if (!plugin) $3fcdd01f4bd90a60$var$die(0, pluginKey);
    return plugin;
}
var $3fcdd01f4bd90a60$var$isPluginLoaded = (pluginKey)=>!!$3fcdd01f4bd90a60$var$plugins[pluginKey];
function $3fcdd01f4bd90a60$var$loadPlugin(pluginKey, implementation) {
    if (!$3fcdd01f4bd90a60$var$plugins[pluginKey]) $3fcdd01f4bd90a60$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $3fcdd01f4bd90a60$var$currentScope;
var $3fcdd01f4bd90a60$var$getCurrentScope = ()=>$3fcdd01f4bd90a60$var$currentScope;
var $3fcdd01f4bd90a60$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $3fcdd01f4bd90a60$var$isPluginLoaded($3fcdd01f4bd90a60$var$PluginMapSet) ? $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $3fcdd01f4bd90a60$var$isPluginLoaded($3fcdd01f4bd90a60$var$PluginArrayMethods) ? $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginArrayMethods) : void 0
    });
function $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $3fcdd01f4bd90a60$var$revokeScope(scope) {
    $3fcdd01f4bd90a60$var$leaveScope(scope);
    scope.drafts_.forEach($3fcdd01f4bd90a60$var$revokeDraft);
    scope.drafts_ = null;
}
function $3fcdd01f4bd90a60$var$leaveScope(scope) {
    if (scope === $3fcdd01f4bd90a60$var$currentScope) $3fcdd01f4bd90a60$var$currentScope = scope.parent_;
}
var $3fcdd01f4bd90a60$var$enterScope = (immer2)=>$3fcdd01f4bd90a60$var$currentScope = $3fcdd01f4bd90a60$var$createScope($3fcdd01f4bd90a60$var$currentScope, immer2);
function $3fcdd01f4bd90a60$var$revokeDraft(draft) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $3fcdd01f4bd90a60$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].modified_) {
            $3fcdd01f4bd90a60$var$revokeScope(scope);
            $3fcdd01f4bd90a60$var$die(4);
        }
        if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(result)) result = $3fcdd01f4bd90a60$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$3fcdd01f4bd90a60$var$DRAFT_STATE].base_, result, scope);
    } else result = $3fcdd01f4bd90a60$var$finalize(scope, baseDraft);
    $3fcdd01f4bd90a60$var$maybeFreeze(scope, result, true);
    $3fcdd01f4bd90a60$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $3fcdd01f4bd90a60$export$45b790e32b2810ee ? result : void 0;
}
function $3fcdd01f4bd90a60$var$finalize(rootScope, value) {
    if ($3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $3fcdd01f4bd90a60$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$3fcdd01f4bd90a60$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $3fcdd01f4bd90a60$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $3fcdd01f4bd90a60$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(value, deep);
}
function $3fcdd01f4bd90a60$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $3fcdd01f4bd90a60$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $3fcdd01f4bd90a60$var$EMPTY_LOCATIONS_RESULT = [];
function $3fcdd01f4bd90a60$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $3fcdd01f4bd90a60$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $3fcdd01f4bd90a60$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $3fcdd01f4bd90a60$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $3fcdd01f4bd90a60$var$each(parentCopy, (key, value)=>{
            if ($3fcdd01f4bd90a60$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $3fcdd01f4bd90a60$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$3fcdd01f4bd90a60$var$set(parentCopy, location, finalizedValue, parentType);
}
function $3fcdd01f4bd90a60$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$3fcdd01f4bd90a60$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $3fcdd01f4bd90a60$var$getFinalValue(state);
        $3fcdd01f4bd90a60$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $3fcdd01f4bd90a60$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $3fcdd01f4bd90a60$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $3fcdd01f4bd90a60$var$markStateFinalized(state);
    }
}
function $3fcdd01f4bd90a60$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($3fcdd01f4bd90a60$export$541ac630993a4c84(value)) {
        const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        if ($3fcdd01f4bd90a60$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $3fcdd01f4bd90a60$var$prepareCopy(target);
            const finalizedValue = $3fcdd01f4bd90a60$var$getFinalValue(state);
            $3fcdd01f4bd90a60$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $3fcdd01f4bd90a60$var$latest(target);
        if ($3fcdd01f4bd90a60$var$get(targetCopy, key, target.type_) === value) {
            if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $3fcdd01f4bd90a60$var$handleValue($3fcdd01f4bd90a60$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
        }
    });
}
function $3fcdd01f4bd90a60$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($3fcdd01f4bd90a60$export$541ac630993a4c84(target) || handledSet.has(target) || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(target) || $3fcdd01f4bd90a60$var$isFrozen(target)) return target;
    handledSet.add(target);
    $3fcdd01f4bd90a60$var$each(target, (key, value)=>{
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(value)) {
            const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            if ($3fcdd01f4bd90a60$var$isSameScope(state, rootScope)) {
                const updatedValue = $3fcdd01f4bd90a60$var$getFinalValue(state);
                $3fcdd01f4bd90a60$var$set(target, key, updatedValue, target.type_);
                $3fcdd01f4bd90a60$var$markStateFinalized(state);
            }
        } else if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) $3fcdd01f4bd90a60$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $3fcdd01f4bd90a60$var$createProxyProxy(base, parent) {
    const baseIsArray = $3fcdd01f4bd90a60$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $3fcdd01f4bd90a60$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $3fcdd01f4bd90a60$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $3fcdd01f4bd90a60$var$objectTraps = {
    get (state, prop) {
        if (prop === $3fcdd01f4bd90a60$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $3fcdd01f4bd90a60$var$latest(state);
        if (!$3fcdd01f4bd90a60$var$has(source, prop, state.type_)) return $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $3fcdd01f4bd90a60$var$isArrayIndex(prop)) return value;
        if (value === $3fcdd01f4bd90a60$var$peek(state.base_, prop)) {
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $3fcdd01f4bd90a60$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $3fcdd01f4bd90a60$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($3fcdd01f4bd90a60$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto($3fcdd01f4bd90a60$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $3fcdd01f4bd90a60$var$peek($3fcdd01f4bd90a60$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($3fcdd01f4bd90a60$var$is(value, current2) && (value !== void 0 || $3fcdd01f4bd90a60$var$has(state.base_, prop, state.type_))) return true;
            $3fcdd01f4bd90a60$var$prepareCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $3fcdd01f4bd90a60$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $3fcdd01f4bd90a60$var$prepareCopy(state);
        if ($3fcdd01f4bd90a60$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $3fcdd01f4bd90a60$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $3fcdd01f4bd90a60$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$3fcdd01f4bd90a60$var$WRITABLE]: true,
            [$3fcdd01f4bd90a60$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$3fcdd01f4bd90a60$var$ENUMERABLE]: desc[$3fcdd01f4bd90a60$var$ENUMERABLE],
            [$3fcdd01f4bd90a60$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $3fcdd01f4bd90a60$var$die(11);
    },
    getPrototypeOf (state) {
        return $3fcdd01f4bd90a60$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $3fcdd01f4bd90a60$var$die(12);
    }
};
var $3fcdd01f4bd90a60$var$arrayTraps = {};
$3fcdd01f4bd90a60$var$each($3fcdd01f4bd90a60$var$objectTraps, (key, fn)=>{
    $3fcdd01f4bd90a60$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
});
$3fcdd01f4bd90a60$var$arrayTraps.deleteProperty = function(state, prop) {
    return $3fcdd01f4bd90a60$var$arrayTraps.set.call(this, state, prop, void 0);
};
$3fcdd01f4bd90a60$var$arrayTraps.set = function(state, prop, value) {
    return $3fcdd01f4bd90a60$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $3fcdd01f4bd90a60$var$peek(draft, prop) {
    const state = draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    const source = state ? $3fcdd01f4bd90a60$var$latest(state) : draft;
    return source[prop];
}
function $3fcdd01f4bd90a60$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop);
    return desc ? $3fcdd01f4bd90a60$var$VALUE in desc ? desc[$3fcdd01f4bd90a60$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $3fcdd01f4bd90a60$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $3fcdd01f4bd90a60$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $3fcdd01f4bd90a60$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $3fcdd01f4bd90a60$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $3fcdd01f4bd90a60$var$markChanged(state.parent_);
    }
}
function $3fcdd01f4bd90a60$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $3fcdd01f4bd90a60$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $3fcdd01f4bd90a60$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($3fcdd01f4bd90a60$var$isFunction(base) && !$3fcdd01f4bd90a60$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$3fcdd01f4bd90a60$var$isFunction(recipe)) $3fcdd01f4bd90a60$var$die(6);
            if (patchListener !== void 0 && !$3fcdd01f4bd90a60$var$isFunction(patchListener)) $3fcdd01f4bd90a60$var$die(7);
            let result;
            if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) {
                const scope = $3fcdd01f4bd90a60$var$enterScope(this);
                const proxy = $3fcdd01f4bd90a60$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $3fcdd01f4bd90a60$var$revokeScope(scope);
                    else $3fcdd01f4bd90a60$var$leaveScope(scope);
                }
                $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
                return $3fcdd01f4bd90a60$var$processResult(result, scope);
            } else if (!base || !$3fcdd01f4bd90a60$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $3fcdd01f4bd90a60$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $3fcdd01f4bd90a60$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $3fcdd01f4bd90a60$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($3fcdd01f4bd90a60$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($3fcdd01f4bd90a60$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($3fcdd01f4bd90a60$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($3fcdd01f4bd90a60$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(base)) $3fcdd01f4bd90a60$var$die(8);
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) base = $3fcdd01f4bd90a60$export$97aac956da55dae9(base);
        const scope = $3fcdd01f4bd90a60$var$enterScope(this);
        const proxy = $3fcdd01f4bd90a60$var$createProxy(scope, base, void 0);
        proxy[$3fcdd01f4bd90a60$var$DRAFT_STATE].isManual_ = true;
        $3fcdd01f4bd90a60$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$3fcdd01f4bd90a60$var$DRAFT_STATE];
        if (!state || !state.isManual_) $3fcdd01f4bd90a60$var$die(9);
        const { scope_: scope } = state;
        $3fcdd01f4bd90a60$var$usePatchesInScope(scope, patchListener);
        return $3fcdd01f4bd90a60$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginPatches).applyPatches_;
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $3fcdd01f4bd90a60$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $3fcdd01f4bd90a60$var$isMap(value) ? $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginMapSet).proxyMap_(value, parent) : $3fcdd01f4bd90a60$var$isSet(value) ? $3fcdd01f4bd90a60$var$getPlugin($3fcdd01f4bd90a60$var$PluginMapSet).proxySet_(value, parent) : $3fcdd01f4bd90a60$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $3fcdd01f4bd90a60$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $3fcdd01f4bd90a60$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $3fcdd01f4bd90a60$export$97aac956da55dae9(value) {
    if (!$3fcdd01f4bd90a60$export$541ac630993a4c84(value)) $3fcdd01f4bd90a60$var$die(10, value);
    return $3fcdd01f4bd90a60$var$currentImpl(value);
}
function $3fcdd01f4bd90a60$var$currentImpl(value) {
    if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(value) || $3fcdd01f4bd90a60$var$isFrozen(value)) return value;
    const state = value[$3fcdd01f4bd90a60$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $3fcdd01f4bd90a60$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $3fcdd01f4bd90a60$var$shallowCopy(value, true);
    $3fcdd01f4bd90a60$var$each(copy, (key, childValue)=>{
        $3fcdd01f4bd90a60$var$set(copy, key, $3fcdd01f4bd90a60$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $3fcdd01f4bd90a60$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if ("key_" in state && state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $3fcdd01f4bd90a60$var$getProxyDraft($3fcdd01f4bd90a60$var$get(parentCopy, state.key_));
            const valueAtKey = $3fcdd01f4bd90a60$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $3fcdd01f4bd90a60$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $3fcdd01f4bd90a60$var$get(current2, key);
            if (!$3fcdd01f4bd90a60$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$3fcdd01f4bd90a60$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $3fcdd01f4bd90a60$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $3fcdd01f4bd90a60$var$get(base_, key, type_);
            const value = $3fcdd01f4bd90a60$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $3fcdd01f4bd90a60$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $3fcdd01f4bd90a60$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $3fcdd01f4bd90a60$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $3fcdd01f4bd90a60$var$CONSTRUCTOR)) $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                if ($3fcdd01f4bd90a60$var$isFunction(base) && p === $3fcdd01f4bd90a60$var$PROTOTYPE) $3fcdd01f4bd90a60$var$die(errorOffset + 3);
                base = $3fcdd01f4bd90a60$var$get(base, p);
                if (!$3fcdd01f4bd90a60$var$isObjectish(base)) $3fcdd01f4bd90a60$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $3fcdd01f4bd90a60$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $3fcdd01f4bd90a60$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $3fcdd01f4bd90a60$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$3fcdd01f4bd90a60$export$16e3aed3edb85946(obj)) return obj;
        if ($3fcdd01f4bd90a60$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($3fcdd01f4bd90a60$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($3fcdd01f4bd90a60$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($3fcdd01f4bd90a60$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($3fcdd01f4bd90a60$var$has(obj, $3fcdd01f4bd90a60$export$6ee2082928bcb0ee)) cloned[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee] = obj[$3fcdd01f4bd90a60$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($3fcdd01f4bd90a60$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $3fcdd01f4bd90a60$var$loadPlugin($3fcdd01f4bd90a60$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $3fcdd01f4bd90a60$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$3fcdd01f4bd90a60$var$latest(state).has(key) || $3fcdd01f4bd90a60$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareMapCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $3fcdd01f4bd90a60$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            $3fcdd01f4bd90a60$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $3fcdd01f4bd90a60$var$latest(state).get(key);
            if (state.finalized_ || !$3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $3fcdd01f4bd90a60$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$3fcdd01f4bd90a60$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$3fcdd01f4bd90a60$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $3fcdd01f4bd90a60$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $3fcdd01f4bd90a60$var$latest(this[$3fcdd01f4bd90a60$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $3fcdd01f4bd90a60$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($3fcdd01f4bd90a60$var$latest(state).size) {
                prepareSetCopy(state);
                $3fcdd01f4bd90a60$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$3fcdd01f4bd90a60$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($3fcdd01f4bd90a60$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$3fcdd01f4bd90a60$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($3fcdd01f4bd90a60$export$16e3aed3edb85946(value)) {
                    const draft = $3fcdd01f4bd90a60$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $3fcdd01f4bd90a60$var$die(3, JSON.stringify($3fcdd01f4bd90a60$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($3fcdd01f4bd90a60$var$getValue(value));
            });
        }
    }
    $3fcdd01f4bd90a60$var$loadPlugin($3fcdd01f4bd90a60$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $3fcdd01f4bd90a60$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $3fcdd01f4bd90a60$var$prepareCopy(state);
        const result = operation();
        $3fcdd01f4bd90a60$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $3fcdd01f4bd90a60$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $3fcdd01f4bd90a60$var$loadPlugin($3fcdd01f4bd90a60$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $3fcdd01f4bd90a60$var$immer = new $3fcdd01f4bd90a60$export$aaadc6ff0f822719();
var $3fcdd01f4bd90a60$export$b46cabe22e78bc00 = $3fcdd01f4bd90a60$var$immer.produce;
var $3fcdd01f4bd90a60$export$4da66d41c9492c78 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.produceWithPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$573f26f60825c493 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.setAutoFreeze.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$333ce65961cbe047 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.setUseStrictShallowCopy.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$1045b3be3904c489 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.setUseStrictIteration.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.applyPatches.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$3c3214997190395f = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.createDraft.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$c60f5e69c521b528 = /* @__PURE__ */ $3fcdd01f4bd90a60$var$immer.finishDraft.bind($3fcdd01f4bd90a60$var$immer);
var $3fcdd01f4bd90a60$export$c05b21e3257751e5 = (value)=>value;
var $3fcdd01f4bd90a60$export$20f911b3f8cf0b74 = (value)=>value;


var $9ed9907f1a4dda7a$var$__defProp = Object.defineProperty;
var $9ed9907f1a4dda7a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9ed9907f1a4dda7a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9ed9907f1a4dda7a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9ed9907f1a4dda7a$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ed9907f1a4dda7a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ed9907f1a4dda7a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9ed9907f1a4dda7a$var$__hasOwnProp.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    if ($9ed9907f1a4dda7a$var$__getOwnPropSymbols) {
        for (var prop of $9ed9907f1a4dda7a$var$__getOwnPropSymbols(b))if ($9ed9907f1a4dda7a$var$__propIsEnum.call(b, prop)) $9ed9907f1a4dda7a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9ed9907f1a4dda7a$var$__publicField = (obj, key, value)=>{
    $9ed9907f1a4dda7a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $9ed9907f1a4dda7a$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $9ed9907f1a4dda7a$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $9ed9907f1a4dda7a$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $9ed9907f1a4dda7a$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($9ed9907f1a4dda7a$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $9ed9907f1a4dda7a$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $9ed9907f1a4dda7a$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $9ed9907f1a4dda7a$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $9ed9907f1a4dda7a$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $9ed9907f1a4dda7a$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, $9ed9907f1a4dda7a$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $9ed9907f1a4dda7a$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $9ed9907f1a4dda7a$var$$REVISION = 0;
var $9ed9907f1a4dda7a$var$CURRENT_TRACKER = null;
var $9ed9907f1a4dda7a$var$Cell = class {
    constructor(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq){
        $9ed9907f1a4dda7a$var$__publicField(this, "revision", $9ed9907f1a4dda7a$var$$REVISION);
        $9ed9907f1a4dda7a$var$__publicField(this, "_value");
        $9ed9907f1a4dda7a$var$__publicField(this, "_lastValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_isEqual", $9ed9907f1a4dda7a$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$9ed9907f1a4dda7a$var$$REVISION;
    }
};
function $9ed9907f1a4dda7a$var$tripleEq(a, b) {
    return a === b;
}
var $9ed9907f1a4dda7a$var$TrackingCache = class {
    constructor(fn){
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedValue");
        $9ed9907f1a4dda7a$var$__publicField(this, "_cachedRevision", -1);
        $9ed9907f1a4dda7a$var$__publicField(this, "_deps", []);
        $9ed9907f1a4dda7a$var$__publicField(this, "hits", 0);
        $9ed9907f1a4dda7a$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $9ed9907f1a4dda7a$var$CURRENT_TRACKER;
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $9ed9907f1a4dda7a$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $9ed9907f1a4dda7a$var$CURRENT_TRACKER == null || $9ed9907f1a4dda7a$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $9ed9907f1a4dda7a$var$getValue(cell) {
    if (!(cell instanceof $9ed9907f1a4dda7a$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $9ed9907f1a4dda7a$var$setValue(storage, value) {
    if (!(storage instanceof $9ed9907f1a4dda7a$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $9ed9907f1a4dda7a$var$createCell(initialValue, isEqual = $9ed9907f1a4dda7a$var$tripleEq) {
    return new $9ed9907f1a4dda7a$var$Cell(initialValue, isEqual);
}
function $9ed9907f1a4dda7a$var$createCache(fn) {
    $9ed9907f1a4dda7a$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $9ed9907f1a4dda7a$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $9ed9907f1a4dda7a$var$neverEq = (a, b)=>false;
function $9ed9907f1a4dda7a$var$createTag() {
    return $9ed9907f1a4dda7a$var$createCell(null, $9ed9907f1a4dda7a$var$neverEq);
}
function $9ed9907f1a4dda7a$var$dirtyTag(tag, value) {
    $9ed9907f1a4dda7a$var$setValue(tag, value);
}
var $9ed9907f1a4dda7a$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $9ed9907f1a4dda7a$var$createTag();
    $9ed9907f1a4dda7a$var$getValue(tag);
};
var $9ed9907f1a4dda7a$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $9ed9907f1a4dda7a$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $9ed9907f1a4dda7a$var$REDUX_PROXY_LABEL = Symbol();
var $9ed9907f1a4dda7a$var$nextId = 0;
var $9ed9907f1a4dda7a$var$proto = Object.getPrototypeOf({});
var $9ed9907f1a4dda7a$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy(this, $9ed9907f1a4dda7a$var$objectProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $9ed9907f1a4dda7a$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $9ed9907f1a4dda7a$var$createNode(childValue);
                if (childNode.tag) $9ed9907f1a4dda7a$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $9ed9907f1a4dda7a$var$createTag();
                    tag.value = childValue;
                }
                $9ed9907f1a4dda7a$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $9ed9907f1a4dda7a$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $9ed9907f1a4dda7a$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $9ed9907f1a4dda7a$var$__publicField(this, "proxy", new Proxy([
            this
        ], $9ed9907f1a4dda7a$var$arrayProxyHandler));
        $9ed9907f1a4dda7a$var$__publicField(this, "tag", $9ed9907f1a4dda7a$var$createTag());
        $9ed9907f1a4dda7a$var$__publicField(this, "tags", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "children", {});
        $9ed9907f1a4dda7a$var$__publicField(this, "collectionTag", null);
        $9ed9907f1a4dda7a$var$__publicField(this, "id", $9ed9907f1a4dda7a$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $9ed9907f1a4dda7a$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $9ed9907f1a4dda7a$var$consumeCollection(node);
        return $9ed9907f1a4dda7a$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $9ed9907f1a4dda7a$var$objectProxyHandler.has(node, prop);
    }
};
function $9ed9907f1a4dda7a$var$createNode(value) {
    if (Array.isArray(value)) return new $9ed9907f1a4dda7a$var$ArrayTreeNode(value);
    return new $9ed9907f1a4dda7a$var$ObjectTreeNode(value);
}
function $9ed9907f1a4dda7a$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $9ed9907f1a4dda7a$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $9ed9907f1a4dda7a$var$dirtyCollection(node);
            $9ed9907f1a4dda7a$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $9ed9907f1a4dda7a$var$updateNode(childNode, newChildValue);
        else {
            $9ed9907f1a4dda7a$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $9ed9907f1a4dda7a$var$deleteNode(node) {
    if (node.tag) $9ed9907f1a4dda7a$var$dirtyTag(node.tag, null);
    $9ed9907f1a4dda7a$var$dirtyCollection(node);
    for(const key in node.tags)$9ed9907f1a4dda7a$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$9ed9907f1a4dda7a$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $9ed9907f1a4dda7a$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $9ed9907f1a4dda7a$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $9ed9907f1a4dda7a$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $9ed9907f1a4dda7a$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $9ed9907f1a4dda7a$export$3f025202a230c6dd = (a, b)=>a === b;
function $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $9ed9907f1a4dda7a$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $9ed9907f1a4dda7a$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $9ed9907f1a4dda7a$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $9ed9907f1a4dda7a$var$createSingletonCache(comparator) : $9ed9907f1a4dda7a$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $9ed9907f1a4dda7a$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $9ed9907f1a4dda7a$export$c8f9cf88d9fdee55(func) {
    const node = $9ed9907f1a4dda7a$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $9ed9907f1a4dda7a$var$createCacheKeyComparator($9ed9907f1a4dda7a$export$3f025202a230c6dd);
    const cache = $9ed9907f1a4dda7a$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $9ed9907f1a4dda7a$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $9ed9907f1a4dda7a$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $9ed9907f1a4dda7a$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $9ed9907f1a4dda7a$var$StrongRef;
var $9ed9907f1a4dda7a$var$UNTERMINATED = 0;
var $9ed9907f1a4dda7a$var$TERMINATED = 1;
function $9ed9907f1a4dda7a$var$createCacheNode() {
    return {
        s: $9ed9907f1a4dda7a$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $9ed9907f1a4dda7a$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $9ed9907f1a4dda7a$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $9ed9907f1a4dda7a$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $9ed9907f1a4dda7a$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $9ed9907f1a4dda7a$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $9ed9907f1a4dda7a$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $9ed9907f1a4dda7a$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $9ed9907f1a4dda7a$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $9ed9907f1a4dda7a$var$__spreadValues($9ed9907f1a4dda7a$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $9ed9907f1a4dda7a$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $9ed9907f1a4dda7a$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $9ed9907f1a4dda7a$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $9ed9907f1a4dda7a$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $9ed9907f1a4dda7a$export$595d22ed68ca2841 = /* @__PURE__ */ $9ed9907f1a4dda7a$export$5943f4447f6ef248($9ed9907f1a4dda7a$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $9ed9907f1a4dda7a$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $9ed9907f1a4dda7a$export$595d22ed68ca2841)=>{
    $9ed9907f1a4dda7a$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$9ed9907f1a4dda7a$export$75979cfcd91bf38f
});


// src/index.ts
function $7c2f93b225350c5e$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $7c2f93b225350c5e$export$dd164f5517779f15 = $7c2f93b225350c5e$var$createThunkMiddleware();
var $7c2f93b225350c5e$export$16d06542a1949d9e = $7c2f93b225350c5e$var$createThunkMiddleware;


var $6d3bbb1da5d24806$var$__defProp = Object.defineProperty;
var $6d3bbb1da5d24806$var$__defProps = Object.defineProperties;
var $6d3bbb1da5d24806$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6d3bbb1da5d24806$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6d3bbb1da5d24806$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6d3bbb1da5d24806$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6d3bbb1da5d24806$var$__defNormalProp = (obj, key, value)=>key in obj ? $6d3bbb1da5d24806$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6d3bbb1da5d24806$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6d3bbb1da5d24806$var$__hasOwnProp.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    if ($6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(b))if ($6d3bbb1da5d24806$var$__propIsEnum.call(b, prop)) $6d3bbb1da5d24806$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6d3bbb1da5d24806$var$__spreadProps = (a, b)=>$6d3bbb1da5d24806$var$__defProps(a, $6d3bbb1da5d24806$var$__getOwnPropDescs(b));
var $6d3bbb1da5d24806$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6d3bbb1da5d24806$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6d3bbb1da5d24806$var$__getOwnPropSymbols) {
        for (var prop of $6d3bbb1da5d24806$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6d3bbb1da5d24806$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $6d3bbb1da5d24806$var$__publicField = (obj, key, value)=>$6d3bbb1da5d24806$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $6d3bbb1da5d24806$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $9ed9907f1a4dda7a$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $6d3bbb1da5d24806$export$a5d3c27355e35910 = /* @__PURE__ */ $6d3bbb1da5d24806$export$aab6de9e3dbb1473((0, $9ed9907f1a4dda7a$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $6d3bbb1da5d24806$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $876d8277641f3cc3$export$f672e0b6f7222cd7;
    return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $6d3bbb1da5d24806$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $6d3bbb1da5d24806$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(0));
            return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $876d8277641f3cc3$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $6d3bbb1da5d24806$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $6d3bbb1da5d24806$var$hasMatchFunction(action);
}
function $6d3bbb1da5d24806$export$ebd532f9034651f3(action) {
    return (0, $876d8277641f3cc3$export$b956e38827fca970)(action) && Object.keys(action).every($6d3bbb1da5d24806$var$isValidKey);
}
function $6d3bbb1da5d24806$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $6d3bbb1da5d24806$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $6d3bbb1da5d24806$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $6d3bbb1da5d24806$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $6d3bbb1da5d24806$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $6d3bbb1da5d24806$var$freezeDraftable(val) {
    return (0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(val) ? (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $6d3bbb1da5d24806$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $6d3bbb1da5d24806$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $6d3bbb1da5d24806$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $6d3bbb1da5d24806$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $6d3bbb1da5d24806$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $6d3bbb1da5d24806$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $6d3bbb1da5d24806$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $876d8277641f3cc3$export$53b83ca8eaab0383)(val);
}
function $6d3bbb1da5d24806$export$ada5dca0b571bc7(value, path = "", isSerializable = $6d3bbb1da5d24806$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $6d3bbb1da5d24806$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $6d3bbb1da5d24806$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $6d3bbb1da5d24806$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$6d3bbb1da5d24806$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $6d3bbb1da5d24806$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $6d3bbb1da5d24806$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $6d3bbb1da5d24806$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9();
        if (thunk) {
            if ($6d3bbb1da5d24806$var$isBoolean(thunk)) middlewareArray.push((0, $7c2f93b225350c5e$export$dd164f5517779f15));
            else middlewareArray.push((0, $7c2f93b225350c5e$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $6d3bbb1da5d24806$export$8fb31c0f05df007b = "RTK_autoBatch";
var $6d3bbb1da5d24806$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$6d3bbb1da5d24806$export$8fb31c0f05df007b]: true
            }
        });
var $6d3bbb1da5d24806$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $6d3bbb1da5d24806$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $6d3bbb1da5d24806$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $6d3bbb1da5d24806$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$6d3bbb1da5d24806$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $6d3bbb1da5d24806$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $6d3bbb1da5d24806$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($6d3bbb1da5d24806$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $6d3bbb1da5d24806$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $6d3bbb1da5d24806$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $876d8277641f3cc3$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducer);
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $876d8277641f3cc3$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $6d3bbb1da5d24806$var$composeWithDevTools($6d3bbb1da5d24806$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $876d8277641f3cc3$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $6d3bbb1da5d24806$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $876d8277641f3cc3$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $6d3bbb1da5d24806$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $6d3bbb1da5d24806$var$isStateFunction(x) {
    return typeof x === "function";
}
function $6d3bbb1da5d24806$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $6d3bbb1da5d24806$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($6d3bbb1da5d24806$var$isStateFunction(initialState)) getInitialState = ()=>$6d3bbb1da5d24806$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $6d3bbb1da5d24806$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $3fcdd01f4bd90a60$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $6d3bbb1da5d24806$var$matches = (matcher, action)=>{
    if ($6d3bbb1da5d24806$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$6d3bbb1da5d24806$var$matches(matcher, action));
    };
}
function $6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $6d3bbb1da5d24806$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $6d3bbb1da5d24806$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$872dec21e9a69476()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $6d3bbb1da5d24806$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$fcc3388fb56de601()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$9dd1fb32974da385($6d3bbb1da5d24806$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $6d3bbb1da5d24806$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$1da80a6ef1307441()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $6d3bbb1da5d24806$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$6d3bbb1da5d24806$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$6d3bbb1da5d24806$var$isAsyncThunkArray(asyncThunks)) return $6d3bbb1da5d24806$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $6d3bbb1da5d24806$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $6d3bbb1da5d24806$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $6d3bbb1da5d24806$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $6d3bbb1da5d24806$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $6d3bbb1da5d24806$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $6d3bbb1da5d24806$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $6d3bbb1da5d24806$var$__publicField(this, "_type");
    }
};
var $6d3bbb1da5d24806$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $6d3bbb1da5d24806$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $6d3bbb1da5d24806$var$externalAbortMessage = "External signal was aborted";
var $6d3bbb1da5d24806$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $6d3bbb1da5d24806$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($6d3bbb1da5d24806$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($6d3bbb1da5d24806$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($6d3bbb1da5d24806$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $6d3bbb1da5d24806$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $6d3bbb1da5d24806$var$RejectWithValue) throw result;
                                if (result instanceof $6d3bbb1da5d24806$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $6d3bbb1da5d24806$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($6d3bbb1da5d24806$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $6d3bbb1da5d24806$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $6d3bbb1da5d24806$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $6d3bbb1da5d24806$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $6d3bbb1da5d24806$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $6d3bbb1da5d24806$export$343355ed40c51c46 = {
    [$6d3bbb1da5d24806$var$asyncThunkSymbol]: $6d3bbb1da5d24806$export$6abd22dc03e5063f
};
var $6d3bbb1da5d24806$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($6d3bbb1da5d24806$export$23a094319a4b586 || {});
function $6d3bbb1da5d24806$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $6d3bbb1da5d24806$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$6d3bbb1da5d24806$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($6d3bbb1da5d24806$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $6d3bbb1da5d24806$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $6d3bbb1da5d24806$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $6d3bbb1da5d24806$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $6d3bbb1da5d24806$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $6d3bbb1da5d24806$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $6d3bbb1da5d24806$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $6d3bbb1da5d24806$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, ()=>$6d3bbb1da5d24806$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $6d3bbb1da5d24806$var$__spreadProps($6d3bbb1da5d24806$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $6d3bbb1da5d24806$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $6d3bbb1da5d24806$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $6d3bbb1da5d24806$export$affdea4146de9cf5();
function $6d3bbb1da5d24806$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $6d3bbb1da5d24806$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $6d3bbb1da5d24806$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type, prepareCallback) : $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type));
}
function $6d3bbb1da5d24806$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $6d3bbb1da5d24806$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $6d3bbb1da5d24806$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $6d3bbb1da5d24806$var$noop,
        pending: pending || $6d3bbb1da5d24806$var$noop,
        rejected: rejected || $6d3bbb1da5d24806$var$noop,
        settled: settled || $6d3bbb1da5d24806$var$noop
    });
}
function $6d3bbb1da5d24806$var$noop() {}
// src/entities/entity_state.ts
function $6d3bbb1da5d24806$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($6d3bbb1da5d24806$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $6d3bbb1da5d24806$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $6d3bbb1da5d24806$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $6d3bbb1da5d24806$var$isDraftTyped = (0, $3fcdd01f4bd90a60$export$541ac630993a4c84);
function $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(mutator) {
    const operator = $6d3bbb1da5d24806$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $6d3bbb1da5d24806$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $6d3bbb1da5d24806$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($6d3bbb1da5d24806$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $3fcdd01f4bd90a60$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $6d3bbb1da5d24806$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $6d3bbb1da5d24806$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $6d3bbb1da5d24806$var$getCurrent(value) {
    return (0, $3fcdd01f4bd90a60$export$541ac630993a4c84)(value) ? (0, $3fcdd01f4bd90a60$export$97aac956da55dae9)(value) : value;
}
function $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $6d3bbb1da5d24806$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $6d3bbb1da5d24806$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $6d3bbb1da5d24806$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$6d3bbb1da5d24806$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $6d3bbb1da5d24806$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably),
        removeOne: $6d3bbb1da5d24806$var$createStateOperator(removeOneMutably),
        removeMany: $6d3bbb1da5d24806$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $6d3bbb1da5d24806$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $6d3bbb1da5d24806$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $6d3bbb1da5d24806$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $6d3bbb1da5d24806$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $6d3bbb1da5d24806$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $6d3bbb1da5d24806$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $6d3bbb1da5d24806$var$getCurrent(state.entities);
        const currentIds = $6d3bbb1da5d24806$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $6d3bbb1da5d24806$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $6d3bbb1da5d24806$var$createStateOperator(addOneMutably),
        updateOne: $6d3bbb1da5d24806$var$createStateOperator(updateOneMutably),
        upsertOne: $6d3bbb1da5d24806$var$createStateOperator(upsertOneMutably),
        setOne: $6d3bbb1da5d24806$var$createStateOperator(setOneMutably),
        setMany: $6d3bbb1da5d24806$var$createStateOperator(setManyMutably),
        setAll: $6d3bbb1da5d24806$var$createStateOperator(setAllMutably),
        addMany: $6d3bbb1da5d24806$var$createStateOperator(addManyMutably),
        updateMany: $6d3bbb1da5d24806$var$createStateOperator(updateManyMutably),
        upsertMany: $6d3bbb1da5d24806$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $6d3bbb1da5d24806$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $6d3bbb1da5d24806$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $6d3bbb1da5d24806$var$createSortedStateAdapter(selectId, sortComparer) : $6d3bbb1da5d24806$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $6d3bbb1da5d24806$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $6d3bbb1da5d24806$var$createSelectorsFactory();
    return $6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues($6d3bbb1da5d24806$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $6d3bbb1da5d24806$var$task = "task";
var $6d3bbb1da5d24806$var$listener = "listener";
var $6d3bbb1da5d24806$var$completed = "completed";
var $6d3bbb1da5d24806$var$cancelled = "cancelled";
var $6d3bbb1da5d24806$var$taskCancelled = `task-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$taskCompleted = `task-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$var$listenerCancelled = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$cancelled}`;
var $6d3bbb1da5d24806$var$listenerCompleted = `${$6d3bbb1da5d24806$var$listener}-${$6d3bbb1da5d24806$var$completed}`;
var $6d3bbb1da5d24806$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $6d3bbb1da5d24806$var$__publicField(this, "name", "TaskAbortError");
        $6d3bbb1da5d24806$var$__publicField(this, "message");
        this.message = `${$6d3bbb1da5d24806$var$task} ${$6d3bbb1da5d24806$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $6d3bbb1da5d24806$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($6d3bbb1da5d24806$export$378fa86b259c0280(32));
};
var $6d3bbb1da5d24806$var$noop2 = ()=>{};
var $6d3bbb1da5d24806$var$catchRejection = (promise, onError = $6d3bbb1da5d24806$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $6d3bbb1da5d24806$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $6d3bbb1da5d24806$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $6d3bbb1da5d24806$export$cb1bdac908fed7f(signal.reason);
};
function $6d3bbb1da5d24806$var$raceWithSignal(signal, promise) {
    let cleanup = $6d3bbb1da5d24806$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $6d3bbb1da5d24806$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $6d3bbb1da5d24806$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $6d3bbb1da5d24806$var$noop2;
    });
}
var $6d3bbb1da5d24806$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $6d3bbb1da5d24806$var$createPause = (signal)=>{
    return (promise)=>{
        return $6d3bbb1da5d24806$var$catchRejection($6d3bbb1da5d24806$var$raceWithSignal(signal, promise).then((output)=>{
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        }));
    };
};
var $6d3bbb1da5d24806$var$createDelay = (signal)=>{
    const pause = $6d3bbb1da5d24806$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $6d3bbb1da5d24806$var$assign } = Object;
var $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN = {};
var $6d3bbb1da5d24806$var$alm = "listenerMiddleware";
var $6d3bbb1da5d24806$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$6d3bbb1da5d24806$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $6d3bbb1da5d24806$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $6d3bbb1da5d24806$var$runTask(async ()=>{
            $6d3bbb1da5d24806$var$validateActive(parentAbortSignal);
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $6d3bbb1da5d24806$var$createPause(childAbortController.signal),
                delay: $6d3bbb1da5d24806$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $6d3bbb1da5d24806$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($6d3bbb1da5d24806$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($6d3bbb1da5d24806$var$noop2));
        return {
            result: $6d3bbb1da5d24806$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($6d3bbb1da5d24806$var$taskCancelled);
            }
        };
    };
};
var $6d3bbb1da5d24806$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $6d3bbb1da5d24806$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $6d3bbb1da5d24806$var$raceWithSignal(signal, Promise.race(promises));
            $6d3bbb1da5d24806$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$6d3bbb1da5d24806$var$catchRejection(take(predicate, timeout));
};
var $6d3bbb1da5d24806$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $6d3bbb1da5d24806$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(21));
    $6d3bbb1da5d24806$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $6d3bbb1da5d24806$var$createListenerEntry = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $6d3bbb1da5d24806$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$6d3bbb1da5d24806$var$createListenerEntry
});
var $6d3bbb1da5d24806$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $6d3bbb1da5d24806$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $6d3bbb1da5d24806$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($6d3bbb1da5d24806$var$listenerCancelled);
    });
};
var $6d3bbb1da5d24806$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$6d3bbb1da5d24806$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $6d3bbb1da5d24806$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $6d3bbb1da5d24806$export$f03a6b845d3fb58b = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign(/* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/add`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$f03a6b845d3fb58b
});
var $6d3bbb1da5d24806$export$b1b8022855fb2b71 = /* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/removeAll`);
var $6d3bbb1da5d24806$export$b03e9483f936dccb = /* @__PURE__ */ $6d3bbb1da5d24806$var$assign(/* @__PURE__ */ $6d3bbb1da5d24806$export$309c7a02b0b0bc62(`${$6d3bbb1da5d24806$var$alm}/remove`), {
    withTypes: ()=>$6d3bbb1da5d24806$export$b03e9483f936dccb
});
var $6d3bbb1da5d24806$var$defaultErrorHandler = (...args)=>{
    console.error(`${$6d3bbb1da5d24806$var$alm}/error`, ...args);
};
var $6d3bbb1da5d24806$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $6d3bbb1da5d24806$var$defaultErrorHandler } = middlewareOptions;
    $6d3bbb1da5d24806$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $6d3bbb1da5d24806$var$findListenerEntry(listenerMap, options)) != null ? _a : $6d3bbb1da5d24806$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $6d3bbb1da5d24806$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $6d3bbb1da5d24806$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $6d3bbb1da5d24806$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $6d3bbb1da5d24806$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $6d3bbb1da5d24806$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $6d3bbb1da5d24806$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $6d3bbb1da5d24806$var$createDelay(internalTaskController.signal),
                pause: $6d3bbb1da5d24806$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $6d3bbb1da5d24806$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($6d3bbb1da5d24806$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($6d3bbb1da5d24806$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $6d3bbb1da5d24806$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $6d3bbb1da5d24806$export$cb1bdac908fed7f)) $6d3bbb1da5d24806$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($6d3bbb1da5d24806$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $6d3bbb1da5d24806$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $876d8277641f3cc3$export$b956e38827fca970)(action)) return next(action);
                if ($6d3bbb1da5d24806$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($6d3bbb1da5d24806$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($6d3bbb1da5d24806$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $6d3bbb1da5d24806$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $6d3bbb1da5d24806$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $6d3bbb1da5d24806$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $6d3bbb1da5d24806$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $6d3bbb1da5d24806$export$4bb1606a79445586 = ()=>{
    const instanceId = $6d3bbb1da5d24806$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($6d3bbb1da5d24806$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $6d3bbb1da5d24806$var$getOrInsertComputed(middlewareMap, middleware2, $6d3bbb1da5d24806$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$6d3bbb1da5d24806$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $876d8277641f3cc3$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $6d3bbb1da5d24806$export$9dd1fb32974da385(withMiddleware, $6d3bbb1da5d24806$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $6d3bbb1da5d24806$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $6d3bbb1da5d24806$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$6d3bbb1da5d24806$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $6d3bbb1da5d24806$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $6d3bbb1da5d24806$var$isStateProxy = (value)=>!!value && !!value[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
var $6d3bbb1da5d24806$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $6d3bbb1da5d24806$var$createStateProxy = (state, reducerMap, initialStateCache)=>$6d3bbb1da5d24806$var$getOrInsertComputed($6d3bbb1da5d24806$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $6d3bbb1da5d24806$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $6d3bbb1da5d24806$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $6d3bbb1da5d24806$var$original = (state)=>{
    if (!$6d3bbb1da5d24806$var$isStateProxy(state)) throw new Error($6d3bbb1da5d24806$export$378fa86b259c0280(25));
    return state[$6d3bbb1da5d24806$var$ORIGINAL_STATE];
};
var $6d3bbb1da5d24806$var$emptyObject = {};
var $6d3bbb1da5d24806$var$noopReducer = (state = $6d3bbb1da5d24806$var$emptyObject)=>state;
function $6d3bbb1da5d24806$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($6d3bbb1da5d24806$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $876d8277641f3cc3$export$66e4520cdb265d18)(reducerMap) : $6d3bbb1da5d24806$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($6d3bbb1da5d24806$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $6d3bbb1da5d24806$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $6d3bbb1da5d24806$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


// Creating a slice for cart-related state
const $be82901f22730e57$var$cartSlice = (0, $6d3bbb1da5d24806$export$4d8d9bd83c24ae8b)({
    // Name of the slice (used as a key in the Redux store)
    name: "cart",
    // Initial state of the cart
    initialState: {
        items: []
    },
    // Reducer functions to update the cart state
    reducers: {
        // Adds a new item to the cart
        // action.payload contains the item data
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        // Removes the last item from the cart
        removeItem: (state)=>{
            state.items.pop();
        },
        // Clears all items from the cart
        // originalState = ["pizza"]
        clearCart: (state, action)=>{
            //   state.items.length = 0;
            return {
                items: []
            };
        }
    }
});
const { addItem: $be82901f22730e57$export$fb9705de59d96855, removeItem: $be82901f22730e57$export$fe2d9b4e03920b4c, clearCart: $be82901f22730e57$export$810121176e3e3671 } = $be82901f22730e57$var$cartSlice.actions;
var // Export reducer to update the Redux store
$be82901f22730e57$export$2e2bcd8739ae039 = $be82901f22730e57$var$cartSlice.reducer;


const $839b398f111495d4$var$MenuItem = ({ menuInfo: menuInfo, showAddButton: showAddButton = true })=>{
    if (!menuInfo) return null;
    const IMG_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";
    const { name: name, price: price, description: description, imageId: imageId, ratings: ratings = {} } = menuInfo;
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $jk232.jsxs)("li", {
        role: "button",
        tabIndex: 0,
        className: " my-7 flex justify-between gap-8 py-5 px-7 bg-white  rounded-3xl  shadow-[0_6px_14px_-6px_rgba(0,0,0,0.18)] hover:shadow-[0_10px_20px_-8px_rgba(0,0,0,0.28)]  cursor-pointer transition-shadow duration-300 ease-in-out  font-['Segoe_UI',Tahoma,Geneva,Verdana,sans-serif] ",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("h4", {
                        className: "text-lg font-bold text-[#242323]",
                        children: name
                    }),
                    price && /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "mt-1 font-medium",
                        children: [
                            "\u20B9",
                            (price / 100).toFixed(2),
                            "/_ only"
                        ]
                    }),
                    ratings?.aggregatedRating?.rating && /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                        className: "mt-1",
                        children: [
                            ratings.aggregatedRating.rating,
                            " \u2B50 (",
                            ratings.aggregatedRating.ratingCountV2,
                            ")"
                        ]
                    }),
                    description && /*#__PURE__*/ (0, $jk232.jsx)("p", {
                        className: "mt-2 pr-10 text-[#242323] text-sm leading-relaxed",
                        children: description
                    })
                ]
            }),
            imageId && /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsx)("img", {
                        src: IMG_URL + imageId,
                        alt: name,
                        className: " w-[140px] h-[120px] object-cover rounded-[15px] shadow-[0_8px_12px_rgba(0,0,0,0.2)] "
                    }),
                    showAddButton && /*#__PURE__*/ (0, $jk232.jsx)("button", {
                        onClick: ()=>dispatch((0, $be82901f22730e57$export$fb9705de59d96855)(menuInfo)),
                        className: " absolute -bottom-3 left-1/2 -translate-x-1/2 bg-white text-green-600 font-bold px-6 py-1 rounded-lg shadow-md hover:shadow-lg active:scale-95 transition ",
                        children: "ADD +"
                    })
                ]
            })
        ]
    });
};
var $839b398f111495d4$export$2e2bcd8739ae039 = $839b398f111495d4$var$MenuItem;


const $579a12e96e24a9c9$var$ItemCategory = ({ data: data, isOpen: isOpen, onToggle: onToggle, addToCart: addToCart })=>{
    const { title: title, itemCards: itemCards = [] } = data;
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "mb-4 bg-gray-100 rounded-xl shadow-sm",
        children: [
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                onClick: onToggle,
                className: "flex justify-between items-center px-6 py-4 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $jk232.jsxs)("h2", {
                        className: "text-lg font-bold text-black",
                        children: [
                            title,
                            " (",
                            itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "w-7 h-7 flex items-center justify-center bg-black rounded-full",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("img", {
                            width: "30",
                            height: "30",
                            src: "https://img.icons8.com/sf-regular-filled/48/circled-chevron-up.png",
                            alt: "toggle-arrow",
                            className: `transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jk232.jsx)("div", {
                className: "border-t border-gray-300 mx-6"
            }),
            isOpen && /*#__PURE__*/ (0, $jk232.jsx)("div", {
                className: "px-6 py-3",
                children: itemCards.map((item, index)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $839b398f111495d4$export$2e2bcd8739ae039), {
                        menuInfo: item?.card?.info,
                        addToCart: addToCart
                    }, item?.card?.info?.id ?? index))
            })
        ]
    });
};
var $579a12e96e24a9c9$export$2e2bcd8739ae039 = $579a12e96e24a9c9$var$ItemCategory;



var $4RFnf = parcelRequire("4RFnf");
var $0b2b362ceb9aba3c$exports = {};
$0b2b362ceb9aba3c$exports = JSON.parse('{"id":1,"statusCode":0,"data":{"statusMessage":"done successfully","cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2","text":"Oh!Hunger","headerStyling":{"textColor":"text_Highest_Emphasis","textVariant":"header_H3_Black"}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab","tabs":[{"id":"Order Online","title":"Order Online"}]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Restaurant","info":{"id":"666909","name":"Oh!Hunger","city":"Delhi","slugs":{"restaurant":"oh!hunger-karol-bagh-karol-bagh","city":"delhi"},"uniqueId":"e51e6528-4859-48c8-8fed-e84c17dc2d76","cloudinaryImageId":"d270f97263e5e0a99cb99137e4a58c8b","locality":"Chuna Mandi","areaName":"Paharganj","costForTwo":"25000","costForTwoMessage":"\u20B9250 for two","cuisines":["Fast Food","Snacks"],"avgRating":4.2,"feeDetails":{"restaurantId":"666909","fees":[{}]},"parentId":"400023","avgRatingString":"4.2","totalRatingsString":"2.9K+ ratings","sla":{"restaurantId":"666909","deliveryTime":29,"minDeliveryTime":25,"maxDeliveryTime":30,"lastMileTravel":2.1,"serviceability":"SERVICEABLE","stressFactor":1,"rainMode":"RAIN_MODE_NONE","longDistance":"LONG_DISTANCE_NOT_LONG_DISTANCE","zoneId":96,"slaString":"25-30 MINS","lastMileTravelString":"2.1 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","visibility":true,"opened":true,"restaurantClosedMeta":{}},"aggregatedDiscountInfo":{"header":"Get every item @ 59","shortDescriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199","discountType":"Flat","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199 | Use code FLAT100","discountType":"Flat","operationType":"RESTAURANT"}],"visible":true},"badges":{},"slugString":"oh!hunger-karol-bagh-karol-bagh","multiOutlet":true,"isOpen":true,"labels":[{"title":"Timings","message":"null"},{"title":"Address","message":"1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"},{"title":"Cuisines","message":"Fast Food,Snacks"}],"totalRatings":2900,"aggregatedDiscountInfoV2":{"header":"Get every item @ 59","shortDescriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199","discountType":"Flat","operationType":"RESTAURANT"}],"descriptionList":[{"meta":"Get every item @ 59","discountType":"FinalPrice","operationType":"RESTAURANT"},{"meta":"Flat \u20B9100 off on orders above \u20B9199 | Use code FLAT100","discountType":"Flat","operationType":"RESTAURANT"}],"couponDetailsCta":"View coupon details"},"type":"F","nudgeBanners":[{"priority":9,"discountInfo":{"discountType":"FinalPrice","value":109},"unlockedMessage":"Deal of the Day unlocked!","minItemCount":1,"maxItemCount":1,"type":"SILD","nudgeTagInfo":{"title":"Deal of the Day","fontName":"FONT_NAME_CONDENSED_BOLD"},"logoCtx":{},"movComputationType":"MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"}],"headerBanner":{"url":"swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/666909"},"ratingSlab":"RATING_SLAB_5","orderabilityCommunication":{"title":{},"subTitle":{},"message":{},"customIcon":{},"commsStyling":{}},"hasBestsellerItems":true,"cartOrderabilityNudgeBanner":{"parameters":{},"presentation":{}},"latLong":"28.641069,77.209671","backgroundImageOverlayInfo":{},"featuredSectionInfo":{},"requestContexts":["enable_ecosaver","99store"]},"analytics":{}},"relevance":{"type":"RELEVANCE_TYPE_CHECK_ORDERABILITY_AND_SHOW_MENU_OFFER_NUDGE","sectionId":"MENU_ITEM_CART_UPDATE_POP_CROUTON"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","layout":{"rows":1,"columns":5,"horizontalScrollEnabled":true,"itemSpacing":12,"lineSpacing":10,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":10,"right":10,"bottom":16}}},"id":"offerCollectionWidget_UX4","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle","offers":[{"info":{"header":"50% OFF","offerTag":"DEAL OF DAY","offerTagColor":"#E46D47","offerIds":["3d3deff4-5f75-4cc2-b1d7-dca34271ee04"],"expiryTime":"1970-01-01T00:56:06Z","offerType":"offers","restId":"666909","offerLogo":"offers/DealRush_Offer_Icon.png","descriptionTextColor":"#7302060C","showExpiryTimer":true,"primaryDescription":"5 DEALS LEFT"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9100 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["f609cd84-fb53-43da-912e-ba9bccf494d7"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT100","description":"ABOVE \u20B9199","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT100"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9125 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["112e0e28-548a-474f-89cb-7cebbe4343fa"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT125","description":"ABOVE \u20B9249","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT125"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"50% OFF UPTO \u20B9100","offerTagColor":"#E46D47","offerIds":["32bf37ac-aa33-4293-bed3-41a512ad2b25"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE TRYNEW","description":"ABOVE \u20B9179","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE TRYNEW"},"cta":{"type":"OFFER_HALF_CARD"}},{"info":{"header":"FLAT \u20B9200 OFF","offerTag":"FLAT DEAL","offerTagColor":"#E46D47","offerIds":["801c250e-4858-420a-a764-6a0802835b40"],"expiryTime":"1970-01-01T00:00:00Z","couponCode":"USE FLAT200","description":"ABOVE \u20B9649","offerType":"offers","restId":"666909","offerLogo":"offers/generic","descriptionTextColor":"#7302060C","primaryDescription":"USE FLAT200"},"cta":{"type":"OFFER_HALF_CARD"}}],"habitMilestoneInfo":{"callout":{}},"loyaltyDiscoverPresentationInfo":{"logoCtx":{}}}}}}},{"groupedCard":{"cardGroupMap":{"REGULAR":{"cards":[{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge","badges":{},"vegOnlyDetails":{"imageId":"AutoVegOnly_qkjowj","title":"Showing only vegetarian options.","description":"Tap on the VEG ONLY button to turn off the setting"},"topRatedFilter":{"attributes":{"displayText":"Ratings 4.0+"}},"kidsCategoryFilter":{"attributes":{"displayText":"Kids Favourites","tooltip":{"enabled":true,"displayText":"Kids Favourites Filter applied. Remove this filter to see the full Menu."}}},"vegFilter":{"attributes":{"displayText":"VEG"}},"nonvegFilter":{"attributes":{"displayText":"NONVEG"}}},"relevance":{"type":"RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED","sectionId":"MENU_FILTER_TOGGLE"}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"99 Store","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep_widget","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"75385694"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep_widget","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"62480122"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"subtitleColor":"highlight","categoryId":"1234567","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{"rows":1,"columns":2,"itemSpacing":16,"containerStyle":{"containerPadding":{"left":16,"top":8,"right":16,"bottom":12}}},"itemStyle":{"width":{"type":"TYPE_RELATIVE","value":0.5,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":0.9,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}},"titleCreative":{"creativeId":"affordable/Menu%20widget%20-%20Title%20badge%20-%203.png","style":{"width":{"type":"TYPE_ABSOLUTE","value":84},"height":{"type":"TYPE_ABSOLUTE","value":25}}},"subtitleCreative":{"creativeId":"99store/Category%20subtext.png?updatedAt=1756989067080","style":{"width":{"type":"TYPE_ABSOLUTE","value":246},"height":{"type":"TYPE_ABSOLUTE","value":25}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Recommended","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"62480122"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832043","name":"Classic Maggi","category":"Maggi & Momos","description":"Classic maggi with added extra vegetables & Spices.","imageId":"285a763faec0781c1f8944f808821627","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"476 ratings","ratingCountV2":"476"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480066"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831984","name":"Poha With Sev","category":"All Day Breakfast","description":"Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.","imageId":"7a0ba771f71c9f995a4a83a00497b8e5","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394261","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480108"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.5,"height":0.9},"isNinetyninestoreItem":true,"parentId":"75385694"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576922","name":"Chicken Tikka Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.","imageId":"ed102873ace7fcd6f5b9784db1a30387","inStock":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"136 ratings","ratingCountV2":"136"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.5,"height":0.9},"parentId":"63848610","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576931","name":"Adarak Wali Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.","imageId":"90cea1cd1b6eff5cf637e34c7c218564","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"124 ratings","ratingCountV2":"124"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480032"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831975","name":"Mumbai Street Style Pav Bhaji","category":"All Day Breakfast","description":"Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.","imageId":"c9950bf23deeb3f297046ff0e236e75f","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394263","groupName":"Extra Add Ons","choices":[{"id":"122678746","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678738","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678731","name":"Bhaji","price":12900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678725","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678750","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678735","name":"Gulab Jamun 2 Pcs","price":7900,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"227 ratings","ratingCountV2":"227"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"62480098","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746208","name":"Cheese & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"59 ratings","ratingCountV2":"59"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"75385692","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716238","name":"Egg Roll","category":"Rolls","description":"Indian style egg rolled in a bread.","imageId":"40486f92274e4e01e18e94bbe59505f2","inStock":1,"price":9900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599020","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599022","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599025","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599026","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"182 ratings","ratingCountV2":"182"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65727901"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832046","name":"Egg Bhurji Maggi","category":"Maggi & Momos","description":"Made with Indian style scrambled egg.","imageId":"e44004aac4df3a9d5f4e483a22a59d33","inStock":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480071"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832044","name":"Peri Peri Maggi","category":"Maggi & Momos","description":"Made with extra dose of peri peri sauce.","imageId":"6575e3e347e27529cb84c0906d4b0a7c","inStock":1,"isVeg":1,"price":13900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"161 ratings","ratingCountV2":"161"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480107"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832047","name":"Chicken Keema Maggi","category":"Maggi & Momos","description":"Made with Spicy Chicken keema.","imageId":"0779117a4136f19ef1e07aa57e05205b","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"57 ratings","ratingCountV2":"57"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"62480050","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821110","name":"Penne Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.","imageId":"15f579ecdf022bf645f073b8a9283ac4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897968","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541010"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821108","name":"Spaghetti Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.","imageId":"203fb6f02f3cae0fa745f962c00a8c74","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897967","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"44 ratings","ratingCountV2":"44"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541012"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832045","name":"Cheese & Jalapeno Maggi","category":"Maggi & Momos","description":"Made with Cheese & Jalapeno.","imageId":"1b194491d06902dc12b533739256afd8","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480044"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716241","name":"Takatak Paneer Tikka Roll","category":"Rolls","description":"Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.","imageId":"193ac982ad8ac0c9bbc20921686ffa01","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599047","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599048","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599049","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599050","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.5,"height":0.9},"parentId":"67273352","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617185","name":"Rajma & Rice","category":"Indian Meal","description":"Made with protein rich kidney beans. Served with rice.","imageId":"2d72335d0004cedb54725a02a530e6ef","inStock":1,"isVeg":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"63685388"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876020","name":"Sabudana Khichdi","category":"All Day Breakfast","description":"Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.","imageId":"a3e91009b0a3a84b28adaf15a5128967","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394260","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"showImage":true,"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"77 ratings","ratingCountV2":"77"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.5,"height":0.9},"parentId":"63591707","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821103","name":"Chicken Kurket [6 Pcs]","category":"Continental","description":"Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.","imageId":"9ee3be8226ddd34bf17d221d0952b298","inStock":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"72 ratings","ratingCountV2":"72"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"65541007"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576928","name":"Shredded Chicken Cold Sandwich (brown Bread)","category":"Sandwiches","description":"Made with shredded chicken, mayo, vegetables, flavored with salt & paper.","imageId":"a5d546677bb738f7d33c88b4130424b4","inStock":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"showImage":true,"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"24 ratings","ratingCountV2":"24"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.5,"height":0.9},"parentId":"62480117"},"restaurant":{"info":{"id":"666909","parentId":"400023","sla":{"serviceability":"NON_SERVICEABLE","iconType":"ICON_TYPE_EMPTY"},"availability":{},"badges":{},"aggregatedDiscountInfoV2":{},"badgesV2":{},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"dishStyle":{"socialMarkerStyle":[{"socialMarkerType":"SOCIAL_MARKER_TYPE_HIGH_PROTEIN","title":"Protein Rich","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"brand_proteinator_primary"},{"socialMarkerType":"SOCIAL_MARKER_TYPE_BESTSELLER","title":"Bestseller","textStyle":"FONT_NAME_V2_BODY3_NEUTRAL_BOLD","textColor":"color_swiggy_one"}]}}},"hideRestaurantDetails":true}}],"type":"CATEGORY_TYPE_RECOMMENDED","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{"rows":1,"columns":2,"horizontalScrollEnabled":true,"itemSpacing":16,"containerStyle":{"containerPadding":{"left":16,"top":12,"right":16,"bottom":12}}},"itemStyle":{"width":{"type":"TYPE_RELATIVE","value":0.5,"reference":"RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"},"height":{"type":"TYPE_RELATIVE","value":1,"reference":"RELATIVE_DIMENSION_REFERENCE_WIDTH"}},"supportEvenItemsOnly":true},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"All Day Breakfast","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831984","name":"Poha With Sev","category":"All Day Breakfast","description":"Traditional Indian Breakfast made with flattened rice, onions, peanuts and flavored with basic spices and herbs served with medium spicy sev.","imageId":"7a0ba771f71c9f995a4a83a00497b8e5","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394261","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480108"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831975","name":"Mumbai Street Style Pav Bhaji","category":"All Day Breakfast","description":"Mumbai street food made of a spicy mashed vegetable curry served topped with a dollop of butter along with soft dinner roll.","imageId":"c9950bf23deeb3f297046ff0e236e75f","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394263","groupName":"Extra Add Ons","choices":[{"id":"122678746","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678738","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678731","name":"Bhaji","price":12900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678725","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678750","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678735","name":"Gulab Jamun 2 Pcs","price":7900,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"227 ratings","ratingCountV2":"227"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62480098","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876024","name":"Hot N Healthy Steamed Black Chana","category":"All Day Breakfast","description":"Super healthy Steamed chana garnished with indian herbs & spices.","imageId":"bbdea2b52905e1c5c2a4aec21547cbca","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"101 ratings","ratingCountV2":"101"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480078"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831976","name":"Vada Pav (2 Pcs)","category":"All Day Breakfast","description":"Savory dinner roll stuffed with fried mashed and spiced potato fritters.","imageId":"be79240af2f5d877e381e7fd055b219a","inStock":1,"isVeg":1,"price":10900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394265","groupName":"Extra For Vada Pav","choices":[{"id":"122678730","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678742","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678748","name":"Nembu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"254 ratings","ratingCountV2":"254"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480127","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832038","name":"Bun Maska","category":"All Day Breakfast","description":"Bun & Butter","imageId":"6ac88422b882ed756f48020cebd8e5a5","inStock":1,"isVeg":1,"price":4900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"190 ratings","ratingCountV2":"190"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480042"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831977","name":"Egg Bhurji With Pav","category":"All Day Breakfast","description":"Indian style spiced scrambled egg served with dinner roll.","imageId":"20c333611bdc4969b1a37de4f30887f9","inStock":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394264","groupName":"Extra For Bhurji Pav","choices":[{"id":"122678723","name":"Pav 2 Pcs","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678733","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678727","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678753","name":"Egg Bhurji","price":7900,"inStock":1,"isEnabled":1},{"id":"122678747","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678740","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"53 ratings","ratingCountV2":"53"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480072"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831979","name":"Idili Sambar","category":"All Day Breakfast","description":"Steamed spongy rice cake paired with a spicy and tangy","imageId":"cf72cb7bff86a1c532419cd20cb76709","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394266","groupName":"Extra","choices":[{"id":"122678721","name":"Idli 2 Pcs","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678732","name":"Extra Tomoto & Coconut Chutney","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678744","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678739","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678726","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678751","name":"Extra Sambar","price":5900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"149 ratings","ratingCountV2":"149"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480081"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831985","name":"Upma With Chutney","category":"All Day Breakfast","description":"Traditional south Indian breakfast dish made by simmering roasted rava in tempered & spiced boiling water served with coconut chutney","imageId":"6aabdefd1067624a6eeb49ce11195933","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394259","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"60 ratings","ratingCountV2":"60"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480126"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110876020","name":"Sabudana Khichdi","category":"All Day Breakfast","description":"Made with tapioca pearls, whole spices, roasted peanuts, potatoes and fresh curry leaves.","imageId":"a3e91009b0a3a84b28adaf15a5128967","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394260","groupName":"Extra For Any","choices":[{"id":"122678749","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678729","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678736","name":"Raita","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678743","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"77 ratings","ratingCountV2":"77"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"63591707","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831989","name":"Hummus Falafel","category":"All Day Breakfast","description":"Falafels & Hummus are?a middle eastern food made from chickpeas, spices, and herbs.","imageId":"660ae199256911f27d40ca7541175a66","inStock":1,"isVeg":1,"price":21900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394268","groupName":"Esxtra For Hummus Falafel","choices":[{"id":"122678722","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678741","name":"Extra Falafe","price":12500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678752","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678720","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678728","name":"Extra Hummus","price":12500,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480079"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831986","name":"Bisi Belle Bath","category":"All Day Breakfast","description":"Bisi bele bath?is a flavorsome, spicy and slightly tangy meal made with lentils, rice, mixed vegetables and a super aromatic spice powder.","imageId":"0f89c68a7c8a9ecf89490ca22b2ef5e3","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394267","groupName":"Extra For Bisi Belle Bath","choices":[{"id":"122678734","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678745","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678724","name":"Jaggery, Pickle & Papad Churi","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678737","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480039"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832039","name":"Bun Omelet","category":"All Day Breakfast","description":"Egg?omelette, stuffed in?bun.","imageId":"7e5255da515a8a07a459b55e60a400d9","inStock":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"32 ratings","ratingCountV2":"32"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480043"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831988","name":"Hot Cup Corn Snack","category":"All Day Breakfast","description":"Made with?boiled corns, butter, lemon juice and spices?like chaat masala, garam masala, and chili powder.","imageId":"dfc4b0ebe350e8411d59b78d4545cd76","inStock":1,"isVeg":1,"price":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"76 ratings","ratingCountV2":"76"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480077"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831980","name":"Sambar Vada","category":"All Day Breakfast","description":"Donut shaped lentil fritters?that are fluffy, crispy, soft and delicious paired with a spicy and tangy?sambar served with coconut & red chutney.","imageId":"026d87c4bb43727ea3b19411020f148b","inStock":1,"isVeg":1,"price":10900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"169394262","groupName":"Extra","choices":[{"id":"122678721","name":"Idli 2 Pcs","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678732","name":"Extra Tomoto & Coconut Chutney","price":3900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678744","name":"Nimbu Pani","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678739","name":"Gulab Jamun 2 Pcs","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678726","name":"Jaljeera","price":6900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"122678751","name":"Extra Sambar","price":5900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"103 ratings","ratingCountV2":"103"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480116","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"7a0ba771f71c9f995a4a83a00497b8e5","categoryId":"32222325","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Sandwiches","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576930","name":"Tandoori Paneer Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Soft paneer marinated with curd and spices. Loaded with exotic vegetables.","imageId":"b5bb7ff584ad97aebc3a08fba8e29bed","inStock":1,"isVeg":1,"price":20900,"finalPrice":10900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"308 ratings","ratingCountV2":"308"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["fcc54975-da56-490d-8df7-cdf8a5843fdb"],"size":{"width":0.46,"height":1},"isNinetyninestoreItem":true,"parentId":"62480122"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746211","name":"Potato & Vegetable Sandwich (brown Bread)","category":"Sandwiches","description":"Potato sandwich?s made with aloo tikki, vegetables & combination of sauces","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/29a17544-0e40-45ea-b0cf-10b94df2b25b_925269ce-dcdc-483b-96e3-4b67c094b23c.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"113 ratings","ratingCountV2":"113"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"cartContext":"quick_prep","offerIds":["7201da4b-5963-4a8d-8ca4-d5ee6abdec2c"],"size":{"width":0.46,"height":1},"isNinetyninestoreItem":true,"parentId":"75385694"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576922","name":"Chicken Tikka Grilled Sandwich (brown Bread)","category":"Sandwiches","description":"Made with layers of?tandoori chicken, Vegetables and a homemade spicy mayonnaise dressing.","imageId":"ed102873ace7fcd6f5b9784db1a30387","inStock":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"136 ratings","ratingCountV2":"136"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"63848610","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746208","name":"Cheese & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Corn sandwich is a filled primarily with sweet corn & Cheese along with other spices.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/268f6aab-1a71-4044-bcff-4647a866ebf7_38270eec-4094-4f1d-a1a6-5a2b24be1d16.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"59 ratings","ratingCountV2":"59"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"75385692","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576928","name":"Shredded Chicken Cold Sandwich (brown Bread)","category":"Sandwiches","description":"Made with shredded chicken, mayo, vegetables, flavored with salt & paper.","imageId":"a5d546677bb738f7d33c88b4130424b4","inStock":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.7","ratingCount":"24 ratings","ratingCountV2":"24"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480117"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746209","name":"Soya Tikka Sandwich (brown Bread)","category":"Sandwiches","description":"Soya sandwich made with soya chunk along with tangy tikka gravy.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/afbeb5f5-9b45-4110-8c55-300ac4501166_cb852a67-d930-44ef-b4dc-6bce4aa39723.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"75385695","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129746210","name":"Mushroom & Corn Sandwich (brown Bread)","category":"Sandwiches","description":"Made with?ushroom & sweet?orn?long with tikka gravy.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/9/30/cf21e401-e64c-4bc3-be34-25e6e6e3b8ab_936df9ee-6481-40c3-81bf-64ee6832d6ab.jpg","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.6","ratingCount":"6 ratings","ratingCountV2":"6"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"75385693","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"b5bb7ff584ad97aebc3a08fba8e29bed","categoryId":"32222331","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Maggi & Momos","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832043","name":"Classic Maggi","category":"Maggi & Momos","description":"Classic maggi with added extra vegetables & Spices.","imageId":"285a763faec0781c1f8944f808821627","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"476 ratings","ratingCountV2":"476"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480066"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832046","name":"Egg Bhurji Maggi","category":"Maggi & Momos","description":"Made with Indian style scrambled egg.","imageId":"e44004aac4df3a9d5f4e483a22a59d33","inStock":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480071"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832044","name":"Peri Peri Maggi","category":"Maggi & Momos","description":"Made with extra dose of peri peri sauce.","imageId":"6575e3e347e27529cb84c0906d4b0a7c","inStock":1,"isVeg":1,"price":13900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"161 ratings","ratingCountV2":"161"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480107"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129106823","name":"Mutton Momos (6 Pcs)","category":"Maggi & Momos","description":"Made with ground mutton & vegetables, Served with eggless mayonnaise & spicy momos sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/817334af-b53e-4522-9b6c-2abfd7d17252_2c29a4bb-cc3c-45d5-909c-242e450ab65d.jpg","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.7","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"74991087"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832047","name":"Chicken Keema Maggi","category":"Maggi & Momos","description":"Made with Spicy Chicken keema.","imageId":"0779117a4136f19ef1e07aa57e05205b","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"57 ratings","ratingCountV2":"57"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62480050","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576915","name":"Chicken Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with chicken & other vegetables, Served with eggless mayonnaise & spicy momos sauce.","imageId":"1597c6b8c31da30d670e696b09eed5d3","inStock":1,"price":18900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"62741852","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576918","name":"Paneer Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with Paneer & other vegetables, served with eggless mayonnaise & spicy momos sauce.","imageId":"789b986dafa18d9c554b0b98e0de03c0","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62741862"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832045","name":"Cheese & Jalapeno Maggi","category":"Maggi & Momos","description":"Made with Cheese & Jalapeno.","imageId":"1b194491d06902dc12b533739256afd8","inStock":1,"isVeg":1,"price":15900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.3","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480044"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129106822","name":"Soya Momos (6 Pcs)","category":"Maggi & Momos","description":"Made with soya chunks & vegetables, Served with eggless mayonnaise & spicy momos sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/baa9bc1e-659e-4b71-b81f-5e1e9bf6e956_79a3f5dc-2c6d-4853-a8bc-bd9aa25fda07.jpg","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"9 ratings","ratingCountV2":"9"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"74991088"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576921","name":"Veg Momos Steam (6 Pcs)","category":"Maggi & Momos","description":"Made with cabbage & other vegetables, served with eggless mayonnaise & spicy momos sauce.","imageId":"7ac268d2e4d9f2c9880ad4ce8f93ba16","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62741866"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"285a763faec0781c1f8944f808821627","categoryId":"43092088","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Continental","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964645","name":"Baked Mutton Meatballs (indian Style)","category":"Continental","description":"Baked Mutton meatballs made with ground mutton and a mixture of Indian spices, Served with Mint sauce","inStock":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543669"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821108","name":"Spaghetti Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh Spaghetti?pasta, vegetables combined with butter, cream and cheese.","imageId":"203fb6f02f3cae0fa745f962c00a8c74","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897967","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"44 ratings","ratingCountV2":"44"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541012"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821104","name":"Spaghetti Red Sauce Pasta With Garlic Bread","category":"Continental","description":"Red sauce spaghetti pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.","imageId":"e3fb65783d48fef03717acbb11630408","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897965","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541013"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821110","name":"Penne Alfredo Pasta With Garlic Bread","category":"Continental","description":"The?Alfredo Pasta?is an Italian?pasta?dish made using fresh penne?pasta, vegetables combined with butter, cream and cheese.","imageId":"15f579ecdf022bf645f073b8a9283ac4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897968","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541010"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821107","name":"Penne Red Sauce Pasta With Garlic Bread","category":"Continental","description":"Red sauce penne pasta is doused in?tomato sauce?and cooked in a seasoning of herbs parmesan cheese & spices.","imageId":"86467e130667db245fc9601a5b30c9d4","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"addons":[{"groupId":"124897966","groupName":"Add Ons","choices":[{"id":"107558175","name":"3 Pcs Of Chicken Meatballs","price":12900,"inStock":1,"isEnabled":1},{"id":"107558176","name":"3 Pcs Of Mutton Meatballs","price":17900,"inStock":1,"isEnabled":1}],"maxAddons":2,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541011"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"118222515","name":"Baked Chicken Meatballs Indian Style (8 Pcs)","category":"Continental","description":"Baked Chicken meatballs made with ground chicken and a mixture of Indian spices, Served with Mint sauce.","imageId":"e52171e6b0a992cfadce8cddff627900","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"16 ratings","ratingCountV2":"16"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67797310"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821103","name":"Chicken Kurket [6 Pcs]","category":"Continental","description":"Chicken kurket?are deep fried, stuffed with minced chicken, Potato and spices coated in crispy breadcrumbs.","imageId":"9ee3be8226ddd34bf17d221d0952b298","inStock":1,"price":19900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"72 ratings","ratingCountV2":"72"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541007"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113821106","name":"Jalapeno Cheese Balls [6 Pcs]","category":"Continental","description":"Jalapeno cheese balls?are deep fried, melted cheese balls stuffed with diced jalape?os and coated in crispy breadcrumbs.","imageId":"98800940915ef180861f47ee0d77522e","inStock":1,"isVeg":1,"price":17900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"25 ratings","ratingCountV2":"25"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65541009"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"203fb6f02f3cae0fa745f962c00a8c74","categoryId":"33505198","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Indian Meal","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617192","name":"Bihar Special Champaran Mutton & Rice","category":"Indian Meal","description":"Made with juicy mutton & mix of indian spices, Served with rice.","imageId":"58530a64fcb2663b9e37dbd2310abf42","inStock":1,"price":35900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"21 ratings","ratingCountV2":"21"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685377"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617191","name":"Punjabi Chicken Curry & Rice","category":"Indian Meal","description":"Punjabi style cooked chicken, Served with rice","imageId":"64352b29e04bc4fa7c94860ddcc3c2df","inStock":1,"price":30900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685387"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617190","name":"Murg Makhani & Rice","category":"Indian Meal","description":"Indian curry made with a base of a spiced tomato & butter gravy. Served with rice.","imageId":"c20d8e0dc4364bc36555637a0d97814e","inStock":1,"price":30900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"1.8","ratingCount":"3 ratings","ratingCountV2":"3"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685383"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617187","name":"Paneer Masala & Rice","category":"Indian Meal","description":"Paneer Masala?is a creamy gravy made with butter, tomatoes, and paneer. Served with rice.","imageId":"f600ee6d050f85fcbd0c0d07d3c23312","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685385"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617188","name":"Dal Makhani & Rice","category":"Indian Meal","description":"Black lentils & red kidney beans are slow cooked with spices, butter & cream. Served with rice.","imageId":"289bb06017c12c8e60180a4754c45cdc","inStock":1,"isVeg":1,"price":27900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685379"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617185","name":"Rajma & Rice","category":"Indian Meal","description":"Made with protein rich kidney beans. Served with rice.","imageId":"2d72335d0004cedb54725a02a530e6ef","inStock":1,"isVeg":1,"price":23900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685388"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"110617186","name":"Yellow Dal Tadka Rice","category":"Indian Meal","description":"Yellow dal made with indian spices with a tempering made of ghee & served with rice.","imageId":"a76b030a9169f823df03838da39abf3f","inStock":1,"isVeg":1,"price":22900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"10 ratings","ratingCountV2":"10"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63685391"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"58530a64fcb2663b9e37dbd2310abf42","categoryId":"32222328","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Beverages","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576931","name":"Adarak Wali Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Ginger tea or adrak wali chai is?a warming, spiced and fragrant Indian tea made with fresh ginger roots.","imageId":"90cea1cd1b6eff5cf637e34c7c218564","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{"text":"Bestseller","textColor":"#ffffff","topBackgroundColor":"#d53d4c","bottomBackgroundColor":"#b02331"},"type":"ITEM","itemBadge":{},"badgesV2":{},"isBestseller":true,"ratings":{"aggregatedRating":{"rating":"4.4","ratingCount":"124 ratings","ratingCountV2":"124"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480032"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576935","name":"Masala Chai (mini Flask Serves 2-3)","category":"Beverages","description":"Made with a mix of Indian spices.","imageId":"26ced5b40fa5493a757e8afd44ad334f","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"39 ratings","ratingCountV2":"39"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480093"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576934","name":"Green Tea (mini Flask Serves 2-3)","category":"Beverages","description":"Made solely from the leaves of the camellia sinensis plan - Green tea has one of the highest concentrations of antioxidants of any tea","imageId":"3a964663226e31e492e7d4acb3ec5066","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480074"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576932","name":"Black Coffee (mini Flask Serves 2-3)","category":"Beverages","description":"Served without milk","imageId":"e7d37233c9656ed84b79b11e99c3b240","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480040"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576933","name":"Black Tea (mini Flask Serves 2-3)","category":"Beverages","description":"Served without milk.","imageId":"e4fbd4e28803655def2bb60b226e0f1f","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"5.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480041"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"115218226","name":"Lemon Iced Tea","category":"Beverages","description":"Made with black tea, lemon juice, sugar, water, and ice","imageId":"d9f99755e0312ac72bd520d040c04f6a","inStock":1,"isVeg":1,"price":9900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"66258506"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832066","name":"Nimbu Paani","category":"Beverages","description":"Indian style lemonade made with fresh lemon juice and sugar with a touch of spices.","imageId":"d73949d2f64ab41d3051959f89792354","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"51 ratings","ratingCountV2":"51"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480099"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832067","name":"Jaljeera","category":"Beverages","description":"Jaljeera?is a tangy Indian beverage made using cilantro, mint, and spices.","imageId":"68f4547d4d56b0f23ceca45bc5eb96ef","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"34 ratings","ratingCountV2":"34"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480083"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832062","name":"Masala Chach","category":"Beverages","description":"Refreshing buttermilk lightly spiced.","imageId":"df8643bf393190543318e4ae78c85b0d","inStock":1,"isVeg":1,"price":6900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480092"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"90cea1cd1b6eff5cf637e34c7c218564","categoryId":"32222333","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Rolls","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716238","name":"Egg Roll","category":"Rolls","description":"Indian style egg rolled in a bread.","imageId":"40486f92274e4e01e18e94bbe59505f2","inStock":1,"price":9900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599020","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599022","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599025","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599026","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"182 ratings","ratingCountV2":"182"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65727901"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716239","name":"Chatpata Chicken Tikka Roll","category":"Rolls","description":"Boneless chicken marinated in a blend of Indian spices and curd, grilled and served on a wrap.","imageId":"6fb2d58ae007624ac957f7667a8b0118","inStock":1,"price":23900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599030","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599032","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599033","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599035","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.1","ratingCount":"46 ratings","ratingCountV2":"46"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67273347"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716237","name":"Makhmali Malai Tikka Roll","category":"Rolls","description":"Chicken Malai Tikka Roll is made with tendered chicken tossed in onion, pepper and sauces.","imageId":"32c7351759aed181df5a580105185723","inStock":1,"price":24900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599010","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599012","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599014","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599016","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.2","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67273349"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716241","name":"Takatak Paneer Tikka Roll","category":"Rolls","description":"Made with tandoori paneer, onion, capsicum, cocktail of sauces & Indian spices.","imageId":"193ac982ad8ac0c9bbc20921686ffa01","inStock":1,"isVeg":1,"price":22900,"finalPrice":8900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599047","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599048","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599049","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599050","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"40 ratings","ratingCountV2":"40"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["9caf6a85-3e4e-42da-ae21-f9705c6593d3"],"size":{"width":0.46,"height":1},"parentId":"67273352","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129712500","name":"Mushroom Tikka Roll","category":"Rolls","description":"Mushroom marinated & cooked with Tikka gravy","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/fce4e4ce-496f-4486-9b32-431119fb197b_af6e1683-f0bd-49df-b9aa-f3972c140593.jpg","inStock":1,"isVeg":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75339031"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"117716240","name":"Spicy Soya Roll","category":"Rolls","description":"Chatpata masaledar soya chap is cooked with crunchy onions & capsicums along with sauces and spices","imageId":"116a1be7d390cfc92340f365ecddc2f5","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125599039","groupName":"Addon Egg","choices":[{"id":"107814090","name":"1 Egg","price":2900,"inStock":1,"isEnabled":1},{"id":"107814091","name":"2 Egg","price":4900,"inStock":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599041","groupName":"Choice Of Filling","choices":[{"id":"107814092","name":"Soya Filling","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814093","name":"Paneer Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814094","name":"Chicken Tikka","price":9900,"inStock":1,"isEnabled":1},{"id":"107814095","name":"Malai Tikka","price":9900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107814096","name":"Mutton Masala","price":12900,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599043","groupName":"Choice Of Drinks","choices":[{"id":"107814097","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1},{"groupId":"125599046","groupName":"Choice Of Sweet","choices":[{"id":"107814098","name":"Gulab Jamun 1 Pc","price":4900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":1,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.9","ratingCount":"34 ratings","ratingCountV2":"34"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"67273351","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129712499","name":"Corn Tikka Roll","category":"Rolls","description":"Mushroom marinated & cooked with Tikka gravy","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/70b0b508-084c-4370-8cbd-cdc5f54ab9dc_4ceeffbb-ba0f-4703-b342-686c08130417.jpg","inStock":1,"isVeg":1,"price":20900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.0","ratingCount":"1 rating","ratingCountV2":"1"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75339030"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"40486f92274e4e01e18e94bbe59505f2","categoryId":"35917596","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Biryani","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832028","name":"Hydrabadi Mutton Biryani","category":"Biryani","description":"Hyderabadi mutton biryani?is a classic dish made by layering rice over slow cooked mutton gravy, served with raita.","imageId":"06f78747a4dc200867b3f2e63dae3258","inStock":1,"price":39900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.5","ratingCount":"9 ratings","ratingCountV2":"9"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480080"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832029","name":"Lucknowi Chicken Biryani","category":"Biryani","description":"Awadhi chicken biryani (also known as?Lucknowi chicken biryani) made with long grain basmati rice, chicken, and mild spices, served with raita.","imageId":"f1655bcbe411daeb454363e71156e0a6","inStock":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.5","ratingCount":"17 ratings","ratingCountV2":"17"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480088"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832032","name":"Paneer Tikka Biryani","category":"Biryani","description":"Tandoori paneer biryani is a flavorful biryani, It is a vegetarian\'s delight cooked by marinating paneer with spices, served with raita.","imageId":"fc996d0fe0553e4e434f465dce54d166","inStock":1,"isVeg":1,"price":34900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.9","ratingCount":"17 ratings","ratingCountV2":"17"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480103"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832033","name":"Veg Biryani","category":"Biryani","description":"Vegetable biryani?is an aromatic rice dish made with basmati rice, spices & mixed veggies, served with raita.","imageId":"85fe8713d465212368a759fd82863d41","inStock":1,"isVeg":1,"price":29900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.8","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"24998455"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"06f78747a4dc200867b3f2e63dae3258","categoryId":"32222327","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Burger","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831990","name":"Tikki Burger","category":"Burger","description":"Crisp golden potato patties are sandwiched between burger buns and then topped with veggies & Sauce.","imageId":"c34689260ba758fa6729c73892cec78e","inStock":1,"isVeg":1,"price":7900,"finalPrice":2900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119891","groupName":"Add On","choices":[{"id":"107652393","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652394","name":"Add Aloo Patty","price":4900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652395","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652396","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652397","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"286 ratings","ratingCountV2":"286"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["a927ada4-b889-4406-b5e9-0ab4d390cdac"],"size":{"width":0.46,"height":1},"parentId":"62480125","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831995","name":"Chicken & Cheese Burger","category":"Burger","description":"Crispy?fried chicken?fillet, loaded with vegetables & Cheese.","imageId":"66602c7ebb7c295599d0cf412aa6dbf5","inStock":1,"price":15900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119893","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.4","ratingCount":"26 ratings","ratingCountV2":"26"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480046"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831996","name":"Chicken Tikka Burger","category":"Burger","description":"Juicy and spicy pieces of chicken tikka, layered with fresh veggies and delicious sauces.","imageId":"d128d68ffbabd2bc5275af907aa9c7d9","inStock":1,"price":16900,"finalPrice":6900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119892","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"12 ratings","ratingCountV2":"12"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["568345f1-a79e-4493-bbc4-6f6099228ce8"],"size":{"width":0.46,"height":1},"parentId":"62480056","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576911","name":"BBQ Chicken Burger","category":"Burger","description":"Crispy?fried chicken?fillet, loaded with vegatables & flavor of BBQ sauce.","imageId":"1062c924c7bc54924fabf06a93da3400","inStock":1,"price":14900,"finalPrice":5900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119894","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.3","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["3d3deff4-5f75-4cc2-b1d7-dca34271ee04"],"size":{"width":0.46,"height":1},"parentId":"62480037","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831992","name":"Paneer Tikki Burger","category":"Burger","description":"Made with juicy paneer patty along with fresh greens.","imageId":"c80eb19d908c65625740321b3dccf111","inStock":1,"isVeg":1,"price":12900,"finalPrice":4900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119896","groupName":"Add On","choices":[{"id":"107652403","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652404","name":"Add Paneer Patty","price":7900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652405","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652406","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652407","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"45 ratings","ratingCountV2":"45"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["3d684d37-7a44-4113-b6ca-806845f4afe2"],"size":{"width":0.46,"height":1},"parentId":"62480106","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831993","name":"Juicy Chicken Burger","category":"Burger","description":"Crispy?fried chicken?fillet slathered with a special?burger?sauce & vegetables.","imageId":"d400e637c1c718fb4cba69622c1b0afc","inStock":1,"price":13900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119895","groupName":"Add On","choices":[{"id":"107652398","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652399","name":"Add Chicken Patty","price":7900,"inStock":1,"isEnabled":1},{"id":"107652400","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652401","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652402","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"42 ratings","ratingCountV2":"42"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480084"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108831991","name":"Veggie Delight Burger","category":"Burger","description":"This larger than life veggie burger is?loaded with fresh greens and vegetable patty.","imageId":"04213b86ebfc9e25b26b2a109222a28b","inStock":1,"isVeg":1,"price":8900,"finalPrice":3900,"variants":{},"variantsV2":{},"addons":[{"groupId":"125119897","groupName":"Add On","choices":[{"id":"107652408","name":"Cheese Slice","price":2500,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652409","name":"Add Veggie Patty","price":5900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652410","name":"Add Fries","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652411","name":"Ice Tea","price":8900,"inStock":1,"isVeg":1,"isEnabled":1},{"id":"107652412","name":"Gulab Jamun 2 Pcs","price":8900,"inStock":1,"isVeg":1,"isEnabled":1}],"maxAddons":5,"maxFreeAddons":-1}],"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"3.6","ratingCount":"122 ratings","ratingCountV2":"122"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480131","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"c34689260ba758fa6729c73892cec78e","categoryId":"32222326","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Snacks","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964646","name":"Chicken Cutlet 4 Pcs","category":"Snacks","description":"Made with boneless chicken & Indian spices, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg","inStock":1,"price":24900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"NONVEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.7","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543670"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832057","name":"Fries","category":"Snacks","description":"Classic salted fries.","imageId":"e97ee544cf54bf2a3bd215fd4f88cb73","inStock":1,"isVeg":1,"price":8900,"finalPrice":3900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"167 ratings","ratingCountV2":"167"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["e0dbebae-461e-4fc0-a7d0-8ba51f921c60"],"size":{"width":0.46,"height":1},"parentId":"62480073","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"129964647","name":"Veg Cutlet 4 Pcs","category":"Snacks","description":"Made with mixed vegetables, herbs and spices, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/88f5db7f-62d9-4f55-bc28-da8dc40a306f_f21f8fb6-4b05-4d96-8c0b-4602ed829107.jpg","inStock":1,"isVeg":1,"price":16900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"12 ratings","ratingCountV2":"12"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"75543671"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"108832058","name":"Mexican Salsa Fries","category":"Snacks","description":"Salted fries served with tangy aalsa sauce","imageId":"14c9261a694bf9d76324f9cf89894f0c","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"2.3","ratingCount":"8 ratings","ratingCountV2":"8"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#FFF0CD","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_low","ratingTextColor":"rating_low","ratingCountTextColor":"rating_low","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"63333585"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"131545818","name":"Potato Wedges","category":"Snacks","description":"Delicious golden-brown wedges are perfectly crispy on the outside and soft on the inside, Served with mint sauce","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/56195c0b-bd91-49bf-bd05-cd1cb9456772_b4266453-503d-4484-b24c-1fe5dced067a.jpg","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"5 ratings","ratingCountV2":"5"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"76540606"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/3a6030eb-ef1a-4292-8dfb-66a0d36e52c7_a2910980-0f80-47a1-b176-55bd2dd25b81.jpg","categoryId":"32222329","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Fasting Meals","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381353","name":"Sabutdana Vada","category":"Fasting Meals","description":"Made With Tapioca Pearls (Sago), Roasted Peanuts, Boiled Potatoes And Herbs Served Along With Raita","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"13 ratings","ratingCountV2":"13"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"73124158","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381360","name":"Sabudaba Khichdi","category":"Fasting Meals","description":"Sabudana Ki Khichdi Is A Delicious Dish Of Tapioca Pearls (Sago) Made With Potatoes & Peanuts Served Along With Raita","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/108d8a4b-55dd-4de2-a110-996a06233f0b_c45e0324-a4f6-4aa6-af88-ff18ac09e5a5.jpg","inStock":1,"isVeg":1,"price":19900,"finalPrice":7900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","offerTags":[{"matchText":"SILD"}],"itemBadge":{},"badgesV2":{},"itemNudgeType":"FinalPrice","ratings":{"aggregatedRating":{"rating":"4.1","ratingCount":"15 ratings","ratingCountV2":"15"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"offerIds":["ddb29a66-004d-473d-a6fd-0e9b88a39632"],"size":{"width":0.46,"height":1},"parentId":"73124157","offerCategory":"OFFER_CATEGORY_DEAL_RUSH","offerHeader":"Only till","offerSubHeader":"10:00 AM"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"126381349","name":"Aloo Chat","category":"Fasting Meals","description":"Crispy Potato Pieces Seasoned With Very Few Spices, Fresh Herbs And Drizzled Lemon Juice On Top.","imageId":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/ec527d18-a2f8-4242-aa91-9409975a9d16_7ca1acb7-0c0b-406f-a5c2-f647ad205f04.jpg","inStock":1,"isVeg":1,"price":14900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.0","ratingCount":"4 ratings","ratingCountV2":"4"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"73124154"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"FOOD_CATALOG/IMAGES/CMS/2024/5/15/6841ae8a-c22b-4a3e-8a25-39c8e4e3f654_74905ce8-345f-4eb7-9ad0-e521b2ae17c3.jpg","categoryId":"41334237","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.ItemCategory","title":"Dessert","itemCards":[{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"118074121","name":"Moong Dal Halwa","category":"Dessert","description":"Made moong, milk, sugar and nuts.","imageId":"7d4459f5940e478219f94c03cf02eb9a","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.2","ratingCount":"23 ratings","ratingCountV2":"23"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"67576596"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"113304427","name":"Kheer (cold) (150 Gm)","category":"Dessert","description":"A chilled south Asian dessert mate from rice milk, dry fruit & sugar","imageId":"7a3e64f9704406337c4a8395a1e77ebd","inStock":1,"isVeg":1,"price":12900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"4.9","ratingCount":"15 ratings","ratingCountV2":"15"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#C8F9E5","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_very_good","ratingTextColor":"rating_very_good","ratingCountTextColor":"rating_very_good","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"65286896"},"analytics":{},"hideRestaurantDetails":true}},{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.Dish","info":{"id":"111576936","name":"Gulab Jamun (2 Pcs)","category":"Dessert","description":"Fried dough balls that are soaked in a sweet, sticky sugar syrup","imageId":"d185664d5ef4e5fd8baa369382a1edd1","inStock":1,"isVeg":1,"price":8900,"variants":{},"variantsV2":{},"itemAttribute":{"vegClassifier":"VEG"},"ribbon":{},"type":"ITEM","itemBadge":{},"badgesV2":{},"ratings":{"aggregatedRating":{"rating":"3.8","ratingCount":"29 ratings","ratingCountV2":"29"},"ratingsPresentationConfig":{"bgGradient":{"colours":["#D9EFEC","#00FFFFFF"],"gradientDirection":"GRADIENT_DIRECTION_LEFT_TO_RIGHT"},"ratingIconColor":"rating_medium","ratingTextColor":"rating_medium","ratingCountTextColor":"rating_medium","ratingFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD","ratingCountFontName":"FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"}},"itemPriceStrikeOff":true,"size":{"width":0.46,"height":1},"parentId":"62480075"},"analytics":{},"hideRestaurantDetails":true}}],"subtitleSuffix":{},"image":"7d4459f5940e478219f94c03cf02eb9a","categoryId":"32222334","widgetType":"WIDGET_TYPE_DISH_FIRST","categoryStyle":{"layout":{}},"headerStyle":{"padding":{"left":16,"top":16,"right":16,"bottom":16},"titleColor":"text_color_highest_emphasis","titleFontName":"FONT_NAME_SUB_HEADER_S1_BOLD","imageStyle":{"width":{},"height":{}},"gradientStyle":{}},"dividerStyle":{"color":"#1502060C","height":1,"padding":{"left":16,"right":16}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget","header":{"title":"Try these featured restaurants!","headerStyling":{"padding":{"left":20,"top":24,"bottom":16},"titleSize":18,"subtitleSize":14,"titleColor":"#3e4152","titleFontName":"FONT_NAME_ALL_CAPS_AC1"}},"layout":{"rows":1,"columns":6,"horizontalScrollEnabled":true,"widgetPadding":{},"containerStyle":{"containerPadding":{"left":8,"right":12,"bottom":16}},"scrollBar":{"scrollThumbColor":"#E46D47","scrollTrackColor":"#E4E4E4","width":54,"height":4,"scrollStyling":{"padding":{"top":6,"bottom":24}}},"backgroundColor":"#F1F8FF","widgetBorderStyle":{"top":{"color":"#E7F4FD","height":1},"bottom":{"color":"#E7F4FD","height":1},"left":{},"right":{}},"widgetTheme":{"defaultMode":{"backgroundColour":"#F0F0F5","theme":"THEME_TYPE_LIGHT"},"darkMode":{"backgroundColour":"#1B3028","theme":"THEME_TYPE_DARK"}}},"id":"adsOnlyMenuSimilarRestaurantWidgetUX4","gridElements":{"infoWithStyle":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.SimilarRestaurantsInfoWithStyle","restaurants":[{"info":{"id":"218676","name":"Chai Point","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2025/6/26/f3cb6247-bdad-4c38-9a4e-4f2cfdc503b9_218676.jpg","locality":"Connaught Place","areaName":"Connaught Place","costForTwo":"\u20B9150 for two","cuisines":["Bakery","Beverages","Maharashtrian","Snacks","Street Food","South Indian","Punjabi","Chaat","Indian","American"],"avgRating":4.4,"parentId":"1607","avgRatingString":"4.4","totalRatingsString":"8.3K+","adTrackingId":"cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909","sla":{"deliveryTime":24,"lastMileTravel":1.6,"serviceability":"SERVICEABLE","slaString":"20-25 mins","lastMileTravelString":"1.6 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-20 05:29:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B979","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"4.3","ratingCount":"1.3K+"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"c2fa6272-c42a-4869-9dec-81334ef5a240"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=c2fa6272-c42a-4869-9dec-81334ef5a240~p=0~adgrpid=c2fa6272-c42a-4869-9dec-81334ef5a240#ag3~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=218676~plpr=HOME#SIMILAR_ENTITY~eid=381a043a-b857-4add-b3be-6c0e89474011~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"218676","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"697263","name":"Handi 47","cloudinaryImageId":"f60a0596a76581b140ea724a02b7805b","locality":"Lakshmi Narayan St","areaName":"Karol Bagh","costForTwo":"\u20B9300 for two","cuisines":["North Indian"],"avgRating":4.2,"parentId":"417357","avgRatingString":"4.2","totalRatingsString":"791","adTrackingId":"cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909","sla":{"deliveryTime":32,"lastMileTravel":2.8,"serviceability":"SERVICEABLE","slaString":"30-40 mins","lastMileTravelString":"2.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"8646849f-b580-488f-bd7f-0a96829d32a0"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=8646849f-b580-488f-bd7f-0a96829d32a0~p=1~adgrpid=8646849f-b580-488f-bd7f-0a96829d32a0#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=697263~plpr=HOME#SIMILAR_ENTITY~eid=2b6b355f-5b18-4cac-93ec-ca32374103d4~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"697263","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"939876","name":"Chai Dilli","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2024/8/12/de90ab66-072f-4d03-98d8-d13c644a0650_939876.jpg","locality":"OLD RAJINDER NAGAR","areaName":"Karol Bagh","costForTwo":"\u20B9200 for two","cuisines":["Beverages","Pizzas","Pastas","Fast Food","Burgers"],"avgRating":4.3,"veg":true,"parentId":"551143","avgRatingString":"4.3","totalRatingsString":"183","adTrackingId":"cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909","sla":{"deliveryTime":33,"lastMileTravel":5,"serviceability":"SERVICEABLE","slaString":"30-35 mins","lastMileTravelString":"5.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-19 23:59:00","opened":true},"badges":{"imageBadges":[{"imageId":"v1695133679/badges/Pure_Veg111.png","description":"pureveg"}]},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{"badgeObject":[{"attributes":{"description":"pureveg","imageId":"v1695133679/badges/Pure_Veg111.png"}}]},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B919","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac~p=2~adgrpid=922a7ba2-ba8a-44dd-b8ba-9cbcc34ec1ac#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=939876~plpr=HOME#SIMILAR_ENTITY~eid=bb2d9362-ed66-4dca-af1e-6ccd6435a7e3~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"939876","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"112346","name":"Aunty\'s Paranthe","cloudinaryImageId":"l8d63zn3czlht54ykil0","locality":"KAROL BAGH near bangal chicken corner","areaName":"Karol Bagh","costForTwo":"\u20B9200 for two","cuisines":["North Indian","South Indian"],"avgRating":4.2,"parentId":"15487","avgRatingString":"4.2","totalRatingsString":"9.8K+","adTrackingId":"cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909","sla":{"deliveryTime":37,"lastMileTravel":4.7,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"4.7 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-19 15:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"3.1","ratingCount":"49"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"f770f9dd-7bce-4daa-b237-6f260d100516"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=f770f9dd-7bce-4daa-b237-6f260d100516~p=3~adgrpid=f770f9dd-7bce-4daa-b237-6f260d100516#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=112346~plpr=HOME#SIMILAR_ENTITY~eid=0b52f14b-0401-48d0-8305-f50fb8e292de~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"112346","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"1221537","name":"Boba Bhai - Bubble Tea & Korean Street Food","cloudinaryImageId":"RX_THUMBNAIL/IMAGES/VENDOR/2025/12/4/f156aec5-4281-45c6-be50-75861b8740d0_1221537.JPG","locality":"Patel Nagar","areaName":"East Patel Nagar","costForTwo":"\u20B9200 for two","cuisines":["Bubble Tea","Burger","Korean","Beverages","Fast Food","Juice and shake"],"avgRating":4.6,"parentId":"361235","avgRatingString":"4.6","totalRatingsString":"45","adTrackingId":"cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909","sla":{"deliveryTime":41,"lastMileTravel":6.8,"serviceability":"SERVICEABLE","slaString":"40-45 mins","lastMileTravelString":"6.8 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-26 00:00:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"imageBased":{},"textExtendedBadges":{},"textBased":{}}},"aggregatedDiscountInfoV3":{"header":"ITEMS","subHeader":"AT \u20B9115","logoCtx":{"text":"BENEFITS"}},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","isNewlyOnboarded":true,"restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"--"}},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"7b0032b1-c921-4b20-be3d-5dfe53206357"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=7b0032b1-c921-4b20-be3d-5dfe53206357~p=4~adgrpid=7b0032b1-c921-4b20-be3d-5dfe53206357#ag4~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=1221537~plpr=HOME#SIMILAR_ENTITY~eid=73f493b1-14c3-4408-9eb8-dfcd963a8764~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"1221537","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}},{"info":{"id":"375547","name":"Josie\'s Coffee House","cloudinaryImageId":"gx8s42xrhtgawdv5l0tp","locality":"Rajinder Nagar","areaName":"Karol Bagh","costForTwo":"\u20B9300 for two","cuisines":["Beverages","Juices","Desserts"],"avgRating":4.4,"parentId":"111546","avgRatingString":"4.4","totalRatingsString":"981","adTrackingId":"cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909","sla":{"deliveryTime":39,"lastMileTravel":5,"serviceability":"SERVICEABLE","slaString":"35-40 mins","lastMileTravelString":"5.0 km","iconType":"ICON_TYPE_EMPTY"},"availability":{"nextCloseTime":"2025-12-20 00:30:00","opened":true},"badges":{},"isOpen":true,"badgesV2":{"entityBadges":{"textBased":{},"imageBased":{},"textExtendedBadges":{}}},"aggregatedDiscountInfoV3":{"header":"50% OFF","logoCtx":{"text":"BENEFITS"},"footerText":"3 DEALS LEFT","secondaryHeaderType":"SECONDARY_HEADER_TYPE_USAGE_LIMIT_OFFER"},"differentiatedUi":{"displayType":"ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT","differentiatedUiMediaDetails":{"mediaType":"ADS_MEDIA_ENUM_IMAGE"}},"reviewsSummary":{},"displayType":"RESTAURANT_DISPLAY_TYPE_DEFAULT","restaurantOfferPresentationInfo":{},"externalRatings":{"aggregatedRating":{"rating":"4.3","ratingCount":"686"},"source":"GOOGLE","sourceIconImageId":"v1704440323/google_ratings/rating_google_tag"},"ratingsDisplayPreference":"RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY","campaignId":"d3c58928-824e-4e06-b85c-7255714d0787"},"analytics":{"screenName":"ux4-home-page","context":"{\\"adTrackingId\\":\\"cid=d3c58928-824e-4e06-b85c-7255714d0787~p=5~adgrpid=d3c58928-824e-4e06-b85c-7255714d0787#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=375547~plpr=HOME#SIMILAR_ENTITY~eid=17a2942e-8aa8-4647-ba54-67e6fcb53a5d~srvts=1766115234172~arid=666909~wn=adsOnlyMenuSimilarRestaurantWidget~wn=adsOnlyMenuSimilarRestaurantWidget\\",\\"tid\\":\\"1dc8dfbd-09b9-4970-88af-f1bda78b7b47\\"}","objectValue":"375547","impressionObjectName":"impression-similar-restaurant-item-ad","clickObjectName":"click-similar-restaurant-item-ad"}}],"widgetType":"WIDGET_TYPE_SRW","style":{}}}}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo","type":"FSSAI","imageId":"fssai_final_edss9i","text":["License No. 13322005000901"]}}},{"card":{"card":{"@type":"type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress","name":"Oh!Hunger","area":"Paharganj","completeAddress":"1723, GF, Gali Pratap, Chuna Mandi, Paharganj New Delhi , KAROL BAGH, Central, Delhi-110055"}}}]}}}}],"firstOffsetRequest":true,"isQCLink":false},"tid":"1dc8dfbd-09b9-4970-88af-f1bda78b7b47","sid":"omwacd0d-0b54-4961-83b7-93696c74cc8c","deviceId":"4ca02714-b64e-01a4-087c-5853e40864e6","csrfToken":"ZGrrFfk8gIza-ncHx5TLi-Esw39hosN9I20Uon7E"}');


const $7ef8580496a712f9$var$useRestaurantMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $4RFnf.useState)(null);
    const [resMenu, setResMenu] = (0, $4RFnf.useState)([]);
    (0, $4RFnf.useEffect)(()=>{
        if (!resId) return;
        // 🔹 Restaurant Info
        const restaurantInfo = (0, (/*@__PURE__*/$parcel$interopDefault($0b2b362ceb9aba3c$exports)))?.data?.cards?.find((item)=>item?.card?.card?.["@type"]?.includes("food.v2.Restaurant"));
        // 🔹 Menu Categories
        const menuCategories = (0, (/*@__PURE__*/$parcel$interopDefault($0b2b362ceb9aba3c$exports)))?.data?.cards?.find((card)=>card?.groupedCard)?.groupedCard?.cardGroupMap?.REGULAR?.cards?.filter((card)=>card?.card?.card?.["@type"]?.includes("ItemCategory"))?.map((category)=>({
                categoryId: category?.card?.card?.categoryId,
                title: category?.card?.card?.title,
                itemCards: category?.card?.card?.itemCards || []
            })) || [];
        setResInfo(restaurantInfo);
        setResMenu(menuCategories);
    }, [
        resId
    ]);
    return {
        resInfo: resInfo,
        resMenu: resMenu
    };
};
var $7ef8580496a712f9$export$2e2bcd8739ae039 = $7ef8580496a712f9$var$useRestaurantMenu;


const $39574b0fd08a3b1c$var$RestaurantMenu = ()=>{
    const { resId: resId } = (0, $2dda13c5d6544900$export$99eaa27ddbbb95ef)();
    const { resInfo: resInfo, resMenu: resMenu } = (0, $7ef8580496a712f9$export$2e2bcd8739ae039)(resId);
    const [openIndex, setOpenIndex] = (0, $4RFnf.useState)(null);
    if (!resInfo) return /*#__PURE__*/ (0, $jk232.jsx)((0, $cc5aede9e6f101a2$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines = [], costForTwoMessage: costForTwoMessage, avgRating: avgRating, sla: sla = {}, areaName: areaName } = resInfo?.card?.card?.info || {};
    return /*#__PURE__*/ (0, $jk232.jsx)("div", {
        className: "min-h-screen bg-gray-100",
        children: /*#__PURE__*/ (0, $jk232.jsxs)("div", {
            className: "max-w-[900px] mx-auto px-4 py-6 pb-24",
            children: [
                /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-md p-6 mb-6 text-center",
                    children: [
                        /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                            className: "text-2xl font-bold text-gray-800",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $jk232.jsx)("p", {
                            className: "text-gray-600 mt-1",
                            children: cuisines.join(", ")
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                            className: "flex flex-col items-center gap-2 mt-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $jk232.jsxs)("span", {
                                    className: "px-3 py-1 bg-green-100 text-green-700 rounded-full font-semibold",
                                    children: [
                                        "\u2B50 ",
                                        avgRating
                                    ]
                                }),
                                /*#__PURE__*/ (0, $jk232.jsx)("span", {
                                    className: "text-gray-700",
                                    children: costForTwoMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $jk232.jsxs)("p", {
                            className: "text-sm text-gray-500 mt-3",
                            children: [
                                sla?.minDeliveryTime,
                                "-",
                                sla?.maxDeliveryTime,
                                " mins \u2022 ",
                                areaName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $jk232.jsx)("div", {
                    className: "bg-white rounded-2xl shadow overflow-hidden",
                    children: resMenu?.map((category, index)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $579a12e96e24a9c9$export$2e2bcd8739ae039), {
                            data: category,
                            isOpen: openIndex === index,
                            onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                        }, index))
                })
            ]
        })
    });
};
var $39574b0fd08a3b1c$export$2e2bcd8739ae039 = $39574b0fd08a3b1c$var$RestaurantMenu;




var $jk232 = parcelRequire("jk232");



const $98039df5fee7d435$var$Cart = ()=>{
    const cartItems = (0, $99aed3ab2dc6c7d9$export$2105062e25df4afe)((store)=>store.cart.items);
    const dispatch = (0, $99aed3ab2dc6c7d9$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $jk232.jsxs)("div", {
        className: "min-h-screen bg-gray-50 py-10",
        children: [
            /*#__PURE__*/ (0, $jk232.jsx)("h1", {
                className: "text-4xl font-extrabold text-center mb-8",
                children: "\uD83D\uDED2 Your Cart"
            }),
            /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                className: "w-10/12 md:w-8/12 lg:w-6/12 mx-auto bg-white rounded-2xl shadow-lg p-6",
                children: [
                    cartItems.length > 0 && /*#__PURE__*/ (0, $jk232.jsx)("div", {
                        className: "flex justify-center mb-6",
                        children: /*#__PURE__*/ (0, $jk232.jsx)("button", {
                            onClick: ()=>dispatch((0, $be82901f22730e57$export$810121176e3e3671)()),
                            className: "px-10 py-3 text-lg font-bold rounded-full bg-red-500 text-white hover:bg-red-600 active:scale-95 transition-all duration-200 shadow-md",
                            children: "Clear Cart"
                        })
                    }),
                    cartItems.length === 0 ? /*#__PURE__*/ (0, $jk232.jsxs)("div", {
                        className: "text-center py-10",
                        children: [
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "text-xl text-gray-500 mb-3",
                                children: "Your cart is empty "
                            }),
                            /*#__PURE__*/ (0, $jk232.jsx)("p", {
                                className: "text-gray-400",
                                children: "Discover delicious items and add them to your cart!"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $jk232.jsx)("ul", {
                        className: "space-y-4",
                        children: cartItems.map((item, index)=>/*#__PURE__*/ (0, $jk232.jsx)((0, $839b398f111495d4$export$2e2bcd8739ae039), {
                                menuInfo: item
                            }, item?.id || `cart-item-${index}`))
                    })
                ]
            })
        ]
    });
};
var $98039df5fee7d435$export$2e2bcd8739ae039 = $98039df5fee7d435$var$Cart;




// Import configureStore from Redux Toolkit
// configureStore is the modern way to create a Redux store


// Creating the Redux store here
// Currently the store is empty because no reducer is passed
// Without reducers, the store does not hold or manage any state
const $3ba6b11c45f4b493$var$appStore = (0, $6d3bbb1da5d24806$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $be82901f22730e57$export$2e2bcd8739ae039)
    }
});
var // Exporting the store
// So that the entire application can access it using the Provider
$3ba6b11c45f4b493$export$2e2bcd8739ae039 = $3ba6b11c45f4b493$var$appStore;



const $9abc26aaf5d46eba$var$Grocery = /*#__PURE__*/ (0, $4RFnf.lazy)(()=>(parcelRequire("b1rvU")));
/* ================= APP LAYOUT ================= */ const $9abc26aaf5d46eba$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $4RFnf.useState)("");
    (0, $4RFnf.useEffect)(()=>{
        setUserName("Riyanshu Sharma");
    }, []);
    return /*#__PURE__*/ (0, $jk232.jsx)((0, $99aed3ab2dc6c7d9$export$2881499e37b75b9a), {
        store: (0, $3ba6b11c45f4b493$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $jk232.jsxs)((0, $ea3f38a28bd03b5e$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: [
                /*#__PURE__*/ (0, $jk232.jsx)((0, $323bf0bf7dab78c2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $jk232.jsx)((0, $2dda13c5d6544900$export$910ae8079b2c2852), {})
            ]
        })
    });
};
/* ================= ROUTER ================= */ const $9abc26aaf5d46eba$var$appRouter = (0, $ab1c2d1a5ff1b7e8$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $jk232.jsx)($9abc26aaf5d46eba$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $jk232.jsx)((0, $66b3ab631caa5778$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $1943c5ad6ae77e9b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $8fcb7774a519ed55$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $c30866d045584b89$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $98039df5fee7d435$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $4RFnf.Suspense), {
                    fallback: /*#__PURE__*/ (0, $jk232.jsx)((0, $cc5aede9e6f101a2$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $jk232.jsx)($9abc26aaf5d46eba$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $jk232.jsx)((0, $39574b0fd08a3b1c$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
/* ================= RENDER ================= */ const $9abc26aaf5d46eba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($e6901a497e5ba7f6$exports))).createRoot(document.getElementById("root"));
$9abc26aaf5d46eba$var$root.render(/*#__PURE__*/ (0, $jk232.jsx)((0, $ab1c2d1a5ff1b7e8$export$323e4fc2fa4753fb), {
    router: $9abc26aaf5d46eba$var$appRouter
}));


//# sourceMappingURL=path0.fd914ca2.js.map
